import { getCurrentInstance as qt, inject as ue, computed as G, watch as te, onMounted as Se, onUnmounted as Wr, ref as X, shallowRef as ss, defineComponent as ge, h as co, createVNode as m, Text as is, Fragment as Ae, resolveComponent as U, openBlock as w, createBlock as ce, normalizeClass as ke, createSlots as ls, withCtx as E, renderSlot as mo, normalizeProps as as, guardReactiveProps as us, onBeforeMount as fo, isRef as Sr, reactive as se, onBeforeUnmount as St, unref as r, provide as cn, isReactive as ds, isReadonly as cs, nextTick as ae, useId as Be, createElementBlock as F, toDisplayString as P, createCommentVNode as B, createElementVNode as c, mergeProps as Yr, createTextVNode as Ie, withModifiers as ms, withDirectives as De, vShow as et, renderList as tt, withKeys as qr, createStaticVNode as fs, normalizeStyle as ps } from "vue";
const Hr = Symbol("appSystem");
function Hg(e) {
  if (e === "production") return "PROD";
  if (e === "PROD" || e === "TEST" || e === "BETA" || e === "development")
    return e;
  throw new Error(`Unsupported app system: ${e}`);
}
/*!
  * shared v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function ut(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const mn = {};
function vs(e) {
  mn[e] || (mn[e] = !0, ut(e));
}
const at = typeof window < "u";
let Ze, Tt;
if (process.env.NODE_ENV !== "production") {
  const e = at && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Ze = (t) => {
    e.mark(t);
  }, Tt = (t, s, n) => {
    e.measure(t, s, n), e.clearMarks(s), e.clearMarks(n);
  });
}
const gs = /\{([0-9a-zA-Z]+)\}/g;
function ur(e, ...t) {
  return t.length === 1 && Te(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(gs, (s, n) => t.hasOwnProperty(n) ? t[n] : "");
}
const dt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), ys = (e, t, s) => bs({ l: e, k: t, s }), bs = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Ue = (e) => typeof e == "number" && isFinite(e), Cs = (e) => Qr(e) === "[object Date]", nr = (e) => Qr(e) === "[object RegExp]", dr = (e) => he(e) && Object.keys(e).length === 0, Ge = Object.assign, Is = Object.create, $e = (e = null) => Is(e);
let fn;
const It = () => fn || (fn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : $e());
function pn(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function vn(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function _s(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (n, a, o) => `${a}="${vn(o)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (n, a, o) => `${a}='${vn(o)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && ut("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((n) => {
    e = e.replace(n, "$1javascript&#58;");
  }), e;
}
const hs = Object.prototype.hasOwnProperty;
function rt(e, t) {
  return hs.call(e, t);
}
const je = Array.isArray, Re = (e) => typeof e == "function", le = (e) => typeof e == "string", ze = (e) => typeof e == "boolean", Te = (e) => e !== null && typeof e == "object", Ts = (e) => Te(e) && Re(e.then) && Re(e.catch), po = Object.prototype.toString, Qr = (e) => po.call(e), he = (e) => Qr(e) === "[object Object]", Es = (e) => e == null ? "" : je(e) || he(e) && e.toString === po ? JSON.stringify(e, null, 2) : String(e);
function Kr(e, t = "") {
  return e.reduce((s, n, a) => a === 0 ? s + n : s + t + n, "");
}
const gn = 2;
function Ns(e, t = 0, s = e.length) {
  const n = e.split(/\r?\n/);
  let a = 0;
  const o = [];
  for (let l = 0; l < n.length; l++)
    if (a += n[l].length + 1, a >= t) {
      for (let i = l - gn; i <= l + gn || s > a; i++) {
        if (i < 0 || i >= n.length)
          continue;
        const u = i + 1;
        o.push(`${u}${" ".repeat(3 - String(u).length)}|  ${n[i]}`);
        const d = n[i].length;
        if (i === l) {
          const p = t - (a - d) + 1, y = Math.max(1, s > a ? d - p : s - t);
          o.push("   |  " + " ".repeat(p) + "^".repeat(y));
        } else if (i > l) {
          if (s > a) {
            const p = Math.max(Math.min(s - a, d), 1);
            o.push("   |  " + "^".repeat(p));
          }
          a += d + 1;
        }
      }
      break;
    }
  return o.join(`
`);
}
function Ss() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(s, n) {
      const a = e.get(s);
      a && a.push(n) || e.set(s, [n]);
    },
    off(s, n) {
      const a = e.get(s);
      a && a.splice(a.indexOf(n) >>> 0, 1);
    },
    emit(s, n) {
      (e.get(s) || []).slice().map((a) => a(n)), (e.get("*") || []).slice().map((a) => a(s, n));
    }
  };
}
const Jt = (e) => !Te(e) || je(e);
function er(e, t) {
  if (Jt(e) || Jt(t))
    throw new Error("Invalid value");
  const s = [{ src: e, des: t }];
  for (; s.length; ) {
    const { src: n, des: a } = s.pop();
    Object.keys(n).forEach((o) => {
      o !== "__proto__" && (Te(n[o]) && !Te(a[o]) && (a[o] = Array.isArray(n[o]) ? [] : $e()), Jt(a[o]) || Jt(n[o]) ? a[o] = n[o] : s.push({ src: n[o], des: a[o] }));
    });
  }
}
/*!
  * message-compiler v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Ps(e, t, s) {
  return { line: e, column: t, offset: s };
}
function Pr(e, t, s) {
  return { start: e, end: t };
}
const pe = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, $s = 17, Ms = {
  // tokenizer error messages
  [pe.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [pe.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [pe.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [pe.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [pe.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [pe.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [pe.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [pe.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [pe.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [pe.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [pe.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [pe.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [pe.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [pe.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [pe.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [pe.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function wt(e, t, s = {}) {
  const { domain: n, messages: a, args: o } = s, l = process.env.NODE_ENV !== "production" ? ur((a || Ms)[e] || "", ...o || []) : e, i = new SyntaxError(String(l));
  return i.code = e, t && (i.location = t), i.domain = n, i;
}
function As(e) {
  throw e;
}
const ws = /<\/?[\w\s="/.':;#-\/]+>/, ks = (e) => ws.test(e), it = " ", Os = "\r", He = `
`, Rs = "\u2028", Ls = "\u2029";
function xs(e) {
  const t = e;
  let s = 0, n = 1, a = 1, o = 0;
  const l = (T) => t[T] === Os && t[T + 1] === He, i = (T) => t[T] === He, u = (T) => t[T] === Ls, d = (T) => t[T] === Rs, p = (T) => l(T) || i(T) || u(T) || d(T), y = () => s, f = () => n, _ = () => a, b = () => o, g = (T) => l(T) || u(T) || d(T) ? He : t[T], h = () => g(s), v = () => g(s + o);
  function N() {
    return o = 0, p(s) && (n++, a = 0), l(s) && s++, s++, a++, t[s];
  }
  function $() {
    return l(s + o) && o++, o++, t[s + o];
  }
  function S() {
    s = 0, n = 1, a = 1, o = 0;
  }
  function I(T = 0) {
    o = T;
  }
  function C() {
    const T = s + o;
    for (; T !== s; )
      N();
    o = 0;
  }
  return {
    index: y,
    line: f,
    column: _,
    peekOffset: b,
    charAt: g,
    currentChar: h,
    currentPeek: v,
    next: N,
    peek: $,
    reset: S,
    resetPeek: I,
    skipToPeek: C
  };
}
const ct = void 0, Fs = ".", yn = "'", Vs = "tokenizer";
function zs(e, t = {}) {
  const s = t.location !== !1, n = xs(e), a = () => n.index(), o = () => Ps(n.line(), n.column(), n.index()), l = o(), i = a(), u = {
    currentType: 13,
    offset: i,
    startLoc: l,
    endLoc: l,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: l,
    lastEndLoc: l,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => u, { onError: p } = t;
  function y(k, R, K, ...de) {
    const xe = d();
    if (R.column += K, R.offset += K, p) {
      const Fe = s ? Pr(xe.startLoc, R) : null, _e = wt(k, Fe, {
        domain: Vs,
        args: de
      });
      p(_e);
    }
  }
  function f(k, R, K) {
    k.endLoc = o(), k.currentType = R;
    const de = { type: R };
    return s && (de.loc = Pr(k.startLoc, k.endLoc)), K != null && (de.value = K), de;
  }
  const _ = (k) => f(
    k,
    13
    /* TokenTypes.EOF */
  );
  function b(k, R) {
    return k.currentChar() === R ? (k.next(), R) : (y(pe.EXPECTED_TOKEN, o(), 0, R), "");
  }
  function g(k) {
    let R = "";
    for (; k.currentPeek() === it || k.currentPeek() === He; )
      R += k.currentPeek(), k.peek();
    return R;
  }
  function h(k) {
    const R = g(k);
    return k.skipToPeek(), R;
  }
  function v(k) {
    if (k === ct)
      return !1;
    const R = k.charCodeAt(0);
    return R >= 97 && R <= 122 || // a-z
    R >= 65 && R <= 90 || // A-Z
    R === 95;
  }
  function N(k) {
    if (k === ct)
      return !1;
    const R = k.charCodeAt(0);
    return R >= 48 && R <= 57;
  }
  function $(k, R) {
    const { currentType: K } = R;
    if (K !== 2)
      return !1;
    g(k);
    const de = v(k.currentPeek());
    return k.resetPeek(), de;
  }
  function S(k, R) {
    const { currentType: K } = R;
    if (K !== 2)
      return !1;
    g(k);
    const de = k.currentPeek() === "-" ? k.peek() : k.currentPeek(), xe = N(de);
    return k.resetPeek(), xe;
  }
  function I(k, R) {
    const { currentType: K } = R;
    if (K !== 2)
      return !1;
    g(k);
    const de = k.currentPeek() === yn;
    return k.resetPeek(), de;
  }
  function C(k, R) {
    const { currentType: K } = R;
    if (K !== 7)
      return !1;
    g(k);
    const de = k.currentPeek() === ".";
    return k.resetPeek(), de;
  }
  function T(k, R) {
    const { currentType: K } = R;
    if (K !== 8)
      return !1;
    g(k);
    const de = v(k.currentPeek());
    return k.resetPeek(), de;
  }
  function A(k, R) {
    const { currentType: K } = R;
    if (!(K === 7 || K === 11))
      return !1;
    g(k);
    const de = k.currentPeek() === ":";
    return k.resetPeek(), de;
  }
  function M(k, R) {
    const { currentType: K } = R;
    if (K !== 9)
      return !1;
    const de = () => {
      const Fe = k.currentPeek();
      return Fe === "{" ? v(k.peek()) : Fe === "@" || Fe === "|" || Fe === ":" || Fe === "." || Fe === it || !Fe ? !1 : Fe === He ? (k.peek(), de()) : z(k, !1);
    }, xe = de();
    return k.resetPeek(), xe;
  }
  function L(k) {
    g(k);
    const R = k.currentPeek() === "|";
    return k.resetPeek(), R;
  }
  function z(k, R = !0) {
    const K = (xe = !1, Fe = "") => {
      const _e = k.currentPeek();
      return _e === "{" || _e === "@" || !_e ? xe : _e === "|" ? !(Fe === it || Fe === He) : _e === it ? (k.peek(), K(!0, it)) : _e === He ? (k.peek(), K(!0, He)) : !0;
    }, de = K();
    return R && k.resetPeek(), de;
  }
  function O(k, R) {
    const K = k.currentChar();
    return K === ct ? ct : R(K) ? (k.next(), K) : null;
  }
  function H(k) {
    const R = k.charCodeAt(0);
    return R >= 97 && R <= 122 || // a-z
    R >= 65 && R <= 90 || // A-Z
    R >= 48 && R <= 57 || // 0-9
    R === 95 || // _
    R === 36;
  }
  function q(k) {
    return O(k, H);
  }
  function me(k) {
    const R = k.charCodeAt(0);
    return R >= 97 && R <= 122 || // a-z
    R >= 65 && R <= 90 || // A-Z
    R >= 48 && R <= 57 || // 0-9
    R === 95 || // _
    R === 36 || // $
    R === 45;
  }
  function x(k) {
    return O(k, me);
  }
  function ie(k) {
    const R = k.charCodeAt(0);
    return R >= 48 && R <= 57;
  }
  function ne(k) {
    return O(k, ie);
  }
  function J(k) {
    const R = k.charCodeAt(0);
    return R >= 48 && R <= 57 || // 0-9
    R >= 65 && R <= 70 || // A-F
    R >= 97 && R <= 102;
  }
  function j(k) {
    return O(k, J);
  }
  function Y(k) {
    let R = "", K = "";
    for (; R = ne(k); )
      K += R;
    return K;
  }
  function re(k) {
    let R = "";
    for (; ; ) {
      const K = k.currentChar();
      if (K === "{" || K === "}" || K === "@" || K === "|" || !K)
        break;
      if (K === it || K === He)
        if (z(k))
          R += K, k.next();
        else {
          if (L(k))
            break;
          R += K, k.next();
        }
      else
        R += K, k.next();
    }
    return R;
  }
  function fe(k) {
    h(k);
    let R = "", K = "";
    for (; R = x(k); )
      K += R;
    return k.currentChar() === ct && y(pe.UNTERMINATED_CLOSING_BRACE, o(), 0), K;
  }
  function Le(k) {
    h(k);
    let R = "";
    return k.currentChar() === "-" ? (k.next(), R += `-${Y(k)}`) : R += Y(k), k.currentChar() === ct && y(pe.UNTERMINATED_CLOSING_BRACE, o(), 0), R;
  }
  function Q(k) {
    return k !== yn && k !== He;
  }
  function ee(k) {
    h(k), b(k, "'");
    let R = "", K = "";
    for (; R = O(k, Q); )
      R === "\\" ? K += Xe(k) : K += R;
    const de = k.currentChar();
    return de === He || de === ct ? (y(pe.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, o(), 0), de === He && (k.next(), b(k, "'")), K) : (b(k, "'"), K);
  }
  function Xe(k) {
    const R = k.currentChar();
    switch (R) {
      case "\\":
      case "'":
        return k.next(), `\\${R}`;
      case "u":
        return Kt(k, R, 4);
      case "U":
        return Kt(k, R, 6);
      default:
        return y(pe.UNKNOWN_ESCAPE_SEQUENCE, o(), 0, R), "";
    }
  }
  function Kt(k, R, K) {
    b(k, R);
    let de = "";
    for (let xe = 0; xe < K; xe++) {
      const Fe = j(k);
      if (!Fe) {
        y(pe.INVALID_UNICODE_ESCAPE_SEQUENCE, o(), 0, `\\${R}${de}${k.currentChar()}`);
        break;
      }
      de += Fe;
    }
    return `\\${R}${de}`;
  }
  function pr(k) {
    return k !== "{" && k !== "}" && k !== it && k !== He;
  }
  function vr(k) {
    h(k);
    let R = "", K = "";
    for (; R = O(k, pr); )
      K += R;
    return K;
  }
  function gr(k) {
    let R = "", K = "";
    for (; R = q(k); )
      K += R;
    return K;
  }
  function yr(k) {
    const R = (K) => {
      const de = k.currentChar();
      return de === "{" || de === "@" || de === "|" || de === "(" || de === ")" || !de || de === it ? K : (K += de, k.next(), R(K));
    };
    return R("");
  }
  function Ot(k) {
    h(k);
    const R = b(
      k,
      "|"
      /* TokenChars.Pipe */
    );
    return h(k), R;
  }
  function Rt(k, R) {
    let K = null;
    switch (k.currentChar()) {
      case "{":
        return R.braceNest >= 1 && y(pe.NOT_ALLOW_NEST_PLACEHOLDER, o(), 0), k.next(), K = f(
          R,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), h(k), R.braceNest++, K;
      case "}":
        return R.braceNest > 0 && R.currentType === 2 && y(pe.EMPTY_PLACEHOLDER, o(), 0), k.next(), K = f(
          R,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), R.braceNest--, R.braceNest > 0 && h(k), R.inLinked && R.braceNest === 0 && (R.inLinked = !1), K;
      case "@":
        return R.braceNest > 0 && y(pe.UNTERMINATED_CLOSING_BRACE, o(), 0), K = yt(k, R) || _(R), R.braceNest = 0, K;
      default: {
        let xe = !0, Fe = !0, _e = !0;
        if (L(k))
          return R.braceNest > 0 && y(pe.UNTERMINATED_CLOSING_BRACE, o(), 0), K = f(R, 1, Ot(k)), R.braceNest = 0, R.inLinked = !1, K;
        if (R.braceNest > 0 && (R.currentType === 4 || R.currentType === 5 || R.currentType === 6))
          return y(pe.UNTERMINATED_CLOSING_BRACE, o(), 0), R.braceNest = 0, Lt(k, R);
        if (xe = $(k, R))
          return K = f(R, 4, fe(k)), h(k), K;
        if (Fe = S(k, R))
          return K = f(R, 5, Le(k)), h(k), K;
        if (_e = I(k, R))
          return K = f(R, 6, ee(k)), h(k), K;
        if (!xe && !Fe && !_e)
          return K = f(R, 12, vr(k)), y(pe.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, K.value), h(k), K;
        break;
      }
    }
    return K;
  }
  function yt(k, R) {
    const { currentType: K } = R;
    let de = null;
    const xe = k.currentChar();
    switch ((K === 7 || K === 8 || K === 11 || K === 9) && (xe === He || xe === it) && y(pe.INVALID_LINKED_FORMAT, o(), 0), xe) {
      case "@":
        return k.next(), de = f(
          R,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), R.inLinked = !0, de;
      case ".":
        return h(k), k.next(), f(
          R,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return h(k), k.next(), f(
          R,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return L(k) ? (de = f(R, 1, Ot(k)), R.braceNest = 0, R.inLinked = !1, de) : C(k, R) || A(k, R) ? (h(k), yt(k, R)) : T(k, R) ? (h(k), f(R, 11, gr(k))) : M(k, R) ? (h(k), xe === "{" ? Rt(k, R) || de : f(R, 10, yr(k))) : (K === 7 && y(pe.INVALID_LINKED_FORMAT, o(), 0), R.braceNest = 0, R.inLinked = !1, Lt(k, R));
    }
  }
  function Lt(k, R) {
    let K = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (R.braceNest > 0)
      return Rt(k, R) || _(R);
    if (R.inLinked)
      return yt(k, R) || _(R);
    switch (k.currentChar()) {
      case "{":
        return Rt(k, R) || _(R);
      case "}":
        return y(pe.UNBALANCED_CLOSING_BRACE, o(), 0), k.next(), f(
          R,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return yt(k, R) || _(R);
      default: {
        if (L(k))
          return K = f(R, 1, Ot(k)), R.braceNest = 0, R.inLinked = !1, K;
        if (z(k))
          return f(R, 0, re(k));
        break;
      }
    }
    return K;
  }
  function br() {
    const { currentType: k, offset: R, startLoc: K, endLoc: de } = u;
    return u.lastType = k, u.lastOffset = R, u.lastStartLoc = K, u.lastEndLoc = de, u.offset = a(), u.startLoc = o(), n.currentChar() === ct ? f(
      u,
      13
      /* TokenTypes.EOF */
    ) : Lt(n, u);
  }
  return {
    nextToken: br,
    currentOffset: a,
    currentPosition: o,
    context: d
  };
}
const js = "parser", Us = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Gs(e, t, s) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const n = parseInt(t || s, 16);
      return n <= 55295 || n >= 57344 ? String.fromCodePoint(n) : "�";
    }
  }
}
function Bs(e = {}) {
  const t = e.location !== !1, { onError: s } = e;
  function n(v, N, $, S, ...I) {
    const C = v.currentPosition();
    if (C.offset += S, C.column += S, s) {
      const T = t ? Pr($, C) : null, A = wt(N, T, {
        domain: js,
        args: I
      });
      s(A);
    }
  }
  function a(v, N, $) {
    const S = { type: v };
    return t && (S.start = N, S.end = N, S.loc = { start: $, end: $ }), S;
  }
  function o(v, N, $, S) {
    t && (v.end = N, v.loc && (v.loc.end = $));
  }
  function l(v, N) {
    const $ = v.context(), S = a(3, $.offset, $.startLoc);
    return S.value = N, o(S, v.currentOffset(), v.currentPosition()), S;
  }
  function i(v, N) {
    const $ = v.context(), { lastOffset: S, lastStartLoc: I } = $, C = a(5, S, I);
    return C.index = parseInt(N, 10), v.nextToken(), o(C, v.currentOffset(), v.currentPosition()), C;
  }
  function u(v, N) {
    const $ = v.context(), { lastOffset: S, lastStartLoc: I } = $, C = a(4, S, I);
    return C.key = N, v.nextToken(), o(C, v.currentOffset(), v.currentPosition()), C;
  }
  function d(v, N) {
    const $ = v.context(), { lastOffset: S, lastStartLoc: I } = $, C = a(9, S, I);
    return C.value = N.replace(Us, Gs), v.nextToken(), o(C, v.currentOffset(), v.currentPosition()), C;
  }
  function p(v) {
    const N = v.nextToken(), $ = v.context(), { lastOffset: S, lastStartLoc: I } = $, C = a(8, S, I);
    return N.type !== 11 ? (n(v, pe.UNEXPECTED_EMPTY_LINKED_MODIFIER, $.lastStartLoc, 0), C.value = "", o(C, S, I), {
      nextConsumeToken: N,
      node: C
    }) : (N.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, ot(N)), C.value = N.value || "", o(C, v.currentOffset(), v.currentPosition()), {
      node: C
    });
  }
  function y(v, N) {
    const $ = v.context(), S = a(7, $.offset, $.startLoc);
    return S.value = N, o(S, v.currentOffset(), v.currentPosition()), S;
  }
  function f(v) {
    const N = v.context(), $ = a(6, N.offset, N.startLoc);
    let S = v.nextToken();
    if (S.type === 8) {
      const I = p(v);
      $.modifier = I.node, S = I.nextConsumeToken || v.nextToken();
    }
    switch (S.type !== 9 && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(S)), S = v.nextToken(), S.type === 2 && (S = v.nextToken()), S.type) {
      case 10:
        S.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(S)), $.key = y(v, S.value || "");
        break;
      case 4:
        S.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(S)), $.key = u(v, S.value || "");
        break;
      case 5:
        S.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(S)), $.key = i(v, S.value || "");
        break;
      case 6:
        S.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(S)), $.key = d(v, S.value || "");
        break;
      default: {
        n(v, pe.UNEXPECTED_EMPTY_LINKED_KEY, N.lastStartLoc, 0);
        const I = v.context(), C = a(7, I.offset, I.startLoc);
        return C.value = "", o(C, I.offset, I.startLoc), $.key = C, o($, I.offset, I.startLoc), {
          nextConsumeToken: S,
          node: $
        };
      }
    }
    return o($, v.currentOffset(), v.currentPosition()), {
      node: $
    };
  }
  function _(v) {
    const N = v.context(), $ = N.currentType === 1 ? v.currentOffset() : N.offset, S = N.currentType === 1 ? N.endLoc : N.startLoc, I = a(2, $, S);
    I.items = [];
    let C = null;
    do {
      const M = C || v.nextToken();
      switch (C = null, M.type) {
        case 0:
          M.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(M)), I.items.push(l(v, M.value || ""));
          break;
        case 5:
          M.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(M)), I.items.push(i(v, M.value || ""));
          break;
        case 4:
          M.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(M)), I.items.push(u(v, M.value || ""));
          break;
        case 6:
          M.value == null && n(v, pe.UNEXPECTED_LEXICAL_ANALYSIS, N.lastStartLoc, 0, ot(M)), I.items.push(d(v, M.value || ""));
          break;
        case 7: {
          const L = f(v);
          I.items.push(L.node), C = L.nextConsumeToken || null;
          break;
        }
      }
    } while (N.currentType !== 13 && N.currentType !== 1);
    const T = N.currentType === 1 ? N.lastOffset : v.currentOffset(), A = N.currentType === 1 ? N.lastEndLoc : v.currentPosition();
    return o(I, T, A), I;
  }
  function b(v, N, $, S) {
    const I = v.context();
    let C = S.items.length === 0;
    const T = a(1, N, $);
    T.cases = [], T.cases.push(S);
    do {
      const A = _(v);
      C || (C = A.items.length === 0), T.cases.push(A);
    } while (I.currentType !== 13);
    return C && n(v, pe.MUST_HAVE_MESSAGES_IN_PLURAL, $, 0), o(T, v.currentOffset(), v.currentPosition()), T;
  }
  function g(v) {
    const N = v.context(), { offset: $, startLoc: S } = N, I = _(v);
    return N.currentType === 13 ? I : b(v, $, S, I);
  }
  function h(v) {
    const N = zs(v, Ge({}, e)), $ = N.context(), S = a(0, $.offset, $.startLoc);
    return t && S.loc && (S.loc.source = v), S.body = g(N), e.onCacheKey && (S.cacheKey = e.onCacheKey(v)), $.currentType !== 13 && n(N, pe.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, v[$.offset] || ""), o(S, N.currentOffset(), N.currentPosition()), S;
  }
  return { parse: h };
}
function ot(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Ws(e, t = {}) {
  const s = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => s, helper: (o) => (s.helpers.add(o), o) };
}
function bn(e, t) {
  for (let s = 0; s < e.length; s++)
    Zr(e[s], t);
}
function Zr(e, t) {
  switch (e.type) {
    case 1:
      bn(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      bn(e.items, t);
      break;
    case 6: {
      Zr(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Ys(e, t = {}) {
  const s = Ws(e);
  s.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Zr(e.body, s);
  const n = s.context();
  e.helpers = Array.from(n.helpers);
}
function qs(e) {
  const t = e.body;
  return t.type === 2 ? Cn(t) : t.cases.forEach((s) => Cn(s)), e;
}
function Cn(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let s = 0; s < e.items.length; s++) {
      const n = e.items[s];
      if (!(n.type === 3 || n.type === 9) || n.value == null)
        break;
      t.push(n.value);
    }
    if (t.length === e.items.length) {
      e.static = Kr(t);
      for (let s = 0; s < e.items.length; s++) {
        const n = e.items[s];
        (n.type === 3 || n.type === 9) && delete n.value;
      }
    }
  }
}
const Hs = "minifier";
function Mt(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Mt(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, s = t.cases;
      for (let n = 0; n < s.length; n++)
        Mt(s[n]);
      t.c = s, delete t.cases;
      break;
    }
    case 2: {
      const t = e, s = t.items;
      for (let n = 0; n < s.length; n++)
        Mt(s[n]);
      t.i = s, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Mt(t.key), t.k = t.key, delete t.key, t.modifier && (Mt(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw wt(pe.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Hs,
          args: [e.type]
        });
  }
  delete e.type;
}
const Qs = "parser";
function Ks(e, t) {
  const { filename: s, breakLineCode: n, needIndent: a } = t, o = t.location !== !1, l = {
    filename: s,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: n,
    needIndent: a,
    indentLevel: 0
  };
  o && e.loc && (l.source = e.loc.source);
  const i = () => l;
  function u(g, h) {
    l.code += g;
  }
  function d(g, h = !0) {
    const v = h ? n : "";
    u(a ? v + "  ".repeat(g) : v);
  }
  function p(g = !0) {
    const h = ++l.indentLevel;
    g && d(h);
  }
  function y(g = !0) {
    const h = --l.indentLevel;
    g && d(h);
  }
  function f() {
    d(l.indentLevel);
  }
  return {
    context: i,
    push: u,
    indent: p,
    deindent: y,
    newline: f,
    helper: (g) => `_${g}`,
    needIndent: () => l.needIndent
  };
}
function Zs(e, t) {
  const { helper: s } = e;
  e.push(`${s(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), At(e, t.key), t.modifier ? (e.push(", "), At(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Js(e, t) {
  const { helper: s, needIndent: n } = e;
  e.push(`${s(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(n());
  const a = t.items.length;
  for (let o = 0; o < a && (At(e, t.items[o]), o !== a - 1); o++)
    e.push(", ");
  e.deindent(n()), e.push("])");
}
function Xs(e, t) {
  const { helper: s, needIndent: n } = e;
  if (t.cases.length > 1) {
    e.push(`${s(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(n());
    const a = t.cases.length;
    for (let o = 0; o < a && (At(e, t.cases[o]), o !== a - 1); o++)
      e.push(", ");
    e.deindent(n()), e.push("])");
  }
}
function Ds(e, t) {
  t.body ? At(e, t.body) : e.push("null");
}
function At(e, t) {
  const { helper: s } = e;
  switch (t.type) {
    case 0:
      Ds(e, t);
      break;
    case 1:
      Xs(e, t);
      break;
    case 2:
      Js(e, t);
      break;
    case 6:
      Zs(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${s(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${s(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${s(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${s(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw wt(pe.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Qs,
          args: [t.type]
        });
  }
}
const ei = (e, t = {}) => {
  const s = le(t.mode) ? t.mode : "normal", n = le(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const a = t.breakLineCode != null ? t.breakLineCode : s === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : s !== "arrow", l = e.helpers || [], i = Ks(e, {
    filename: n,
    breakLineCode: a,
    needIndent: o
  });
  i.push(s === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(o), l.length > 0 && (i.push(`const { ${Kr(l.map((p) => `${p}: _${p}`), ", ")} } = ctx`), i.newline()), i.push("return "), At(i, e), i.deindent(o), i.push("}"), delete e.helpers;
  const { code: u, map: d } = i.context();
  return {
    ast: e,
    code: u,
    map: d ? d.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function ti(e, t = {}) {
  const s = Ge({}, t), n = !!s.jit, a = !!s.minify, o = s.optimize == null ? !0 : s.optimize, i = Bs(s).parse(e);
  return n ? (o && qs(i), a && Mt(i), { ast: i, code: "" }) : (Ys(i, s), ei(i, s));
}
/*!
  * core-base v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function ri() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (It().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (It().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function nt(e) {
  return Te(e) && Jr(e) === 0 && (rt(e, "b") || rt(e, "body"));
}
const vo = ["b", "body"];
function ni(e) {
  return ft(e, vo);
}
const go = ["c", "cases"];
function oi(e) {
  return ft(e, go, []);
}
const yo = ["s", "static"];
function si(e) {
  return ft(e, yo);
}
const bo = ["i", "items"];
function ii(e) {
  return ft(e, bo, []);
}
const Co = ["t", "type"];
function Jr(e) {
  return ft(e, Co);
}
const Io = ["v", "value"];
function Xt(e, t) {
  const s = ft(e, Io);
  if (s != null)
    return s;
  throw Ut(t);
}
const _o = ["m", "modifier"];
function li(e) {
  return ft(e, _o);
}
const ho = ["k", "key"];
function ai(e) {
  const t = ft(e, ho);
  if (t)
    return t;
  throw Ut(
    6
    /* NodeTypes.Linked */
  );
}
function ft(e, t, s) {
  for (let n = 0; n < t.length; n++) {
    const a = t[n];
    if (rt(e, a) && e[a] != null)
      return e[a];
  }
  return s;
}
const To = [
  ...vo,
  ...go,
  ...yo,
  ...bo,
  ...ho,
  ..._o,
  ...Io,
  ...Co
];
function Ut(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Cr(e) {
  return (s) => ui(s, e);
}
function ui(e, t) {
  const s = ni(t);
  if (s == null)
    throw Ut(
      0
      /* NodeTypes.Resource */
    );
  if (Jr(s) === 1) {
    const o = oi(s);
    return e.plural(o.reduce((l, i) => [
      ...l,
      In(e, i)
    ], []));
  } else
    return In(e, s);
}
function In(e, t) {
  const s = si(t);
  if (s != null)
    return e.type === "text" ? s : e.normalize([s]);
  {
    const n = ii(t).reduce((a, o) => [...a, $r(e, o)], []);
    return e.normalize(n);
  }
}
function $r(e, t) {
  const s = Jr(t);
  switch (s) {
    case 3:
      return Xt(t, s);
    case 9:
      return Xt(t, s);
    case 4: {
      const n = t;
      if (rt(n, "k") && n.k)
        return e.interpolate(e.named(n.k));
      if (rt(n, "key") && n.key)
        return e.interpolate(e.named(n.key));
      throw Ut(s);
    }
    case 5: {
      const n = t;
      if (rt(n, "i") && Ue(n.i))
        return e.interpolate(e.list(n.i));
      if (rt(n, "index") && Ue(n.index))
        return e.interpolate(e.list(n.index));
      throw Ut(s);
    }
    case 6: {
      const n = t, a = li(n), o = ai(n);
      return e.linked($r(e, o), a ? $r(e, a) : void 0, e.type);
    }
    case 7:
      return Xt(t, s);
    case 8:
      return Xt(t, s);
    default:
      throw new Error(`unhandled node on format message part: ${s}`);
  }
}
const di = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function ci(e, t) {
  t && ks(e) && ut(ur(di, { source: e }));
}
const mi = (e) => e;
let Dt = $e();
function fi(e, t = {}) {
  let s = !1;
  const n = t.onError || As;
  return t.onError = (a) => {
    s = !0, n(a);
  }, { ...ti(e, t), detectError: s };
}
// @__NO_SIDE_EFFECTS__
function pi(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && le(e)) {
    const s = ze(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && ci(e, s);
    const a = (t.onCacheKey || mi)(e), o = Dt[a];
    if (o)
      return o;
    const { ast: l, detectError: i } = fi(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), u = Cr(l);
    return i ? u : Dt[a] = u;
  } else {
    if (process.env.NODE_ENV !== "production" && !nt(e))
      return ut(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const s = e.cacheKey;
    if (s) {
      const n = Dt[s];
      return n || (Dt[s] = Cr(e));
    } else
      return Cr(e);
  }
}
let Gt = null;
function vi(e) {
  Gt = e;
}
function gi(e, t, s) {
  Gt && Gt.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: s
  });
}
const yi = /* @__PURE__ */ bi("function:translate");
function bi(e) {
  return (t) => Gt && Gt.emit(e, t);
}
const Ye = {
  INVALID_ARGUMENT: $s,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, Ci = 24;
function lt(e) {
  return wt(e, null, process.env.NODE_ENV !== "production" ? { messages: Ii } : void 0);
}
const Ii = {
  [Ye.INVALID_ARGUMENT]: "Invalid arguments",
  [Ye.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Ye.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Ye.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Ye.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Ye.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Ye.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Xr(e, t) {
  return t.locale != null ? _n(t.locale) : _n(e.locale);
}
let Ir;
function _n(e) {
  if (le(e))
    return e;
  if (Re(e)) {
    if (e.resolvedOnce && Ir != null)
      return Ir;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Ts(t))
        throw lt(Ye.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Ir = t;
    } else
      throw lt(Ye.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw lt(Ye.NOT_SUPPORT_LOCALE_TYPE);
}
function _i(e, t, s) {
  return [.../* @__PURE__ */ new Set([
    s,
    ...je(t) ? t : Te(t) ? Object.keys(t) : le(t) ? [t] : [s]
  ])];
}
function Eo(e, t, s) {
  const n = le(s) ? s : or, a = e;
  a.__localeChainCache || (a.__localeChainCache = /* @__PURE__ */ new Map());
  let o = a.__localeChainCache.get(n);
  if (!o) {
    o = [];
    let l = [s];
    for (; je(l); )
      l = hn(o, l, t);
    const i = je(t) || !he(t) ? t : t.default ? t.default : null;
    l = le(i) ? [i] : i, je(l) && hn(o, l, !1), a.__localeChainCache.set(n, o);
  }
  return o;
}
function hn(e, t, s) {
  let n = !0;
  for (let a = 0; a < t.length && ze(n); a++) {
    const o = t[a];
    le(o) && (n = hi(e, t[a], s));
  }
  return n;
}
function hi(e, t, s) {
  let n;
  const a = t.split("-");
  do {
    const o = a.join("-");
    n = Ti(e, o, s), a.splice(-1, 1);
  } while (a.length && n === !0);
  return n;
}
function Ti(e, t, s) {
  let n = !1;
  if (!e.includes(t) && (n = !0, t)) {
    n = t[t.length - 1] !== "!";
    const a = t.replace(/!/g, "");
    e.push(a), (je(s) || he(s)) && s[a] && (n = s[a]);
  }
  return n;
}
const pt = [];
pt[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pt[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pt[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
pt[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
pt[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
pt[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
pt[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Ei = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Ni(e) {
  return Ei.test(e);
}
function Si(e) {
  const t = e.charCodeAt(0), s = e.charCodeAt(e.length - 1);
  return t === s && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Pi(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function $i(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Ni(t) ? Si(t) : "*" + t;
}
function Mi(e) {
  const t = [];
  let s = -1, n = 0, a = 0, o, l, i, u, d, p, y;
  const f = [];
  f[
    0
    /* Actions.APPEND */
  ] = () => {
    l === void 0 ? l = i : l += i;
  }, f[
    1
    /* Actions.PUSH */
  ] = () => {
    l !== void 0 && (t.push(l), l = void 0);
  }, f[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    f[
      0
      /* Actions.APPEND */
    ](), a++;
  }, f[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (a > 0)
      a--, n = 4, f[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (a = 0, l === void 0 || (l = $i(l), l === !1))
        return !1;
      f[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function _() {
    const b = e[s + 1];
    if (n === 5 && b === "'" || n === 6 && b === '"')
      return s++, i = "\\" + b, f[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; n !== null; )
    if (s++, o = e[s], !(o === "\\" && _())) {
      if (u = Pi(o), y = pt[n], d = y[u] || y.l || 8, d === 8 || (n = d[0], d[1] !== void 0 && (p = f[d[1]], p && (i = o, p() === !1))))
        return;
      if (n === 7)
        return t;
    }
}
const Tn = /* @__PURE__ */ new Map();
function Ai(e, t) {
  return Te(e) ? e[t] : null;
}
function wi(e, t) {
  if (!Te(e))
    return null;
  let s = Tn.get(t);
  if (s || (s = Mi(t), s && Tn.set(t, s)), !s)
    return null;
  const n = s.length;
  let a = e, o = 0;
  for (; o < n; ) {
    const l = s[o];
    if (To.includes(l) && nt(a))
      return null;
    const i = a[l];
    if (i === void 0 || Re(a))
      return null;
    a = i, o++;
  }
  return a;
}
const Qe = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, ki = 8, Oi = {
  [Qe.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Qe.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Qe.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Qe.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Qe.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Qe.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Qe.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Et(e, ...t) {
  return ur(Oi[e], ...t);
}
const Ri = "10.0.8", cr = -1, or = "en-US", sr = "", En = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Li() {
  return {
    upper: (e, t) => t === "text" && le(e) ? e.toUpperCase() : t === "vnode" && Te(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && le(e) ? e.toLowerCase() : t === "vnode" && Te(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && le(e) ? En(e) : t === "vnode" && Te(e) && "__v_isVNode" in e ? En(e.children) : e
  };
}
let No;
function xi(e) {
  No = e;
}
let So;
function Fi(e) {
  So = e;
}
let Po;
function Vi(e) {
  Po = e;
}
let $o = null;
const zi = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  $o = e;
}, ji = /* @__NO_SIDE_EFFECTS__ */ () => $o;
let Mo = null;
const Nn = (e) => {
  Mo = e;
}, Ui = () => Mo;
let Sn = 0;
function Gi(e = {}) {
  const t = Re(e.onWarn) ? e.onWarn : ut, s = le(e.version) ? e.version : Ri, n = le(e.locale) || Re(e.locale) ? e.locale : or, a = Re(n) ? or : n, o = je(e.fallbackLocale) || he(e.fallbackLocale) || le(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : a, l = he(e.messages) ? e.messages : _r(a), i = he(e.datetimeFormats) ? e.datetimeFormats : _r(a), u = he(e.numberFormats) ? e.numberFormats : _r(a), d = Ge($e(), e.modifiers, Li()), p = e.pluralRules || $e(), y = Re(e.missing) ? e.missing : null, f = ze(e.missingWarn) || nr(e.missingWarn) ? e.missingWarn : !0, _ = ze(e.fallbackWarn) || nr(e.fallbackWarn) ? e.fallbackWarn : !0, b = !!e.fallbackFormat, g = !!e.unresolving, h = Re(e.postTranslation) ? e.postTranslation : null, v = he(e.processor) ? e.processor : null, N = ze(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, $ = !!e.escapeParameter, S = Re(e.messageCompiler) ? e.messageCompiler : No;
  process.env.NODE_ENV !== "production" && Re(e.messageCompiler) && vs(Et(Qe.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const I = Re(e.messageResolver) ? e.messageResolver : So || Ai, C = Re(e.localeFallbacker) ? e.localeFallbacker : Po || _i, T = Te(e.fallbackContext) ? e.fallbackContext : void 0, A = e, M = Te(A.__datetimeFormatters) ? A.__datetimeFormatters : /* @__PURE__ */ new Map(), L = Te(A.__numberFormatters) ? A.__numberFormatters : /* @__PURE__ */ new Map(), z = Te(A.__meta) ? A.__meta : {};
  Sn++;
  const O = {
    version: s,
    cid: Sn,
    locale: n,
    fallbackLocale: o,
    messages: l,
    modifiers: d,
    pluralRules: p,
    missing: y,
    missingWarn: f,
    fallbackWarn: _,
    fallbackFormat: b,
    unresolving: g,
    postTranslation: h,
    processor: v,
    warnHtmlMessage: N,
    escapeParameter: $,
    messageCompiler: S,
    messageResolver: I,
    localeFallbacker: C,
    fallbackContext: T,
    onWarn: t,
    __meta: z
  };
  return O.datetimeFormats = i, O.numberFormats = u, O.__datetimeFormatters = M, O.__numberFormatters = L, process.env.NODE_ENV !== "production" && (O.__v_emitter = A.__v_emitter != null ? A.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && gi(O, s, z), O;
}
const _r = (e) => ({ [e]: $e() });
function mr(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Ao(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Dr(e, t, s, n, a) {
  const { missing: o, onWarn: l } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: s,
      key: t,
      type: a,
      groupId: `${a}:${t}`
    });
  }
  if (o !== null) {
    const i = o(e, s, t, a);
    return le(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Ao(n, t) && l(Et(Qe.NOT_FOUND_KEY, { key: t, locale: s })), t;
}
function xt(e, t, s) {
  const n = e;
  n.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, s, t);
}
function wo(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Bi(e, t) {
  const s = t.indexOf(e);
  if (s === -1)
    return !1;
  for (let n = s + 1; n < t.length; n++)
    if (wo(e, t[n]))
      return !0;
  return !1;
}
const Pn = typeof Intl < "u", ko = {
  dateTimeFormat: Pn && typeof Intl.DateTimeFormat < "u",
  numberFormat: Pn && typeof Intl.NumberFormat < "u"
};
function $n(e, ...t) {
  const { datetimeFormats: s, unresolving: n, fallbackLocale: a, onWarn: o, localeFallbacker: l } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ko.dateTimeFormat)
    return o(Et(Qe.CANNOT_FORMAT_DATE)), sr;
  const [u, d, p, y] = Mr(...t), f = ze(p.missingWarn) ? p.missingWarn : e.missingWarn, _ = ze(p.fallbackWarn) ? p.fallbackWarn : e.fallbackWarn, b = !!p.part, g = Xr(e, p), h = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    g
  );
  if (!le(u) || u === "")
    return new Intl.DateTimeFormat(g, y).format(d);
  let v = {}, N, $ = null, S = g, I = null;
  const C = "datetime format";
  for (let M = 0; M < h.length; M++) {
    if (N = I = h[M], process.env.NODE_ENV !== "production" && g !== N && mr(_, u) && o(Et(Qe.FALLBACK_TO_DATE_FORMAT, {
      key: u,
      target: N
    })), process.env.NODE_ENV !== "production" && g !== N) {
      const L = e.__v_emitter;
      L && L.emit("fallback", {
        type: C,
        key: u,
        from: S,
        to: I,
        groupId: `${C}:${u}`
      });
    }
    if (v = s[N] || {}, $ = v[u], he($))
      break;
    Dr(e, u, N, f, C), S = I;
  }
  if (!he($) || !le(N))
    return n ? cr : u;
  let T = `${N}__${u}`;
  dr(y) || (T = `${T}__${JSON.stringify(y)}`);
  let A = i.get(T);
  return A || (A = new Intl.DateTimeFormat(N, Ge({}, $, y)), i.set(T, A)), b ? A.formatToParts(d) : A.format(d);
}
const Oo = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Mr(...e) {
  const [t, s, n, a] = e, o = $e();
  let l = $e(), i;
  if (le(t)) {
    const u = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!u)
      throw lt(Ye.INVALID_ISO_DATE_ARGUMENT);
    const d = u[3] ? u[3].trim().startsWith("T") ? `${u[1].trim()}${u[3].trim()}` : `${u[1].trim()}T${u[3].trim()}` : u[1].trim();
    i = new Date(d);
    try {
      i.toISOString();
    } catch {
      throw lt(Ye.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Cs(t)) {
    if (isNaN(t.getTime()))
      throw lt(Ye.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (Ue(t))
    i = t;
  else
    throw lt(Ye.INVALID_ARGUMENT);
  return le(s) ? o.key = s : he(s) && Object.keys(s).forEach((u) => {
    Oo.includes(u) ? l[u] = s[u] : o[u] = s[u];
  }), le(n) ? o.locale = n : he(n) && (l = n), he(a) && (l = a), [o.key || "", i, o, l];
}
function Mn(e, t, s) {
  const n = e;
  for (const a in s) {
    const o = `${t}__${a}`;
    n.__datetimeFormatters.has(o) && n.__datetimeFormatters.delete(o);
  }
}
function An(e, ...t) {
  const { numberFormats: s, unresolving: n, fallbackLocale: a, onWarn: o, localeFallbacker: l } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ko.numberFormat)
    return o(Et(Qe.CANNOT_FORMAT_NUMBER)), sr;
  const [u, d, p, y] = Ar(...t), f = ze(p.missingWarn) ? p.missingWarn : e.missingWarn, _ = ze(p.fallbackWarn) ? p.fallbackWarn : e.fallbackWarn, b = !!p.part, g = Xr(e, p), h = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    g
  );
  if (!le(u) || u === "")
    return new Intl.NumberFormat(g, y).format(d);
  let v = {}, N, $ = null, S = g, I = null;
  const C = "number format";
  for (let M = 0; M < h.length; M++) {
    if (N = I = h[M], process.env.NODE_ENV !== "production" && g !== N && mr(_, u) && o(Et(Qe.FALLBACK_TO_NUMBER_FORMAT, {
      key: u,
      target: N
    })), process.env.NODE_ENV !== "production" && g !== N) {
      const L = e.__v_emitter;
      L && L.emit("fallback", {
        type: C,
        key: u,
        from: S,
        to: I,
        groupId: `${C}:${u}`
      });
    }
    if (v = s[N] || {}, $ = v[u], he($))
      break;
    Dr(e, u, N, f, C), S = I;
  }
  if (!he($) || !le(N))
    return n ? cr : u;
  let T = `${N}__${u}`;
  dr(y) || (T = `${T}__${JSON.stringify(y)}`);
  let A = i.get(T);
  return A || (A = new Intl.NumberFormat(N, Ge({}, $, y)), i.set(T, A)), b ? A.formatToParts(d) : A.format(d);
}
const Ro = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Ar(...e) {
  const [t, s, n, a] = e, o = $e();
  let l = $e();
  if (!Ue(t))
    throw lt(Ye.INVALID_ARGUMENT);
  const i = t;
  return le(s) ? o.key = s : he(s) && Object.keys(s).forEach((u) => {
    Ro.includes(u) ? l[u] = s[u] : o[u] = s[u];
  }), le(n) ? o.locale = n : he(n) && (l = n), he(a) && (l = a), [o.key || "", i, o, l];
}
function wn(e, t, s) {
  const n = e;
  for (const a in s) {
    const o = `${t}__${a}`;
    n.__numberFormatters.has(o) && n.__numberFormatters.delete(o);
  }
}
const Wi = (e) => e, Yi = (e) => "", qi = "text", Hi = (e) => e.length === 0 ? "" : Kr(e), Qi = Es;
function kn(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Ki(e) {
  const t = Ue(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Ue(e.named.count) || Ue(e.named.n)) ? Ue(e.named.count) ? e.named.count : Ue(e.named.n) ? e.named.n : t : t;
}
function Zi(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Ji(e = {}) {
  const t = e.locale, s = Ki(e), n = Te(e.pluralRules) && le(t) && Re(e.pluralRules[t]) ? e.pluralRules[t] : kn, a = Te(e.pluralRules) && le(t) && Re(e.pluralRules[t]) ? kn : void 0, o = (v) => v[n(s, v.length, a)], l = e.list || [], i = (v) => l[v], u = e.named || $e();
  Ue(e.pluralIndex) && Zi(s, u);
  const d = (v) => u[v];
  function p(v, N) {
    const $ = Re(e.messages) ? e.messages(v, !!N) : Te(e.messages) ? e.messages[v] : !1;
    return $ || (e.parent ? e.parent.message(v) : Yi);
  }
  const y = (v) => e.modifiers ? e.modifiers[v] : Wi, f = he(e.processor) && Re(e.processor.normalize) ? e.processor.normalize : Hi, _ = he(e.processor) && Re(e.processor.interpolate) ? e.processor.interpolate : Qi, b = he(e.processor) && le(e.processor.type) ? e.processor.type : qi, h = {
    list: i,
    named: d,
    plural: o,
    linked: (v, ...N) => {
      const [$, S] = N;
      let I = "text", C = "";
      N.length === 1 ? Te($) ? (C = $.modifier || C, I = $.type || I) : le($) && (C = $ || C) : N.length === 2 && (le($) && (C = $ || C), le(S) && (I = S || I));
      const T = p(v, !0)(h), A = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        I === "vnode" && je(T) && C ? T[0] : T
      );
      return C ? y(C)(A, I) : A;
    },
    message: p,
    type: b,
    interpolate: _,
    normalize: f,
    values: Ge($e(), l, u)
  };
  return h;
}
const On = () => "", Je = (e) => Re(e);
function Rn(e, ...t) {
  const { fallbackFormat: s, postTranslation: n, unresolving: a, messageCompiler: o, fallbackLocale: l, messages: i } = e, [u, d] = wr(...t), p = ze(d.missingWarn) ? d.missingWarn : e.missingWarn, y = ze(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, f = ze(d.escapeParameter) ? d.escapeParameter : e.escapeParameter, _ = !!d.resolvedMessage, b = le(d.default) || ze(d.default) ? ze(d.default) ? o ? u : () => u : d.default : s ? o ? u : () => u : null, g = s || b != null && (le(b) || Re(b)), h = Xr(e, d);
  f && Xi(d);
  let [v, N, $] = _ ? [
    u,
    h,
    i[h] || $e()
  ] : Lo(e, u, h, l, y, p), S = v, I = u;
  if (!_ && !(le(S) || nt(S) || Je(S)) && g && (S = b, I = S), !_ && (!(le(S) || nt(S) || Je(S)) || !le(N)))
    return a ? cr : u;
  if (process.env.NODE_ENV !== "production" && le(S) && e.messageCompiler == null)
    return ut(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${u}'.`), u;
  let C = !1;
  const T = () => {
    C = !0;
  }, A = Je(S) ? S : xo(e, u, N, S, I, T);
  if (C)
    return S;
  const M = rl(e, N, $, d), L = Ji(M), z = Di(e, A, L);
  let O = n ? n(z, u) : z;
  if (f && le(O) && (O = _s(O)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const H = {
      timestamp: Date.now(),
      key: le(u) ? u : Je(S) ? S.key : "",
      locale: N || (Je(S) ? S.locale : ""),
      format: le(S) ? S : Je(S) ? S.source : "",
      message: O
    };
    H.meta = Ge({}, e.__meta, /* @__PURE__ */ ji() || {}), yi(H);
  }
  return O;
}
function Xi(e) {
  je(e.list) ? e.list = e.list.map((t) => le(t) ? pn(t) : t) : Te(e.named) && Object.keys(e.named).forEach((t) => {
    le(e.named[t]) && (e.named[t] = pn(e.named[t]));
  });
}
function Lo(e, t, s, n, a, o) {
  const { messages: l, onWarn: i, messageResolver: u, localeFallbacker: d } = e, p = d(e, n, s);
  let y = $e(), f, _ = null, b = s, g = null;
  const h = "translate";
  for (let v = 0; v < p.length; v++) {
    if (f = g = p[v], process.env.NODE_ENV !== "production" && s !== f && !wo(s, f) && mr(a, t) && i(Et(Qe.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: f
    })), process.env.NODE_ENV !== "production" && s !== f) {
      const I = e.__v_emitter;
      I && I.emit("fallback", {
        type: h,
        key: t,
        from: b,
        to: g,
        groupId: `${h}:${t}`
      });
    }
    y = l[f] || $e();
    let N = null, $, S;
    if (process.env.NODE_ENV !== "production" && at && (N = window.performance.now(), $ = "intlify-message-resolve-start", S = "intlify-message-resolve-end", Ze && Ze($)), (_ = u(y, t)) === null && (_ = y[t]), process.env.NODE_ENV !== "production" && at) {
      const I = window.performance.now(), C = e.__v_emitter;
      C && N && _ && C.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: _,
        time: I - N,
        groupId: `${h}:${t}`
      }), $ && S && Ze && Tt && (Ze(S), Tt("intlify message resolve", $, S));
    }
    if (le(_) || nt(_) || Je(_))
      break;
    if (!Bi(f, p)) {
      const I = Dr(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        f,
        o,
        h
      );
      I !== t && (_ = I);
    }
    b = g;
  }
  return [_, f, y];
}
function xo(e, t, s, n, a, o) {
  const { messageCompiler: l, warnHtmlMessage: i } = e;
  if (Je(n)) {
    const f = n;
    return f.locale = f.locale || s, f.key = f.key || t, f;
  }
  if (l == null) {
    const f = () => n;
    return f.locale = s, f.key = t, f;
  }
  let u = null, d, p;
  process.env.NODE_ENV !== "production" && at && (u = window.performance.now(), d = "intlify-message-compilation-start", p = "intlify-message-compilation-end", Ze && Ze(d));
  const y = l(n, el(e, s, a, n, i, o));
  if (process.env.NODE_ENV !== "production" && at) {
    const f = window.performance.now(), _ = e.__v_emitter;
    _ && u && _.emit("message-compilation", {
      type: "message-compilation",
      message: n,
      time: f - u,
      groupId: `translate:${t}`
    }), d && p && Ze && Tt && (Ze(p), Tt("intlify message compilation", d, p));
  }
  return y.locale = s, y.key = t, y.source = n, y;
}
function Di(e, t, s) {
  let n = null, a, o;
  process.env.NODE_ENV !== "production" && at && (n = window.performance.now(), a = "intlify-message-evaluation-start", o = "intlify-message-evaluation-end", Ze && Ze(a));
  const l = t(s);
  if (process.env.NODE_ENV !== "production" && at) {
    const i = window.performance.now(), u = e.__v_emitter;
    u && n && u.emit("message-evaluation", {
      type: "message-evaluation",
      value: l,
      time: i - n,
      groupId: `translate:${t.key}`
    }), a && o && Ze && Tt && (Ze(o), Tt("intlify message evaluation", a, o));
  }
  return l;
}
function wr(...e) {
  const [t, s, n] = e, a = $e();
  if (!le(t) && !Ue(t) && !Je(t) && !nt(t))
    throw lt(Ye.INVALID_ARGUMENT);
  const o = Ue(t) ? String(t) : (Je(t), t);
  return Ue(s) ? a.plural = s : le(s) ? a.default = s : he(s) && !dr(s) ? a.named = s : je(s) && (a.list = s), Ue(n) ? a.plural = n : le(n) ? a.default = n : he(n) && Ge(a, n), [o, a];
}
function el(e, t, s, n, a, o) {
  return {
    locale: t,
    key: s,
    warnHtmlMessage: a,
    onError: (l) => {
      if (o && o(l), process.env.NODE_ENV !== "production") {
        const i = tl(n), u = `Message compilation error: ${l.message}`, d = l.location && i && Ns(i, l.location.start.offset, l.location.end.offset), p = e.__v_emitter;
        p && i && p.emit("compile-error", {
          message: i,
          error: l.message,
          start: l.location && l.location.start.offset,
          end: l.location && l.location.end.offset,
          groupId: `translate:${s}`
        }), console.error(d ? `${u}
${d}` : u);
      } else
        throw l;
    },
    onCacheKey: (l) => ys(t, s, l)
  };
}
function tl(e) {
  if (le(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function rl(e, t, s, n) {
  const { modifiers: a, pluralRules: o, messageResolver: l, fallbackLocale: i, fallbackWarn: u, missingWarn: d, fallbackContext: p } = e, f = {
    locale: t,
    modifiers: a,
    pluralRules: o,
    messages: (_, b) => {
      let g = l(s, _);
      if (g == null && (p || b)) {
        const [, , h] = Lo(
          p || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          _,
          t,
          i,
          u,
          d
        );
        g = l(h, _);
      }
      if (le(g) || nt(g)) {
        let h = !1;
        const N = xo(e, _, t, g, _, () => {
          h = !0;
        });
        return h ? On : N;
      } else return Je(g) ? g : On;
    }
  };
  return e.processor && (f.processor = e.processor), n.list && (f.list = n.list), n.named && (f.named = n.named), Ue(n.plural) && (f.pluralIndex = n.plural), f;
}
ri();
/*!
  * vue-i18n v10.0.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const nl = "10.0.8";
function ol() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (It().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (It().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (It().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (It().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const _t = {
  FALLBACK_TO_ROOT: ki,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  DEPRECATE_TC: 11
}, sl = {
  [_t.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [_t.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [_t.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [_t.DEPRECATE_TC]: "'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc’ are going to remove in v11."
};
function en(e, ...t) {
  return ur(sl[e], ...t);
}
const We = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Ci,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function Bt(e, ...t) {
  return wt(e, null, process.env.NODE_ENV !== "production" ? { messages: il, args: t } : void 0);
}
const il = {
  [We.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [We.INVALID_ARGUMENT]: "Invalid argument",
  [We.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [We.NOT_INSTALLED]: "Need to install with `app.use` function",
  [We.UNEXPECTED_ERROR]: "Unexpected error",
  [We.REQUIRED_VALUE]: "Required in value: {0}",
  [We.INVALID_VALUE]: "Invalid value",
  [We.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [We.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [We.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [We.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, kr = /* @__PURE__ */ dt("__translateVNode"), Or = /* @__PURE__ */ dt("__datetimeParts"), Rr = /* @__PURE__ */ dt("__numberParts"), Lr = /* @__PURE__ */ dt("__enableEmitter"), xr = /* @__PURE__ */ dt("__disableEmitter"), ll = dt("__setPluralRules"), Fo = /* @__PURE__ */ dt("__injectWithOption"), Fr = /* @__PURE__ */ dt("__dispose");
function Wt(e) {
  if (!Te(e) || nt(e))
    return e;
  for (const t in e)
    if (rt(e, t))
      if (!t.includes("."))
        Te(e[t]) && Wt(e[t]);
      else {
        const s = t.split("."), n = s.length - 1;
        let a = e, o = !1;
        for (let l = 0; l < n; l++) {
          if (s[l] === "__proto__")
            throw new Error(`unsafe key: ${s[l]}`);
          if (s[l] in a || (a[s[l]] = $e()), !Te(a[s[l]])) {
            process.env.NODE_ENV !== "production" && ut(en(_t.IGNORE_OBJ_FLATTEN, {
              key: s[l]
            })), o = !0;
            break;
          }
          a = a[s[l]];
        }
        if (o || (nt(a) ? To.includes(s[n]) || delete e[t] : (a[s[n]] = e[t], delete e[t])), !nt(a)) {
          const l = a[s[n]];
          Te(l) && Wt(l);
        }
      }
  return e;
}
function Vo(e, t) {
  const { messages: s, __i18n: n, messageResolver: a, flatJson: o } = t, l = he(s) ? s : je(n) ? $e() : { [e]: $e() };
  if (je(n) && n.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: u, resource: d } = i;
      u ? (l[u] = l[u] || $e(), er(d, l[u])) : er(d, l);
    } else
      le(i) && er(JSON.parse(i), l);
  }), a == null && o)
    for (const i in l)
      rt(l, i) && Wt(l[i]);
  return l;
}
function zo(e) {
  return e.type;
}
function al(e, t, s) {
  let n = Te(t.messages) ? t.messages : $e();
  "__i18nGlobal" in s && (n = Vo(e.locale.value, {
    messages: n,
    __i18n: s.__i18nGlobal
  }));
  const a = Object.keys(n);
  a.length && a.forEach((o) => {
    e.mergeLocaleMessage(o, n[o]);
  });
  {
    if (Te(t.datetimeFormats)) {
      const o = Object.keys(t.datetimeFormats);
      o.length && o.forEach((l) => {
        e.mergeDateTimeFormat(l, t.datetimeFormats[l]);
      });
    }
    if (Te(t.numberFormats)) {
      const o = Object.keys(t.numberFormats);
      o.length && o.forEach((l) => {
        e.mergeNumberFormat(l, t.numberFormats[l]);
      });
    }
  }
}
function Ln(e) {
  return m(is, null, e, 0);
}
const xn = "__INTLIFY_META__", Fn = () => [], ul = () => !1;
let Vn = 0;
function zn(e) {
  return (t, s, n, a) => e(s, n, qt() || void 0, a);
}
const dl = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = qt();
  let t = null;
  return e && (t = zo(e)[xn]) ? { [xn]: t } : null;
};
function cl(e = {}) {
  const { __root: t, __injectWithOption: s } = e, n = t === void 0, a = e.flatJson, o = at ? X : ss;
  let l = ze(e.inheritLocale) ? e.inheritLocale : !0;
  const i = o(
    // prettier-ignore
    t && l ? t.locale.value : le(e.locale) ? e.locale : or
  ), u = o(
    // prettier-ignore
    t && l ? t.fallbackLocale.value : le(e.fallbackLocale) || je(e.fallbackLocale) || he(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), d = o(Vo(i.value, e)), p = o(he(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), y = o(he(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let f = t ? t.missingWarn : ze(e.missingWarn) || nr(e.missingWarn) ? e.missingWarn : !0, _ = t ? t.fallbackWarn : ze(e.fallbackWarn) || nr(e.fallbackWarn) ? e.fallbackWarn : !0, b = t ? t.fallbackRoot : ze(e.fallbackRoot) ? e.fallbackRoot : !0, g = !!e.fallbackFormat, h = Re(e.missing) ? e.missing : null, v = Re(e.missing) ? zn(e.missing) : null, N = Re(e.postTranslation) ? e.postTranslation : null, $ = t ? t.warnHtmlMessage : ze(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, S = !!e.escapeParameter;
  const I = t ? t.modifiers : he(e.modifiers) ? e.modifiers : {};
  let C = e.pluralRules || t && t.pluralRules, T;
  T = (() => {
    n && Nn(null);
    const W = {
      version: nl,
      locale: i.value,
      fallbackLocale: u.value,
      messages: d.value,
      modifiers: I,
      pluralRules: C,
      missing: v === null ? void 0 : v,
      missingWarn: f,
      fallbackWarn: _,
      fallbackFormat: g,
      unresolving: !0,
      postTranslation: N === null ? void 0 : N,
      warnHtmlMessage: $,
      escapeParameter: S,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    W.datetimeFormats = p.value, W.numberFormats = y.value, W.__datetimeFormatters = he(T) ? T.__datetimeFormatters : void 0, W.__numberFormatters = he(T) ? T.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (W.__v_emitter = he(T) ? T.__v_emitter : void 0);
    const D = Gi(W);
    return n && Nn(D), D;
  })(), xt(T, i.value, u.value);
  function M() {
    return [
      i.value,
      u.value,
      d.value,
      p.value,
      y.value
    ];
  }
  const L = G({
    get: () => i.value,
    set: (W) => {
      i.value = W, T.locale = i.value;
    }
  }), z = G({
    get: () => u.value,
    set: (W) => {
      u.value = W, T.fallbackLocale = u.value, xt(T, i.value, W);
    }
  }), O = G(() => d.value), H = /* @__PURE__ */ G(() => p.value), q = /* @__PURE__ */ G(() => y.value);
  function me() {
    return Re(N) ? N : null;
  }
  function x(W) {
    N = W, T.postTranslation = W;
  }
  function ie() {
    return h;
  }
  function ne(W) {
    W !== null && (v = zn(W)), h = W, T.missing = v;
  }
  function J(W, D) {
    return W !== "translate" || !D.resolvedMessage;
  }
  const j = (W, D, Ee, Ve, bt, Zt) => {
    M();
    let $t;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, n || (T.fallbackContext = t ? Ui() : void 0), $t = W(T);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, n || (T.fallbackContext = void 0);
    }
    if (Ee !== "translate exists" && // for not `te` (e.g `t`)
    Ue($t) && $t === cr || Ee === "translate exists" && !$t) {
      const [Ct, os] = D();
      if (process.env.NODE_ENV !== "production" && t && le(Ct) && J(Ee, os) && (b && (mr(_, Ct) || Ao(f, Ct)) && ut(en(_t.FALLBACK_TO_ROOT, {
        key: Ct,
        type: Ee
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: dn } = T;
        dn && b && dn.emit("fallback", {
          type: Ee,
          key: Ct,
          to: "global",
          groupId: `${Ee}:${Ct}`
        });
      }
      return t && b ? Ve(t) : bt(Ct);
    } else {
      if (Zt($t))
        return $t;
      throw Bt(We.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Y(...W) {
    return j((D) => Reflect.apply(Rn, null, [D, ...W]), () => wr(...W), "translate", (D) => Reflect.apply(D.t, D, [...W]), (D) => D, (D) => le(D));
  }
  function re(...W) {
    const [D, Ee, Ve] = W;
    if (Ve && !Te(Ve))
      throw Bt(We.INVALID_ARGUMENT);
    return Y(D, Ee, Ge({ resolvedMessage: !0 }, Ve || {}));
  }
  function fe(...W) {
    return j((D) => Reflect.apply($n, null, [D, ...W]), () => Mr(...W), "datetime format", (D) => Reflect.apply(D.d, D, [...W]), () => sr, (D) => le(D));
  }
  function Le(...W) {
    return j((D) => Reflect.apply(An, null, [D, ...W]), () => Ar(...W), "number format", (D) => Reflect.apply(D.n, D, [...W]), () => sr, (D) => le(D));
  }
  function Q(W) {
    return W.map((D) => le(D) || Ue(D) || ze(D) ? Ln(String(D)) : D);
  }
  const Xe = {
    normalize: Q,
    interpolate: (W) => W,
    type: "vnode"
  };
  function Kt(...W) {
    return j((D) => {
      let Ee;
      const Ve = D;
      try {
        Ve.processor = Xe, Ee = Reflect.apply(Rn, null, [Ve, ...W]);
      } finally {
        Ve.processor = null;
      }
      return Ee;
    }, () => wr(...W), "translate", (D) => D[kr](...W), (D) => [Ln(D)], (D) => je(D));
  }
  function pr(...W) {
    return j((D) => Reflect.apply(An, null, [D, ...W]), () => Ar(...W), "number format", (D) => D[Rr](...W), Fn, (D) => le(D) || je(D));
  }
  function vr(...W) {
    return j((D) => Reflect.apply($n, null, [D, ...W]), () => Mr(...W), "datetime format", (D) => D[Or](...W), Fn, (D) => le(D) || je(D));
  }
  function gr(W) {
    C = W, T.pluralRules = C;
  }
  function yr(W, D) {
    return j(() => {
      if (!W)
        return !1;
      const Ee = le(D) ? D : i.value, Ve = yt(Ee), bt = T.messageResolver(Ve, W);
      return nt(bt) || Je(bt) || le(bt);
    }, () => [W], "translate exists", (Ee) => Reflect.apply(Ee.te, Ee, [W, D]), ul, (Ee) => ze(Ee));
  }
  function Ot(W) {
    let D = null;
    const Ee = Eo(T, u.value, i.value);
    for (let Ve = 0; Ve < Ee.length; Ve++) {
      const bt = d.value[Ee[Ve]] || {}, Zt = T.messageResolver(bt, W);
      if (Zt != null) {
        D = Zt;
        break;
      }
    }
    return D;
  }
  function Rt(W) {
    const D = Ot(W);
    return D ?? (t ? t.tm(W) || {} : {});
  }
  function yt(W) {
    return d.value[W] || {};
  }
  function Lt(W, D) {
    if (a) {
      const Ee = { [W]: D };
      for (const Ve in Ee)
        rt(Ee, Ve) && Wt(Ee[Ve]);
      D = Ee[W];
    }
    d.value[W] = D, T.messages = d.value;
  }
  function br(W, D) {
    d.value[W] = d.value[W] || {};
    const Ee = { [W]: D };
    if (a)
      for (const Ve in Ee)
        rt(Ee, Ve) && Wt(Ee[Ve]);
    D = Ee[W], er(D, d.value[W]), T.messages = d.value;
  }
  function k(W) {
    return p.value[W] || {};
  }
  function R(W, D) {
    p.value[W] = D, T.datetimeFormats = p.value, Mn(T, W, D);
  }
  function K(W, D) {
    p.value[W] = Ge(p.value[W] || {}, D), T.datetimeFormats = p.value, Mn(T, W, D);
  }
  function de(W) {
    return y.value[W] || {};
  }
  function xe(W, D) {
    y.value[W] = D, T.numberFormats = y.value, wn(T, W, D);
  }
  function Fe(W, D) {
    y.value[W] = Ge(y.value[W] || {}, D), T.numberFormats = y.value, wn(T, W, D);
  }
  Vn++, t && at && (te(t.locale, (W) => {
    l && (i.value = W, T.locale = W, xt(T, i.value, u.value));
  }), te(t.fallbackLocale, (W) => {
    l && (u.value = W, T.fallbackLocale = W, xt(T, i.value, u.value));
  }));
  const _e = {
    id: Vn,
    locale: L,
    fallbackLocale: z,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(W) {
      l = W, W && t && (i.value = t.locale.value, u.value = t.fallbackLocale.value, xt(T, i.value, u.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: O,
    get modifiers() {
      return I;
    },
    get pluralRules() {
      return C || {};
    },
    get isGlobal() {
      return n;
    },
    get missingWarn() {
      return f;
    },
    set missingWarn(W) {
      f = W, T.missingWarn = f;
    },
    get fallbackWarn() {
      return _;
    },
    set fallbackWarn(W) {
      _ = W, T.fallbackWarn = _;
    },
    get fallbackRoot() {
      return b;
    },
    set fallbackRoot(W) {
      b = W;
    },
    get fallbackFormat() {
      return g;
    },
    set fallbackFormat(W) {
      g = W, T.fallbackFormat = g;
    },
    get warnHtmlMessage() {
      return $;
    },
    set warnHtmlMessage(W) {
      $ = W, T.warnHtmlMessage = W;
    },
    get escapeParameter() {
      return S;
    },
    set escapeParameter(W) {
      S = W, T.escapeParameter = W;
    },
    t: Y,
    getLocaleMessage: yt,
    setLocaleMessage: Lt,
    mergeLocaleMessage: br,
    getPostTranslationHandler: me,
    setPostTranslationHandler: x,
    getMissingHandler: ie,
    setMissingHandler: ne,
    [ll]: gr
  };
  return _e.datetimeFormats = H, _e.numberFormats = q, _e.rt = re, _e.te = yr, _e.tm = Rt, _e.d = fe, _e.n = Le, _e.getDateTimeFormat = k, _e.setDateTimeFormat = R, _e.mergeDateTimeFormat = K, _e.getNumberFormat = de, _e.setNumberFormat = xe, _e.mergeNumberFormat = Fe, _e[Fo] = s, _e[kr] = Kt, _e[Or] = vr, _e[Rr] = pr, process.env.NODE_ENV !== "production" && (_e[Lr] = (W) => {
    T.__v_emitter = W;
  }, _e[xr] = () => {
    T.__v_emitter = void 0;
  }), _e;
}
function jn(e, t) {
}
const tn = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function ml({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((n, a) => [
    ...n,
    // prettier-ignore
    ...a.type === Ae ? a.children : [a]
  ], []) : t.reduce((s, n) => {
    const a = e[n];
    return a && (s[n] = a()), s;
  }, $e());
}
function jo() {
  return Ae;
}
Ge({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => Ue(e) || !isNaN(e)
  }
}, tn);
function fl(e) {
  return je(e) && !le(e[0]);
}
function Uo(e, t, s, n) {
  const { slots: a, attrs: o } = t;
  return () => {
    const l = { part: !0 };
    let i = $e();
    e.locale && (l.locale = e.locale), le(e.format) ? l.key = e.format : Te(e.format) && (le(e.format.key) && (l.key = e.format.key), i = Object.keys(e.format).reduce((f, _) => s.includes(_) ? Ge($e(), f, { [_]: e.format[_] }) : f, $e()));
    const u = n(e.value, l, i);
    let d = [l.key];
    je(u) ? d = u.map((f, _) => {
      const b = a[f.type], g = b ? b({ [f.type]: f.value, index: _, parts: u }) : [f.value];
      return fl(g) && (g[0].key = `${f.type}-${_}`), g;
    }) : le(u) && (d = [u]);
    const p = Ge($e(), o), y = le(e.tag) || Te(e.tag) ? e.tag : jo();
    return co(y, p, d);
  };
}
Ge({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, tn);
Ge({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, tn);
const pl = /* @__PURE__ */ dt("global-vue-i18n");
function oe(e = {}) {
  const t = qt();
  if (t == null)
    throw Bt(We.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Bt(We.NOT_INSTALLED);
  const s = vl(t), n = yl(s), a = zo(t), o = gl(e, a);
  if (o === "global")
    return al(n, e, a), n;
  if (o === "parent") {
    let u = bl(s, t, e.__useComponent);
    return u == null && (process.env.NODE_ENV !== "production" && ut(en(_t.NOT_FOUND_PARENT_SCOPE)), u = n), u;
  }
  const l = s;
  let i = l.__getInstance(t);
  if (i == null) {
    const u = Ge({}, e);
    "__i18n" in a && (u.__i18n = a.__i18n), n && (u.__root = n), i = cl(u), l.__composerExtend && (i[Fr] = l.__composerExtend(i)), Il(l, t, i), l.__setInstance(t, i);
  }
  return i;
}
function vl(e) {
  const t = ue(e.isCE ? pl : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw Bt(e.isCE ? We.NOT_INSTALLED_WITH_PROVIDE : We.UNEXPECTED_ERROR);
  return t;
}
function gl(e, t) {
  return dr(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function yl(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function bl(e, t, s = !1) {
  let n = null;
  const a = t.root;
  let o = Cl(t, s);
  for (; o != null; ) {
    const l = e;
    if (e.mode === "composition")
      n = l.__getInstance(o);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = l.__getInstance(o);
      i != null && (n = i.__composer, s && n && !n[Fo] && (n = null));
    }
    if (n != null || a === o)
      break;
    o = o.parent;
  }
  return n;
}
function Cl(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Il(e, t, s) {
  let n = null;
  Se(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = s, n = Ss();
      const a = s;
      a[Lr] && a[Lr](n), n.on("*", jn);
    }
  }, t), Wr(() => {
    const a = s;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (n && n.off("*", jn), a[xr] && a[xr](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const o = a[Fr];
    o && (o(), delete a[Fr]);
  }, t);
}
ol();
xi(pi);
Fi(wi);
Vi(Eo);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = It();
  e.__INTLIFY__ = !0, vi(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const be = /* @__PURE__ */ ge({
  __name: "text-input-uppercase",
  props: {
    notPrefilled: {
      type: Boolean,
      default: !1
    },
    autocomplete: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (t, s) => {
      const n = U("v-text-field");
      return w(), ce(n, {
        class: ke([e.notPrefilled ? "v-input--warning" : null]),
        "onUpdate:modelValue": s[0] || (s[0] = (a) => t.$emit("update:modelValue", a.toString().toUpperCase())),
        autocomplete: e.autocomplete
      }, ls({ _: 2 }, [
        t.$slots["append-inner"] ? {
          name: "append-inner",
          fn: E((a) => [
            mo(t.$slots, "append-inner", as(us(a)))
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["class", "autocomplete"]);
    };
  }
}), _l = {
  employmentType: void 0,
  employerName: "",
  employerAddress: "",
  employerPostCode: void 0,
  flowType: void 0,
  hasSlovenianIncome: void 0,
  isSlovenianCitizen: void 0
};
function hl() {
  return {
    ..._l
  };
}
function Un(e, t) {
  var s = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), s.push.apply(s, n);
  }
  return s;
}
function mt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var s = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Un(Object(s), !0).forEach(function(n) {
      Tl(e, n, s[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(s)) : Un(Object(s)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(s, n));
    });
  }
  return e;
}
function Tl(e, t, s) {
  return t in e ? Object.defineProperty(e, t, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = s, e;
}
function Gn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Object.keys(e).reduce((s, n) => (t.includes(n) || (s[n] = r(e[n])), s), {});
}
function ir(e) {
  return typeof e == "function";
}
function El(e) {
  return ds(e) || cs(e);
}
function Go(e, t, s) {
  let n = e;
  const a = t.split(".");
  for (let o = 0; o < a.length; o++) {
    if (!n[a[o]]) return s;
    n = n[a[o]];
  }
  return n;
}
function hr(e, t, s) {
  return G(() => e.some((n) => Go(t, n, {
    [s]: !1
  })[s]));
}
function Bn(e, t, s) {
  return G(() => e.reduce((n, a) => {
    const o = Go(t, a, {
      [s]: !1
    })[s] || [];
    return n.concat(o);
  }, []));
}
function Bo(e, t, s, n) {
  return e.call(n, r(t), r(s), n);
}
function Wo(e) {
  return e.$valid !== void 0 ? !e.$valid : !e;
}
function Nl(e, t, s, n, a, o, l) {
  let {
    $lazy: i,
    $rewardEarly: u
  } = a, d = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], p = arguments.length > 8 ? arguments[8] : void 0, y = arguments.length > 9 ? arguments[9] : void 0, f = arguments.length > 10 ? arguments[10] : void 0;
  const _ = X(!!n.value), b = X(0);
  s.value = !1;
  const g = te([t, n].concat(d, f), () => {
    if (i && !n.value || u && !y.value && !s.value)
      return;
    let h;
    try {
      h = Bo(e, t, p, l);
    } catch (v) {
      h = Promise.reject(v);
    }
    b.value++, s.value = !!b.value, _.value = !1, Promise.resolve(h).then((v) => {
      b.value--, s.value = !!b.value, o.value = v, _.value = Wo(v);
    }).catch((v) => {
      b.value--, s.value = !!b.value, o.value = v, _.value = !0;
    });
  }, {
    immediate: !0,
    deep: typeof t == "object"
  });
  return {
    $invalid: _,
    $unwatch: g
  };
}
function Sl(e, t, s, n, a, o, l, i) {
  let {
    $lazy: u,
    $rewardEarly: d
  } = n;
  const p = () => ({}), y = G(() => {
    if (u && !s.value || d && !i.value)
      return !1;
    let f = !0;
    try {
      const _ = Bo(e, t, l, o);
      a.value = _, f = Wo(_);
    } catch (_) {
      a.value = _;
    }
    return f;
  });
  return {
    $unwatch: p,
    $invalid: y
  };
}
function Pl(e, t, s, n, a, o, l, i, u, d, p) {
  const y = X(!1), f = e.$params || {}, _ = X(null);
  let b, g;
  e.$async ? {
    $invalid: b,
    $unwatch: g
  } = Nl(e.$validator, t, y, s, n, _, a, e.$watchTargets, u, d, p) : {
    $invalid: b,
    $unwatch: g
  } = Sl(e.$validator, t, s, n, _, a, u, d);
  const h = e.$message;
  return {
    $message: ir(h) ? G(() => h(Gn({
      $pending: y,
      $invalid: b,
      $params: Gn(f),
      $model: t,
      $response: _,
      $validator: o,
      $propertyPath: i,
      $property: l
    }))) : h || "",
    $params: f,
    $pending: y,
    $invalid: b,
    $response: _,
    $unwatch: g
  };
}
function $l() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = r(e), s = Object.keys(t), n = {}, a = {}, o = {};
  let l = null;
  return s.forEach((i) => {
    const u = t[i];
    switch (!0) {
      case ir(u.$validator):
        n[i] = u;
        break;
      case ir(u):
        n[i] = {
          $validator: u
        };
        break;
      case i === "$validationGroups":
        l = u;
        break;
      case i.startsWith("$"):
        o[i] = u;
        break;
      default:
        a[i] = u;
    }
  }), {
    rules: n,
    nestedValidators: a,
    config: o,
    validationGroups: l
  };
}
const Ml = "__root";
function Al(e, t, s, n, a, o, l, i, u) {
  const d = Object.keys(e), p = n.get(a, e), y = X(!1), f = X(!1), _ = X(0);
  if (p) {
    if (!p.$partial) return p;
    p.$unwatch(), y.value = p.$dirty.value;
  }
  const b = {
    $dirty: y,
    $path: a,
    $touch: () => {
      y.value || (y.value = !0);
    },
    $reset: () => {
      y.value && (y.value = !1);
    },
    $commit: () => {
    }
  };
  return d.length ? (d.forEach((g) => {
    b[g] = Pl(e[g], t, b.$dirty, o, l, g, s, a, u, f, _);
  }), b.$externalResults = G(() => i.value ? [].concat(i.value).map((g, h) => ({
    $propertyPath: a,
    $property: s,
    $validator: "$externalResults",
    $uid: `${a}-externalResult-${h}`,
    $message: g,
    $params: {},
    $response: null,
    $pending: !1
  })) : []), b.$invalid = G(() => {
    const g = d.some((h) => r(b[h].$invalid));
    return f.value = g, !!b.$externalResults.value.length || g;
  }), b.$pending = G(() => d.some((g) => r(b[g].$pending))), b.$error = G(() => b.$dirty.value ? b.$pending.value || b.$invalid.value : !1), b.$silentErrors = G(() => d.filter((g) => r(b[g].$invalid)).map((g) => {
    const h = b[g];
    return se({
      $propertyPath: a,
      $property: s,
      $validator: g,
      $uid: `${a}-${g}`,
      $message: h.$message,
      $params: h.$params,
      $response: h.$response,
      $pending: h.$pending
    });
  }).concat(b.$externalResults.value)), b.$errors = G(() => b.$dirty.value ? b.$silentErrors.value : []), b.$unwatch = () => d.forEach((g) => {
    b[g].$unwatch();
  }), b.$commit = () => {
    f.value = !0, _.value = Date.now();
  }, n.set(a, e, b), b) : (p && n.set(a, e, b), b);
}
function wl(e, t, s, n, a, o, l) {
  const i = Object.keys(e);
  return i.length ? i.reduce((u, d) => (u[d] = Vr({
    validations: e[d],
    state: t,
    key: d,
    parentKey: s,
    resultsCache: n,
    globalConfig: a,
    instance: o,
    externalResults: l
  }), u), {}) : {};
}
function kl(e, t, s) {
  const n = G(() => [t, s].filter((b) => b).reduce((b, g) => b.concat(Object.values(r(g))), [])), a = G({
    get() {
      return e.$dirty.value || (n.value.length ? n.value.every((b) => b.$dirty) : !1);
    },
    set(b) {
      e.$dirty.value = b;
    }
  }), o = G(() => {
    const b = r(e.$silentErrors) || [], g = n.value.filter((h) => (r(h).$silentErrors || []).length).reduce((h, v) => h.concat(...v.$silentErrors), []);
    return b.concat(g);
  }), l = G(() => {
    const b = r(e.$errors) || [], g = n.value.filter((h) => (r(h).$errors || []).length).reduce((h, v) => h.concat(...v.$errors), []);
    return b.concat(g);
  }), i = G(() => n.value.some((b) => b.$invalid) || r(e.$invalid) || !1), u = G(() => n.value.some((b) => r(b.$pending)) || r(e.$pending) || !1), d = G(() => n.value.some((b) => b.$dirty) || n.value.some((b) => b.$anyDirty) || a.value), p = G(() => a.value ? u.value || i.value : !1), y = () => {
    e.$touch(), n.value.forEach((b) => {
      b.$touch();
    });
  }, f = () => {
    e.$commit(), n.value.forEach((b) => {
      b.$commit();
    });
  }, _ = () => {
    e.$reset(), n.value.forEach((b) => {
      b.$reset();
    });
  };
  return n.value.length && n.value.every((b) => b.$dirty) && y(), {
    $dirty: a,
    $errors: l,
    $invalid: i,
    $anyDirty: d,
    $error: p,
    $pending: u,
    $touch: y,
    $reset: _,
    $silentErrors: o,
    $commit: f
  };
}
function Vr(e) {
  let {
    validations: t,
    state: s,
    key: n,
    parentKey: a,
    childResults: o,
    resultsCache: l,
    globalConfig: i = {},
    instance: u,
    externalResults: d
  } = e;
  const p = a ? `${a}.${n}` : n, {
    rules: y,
    nestedValidators: f,
    config: _,
    validationGroups: b
  } = $l(t), g = mt(mt({}, i), _), h = n ? G(() => {
    const j = r(s);
    return j ? r(j[n]) : void 0;
  }) : s, v = mt({}, r(d) || {}), N = G(() => {
    const j = r(d);
    return n ? j ? r(j[n]) : void 0 : j;
  }), $ = Al(y, h, n, l, p, g, u, N, s), S = wl(f, h, p, l, g, u, N), I = {};
  b && Object.entries(b).forEach((j) => {
    let [Y, re] = j;
    I[Y] = {
      $invalid: hr(re, S, "$invalid"),
      $error: hr(re, S, "$error"),
      $pending: hr(re, S, "$pending"),
      $errors: Bn(re, S, "$errors"),
      $silentErrors: Bn(re, S, "$silentErrors")
    };
  });
  const {
    $dirty: C,
    $errors: T,
    $invalid: A,
    $anyDirty: M,
    $error: L,
    $pending: z,
    $touch: O,
    $reset: H,
    $silentErrors: q,
    $commit: me
  } = kl($, S, o), x = n ? G({
    get: () => r(h),
    set: (j) => {
      C.value = !0;
      const Y = r(s), re = r(d);
      re && (re[n] = v[n]), Sr(Y[n]) ? Y[n].value = j : Y[n] = j;
    }
  }) : null;
  n && g.$autoDirty && te(h, () => {
    C.value || O();
    const j = r(d);
    j && (j[n] = v[n]);
  }, {
    flush: "sync"
  });
  async function ie() {
    return O(), g.$rewardEarly && (me(), await ae()), await ae(), new Promise((j) => {
      if (!z.value) return j(!A.value);
      const Y = te(z, () => {
        j(!A.value), Y();
      });
    });
  }
  function ne(j) {
    return (o.value || {})[j];
  }
  function J() {
    Sr(d) ? d.value = v : Object.keys(v).length === 0 ? Object.keys(d).forEach((j) => {
      delete d[j];
    }) : Object.assign(d, v);
  }
  return se(mt(mt(mt({}, $), {}, {
    $model: x,
    $dirty: C,
    $error: L,
    $errors: T,
    $invalid: A,
    $anyDirty: M,
    $pending: z,
    $touch: O,
    $reset: H,
    $path: p || Ml,
    $silentErrors: q,
    $validate: ie,
    $commit: me
  }, o && {
    $getResultsForChild: ne,
    $clearExternalResults: J,
    $validationGroups: I
  }), S));
}
class Ol {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  set(t, s, n) {
    this.storage.set(t, {
      rules: s,
      result: n
    });
  }
  checkRulesValidity(t, s, n) {
    const a = Object.keys(n), o = Object.keys(s);
    return o.length !== a.length || !o.every((i) => a.includes(i)) ? !1 : o.every((i) => s[i].$params ? Object.keys(s[i].$params).every((u) => r(n[i].$params[u]) === r(s[i].$params[u])) : !0);
  }
  get(t, s) {
    const n = this.storage.get(t);
    if (!n) return;
    const {
      rules: a,
      result: o
    } = n, l = this.checkRulesValidity(t, s, a), i = o.$unwatch ? o.$unwatch : () => ({});
    return l ? o : {
      $dirty: o.$dirty,
      $partial: !0,
      $unwatch: i
    };
  }
}
const tr = {
  COLLECT_ALL: !0,
  COLLECT_NONE: !1
}, Wn = Symbol("vuelidate#injectChildResults"), Yn = Symbol("vuelidate#removeChildResults");
function Rl(e) {
  let {
    $scope: t,
    instance: s
  } = e;
  const n = {}, a = X([]), o = G(() => a.value.reduce((p, y) => (p[y] = r(n[y]), p), {}));
  function l(p, y) {
    let {
      $registerAs: f,
      $scope: _,
      $stopPropagation: b
    } = y;
    b || t === tr.COLLECT_NONE || _ === tr.COLLECT_NONE || t !== tr.COLLECT_ALL && t !== _ || (n[f] = p, a.value.push(f));
  }
  s.__vuelidateInjectInstances = [].concat(s.__vuelidateInjectInstances || [], l);
  function i(p) {
    a.value = a.value.filter((y) => y !== p), delete n[p];
  }
  s.__vuelidateRemoveInstances = [].concat(s.__vuelidateRemoveInstances || [], i);
  const u = ue(Wn, []);
  cn(Wn, s.__vuelidateInjectInstances);
  const d = ue(Yn, []);
  return cn(Yn, s.__vuelidateRemoveInstances), {
    childResults: o,
    sendValidationResultsToParent: u,
    removeValidationResultsFromParent: d
  };
}
function Yo(e) {
  return new Proxy(e, {
    get(t, s) {
      return typeof t[s] == "object" ? Yo(t[s]) : G(() => t[s]);
    }
  });
}
let qn = 0;
function Me(e, t) {
  var s;
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  arguments.length === 1 && (n = e, e = void 0, t = void 0);
  let {
    $registerAs: a,
    $scope: o = tr.COLLECT_ALL,
    $stopPropagation: l,
    $externalResults: i,
    currentVueInstance: u
  } = n;
  const d = u || ((s = qt()) === null || s === void 0 ? void 0 : s.proxy), p = d ? d.$options : {};
  a || (qn += 1, a = `_vuelidate_${qn}`);
  const y = X({}), f = new Ol(), {
    childResults: _,
    sendValidationResultsToParent: b,
    removeValidationResultsFromParent: g
  } = d ? Rl({
    $scope: o,
    instance: d
  }) : {
    childResults: X({})
  };
  if (!e && p.validations) {
    const h = p.validations;
    t = X({}), fo(() => {
      t.value = d, te(() => ir(h) ? h.call(t.value, new Yo(t.value)) : h, (v) => {
        y.value = Vr({
          validations: v,
          state: t,
          childResults: _,
          resultsCache: f,
          globalConfig: n,
          instance: d,
          externalResults: i || d.vuelidateExternalResults
        });
      }, {
        immediate: !0
      });
    }), n = p.validationsConfig || n;
  } else {
    const h = Sr(e) || El(e) ? e : se(e || {});
    te(h, (v) => {
      y.value = Vr({
        validations: v,
        state: t,
        childResults: _,
        resultsCache: f,
        globalConfig: n,
        instance: d ?? {},
        externalResults: i
      });
    }, {
      immediate: !0
    });
  }
  return d && (b.forEach((h) => h(y, {
    $registerAs: a,
    $scope: o,
    $stopPropagation: l
  })), St(() => g.forEach((h) => h(a)))), G(() => mt(mt({}, r(y.value)), _.value));
}
function Hn(e, t) {
  var s = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), s.push.apply(s, n);
  }
  return s;
}
function Yt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var s = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hn(Object(s), !0).forEach(function(n) {
      Ll(e, n, s[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(s)) : Hn(Object(s)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(s, n));
    });
  }
  return e;
}
function Ll(e, t, s) {
  return t in e ? Object.defineProperty(e, t, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = s, e;
}
function lr(e) {
  return typeof e == "function";
}
function zr(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function fr(e) {
  return lr(e.$validator) ? Yt({}, e) : {
    $validator: e
  };
}
function qo(e) {
  return typeof e == "object" ? e.$valid : e;
}
function Ho(e) {
  return e.$validator || e;
}
function xl(e, t) {
  if (!zr(e)) throw new Error(`[@vuelidate/validators]: First parameter to "withParams" should be an object, provided ${typeof e}`);
  if (!zr(t) && !lr(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const s = fr(t);
  return s.$params = Yt(Yt({}, s.$params || {}), e), s;
}
function Fl(e, t) {
  if (!lr(e) && typeof r(e) != "string") throw new Error(`[@vuelidate/validators]: First parameter to "withMessage" should be string or a function returning a string, provided ${typeof e}`);
  if (!zr(t) && !lr(t)) throw new Error("[@vuelidate/validators]: Validator must be a function or object with $validator parameter");
  const s = fr(t);
  return s.$message = e, s;
}
function Vl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  const s = fr(e);
  return Yt(Yt({}, s), {}, {
    $async: !0,
    $watchTargets: t
  });
}
function zl(e) {
  return {
    $validator(t) {
      for (var s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), a = 1; a < s; a++)
        n[a - 1] = arguments[a];
      return r(t).reduce((o, l, i) => {
        const u = Object.entries(l).reduce((d, p) => {
          let [y, f] = p;
          const _ = e[y] || {}, b = Object.entries(_).reduce((g, h) => {
            let [v, N] = h;
            const S = Ho(N).call(this, f, l, i, ...n), I = qo(S);
            if (g.$data[v] = S, g.$data.$invalid = !I || !!g.$data.$invalid, g.$data.$error = g.$data.$invalid, !I) {
              let C = N.$message || "";
              const T = N.$params || {};
              typeof C == "function" && (C = C({
                $pending: !1,
                $invalid: !I,
                $params: T,
                $model: f,
                $response: S
              })), g.$errors.push({
                $property: y,
                $message: C,
                $params: T,
                $response: S,
                $model: f,
                $pending: !1,
                $validator: v
              });
            }
            return {
              $valid: g.$valid && I,
              $data: g.$data,
              $errors: g.$errors
            };
          }, {
            $valid: !0,
            $data: {},
            $errors: []
          });
          return d.$data[y] = b.$data, d.$errors[y] = b.$errors, {
            $valid: d.$valid && b.$valid,
            $data: d.$data,
            $errors: d.$errors
          };
        }, {
          $valid: !0,
          $data: {},
          $errors: {}
        });
        return {
          $valid: o.$valid && u.$valid,
          $data: o.$data.concat(u.$data),
          $errors: o.$errors.concat(u.$errors)
        };
      }, {
        $valid: !0,
        $data: [],
        $errors: []
      });
    },
    $message: (t) => {
      let {
        $response: s
      } = t;
      return s ? s.$errors.map((n) => Object.values(n).map((a) => a.map((o) => o.$message)).reduce((a, o) => a.concat(o), [])) : [];
    }
  };
}
const vt = (e) => {
  if (e = r(e), Array.isArray(e)) return !!e.length;
  if (e == null)
    return !1;
  if (e === !1)
    return !0;
  if (e instanceof Date)
    return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (let t in e) return !0;
    return !1;
  }
  return !!String(e).length;
}, rn = (e) => (e = r(e), Array.isArray(e) ? e.length : typeof e == "object" ? Object.keys(e).length : String(e).length);
function gt() {
  for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
    t[s] = arguments[s];
  return (n) => (n = r(n), !vt(n) || t.every((a) => (a.lastIndex = 0, a.test(n))));
}
var V = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  forEach: zl,
  len: rn,
  normalizeValidatorObject: fr,
  regex: gt,
  req: vt,
  unwrap: r,
  unwrapNormalizedValidator: Ho,
  unwrapValidatorResponse: qo,
  withAsync: Vl,
  withMessage: Fl,
  withParams: xl
});
gt(/^[a-zA-Z]*$/);
gt(/^[a-zA-Z0-9]*$/);
gt(/^\d*(\.\d+)?$/);
const jl = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var Ul = gt(jl), Gl = {
  $validator: Ul,
  $message: "Value is not a valid email address",
  $params: {
    type: "email"
  }
};
function Bl(e) {
  return (t) => !vt(t) || rn(t) <= r(e);
}
function Wl(e) {
  return {
    $validator: Bl(e),
    $message: (t) => {
      let {
        $params: s
      } = t;
      return `The maximum length allowed is ${s.max}`;
    },
    $params: {
      max: e,
      type: "maxLength"
    }
  };
}
function Yl(e) {
  return (t) => !vt(t) || rn(t) >= r(e);
}
function ql(e) {
  return {
    $validator: Yl(e),
    $message: (t) => {
      let {
        $params: s
      } = t;
      return `This field should be at least ${s.min} characters long`;
    },
    $params: {
      min: e,
      type: "minLength"
    }
  };
}
function Hl(e) {
  return typeof e == "string" && (e = e.trim()), vt(e);
}
var ye = {
  $validator: Hl,
  $message: "Value is required",
  $params: {
    type: "required"
  }
};
const Qn = (e, t) => e ? vt(typeof t == "string" ? t.trim() : t) : !0;
function Ql(e) {
  return function(t, s) {
    if (typeof e != "function")
      return Qn(r(e), t);
    const n = e.call(this, t, s);
    return Qn(n, t);
  };
}
function ve(e) {
  return {
    $validator: Ql(e),
    $message: "The value is required",
    $params: {
      type: "requiredIf",
      prop: e
    }
  };
}
function Kl(e) {
  return (t) => r(t) === r(e);
}
function Ht(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "other";
  return {
    $validator: Kl(e),
    $message: (s) => `The value must be equal to the ${t} value`,
    $params: {
      equalTo: e,
      otherName: t,
      type: "sameAs"
    }
  };
}
const Zl = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
gt(Zl);
function Jl(e) {
  return (t) => !vt(t) || (!/\s/.test(t) || t instanceof Date) && +t >= +r(e);
}
function Vt(e) {
  return {
    $validator: Jl(e),
    $message: (t) => {
      let {
        $params: s
      } = t;
      return `The minimum value allowed is ${s.min}`;
    },
    $params: {
      min: e,
      type: "minValue"
    }
  };
}
function Xl(e) {
  return (t) => !vt(t) || (!/\s/.test(t) || t instanceof Date) && +t <= +r(e);
}
var Qo = (e) => ({
  $validator: Xl(e),
  $message: (t) => {
    let {
      $params: s
    } = t;
    return `The maximum value allowed is ${s.max}`;
  },
  $params: {
    max: e,
    type: "maxValue"
  }
});
gt(/(^[0-9]*$)|(^-[0-9]+$)/);
gt(/^[-]?\d*(\.\d+)?$/);
var Z = /* @__PURE__ */ ((e) => (e.POS = "pos", e.POS_STRANKA = "posstranka", e.WEB = "web", e.SKLENI_SAM = "dob", e.VLOGA = "vloga", e.INFOCALC = "infocalc", e.WEB_INFOCALC = "infocalcweb", e.PORTAL_INFOCALC = "infocalcportal", e.DOKUMENTACIJA = "doc", e.LIMIT = "limit", e))(Z || {}), Ne = /* @__PURE__ */ ((e) => (e.Zaposlen = "Z", e.Upokojenec = "U", e.SP = "SP", e))(Ne || {}), st = /* @__PURE__ */ ((e) => (e.AfternoonSP = "AS", e.SP = "SP", e))(st || {}), qe = /* @__PURE__ */ ((e) => (e.PersonalId = "OS", e.Passport = "PL", e))(qe || {}), nn = /* @__PURE__ */ ((e) => (e[e.Success = 1] = "Success", e[e.Error = 2] = "Error", e[e.Undefined = 3] = "Undefined", e))(nn || {}), Ko = /* @__PURE__ */ ((e) => (e.pi = "SL", e.stalni = "DOM", e.posta = "PS", e.zacasni = "ZAC", e.drugi = "DRG", e.sls = "SLS", e.trgovec = "TRG", e.petrol = "PETROL", e))(Ko || {}), ht = /* @__PURE__ */ ((e) => (e.Elektronsko = "elektronsko", e.Posta = "posta", e))(ht || {}), Nt = /* @__PURE__ */ ((e) => (e.SMS = "sms", e.PodpisnaTablica = "podpisna", e))(Nt || {}), ar = /* @__PURE__ */ ((e) => (e.PermanentResidence = "S", e.TemporaryResidence = "Z", e))(ar || {}), Ce = /* @__PURE__ */ ((e) => (e.Notice = "notice", e.Info = "info", e.Warning = "warning", e.Success = "success", e.Error = "error", e.Alert = "alert", e))(Ce || {});
function Dl(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    employmentType: {
      required: V.withMessage("employmentType: " + t("GlobalErrors.ChoiceRequired"), ye)
    },
    employerName: {
      required: V.withMessage(t("GlobalErrors.FIELD_REQUIRED"), ve(() => e.employmentType !== Ne.Upokojenec))
    },
    employerAddress: {
      required: V.withMessage(t("GlobalErrors.FIELD_REQUIRED"), ve(() => e.employmentType !== Ne.Upokojenec))
    },
    employerPostCode: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ve(() => e.employmentType !== Ne.Upokojenec))
    }
  })) };
}
function Oe() {
  function e(t) {
    var n;
    const s = typeof t == "string" ? document.querySelector(t) : t;
    (n = s == null ? void 0 : s.querySelector(".v-input--error")) == null || n.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }
  return {
    scrollToFirstError: e
  };
}
function we(e) {
  if (e === null) return null;
  if (Number.isNaN(e.getTime()))
    throw new Error("Invalid birthdate");
  const t = String(e.getFullYear()).padStart(4, "0"), s = String(e.getMonth() + 1).padStart(2, "0"), n = String(e.getDate()).padStart(2, "0");
  return `${t}-${s}-${n}`;
}
function jr(e) {
  return new Intl.NumberFormat("sl-SI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(e);
}
function Pe(e, t) {
  const s = Object.keys(t).filter(
    (n) => n in e
  );
  for (const n of s)
    e[n] = t[n];
  return e;
}
function zt(e) {
  return e instanceof Date ? new Date(e.getTime()) : Array.isArray(e) ? e.map(zt) : e && typeof e == "object" ? Object.fromEntries(Object.entries(e).map(([t, s]) => [t, zt(s)])) : e;
}
function Kn(e) {
  return typeof e == "string" ? e.length > 0 : typeof e == "number" && Number.isFinite(e);
}
function ea(e, t) {
  return Kn(e) && Kn(t) && String(e) === String(t);
}
function Ur(e, t) {
  if (Object.is(e, t))
    return !0;
  if (e instanceof Date && t instanceof Date)
    return e.getTime() === t.getTime();
  if (!e || !t || typeof e != "object" || typeof t != "object")
    return !1;
  const s = Object.keys(e);
  return s.length !== Object.keys(t).length ? !1 : s.every((n) => {
    const a = e[n], o = t[n];
    return Ur(a, o);
  });
}
function Zn(e) {
  return new Date(e).toLocaleDateString("he-IL");
}
function ta(e, t) {
  async function s() {
    return l.value.$touch(), await l.value.$validate();
  }
  const n = ue("generalStore"), { scrollToFirstError: a } = Oe(), { validationRules: o } = Dl(e), l = Me(o, G(() => e), {
    $autoDirty: !0
  }), i = G(() => e.flowType !== Z.LIMIT), u = G(() => e.employmentType !== Ne.Upokojenec), d = G(() => {
    const y = n.state.postalCodeList ?? [];
    return e.isSlovenianCitizen === !0 ? e.hasSlovenianIncome === !0 || e.employmentType === Ne.SP ? y.slice(0, -1) : y.slice(-1) : e.isSlovenianCitizen === !1 ? y.slice(0, -1) : y;
  });
  function p() {
    a(t.value);
  }
  return {
    v$: l,
    showHeading: i,
    showEmployerFields: u,
    getPostCodeEmploymentInfo: d,
    validateForm: s,
    scrollToFirstErrorWrapper: p
  };
}
const ra = {
  key: 0,
  class: "section-heading"
}, na = { class: "mb-2" }, oa = { class: "mb-2" }, sa = {
  key: 3,
  class: "text-error",
  role: "alert"
}, Qg = /* @__PURE__ */ ge({
  __name: "employment-info-component",
  props: {
    data: { default: hl }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = se({
      ...n.data
    }), i = X(null), u = X(!1), d = Be(), p = d + "-employer-name", y = d + "-employer-address", f = d + "-employer-post-code", {
      v$: _,
      validateForm: b,
      getPostCodeEmploymentInfo: g,
      scrollToFirstErrorWrapper: h,
      showHeading: v,
      showEmployerFields: N
    } = ta(l, i);
    return te(
      () => n.data,
      // Watch for changes in the data
      ($) => {
        Object.assign(l, $);
      },
      { deep: !0 }
    ), te(
      l,
      ($) => {
        a("update:data", $);
      },
      { deep: !0 }
    ), Se(() => {
      u.value = !0, a("componentReady");
    }), t({
      validateForm: b,
      scrollToFirstErrorWrapper: h,
      componentReady: u
    }), ($, S) => {
      var A;
      const I = U("v-col"), C = U("v-row"), T = U("v-autocomplete");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: i,
        class: "employment-info-component"
      }, [
        r(v) ? (w(), F("h2", ra, P(r(o)("Components.EmplymentInfoComponent.EmploymentTitle")), 1)) : B("", !0),
        r(N) ? (w(), ce(C, { key: 1 }, {
          default: E(() => [
            m(I, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var M;
                return [
                  c("div", na, [
                    c("label", {
                      for: p,
                      class: "form-label"
                    }, P(r(o)("Components.EmplymentInfoComponent.EmployerName")), 1),
                    m(be, {
                      id: p,
                      modelValue: l.employerName,
                      "onUpdate:modelValue": S[0] || (S[0] = (L) => l.employerName = L),
                      error: r(_).employerName.$error,
                      "error-messages": ((M = r(_).employerName.$errors[0]) == null ? void 0 : M.$message) ?? "",
                      variant: "outlined",
                      onFocus: S[1] || (S[1] = (L) => r(_).employerName.$reset()),
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            m(I, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var M;
                return [
                  c("div", oa, [
                    c("label", {
                      for: y,
                      class: "form-label"
                    }, P(r(o)("Components.EmplymentInfoComponent.EmployerAddress")), 1),
                    m(be, {
                      id: y,
                      modelValue: l.employerAddress,
                      "onUpdate:modelValue": S[2] || (S[2] = (L) => l.employerAddress = L),
                      error: r(_).employerAddress.$error,
                      "error-messages": ((M = r(_).employerAddress.$errors[0]) == null ? void 0 : M.$message) ?? "",
                      variant: "outlined",
                      onFocus: S[3] || (S[3] = (L) => r(_).employerAddress.$reset()),
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0),
        r(N) ? (w(), ce(C, { key: 2 }, {
          default: E(() => [
            m(I, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var M;
                return [
                  c("div", null, [
                    c("label", {
                      for: f,
                      class: "form-label"
                    }, P(r(o)("Components.EmplymentInfoComponent.EmployerPostalCode")), 1),
                    m(T, {
                      id: f,
                      modelValue: l.employerPostCode,
                      "onUpdate:modelValue": S[4] || (S[4] = (L) => l.employerPostCode = L),
                      error: r(_).employerPostCode.$error,
                      "error-messages": String(((M = r(_).employerPostCode.$errors[0]) == null ? void 0 : M.$message) ?? ""),
                      items: r(g),
                      "item-title": "Value",
                      "item-value": "Key",
                      variant: "outlined",
                      onFocus: S[5] || (S[5] = (L) => r(_).employerPostCode.$reset())
                    }, null, 8, ["modelValue", "error", "error-messages", "items"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0),
        r(_).employmentType.$error ? (w(), F("div", sa, P(((A = r(_).employmentType.$errors[0]) == null ? void 0 : A.$message) ?? ""), 1)) : B("", !0)
      ], 512);
    };
  }
});
function Jn() {
  return {
    hasPermanentResidenceInSlovenia: void 0,
    isSlovenianCitizen: void 0,
    hasSlovenianIncome: void 0,
    hasSlovenianBankAccount: void 0,
    employmentSubType: void 0,
    orderToken: ""
  };
}
function ia() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function la(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    hasPermanentResidenceInSlovenia: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    isSlovenianCitizen: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    hasSlovenianIncome: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    hasSlovenianBankAccount: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ve(() => e.isSlovenianCitizen === !1))
    }
  })) };
}
function aa(e, t, s) {
  const { validationRules: n } = la(e), a = Me(n, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: o } = Oe();
  async function l() {
    return a.value.$touch(), await a.value.$validate();
  }
  function i() {
    o(s.value);
  }
  const { t: u } = oe(), d = G(() => {
    const y = e.hasPermanentResidenceInSlovenia === !1, f = e.hasSlovenianIncome === !1 || e.hasSlovenianBankAccount === !1, _ = e.isSlovenianCitizen === !1 && f;
    return y || _ ? u("GlobalErrors.NotEligible") : "";
  });
  async function p(y) {
    e.isSlovenianCitizen != y.isSlovenianCitizen && (e.isSlovenianCitizen === !1 && (e.employmentSubType = st.AfternoonSP), e.hasSlovenianBankAccount = void 0);
  }
  return {
    v$: a,
    dataChanged: p,
    validateForm: l,
    scrollToFirstErrorWrapper: i,
    eligibilityError: d
  };
}
const ua = { class: "section-heading" }, da = ["id"], ca = ["id"], ma = ["id"], fa = ["id"], pa = {
  key: 0,
  class: "notification notification--warning",
  role: "alert"
}, va = {
  key: 1,
  class: "notification notification--warning",
  role: "alert"
}, Kg = /* @__PURE__ */ ge({
  __name: "precheck-component",
  props: {
    data: { default: Jn }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = se({ ...n.data }), i = se(ia()), u = se(Jn()), d = Be(), p = X(null), y = X(!1);
    te(
      () => n.data,
      // Watch for changes in the data
      (v) => {
        Object.assign(l, v);
      },
      { deep: !0 }
    ), te(
      l,
      async (v) => {
        await _(u), Object.assign(u, v), a("update:data", v);
      },
      { deep: !0 }
    ), Se(() => {
      y.value = !0, a("componentReady");
    });
    const {
      v$: f,
      dataChanged: _,
      scrollToFirstErrorWrapper: b,
      eligibilityError: g,
      validateForm: h
    } = aa(l, i, p);
    return t({
      componentReady: y,
      validateForm: h,
      scrollToFirstErrorWrapper: b
    }), (v, N) => {
      const $ = U("v-radio"), S = U("v-radio-group"), I = U("v-col"), C = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: p,
        class: "precheck-component"
      }, [
        c("h2", ua, P(r(o)("Components.PrecheckComponent.Title")), 1),
        m(C, null, {
          default: E(() => [
            m(I, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var T;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-hasPermanentResidenceInSlovenia-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.PrecheckComponent.hasPermanentResidenceInSlovenia")), 9, da),
                    m(S, {
                      modelValue: l.hasPermanentResidenceInSlovenia,
                      "onUpdate:modelValue": N[0] || (N[0] = (A) => l.hasPermanentResidenceInSlovenia = A),
                      "aria-labelledby": r(d) + "-hasPermanentResidenceInSlovenia-label",
                      error: r(f).hasPermanentResidenceInSlovenia.$error,
                      "error-messages": ((T = r(f).hasPermanentResidenceInSlovenia.$errors[0]) == null ? void 0 : T.$message) ?? "",
                      onFocus: N[1] || (N[1] = (A) => r(f).hasPermanentResidenceInSlovenia.$reset())
                    }, {
                      default: E(() => [
                        m($, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m($, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            m(I, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var T;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-isSlovenianCitizen-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.PrecheckComponent.isSlovenianCitizen")), 9, ca),
                    m(S, {
                      modelValue: l.isSlovenianCitizen,
                      "onUpdate:modelValue": N[2] || (N[2] = (A) => l.isSlovenianCitizen = A),
                      "aria-labelledby": r(d) + "-isSlovenianCitizen-label",
                      error: r(f).isSlovenianCitizen.$error,
                      "error-messages": ((T = r(f).isSlovenianCitizen.$errors[0]) == null ? void 0 : T.$message) ?? "",
                      onFocus: N[3] || (N[3] = (A) => r(f).isSlovenianCitizen.$reset())
                    }, {
                      default: E(() => [
                        m($, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m($, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(C, null, {
          default: E(() => [
            m(I, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var T;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-hasSlovenianIncome-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.PrecheckComponent.hasSlovenianIncome")), 9, ma),
                    m(S, {
                      modelValue: l.hasSlovenianIncome,
                      "onUpdate:modelValue": N[4] || (N[4] = (A) => l.hasSlovenianIncome = A),
                      "aria-labelledby": r(d) + "-hasSlovenianIncome-label",
                      error: r(f).hasSlovenianIncome.$error,
                      "error-messages": ((T = r(f).hasSlovenianIncome.$errors[0]) == null ? void 0 : T.$message) ?? "",
                      onFocus: N[5] || (N[5] = (A) => r(f).hasSlovenianIncome.$reset())
                    }, {
                      default: E(() => [
                        m($, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m($, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            l.isSlovenianCitizen === !1 ? (w(), ce(I, {
              key: 0,
              class: "v-col-12 v-col-md-6"
            }, {
              default: E(() => {
                var T;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-hasSlovenianBankAccount-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.PrecheckComponent.hasSlovenianBankAccount")), 9, fa),
                    m(S, {
                      modelValue: l.hasSlovenianBankAccount,
                      "onUpdate:modelValue": N[6] || (N[6] = (A) => l.hasSlovenianBankAccount = A),
                      "aria-labelledby": r(d) + "-hasSlovenianBankAccount-label",
                      error: r(f).hasSlovenianBankAccount.$error,
                      "error-messages": ((T = r(f).hasSlovenianBankAccount.$errors[0]) == null ? void 0 : T.$message) ?? "",
                      onFocus: N[7] || (N[7] = (A) => r(f).hasSlovenianBankAccount.$reset())
                    }, {
                      default: E(() => [
                        m($, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m($, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })) : B("", !0)
          ]),
          _: 1
        }),
        r(g) ? (w(), F("div", pa, P(r(g)), 1)) : B("", !0),
        i.message ? (w(), F("div", va, P(i.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function Xn() {
  return {
    taxNumber: void 0,
    orderToken: "",
    isCompanyTaxNumber: !1,
    isSlovenianCitizen: void 0,
    hasSlovenianBankAccount: void 0,
    employmentType: void 0,
    employmentSubType: void 0
  };
}
function ga() {
  return {
    externalResults: {},
    isDataLoading: !0,
    message: ""
  };
}
function ya(e) {
  const { t } = oe();
  function s() {
    return !e.isCompanyTaxNumber || e.employmentSubType === st.AfternoonSP;
  }
  return { validationRules: G(() => ({
    employmentSubType: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ve(() => e.isCompanyTaxNumber))
    },
    employmentType: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ve(s))
    }
  })) };
}
function ba(e, t, s) {
  const n = ue("commClient"), { validationRules: a } = ya(e), o = Me(a, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: l } = Oe();
  async function i() {
    return o.value.$touch(), await o.value.$validate();
  }
  function u() {
    l(s.value);
  }
  async function d() {
    const y = await n.executeMethodAsync("DavcnaPravna", {
      OrderToken: e.orderToken,
      DavcnaSt: e.taxNumber
    });
    y.ErrorText === "" && (e.isCompanyTaxNumber = y.IsCompanyTax);
  }
  async function p(y) {
    e.employmentSubType != y.employmentSubType && (e.employmentSubType === st.SP ? (e.employmentType = Ne.SP, e.hasSlovenianBankAccount = !0, e.isSlovenianCitizen = !0) : y.employmentSubType !== void 0 && (y.employmentSubType === st.SP || e.employmentSubType !== st.AfternoonSP) && (e.employmentType = void 0)), e.isCompanyTaxNumber != y.isCompanyTaxNumber && (e.employmentSubType = void 0, e.employmentType = void 0);
  }
  return {
    v$: o,
    dataChanged: p,
    validateForm: i,
    scrollToFirstErrorWrapper: u,
    checkIfTaxNumberIsCompany: d
  };
}
const Ca = ["id"], Ia = ["id"], _a = {
  key: 0,
  class: "notification notification--warning",
  role: "alert"
}, Zg = /* @__PURE__ */ ge({
  __name: "employment-type-component",
  props: {
    data: { default: Xn }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = Be(), i = X(null), u = X(!1), d = se({ ...n.data }), p = se(Xn()), y = se(ga());
    te(
      () => n.data,
      // Watch for changes in the data
      (v) => {
        Object.assign(d, v);
      },
      { deep: !0 }
    ), te(
      d,
      async (v) => {
        await _(p), Object.assign(p, v), a("update:data", v);
      },
      { deep: !0 }
    ), Se(async () => {
      await g(), u.value = !0, a("componentReady");
    });
    const {
      v$: f,
      dataChanged: _,
      validateForm: b,
      checkIfTaxNumberIsCompany: g,
      scrollToFirstErrorWrapper: h
    } = ba(d, y, i);
    return t({
      componentReady: u,
      validateForm: b,
      scrollToFirstErrorWrapper: h
    }), (v, N) => {
      const $ = U("v-radio"), S = U("v-radio-group"), I = U("v-col"), C = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: i,
        class: "employment-type-component"
      }, [
        m(C, null, {
          default: E(() => [
            d.isCompanyTaxNumber ? (w(), ce(I, {
              key: 0,
              class: "v-col-12 v-col-md-6"
            }, {
              default: E(() => {
                var T;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(l) + "-employmentSubType-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.EmploymentTypeComponent.employmentSubType")), 9, Ca),
                    m(S, {
                      modelValue: d.employmentSubType,
                      "onUpdate:modelValue": N[0] || (N[0] = (A) => d.employmentSubType = A),
                      "aria-labelledby": r(l) + "-employmentSubType-label",
                      error: r(f).employmentSubType.$error,
                      "error-messages": ((T = r(f).employmentSubType.$errors[0]) == null ? void 0 : T.$message) ?? "",
                      onFocus: N[1] || (N[1] = (A) => r(f).employmentSubType.$reset())
                    }, {
                      default: E(() => [
                        m($, {
                          label: r(o)("Components.EmploymentTypeComponent.AfternoonSP"),
                          value: r(st).AfternoonSP
                        }, null, 8, ["label", "value"]),
                        m($, {
                          label: r(o)("Components.EmploymentTypeComponent.SP"),
                          value: r(st).SP,
                          disabled: d.isSlovenianCitizen === !1
                        }, null, 8, ["label", "value", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })) : B("", !0),
            !d.isCompanyTaxNumber || d.employmentSubType === r(st).AfternoonSP ? (w(), ce(I, {
              key: 1,
              class: "v-col-12 v-col-md-6"
            }, {
              default: E(() => {
                var T;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(l) + "-employmentType-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.EmploymentTypeComponent.employmentType")), 9, Ia),
                    m(S, {
                      modelValue: d.employmentType,
                      "onUpdate:modelValue": N[2] || (N[2] = (A) => d.employmentType = A),
                      "aria-labelledby": r(l) + "-employmentType-label",
                      error: r(f).employmentType.$error,
                      "error-messages": ((T = r(f).employmentType.$errors[0]) == null ? void 0 : T.$message) ?? "",
                      onFocus: N[3] || (N[3] = (A) => r(f).employmentType.$reset())
                    }, {
                      default: E(() => [
                        m($, {
                          label: r(o)("Components.EmploymentTypeComponent.Employed"),
                          value: r(Ne).Zaposlen
                        }, null, 8, ["label", "value"]),
                        m($, {
                          label: r(o)("Components.EmploymentTypeComponent.Pensioner"),
                          value: r(Ne).Upokojenec
                        }, null, 8, ["label", "value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })) : B("", !0)
          ]),
          _: 1
        }),
        y.message ? (w(), F("div", _a, P(y.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function Dn() {
  return {
    hadTRRExecution: void 0,
    hadBlockedTRR: void 0,
    hadLatePayment: void 0,
    hadBankruptcyProceedings: void 0,
    flowType: void 0,
    isViewDataLoading: !1,
    orderToken: "",
    averageSalary: void 0,
    sumInstallments: void 0,
    taxNumber: void 0,
    msisdn: null,
    isSlovenianCitizen: void 0
  };
}
function ha() {
  return {
    showConfirmData: !0,
    confirmDataError: !1
  };
}
const Ta = ge({
  props: {
    modelValue: {
      type: null,
      required: !1
    },
    numberOfDecimals: {
      type: Number,
      default: 0
    },
    maxLength: {
      type: Number,
      default: 0
    },
    appendInnerIcon: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    maxValue: {
      type: Number
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    formatNumber: {
      type: Function,
      required: !1
    },
    appendText: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String
    }
  },
  setup(e, { emit: t }) {
    const s = X(null), n = X(!1), a = G(() => e.modelValue), { n: o } = oe();
    async function l() {
      await navigator.clipboard.readText().then((y) => {
        y = y.replace(/\s/g, "").replace(new RegExp("(?<=\\d)\\.(?=\\d{3})", "g"), "").replace(",", ".");
        let f = parseFloat(y);
        i(isNaN(f) ? 0 : f);
      });
    }
    te(a, () => {
      e.maxValue && e.modelValue > e.maxValue ? i(e.maxValue) : i(a.value);
    }), Se(() => {
      i(e.modelValue);
    });
    function i(y) {
      y != parseFloat(s.value.value.replace(",", ".")) && (y != null && y != null ? s.value.value = o(parseFloat(y.toString().replace(",", ".")), { key: "decimal", minimumFractionDigits: e.numberOfDecimals, maximumFractionDigits: e.numberOfDecimals, useGrouping: !1 }) : s.value.value = null);
    }
    function u(y) {
      e.maxLength == 1 && !isNaN(parseInt(y.key)) ? y.target.value = "" : (e.numberOfDecimals == 0 && y.key == "," || y.key != "," && isNaN(parseInt(y.key))) && y.preventDefault();
    }
    function d(y) {
      let f = parseFloat(y.target.value.replace(",", "."));
      t("update:modelValue", isNaN(f) ? null : f);
    }
    function p(y) {
      n.value = !1;
      let f = y.target.value;
      f && e.numberOfDecimals > 0 && (y.target.value = o(parseFloat(f.replace(",", ".")), { key: "decimal", minimumFractionDigits: e.numberOfDecimals, maximumFractionDigits: e.numberOfDecimals, useGrouping: !1 }), t("update:modelValue", parseFloat(y.target.value.replace(",", "."))));
    }
    return {
      input: s,
      focused: n,
      KeyPressed: u,
      UpdateValue: d,
      FixInputValue: p,
      FixPasteValue: l
    };
  }
}), Zo = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [n, a] of t)
    s[n] = a;
  return s;
}, Ea = {
  class: "v-field__field",
  "data-no-activator": ""
}, Na = {
  class: "v-field__input",
  "data-no-activator": ""
}, Sa = ["maxLength", "maxValue", "autofocus", "autocomplete"], Pa = {
  key: 0,
  class: "v-field__append-inner"
}, $a = {
  key: 1,
  class: "v-field__append-inner"
};
function Ma(e, t, s, n, a, o) {
  const l = U("v-input");
  return w(), ce(l, { class: "v-text-field v-numeric-field" }, {
    default: E(() => [
      c("div", {
        tabIndex: 0,
        onFocus: t[6] || (t[6] = (...i) => e.input.focus && e.input.focus(...i)),
        class: ke([{ "v-field--appended": e.appendInnerIcon != "" || e.appendText != "", "v-field--focused": e.focused, "v-field--disabled": e.disabled }, "v-field v-field--variant-outlined"]),
        role: "textbox"
      }, [
        t[8] || (t[8] = c("div", { class: "v-field__overlay" }, null, -1)),
        c("div", Ea, [
          t[7] || (t[7] = c("label", { class: "v-label v-field-label" }, null, -1)),
          c("div", Na, [
            c("input", Yr(e.$attrs, {
              ref: "input",
              onFocus: t[0] || (t[0] = (i) => e.focused = !0),
              onBlur: t[1] || (t[1] = (i) => e.focused = !1),
              onPaste: t[2] || (t[2] = (i) => e.FixPasteValue()),
              onKeypress: t[3] || (t[3] = (...i) => e.KeyPressed && e.KeyPressed(...i)),
              onInput: t[4] || (t[4] = (...i) => e.UpdateValue && e.UpdateValue(...i)),
              onChange: t[5] || (t[5] = (...i) => e.FixInputValue && e.FixInputValue(...i)),
              type: "text",
              size: "1",
              maxLength: e.maxLength == 0 ? void 0 : e.maxLength,
              maxValue: e.maxValue,
              autofocus: e.autofocus,
              autocomplete: e.autocomplete
            }), null, 16, Sa)
          ])
        ]),
        e.appendInnerIcon != "" ? (w(), F("div", Pa, [
          c("i", {
            class: ke([e.appendInnerIcon, "mdi v-icon notranslate v-icon--size-default"]),
            "aria-hidden": "true"
          }, null, 2)
        ])) : B("", !0),
        e.appendText != "" ? (w(), F("div", $a, P(e.appendText), 1)) : B("", !0),
        t[9] || (t[9] = c("div", { class: "v-field__outline" }, [
          c("div", { class: "v-field__outline__start" }),
          c("div", { class: "v-field__outline__end" })
        ], -1))
      ], 34)
    ]),
    _: 1
  });
}
const Ke = /* @__PURE__ */ Zo(Ta, [["render", Ma]]);
function Aa(e) {
  const { t } = oe();
  return G(() => ({
    hadTRRExecution: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    hadBlockedTRR: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    hadLatePayment: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    hadBankruptcyProceedings: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    averageSalary: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    sumInstallments: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    }
  }));
}
function wa(e, t) {
  const s = Me(Aa(), G(() => e), { $autoDirty: !0 }), n = ue("commClient"), a = ue("navigationButtonsApi", null), { scrollToFirstError: o } = Oe();
  async function l() {
    return s.value.$touch(), s.value.$validate();
  }
  function i() {
    a !== null && a.setButtonDisabled("Next", !0);
  }
  async function u() {
    s.value.$touch();
    const f = await s.value.$validate();
    return f && (window.dataLayer && window.dataLayer.push({
      event: "funnel_8",
      funnel_name: "izracun_limita",
      step: 8,
      step_name: "financni_podatki",
      cta_name: "Potrdi"
    }), a !== null && (a == null || a.setButtonDisabled("Next", !1)), t.showConfirmData = !1, t.confirmDataError = !1), f;
  }
  async function d(f) {
    [
      "hadTRRExecution",
      "hadBlockedTRR",
      "hadLatePayment",
      "hadBankruptcyProceedings",
      "averageSalary",
      "sumInstallments"
    ].some((g) => e[g] !== f[g]) && (a !== null && (a == null || a.setButtonDisabled("Next", !0)), t.showConfirmData = !0, t.confirmDataError = !1);
  }
  function p() {
    o(".financial-conditions-component");
  }
  async function y(f) {
    let _ = !1, b = null;
    switch (f) {
      case "validate":
        _ = await l(), _ && (b = { name: "valid" });
        break;
      case "webNext":
        if (_ = await l(), _) {
          if (t.showConfirmData)
            return t.confirmDataError = !0, null;
          await n.executeMethodAsync("SaveFinancialData", {
            TaxNumber: e.taxNumber,
            Msisdn: e.msisdn,
            IsSlovenianCitizen: e.isSlovenianCitizen,
            HadTRRExecution: e.hadTRRExecution,
            HadBlockedTRR: e.hadBlockedTRR,
            HadLatePayment: e.hadLatePayment,
            HadBankruptcyProceedings: e.hadBankruptcyProceedings,
            AverageSalary: e.averageSalary,
            SumInstallments: e.sumInstallments,
            OrderToken: e.orderToken
          }), e.hadBankruptcyProceedings === !0 || e.hadLatePayment === !0 || e.hadBlockedTRR === !0 || e.hadTRRExecution === !0 ? b = { name: "endFail" } : b = { name: "nextStep" };
        }
        break;
    }
    return b;
  }
  return {
    v$: s,
    navigationAction: y,
    scrollToFirstErrorWrapper: p,
    confirmData: u,
    dataChanged: d,
    setupComponent: i
  };
}
const ka = {
  class: "financial-conditions-component",
  ref: "rootRef"
}, Oa = { class: "section-heading" }, Ra = {
  key: 0,
  class: "callout mt-10"
}, La = { class: "mt-8" }, xa = {
  key: 0,
  class: "v-input--error mt-4"
}, Fa = { class: "v-input__details" }, Va = { class: "v-messages" }, za = { class: "v-messages__message" }, Jg = /* @__PURE__ */ ge({
  __name: "financial-conditions-component",
  props: {
    data: { default: Dn }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: s }) {
    const { t: n } = oe(), a = e, o = s;
    let l = X(!1);
    const i = se({ ...a.data });
    let u = Dn();
    const d = se(ha()), { v$: p, navigationAction: y, scrollToFirstErrorWrapper: f, confirmData: _, dataChanged: b, setupComponent: g } = wa(i, d);
    return te(
      () => a.data,
      // Watch for changes in the data
      (h) => {
        Object.assign(i, h);
      },
      { deep: !0 }
    ), te(
      i,
      async (h) => {
        await b(u), Object.assign(u, h), o("update:data", h);
      },
      { deep: !0 }
    ), Se(() => {
      g(), l.value = !0, o("componentReady");
    }), t({
      navigationAction: y,
      scrollToFirstErrorWrapper: f,
      componentReady: l
    }), (h, v) => {
      const N = U("v-radio"), $ = U("v-radio-group"), S = U("v-col"), I = U("v-row"), C = U("v-btn");
      return w(), F("div", ka, [
        c("h2", Oa, P(r(n)("Components.FinancialConditionComponent.FinancialTitle")), 1),
        m(I, null, {
          default: E(() => [
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                v[7] || (v[7] = c("label", { class: "form-label" }, " Ste imeli v zadnjem letu izvršbo na TRR? ", -1)),
                m($, {
                  modelValue: i.hadTRRExecution,
                  "onUpdate:modelValue": v[0] || (v[0] = (T) => i.hadTRRExecution = T),
                  error: r(p).hadTRRExecution.error,
                  "error-messages": r(p).hadTRRExecution.$errors[0] != null ? r(p).hadTRRExecution.$errors[0].$message : "",
                  onFocus: r(p).hadTRRExecution.$reset
                }, {
                  default: E(() => [
                    m(N, {
                      label: r(n)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    m(N, {
                      label: r(n)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                v[8] || (v[8] = c("label", { class: "form-label" }, " Ste imeli v zadnjem letu blokiran TRR? ", -1)),
                m($, {
                  modelValue: i.hadBlockedTRR,
                  "onUpdate:modelValue": v[1] || (v[1] = (T) => i.hadBlockedTRR = T),
                  error: r(p).hadBlockedTRR.error,
                  "error-messages": r(p).hadBlockedTRR.$errors[0] != null ? r(p).hadBlockedTRR.$errors[0].$message : "",
                  onFocus: r(p).hadBlockedTRR.$reset
                }, {
                  default: E(() => [
                    m(N, {
                      label: r(n)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    m(N, {
                      label: r(n)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        m(I, null, {
          default: E(() => [
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                v[9] || (v[9] = c("label", { class: "form-label" }, " Ste v zadnjem letu zamujali s plačilom obroka kredita ali leasinga? ", -1)),
                m($, {
                  modelValue: i.hadLatePayment,
                  "onUpdate:modelValue": v[2] || (v[2] = (T) => i.hadLatePayment = T),
                  error: r(p).hadLatePayment.error,
                  "error-messages": r(p).hadLatePayment.$errors[0] != null ? r(p).hadLatePayment.$errors[0].$message : "",
                  onFocus: r(p).hadLatePayment.$reset
                }, {
                  default: E(() => [
                    m(N, {
                      label: r(n)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    m(N, {
                      label: r(n)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                v[10] || (v[10] = c("label", { class: "form-label" }, " Ste trenutno v stečajnem postopku? ", -1)),
                m($, {
                  modelValue: i.hadBankruptcyProceedings,
                  "onUpdate:modelValue": v[3] || (v[3] = (T) => i.hadBankruptcyProceedings = T),
                  error: r(p).hadBankruptcyProceedings.error,
                  "error-messages": r(p).hadBankruptcyProceedings.$errors[0] != null ? r(p).hadBankruptcyProceedings.$errors[0].$message : "",
                  onFocus: r(p).hadBankruptcyProceedings.$reset
                }, {
                  default: E(() => [
                    m(N, {
                      label: r(n)("GeneralButtons.Yes"),
                      value: !0
                    }, null, 8, ["label"]),
                    m(N, {
                      label: r(n)("GeneralButtons.No"),
                      value: !1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        m(I, null, {
          default: E(() => [
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                v[11] || (v[11] = c("label", { class: "form-label" }, " Znesek plače ali pokojnine ", -1)),
                m(Ke, {
                  modelValue: i.averageSalary,
                  "onUpdate:modelValue": v[4] || (v[4] = (T) => i.averageSalary = T),
                  "error-messages": r(p).averageSalary.$errors[0] != null ? r(p).averageSalary.$errors[0].$message : "",
                  onFocus: r(p).averageSalary.$reset,
                  variant: "outlined",
                  appendInnerIcon: "mdi-currency-eur",
                  numberOfDecimals: 2,
                  hint: "Vpišite vsoto neto prihodka, prehrane in prevoza.",
                  "persistent-hint": ""
                }, null, 8, ["modelValue", "error-messages", "onFocus"])
              ]),
              _: 1
            }),
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                v[12] || (v[12] = c("label", { class: "form-label" }, " Vsota vseh trenutnih mesečnih obrokov ", -1)),
                m(Ke, {
                  modelValue: i.sumInstallments,
                  "onUpdate:modelValue": v[5] || (v[5] = (T) => i.sumInstallments = T),
                  "error-messages": r(p).sumInstallments.$errors[0] != null ? r(p).sumInstallments.$errors[0].$message : "",
                  onFocus: r(p).sumInstallments.$reset,
                  variant: "outlined",
                  appendInnerIcon: "mdi-currency-eur",
                  numberOfDecimals: 2,
                  hint: "Vpišite seštevek vseh svojih obrokov iz naslova kreditov in leasingov.",
                  "persistent-hint": ""
                }, null, 8, ["modelValue", "error-messages", "onFocus"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d.showConfirmData ? (w(), F("div", Ra, [
          v[14] || (v[14] = Ie(" Prosimo ponovno preverite in potrdite točnost vnesenih finančnih podatkov. ")),
          v[15] || (v[15] = c("br", null, null, -1)),
          v[16] || (v[16] = c("br", null, null, -1)),
          v[17] || (v[17] = c("span", { class: "font-weight-600" }, "Za podane podatke ste pravno in materialno odgovorni.", -1)),
          v[18] || (v[18] = Ie()),
          v[19] || (v[19] = c("br", null, null, -1)),
          v[20] || (v[20] = c("br", null, null, -1)),
          v[21] || (v[21] = Ie(" Vnesene finančne podatke bomo po identifikaciji preverili v informacijskem sistemu bonitet fizičnih oseb (SISBON). Če se bo ob preverjanju izkazalo, da so podatki delno ali v celoti napačni, bo ocena limita za obročno odplačevanje lahko negativna in pogodbe ne bo možno skleniti.")),
          v[22] || (v[22] = c("br", null, null, -1)),
          v[23] || (v[23] = c("br", null, null, -1)),
          c("div", La, [
            m(C, {
              onClick: v[6] || (v[6] = (T) => r(_)()),
              class: "btn btn--primary-fill",
              variant: "flat"
            }, {
              default: E(() => v[13] || (v[13] = [
                Ie(" Potrdi podatke ")
              ])),
              _: 1
            })
          ]),
          d.confirmDataError ? (w(), F("div", xa, [
            c("div", Fa, [
              c("div", Va, [
                c("div", za, P(r(n)("GlobalErrors.ConfirmDataError")), 1)
              ])
            ])
          ])) : B("", !0)
        ])) : B("", !0)
      ], 512);
    };
  }
}), ja = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_41_5426)'%3e%3cpath%20d='M8.00004%2014.6666C11.6819%2014.6666%2014.6667%2011.6819%2014.6667%207.99998C14.6667%204.31808%2011.6819%201.33331%208.00004%201.33331C4.31814%201.33331%201.33337%204.31808%201.33337%207.99998C1.33337%2011.6819%204.31814%2014.6666%208.00004%2014.6666Z'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8%2010.6667V8'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8%205.33331H8.00667'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_41_5426'%3e%3crect%20width='16'%20height='16'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
function Ua() {
  return {
    isPoliticallyExposedPerson: void 0,
    politicalFunction: "",
    pioSourceFunds: "",
    pioFundsStatus: ""
  };
}
function Ga(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    isPoliticallyExposedPerson: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    politicalFunction: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ve(() => e.isPoliticallyExposedPerson === !0))
    },
    pioSourceFunds: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ve(() => e.isPoliticallyExposedPerson === !0))
    },
    pioFundsStatus: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ve(() => e.isPoliticallyExposedPerson === !0))
    }
  })) };
}
function Ba(e, t) {
  const { validationRules: s } = Ga(e), n = se({
    externalResults: {},
    isDataLoading: !1,
    message: ""
  }), a = Me(s, G(() => e), {
    $autoDirty: !0,
    $externalResults: n.externalResults
  }), { scrollToFirstError: o } = Oe();
  async function l() {
    return a.value.$touch(), await a.value.$validate();
  }
  function i() {
    o(t.value);
  }
  function u(d) {
    n.message = d;
  }
  return te(() => e.isPoliticallyExposedPerson, () => {
    e.politicalFunction = "", e.pioSourceFunds = "", e.pioFundsStatus = "", a.value.$reset();
  }, { flush: "sync" }), {
    v$: a,
    localData: n,
    validateForm: l,
    scrollToFirstErrorWrapper: i,
    fail: u
  };
}
const Wa = { class: "section-heading" }, Ya = ["id"], qa = ["aria-label"], Ha = ["for"], Qa = ["for"], Ka = ["for"], Za = {
  key: 1,
  class: "notification notification--warning",
  role: "alert"
}, Xg = /* @__PURE__ */ ge({
  __name: "politically-exposed-person-component",
  props: {
    data: { default: Ua }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = Be(), i = se({ ...n.data }), u = X(null), d = X(!1);
    te(
      () => n.data,
      // Watch for changes in the data
      (b) => {
        Object.assign(i, b);
      },
      { deep: !0 }
    ), te(
      i,
      async (b) => {
        a("update:data", b);
      },
      { deep: !0 }
    ), Se(() => {
      d.value = !0, a("componentReady");
    });
    const {
      v$: p,
      localData: y,
      validateForm: f,
      scrollToFirstErrorWrapper: _
    } = Ba(i, u);
    return t({
      componentReady: d,
      validateForm: f,
      scrollToFirstErrorWrapper: _
    }), (b, g) => {
      const h = U("v-tooltip"), v = U("v-radio"), N = U("v-radio-group"), $ = U("v-col"), S = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: u,
        class: "politically-exposed-person-component"
      }, [
        c("h2", Wa, P(r(o)("Components.PoliticallyExposedPersonComponent.Title")), 1),
        m(S, null, {
          default: E(() => [
            m($, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var I;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(l) + "-isPoliticallyExposedPerson-label",
                      class: "form-label form-label--text d-flex align-center"
                    }, [
                      c("div", null, P(r(o)("Components.PoliticallyExposedPersonComponent.isPoliticallyExposedPerson")), 1),
                      m(h, {
                        text: r(o)("Components.PoliticallyExposedPersonComponent.Help"),
                        location: "bottom",
                        "close-on-content-click": !0,
                        "open-on-click": ""
                      }, {
                        activator: E(({ props: C }) => [
                          c("button", Yr({
                            type: "button",
                            class: "tag tag--white tag--icon ml-3"
                          }, C, {
                            "aria-label": r(o)("Components.PoliticallyExposedPersonComponent.HelpLabel")
                          }), g[8] || (g[8] = [
                            c("img", {
                              src: ja,
                              alt: "Info icon"
                            }, null, -1)
                          ]), 16, qa)
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ], 8, Ya),
                    m(N, {
                      modelValue: i.isPoliticallyExposedPerson,
                      "onUpdate:modelValue": g[0] || (g[0] = (C) => i.isPoliticallyExposedPerson = C),
                      "aria-labelledby": r(l) + "-isPoliticallyExposedPerson-label",
                      error: r(p).isPoliticallyExposedPerson.$error,
                      "error-messages": ((I = r(p).isPoliticallyExposedPerson.$errors[0]) == null ? void 0 : I.$message) ?? "",
                      onFocus: g[1] || (g[1] = (C) => r(p).isPoliticallyExposedPerson.$reset())
                    }, {
                      default: E(() => [
                        m(v, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m(v, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        i.isPoliticallyExposedPerson ? (w(), F(Ae, { key: 0 }, [
          m(S, null, {
            default: E(() => [
              m($, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var I;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(l) + "-politicalFunction",
                        class: "form-label"
                      }, P(r(o)("Components.PoliticallyExposedPersonComponent.politicalFunction")), 9, Ha),
                      m(be, {
                        id: r(l) + "-politicalFunction",
                        modelValue: i.politicalFunction,
                        "onUpdate:modelValue": g[2] || (g[2] = (C) => i.politicalFunction = C),
                        variant: "outlined",
                        error: r(p).politicalFunction.$error,
                        "error-messages": ((I = r(p).politicalFunction.$errors[0]) == null ? void 0 : I.$message) ?? "",
                        onFocus: g[3] || (g[3] = (C) => r(p).politicalFunction.$reset()),
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          m(S, null, {
            default: E(() => [
              m($, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var I;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(l) + "-pioSourceFunds",
                        class: "form-label"
                      }, P(r(o)("Components.PoliticallyExposedPersonComponent.pioSourceFunds")), 9, Qa),
                      m(be, {
                        id: r(l) + "-pioSourceFunds",
                        modelValue: i.pioSourceFunds,
                        "onUpdate:modelValue": g[4] || (g[4] = (C) => i.pioSourceFunds = C),
                        variant: "outlined",
                        error: r(p).pioSourceFunds.$error,
                        "error-messages": ((I = r(p).pioSourceFunds.$errors[0]) == null ? void 0 : I.$message) ?? "",
                        onFocus: g[5] || (g[5] = (C) => r(p).pioSourceFunds.$reset()),
                        hint: r(o)("Components.PoliticallyExposedPersonComponent.SourceHelp"),
                        "persistent-hint": "",
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages", "hint"])
                    ])
                  ];
                }),
                _: 1
              }),
              m($, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var I;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(l) + "-pioFundsStatus",
                        class: "form-label"
                      }, P(r(o)("Components.PoliticallyExposedPersonComponent.pioFundsStatus")), 9, Ka),
                      m(be, {
                        id: r(l) + "-pioFundsStatus",
                        modelValue: i.pioFundsStatus,
                        "onUpdate:modelValue": g[6] || (g[6] = (C) => i.pioFundsStatus = C),
                        variant: "outlined",
                        error: r(p).pioFundsStatus.$error,
                        "error-messages": ((I = r(p).pioFundsStatus.$errors[0]) == null ? void 0 : I.$message) ?? "",
                        onFocus: g[7] || (g[7] = (C) => r(p).pioFundsStatus.$reset()),
                        hint: r(o)("Components.PoliticallyExposedPersonComponent.StatusHelp"),
                        "persistent-hint": "",
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages", "hint"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64)) : B("", !0),
        r(y).message ? (w(), F("div", Za, P(r(y).message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function eo() {
  return {
    birthCity: "",
    isSlovenianCitizen: void 0,
    hasTemporaryResidence: void 0,
    temporaryAddress: "",
    temporaryCitizen: void 0,
    temporaryPostalCode: void 0,
    temporaryForeignPostalCode: "",
    countrySourceFunds: "",
    countryFundsStatus: ""
  };
}
function Ja() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function Xa(e, t) {
  const { t: s } = oe(), n = ue("generalStore");
  return { validationRules: G(() => ({
    birthCity: {
      required: V.withMessage(s("GlobalErrors.FieldRequired"), ye),
      letters: V.withMessage(s("GlobalErrors.InvalidValue"), (o) => /.*[a-zA-ZčžšČŽŠ].*[a-zA-ZčžšČŽŠ]/.test(o))
    },
    hasTemporaryResidence: {
      required: V.withMessage(s("GlobalErrors.ChoiceRequired"), ve(() => e.isSlovenianCitizen !== !1))
    },
    temporaryAddress: {
      required: V.withMessage(s("GlobalErrors.FieldRequired"), ve(() => e.hasTemporaryResidence === !0))
    },
    temporaryCitizen: {
      required: V.withMessage(s("GlobalErrors.ChoiceRequired"), ve(() => e.hasTemporaryResidence === !0))
    },
    temporaryPostalCode: {
      customRequired: V.withMessage(s("GlobalErrors.ChoiceRequired"), ve(() => e.hasTemporaryResidence === !0))
    },
    temporaryForeignPostalCode: {
      required: V.withMessage(s("GlobalErrors.FIELD_REQUIRED"), ve(() => {
        var o, l;
        return e.hasTemporaryResidence === !0 && e.temporaryCitizen !== ((l = (o = n.state.countryList) == null ? void 0 : o[0]) == null ? void 0 : l.Key);
      }))
    },
    countrySourceFunds: {
      required: V.withMessage(s("GlobalErrors.FIELD_REQUIRED"), ve(() => t.value))
    },
    countryFundsStatus: {
      required: V.withMessage(s("GlobalErrors.FIELD_REQUIRED"), ve(() => t.value))
    }
  })) };
}
function Da(e, t, s) {
  const n = ue("generalStore"), a = G(() => n.state.countryList ?? []), o = G(() => n.state.postalCodeList ?? []), l = G(() => {
    var g;
    return e.temporaryCitizen !== void 0 && e.temporaryCitizen !== ((g = a.value[0]) == null ? void 0 : g.Key);
  }), i = G(() => {
    var h;
    if (e.hasTemporaryResidence !== !0 || e.isSlovenianCitizen === !1)
      return !1;
    const g = a.value.find((v) => String(v.Key) === String(e.temporaryCitizen));
    return ((h = g == null ? void 0 : g.AdditionalData) == null ? void 0 : h.RiskDrzava) == !0;
  }), { validationRules: u } = Xa(e, i), d = Me(u, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: p } = Oe();
  async function y() {
    return d.value.$touch(), await d.value.$validate();
  }
  function f() {
    p(s.value);
  }
  function _() {
    var g;
    if (l.value) {
      const h = (g = o.value[o.value.length - 1]) == null ? void 0 : g.Key;
      e.temporaryPostalCode = h === void 0 ? void 0 : String(h);
    } else e.temporaryPostalCode === "9999" && (e.temporaryPostalCode = void 0, d.value.temporaryPostalCode.$reset());
  }
  async function b(g) {
    e.hasTemporaryResidence !== g.hasTemporaryResidence && e.hasTemporaryResidence === !1 && (e.temporaryAddress = "", e.temporaryPostalCode = void 0, e.temporaryCitizen = void 0, e.temporaryForeignPostalCode = "", d.value.$reset()), e.isSlovenianCitizen !== g.isSlovenianCitizen && e.isSlovenianCitizen === !1 && (e.hasTemporaryResidence = void 0);
  }
  return {
    v$: d,
    dataChanged: b,
    validateForm: y,
    scrollToFirstErrorWrapper: f,
    postalCodes: o,
    countries: a,
    isForeignTemporaryCountry: l,
    isRiskCountry: i,
    checkIfSloOrAbroad: _
  };
}
const eu = { class: "section-heading" }, tu = ["for"], ru = ["id"], nu = ["for"], ou = ["for"], su = ["for"], iu = ["for"], lu = { class: "notification notification--notice mb-4" }, au = { class: "font-weight-600" }, uu = ["for"], du = ["for"], cu = {
  key: 1,
  class: "notification notification--warning",
  role: "alert"
}, Dg = /* @__PURE__ */ ge({
  __name: "other-personal-info-component",
  props: {
    data: { default: eo }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, o = se({ ...n.data }), l = se(eo()), i = se(Ja()), { t: u } = oe(), d = Be(), p = X(null), y = X(!1);
    te(
      () => n.data,
      // Watch for changes in the data
      (I) => {
        Object.assign(o, I);
      },
      { deep: !0 }
    ), te(
      o,
      async (I) => {
        await _(l), Object.assign(l, I), a("update:data", I);
      },
      { deep: !0 }
    ), Se(() => {
      y.value = !0, a("componentReady");
    });
    const {
      v$: f,
      dataChanged: _,
      validateForm: b,
      scrollToFirstErrorWrapper: g,
      postalCodes: h,
      countries: v,
      isForeignTemporaryCountry: N,
      isRiskCountry: $,
      checkIfSloOrAbroad: S
    } = Da(o, i, p);
    return t({
      componentReady: y,
      validateForm: b,
      scrollToFirstErrorWrapper: g
    }), (I, C) => {
      const T = U("v-col"), A = U("v-radio"), M = U("v-radio-group"), L = U("v-row"), z = U("v-autocomplete");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: p,
        class: "other-personal-info-component"
      }, [
        c("h2", eu, P(r(u)("Components.OtherPersonalInfoComponent.Title")), 1),
        m(L, null, {
          default: E(() => [
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var O;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(d) + "-birthCity",
                      class: "form-label"
                    }, P(r(u)("Components.OtherPersonalInfoComponent.birthCity")), 9, tu),
                    m(be, {
                      id: r(d) + "-birthCity",
                      modelValue: o.birthCity,
                      "onUpdate:modelValue": C[0] || (C[0] = (H) => o.birthCity = H),
                      variant: "outlined",
                      error: r(f).birthCity.$error,
                      "error-messages": ((O = r(f).birthCity.$errors[0]) == null ? void 0 : O.$message) ?? "",
                      onFocus: C[1] || (C[1] = (H) => r(f).birthCity.$reset()),
                      autocomplete: "off"
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            o.isSlovenianCitizen !== !1 ? (w(), ce(T, {
              key: 0,
              class: "v-col-12 v-col-md-6"
            }, {
              default: E(() => {
                var O;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-hasTemporaryResidence-label",
                      class: "form-label form-label--text"
                    }, P(r(u)("Components.OtherPersonalInfoComponent.hasTemporaryResidence")), 9, ru),
                    m(M, {
                      modelValue: o.hasTemporaryResidence,
                      "onUpdate:modelValue": C[2] || (C[2] = (H) => o.hasTemporaryResidence = H),
                      "aria-labelledby": r(d) + "-hasTemporaryResidence-label",
                      error: r(f).hasTemporaryResidence.$error,
                      "error-messages": ((O = r(f).hasTemporaryResidence.$errors[0]) == null ? void 0 : O.$message) ?? "",
                      onFocus: C[3] || (C[3] = (H) => r(f).hasTemporaryResidence.$reset())
                    }, {
                      default: E(() => [
                        m(A, {
                          label: r(u)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m(A, {
                          label: r(u)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })) : B("", !0)
          ]),
          _: 1
        }),
        o.hasTemporaryResidence && o.isSlovenianCitizen !== !1 ? (w(), F(Ae, { key: 0 }, [
          m(L, null, {
            default: E(() => [
              m(T, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var O;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(d) + "-temporaryCitizen",
                        class: "form-label"
                      }, P(r(u)("Components.AdditionalContactInfoComponent.CountryTemporaryCitizen")), 9, nu),
                      m(z, {
                        id: r(d) + "-temporaryCitizen",
                        modelValue: o.temporaryCitizen,
                        "onUpdate:modelValue": [
                          C[4] || (C[4] = (H) => o.temporaryCitizen = H),
                          r(S)
                        ],
                        items: r(v),
                        "item-title": "Value",
                        "item-value": "Key",
                        variant: "outlined",
                        error: r(f).temporaryCitizen.$error,
                        "error-messages": ((O = r(f).temporaryCitizen.$errors[0]) == null ? void 0 : O.$message) ?? "",
                        onFocus: C[5] || (C[5] = (H) => r(f).temporaryCitizen.$reset())
                      }, null, 8, ["id", "modelValue", "items", "error", "error-messages", "onUpdate:modelValue"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          m(L, null, {
            default: E(() => [
              m(T, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var O;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(d) + "-temporaryAddress",
                        class: "form-label"
                      }, P(r(u)("Components.OtherPersonalInfoComponent.temporaryAddress")), 9, ou),
                      m(be, {
                        id: r(d) + "-temporaryAddress",
                        modelValue: o.temporaryAddress,
                        "onUpdate:modelValue": C[6] || (C[6] = (H) => o.temporaryAddress = H),
                        variant: "outlined",
                        error: r(f).temporaryAddress.$error,
                        "error-messages": ((O = r(f).temporaryAddress.$errors[0]) == null ? void 0 : O.$message) ?? "",
                        onFocus: C[7] || (C[7] = (H) => r(f).temporaryAddress.$reset()),
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages"])
                    ])
                  ];
                }),
                _: 1
              }),
              r(N) ? (w(), ce(T, {
                key: 1,
                class: "v-col-12 v-col-md-6"
              }, {
                default: E(() => {
                  var O;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(d) + "-temporaryForeignPostalCode",
                        class: "form-label"
                      }, P(r(u)("Components.AdditionalContactInfoComponent.PostalCodeTemporaryResidence")), 9, iu),
                      m(be, {
                        id: r(d) + "-temporaryForeignPostalCode",
                        modelValue: o.temporaryForeignPostalCode,
                        "onUpdate:modelValue": C[10] || (C[10] = (H) => o.temporaryForeignPostalCode = H),
                        variant: "outlined",
                        error: r(f).temporaryForeignPostalCode.$error,
                        "error-messages": ((O = r(f).temporaryForeignPostalCode.$errors[0]) == null ? void 0 : O.$message) ?? "",
                        onFocus: C[11] || (C[11] = (H) => r(f).temporaryForeignPostalCode.$reset()),
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages"])
                    ])
                  ];
                }),
                _: 1
              })) : (w(), ce(T, {
                key: 0,
                class: "v-col-12 v-col-md-6"
              }, {
                default: E(() => {
                  var O;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(d) + "-temporaryPostalCode",
                        class: "form-label"
                      }, P(r(u)("Components.OtherPersonalInfoComponent.temporaryPostalCode")), 9, su),
                      m(z, {
                        id: r(d) + "-temporaryPostalCode",
                        modelValue: o.temporaryPostalCode,
                        "onUpdate:modelValue": C[8] || (C[8] = (H) => o.temporaryPostalCode = H),
                        items: r(h),
                        "item-title": "Value",
                        "item-value": "Key",
                        variant: "outlined",
                        error: r(f).temporaryPostalCode.$error,
                        "error-messages": ((O = r(f).temporaryPostalCode.$errors[0]) == null ? void 0 : O.$message) ?? "",
                        onFocus: C[9] || (C[9] = (H) => r(f).temporaryPostalCode.$reset())
                      }, null, 8, ["id", "modelValue", "items", "error", "error-messages"])
                    ])
                  ];
                }),
                _: 1
              }))
            ]),
            _: 1
          }),
          r($) ? (w(), ce(L, { key: 0 }, {
            default: E(() => [
              m(T, null, {
                default: E(() => [
                  c("div", lu, [
                    c("span", au, P(r(u)("Components.AdditionalContactInfoComponent.RiskCountryTitle")), 1),
                    Ie(" " + P(r(u)("Components.AdditionalContactInfoComponent.RiskCountryNotice")), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : B("", !0),
          r($) ? (w(), ce(L, { key: 1 }, {
            default: E(() => [
              m(T, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var O;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(d) + "-countrySourceFunds",
                        class: "form-label"
                      }, P(r(u)("Components.AdditionalContactInfoComponent.CountrySourceFunds")), 9, uu),
                      m(be, {
                        id: r(d) + "-countrySourceFunds",
                        modelValue: o.countrySourceFunds,
                        "onUpdate:modelValue": C[12] || (C[12] = (H) => o.countrySourceFunds = H),
                        variant: "outlined",
                        error: r(f).countrySourceFunds.$error,
                        "error-messages": ((O = r(f).countrySourceFunds.$errors[0]) == null ? void 0 : O.$message) ?? "",
                        onFocus: C[13] || (C[13] = (H) => r(f).countrySourceFunds.$reset()),
                        hint: r(u)("Components.AdditionalContactInfoComponent.CountrySourceFundsInfo"),
                        "persistent-hint": "",
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages", "hint"])
                    ])
                  ];
                }),
                _: 1
              }),
              m(T, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var O;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(d) + "-countryFundsStatus",
                        class: "form-label"
                      }, P(r(u)("Components.AdditionalContactInfoComponent.CountryFundsStatus")), 9, du),
                      m(be, {
                        id: r(d) + "-countryFundsStatus",
                        modelValue: o.countryFundsStatus,
                        "onUpdate:modelValue": C[14] || (C[14] = (H) => o.countryFundsStatus = H),
                        variant: "outlined",
                        error: r(f).countryFundsStatus.$error,
                        "error-messages": ((O = r(f).countryFundsStatus.$errors[0]) == null ? void 0 : O.$message) ?? "",
                        onFocus: C[15] || (C[15] = (H) => r(f).countryFundsStatus.$reset()),
                        hint: r(u)("Components.AdditionalContactInfoComponent.CountryFundsStatusInfo"),
                        "persistent-hint": "",
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages", "hint"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })) : B("", !0)
        ], 64)) : B("", !0),
        i.message ? (w(), F("div", cu, P(i.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function mu() {
  return {
    documentNumber: "",
    bindingFiles: [],
    flowType: Z.POS
  };
}
function fu() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function pu(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    documentNumber: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ve(() => e.flowType === Z.POS))
    }
  })) };
}
function vu(e, t, s) {
  const { validationRules: n } = pu(e), a = Me(n, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: o } = Oe();
  async function l() {
    return a.value.$touch(), await a.value.$validate();
  }
  function i() {
    o(s.value);
  }
  return {
    v$: a,
    validateForm: l,
    scrollToFirstErrorWrapper: i
  };
}
const gu = "data:image/svg+xml;base64,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", yu = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%204L4%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M4%204L12%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", bu = { class: "file-upload" }, Cu = { class: "d-flex align-center" }, Iu = ["accept"], _u = {
  key: 0,
  class: "file-upload__no-file-text"
}, hu = { class: "loader-small" }, Tu = {
  key: 0,
  class: "file-upload__files"
}, Eu = ["onClick"], Nu = {
  key: 0,
  class: "v-input__details"
}, Su = { class: "v-messages" }, Pu = { class: "v-messages__message" }, $u = {
  key: 1,
  class: "v-input__details"
}, Mu = { class: "v-messages" }, Au = { class: "v-messages__message" }, wu = {
  key: 2,
  class: "v-input__details"
}, ku = { class: "v-messages" }, Ou = { class: "v-messages__message" }, Jo = /* @__PURE__ */ ge({
  __name: "file-upload",
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    uploadMethod: {
      type: String,
      default: null
    },
    uploadMethodParams: {
      type: Object,
      default: {}
    },
    extensions: {
      type: [String, Array],
      default: ".pdf,.jpg,.jpeg,.png"
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorText: {
      type: Object,
      default: []
    },
    infoText: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const s = ue("commClient"), { t: n } = oe(), a = e, o = t, l = X(null);
    var i = X(!1);
    let u = X(!1), d = X("");
    const p = G(() => Array.isArray(a.extensions) ? a.extensions.join(",") : a.extensions);
    function y() {
      l.value.value = "", l.value.click(), u.value = !1;
    }
    function f(h) {
      i.value = !1, h.Success === !0 ? o("update:modelValue", [...a.modelValue, ...h.FileData]) : (u.value = !0, d.value = h.ErrorMsg ? n("form_upload." + h.ErrorMsg) : n("form_upload.error_uploading"));
    }
    function _() {
      i.value = !1, u.value = !0, d.value = n("form_upload.error_uploading");
    }
    function b(h) {
      h.target.files.length > 0 && (i.value = !0, s.executeMethodUpload(h.target.files, f, a.uploadMethod, a.uploadMethodParams, _));
    }
    async function g(h, v) {
      await s.executeMethodAsync("fw4.DeleteFile", {
        FileId: h
      }).then(async (N) => {
        if (N.Success == !0) {
          let $ = JSON.parse(JSON.stringify(a.modelValue));
          $.splice(v, 1), o("update:modelValue", $);
        }
      });
    }
    return (h, v) => {
      const N = U("v-btn");
      return w(), F("div", {
        class: ke(e.error ? "v-input--error" : "")
      }, [
        c("div", bu, [
          c("div", Cu, [
            c("div", null, [
              c("input", {
                type: "file",
                ref_key: "fileUpload",
                ref: l,
                style: { display: "none" },
                accept: p.value,
                multiple: "",
                onChange: b
              }, null, 40, Iu),
              m(N, {
                onClick: ms(y, ["stop"]),
                disabled: r(i),
                flat: "",
                class: "btn btn--default-fill btn--sm mr-4"
              }, {
                default: E(() => v[0] || (v[0] = [
                  Ie(" Prebrskaj ")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            e.modelValue != null ? De((w(), F("div", _u, " Ni izbranih datotek. ", 512)), [
              [et, e.modelValue.length == 0 && r(i) == !1]
            ]) : B("", !0),
            De(c("div", hu, v[1] || (v[1] = [
              c("img", {
                src: gu,
                alt: "Loader"
              }, null, -1),
              c("div", null, "Nalagam", -1)
            ]), 512), [
              [et, r(i)]
            ])
          ]),
          e.modelValue != null && e.modelValue.length ? (w(), F("div", Tu, [
            (w(!0), F(Ae, null, tt(e.modelValue, ($, S) => (w(), F("div", null, [
              m(N, {
                class: "file-upload__file btn btn--default-outline btn--sm",
                flat: ""
              }, {
                default: E(() => [
                  Ie(P($.FileName) + " ", 1),
                  c("img", {
                    onClick: (I) => g($.FileId, S),
                    class: "file-upload__icon-delete",
                    src: yu
                  }, null, 8, Eu)
                ]),
                _: 2
              }, 1024)
            ]))), 256))
          ])) : B("", !0)
        ]),
        e.error ? (w(), F("div", Nu, [
          c("div", Su, [
            c("div", Pu, P(e.errorText[0].$message), 1)
          ])
        ])) : r(u) ? (w(), F("div", $u, [
          c("div", Mu, [
            c("div", Au, P(r(d)), 1)
          ])
        ])) : e.infoText != "" && !e.error ? (w(), F("div", wu, [
          c("div", ku, [
            c("div", Ou, P(e.infoText), 1)
          ])
        ])) : B("", !0)
      ], 2);
    };
  }
}), Ru = { class: "section-heading" }, Lu = { class: "notification notification--notice" }, xu = ["for"], Fu = ["for"], Vu = {
  key: 0,
  class: "notification notification--warning",
  role: "alert"
}, ey = /* @__PURE__ */ ge({
  __name: "pos-info-component",
  props: {
    data: { default: mu }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = Be(), i = se({ ...n.data }), u = se(fu()), d = X(null), p = X(!1);
    te(
      () => n.data,
      // Watch for changes in the data
      (b) => {
        Object.assign(i, b);
      },
      { deep: !0 }
    ), te(
      i,
      async (b) => {
        a("update:data", b);
      },
      { deep: !0 }
    ), Se(() => {
      p.value = !0, a("componentReady");
    });
    const {
      v$: y,
      validateForm: f,
      scrollToFirstErrorWrapper: _
    } = vu(i, u, d);
    return t({
      componentReady: p,
      validateForm: f,
      scrollToFirstErrorWrapper: _
    }), (b, g) => {
      const h = U("v-col"), v = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: d,
        class: "pos-info-component"
      }, [
        c("h2", Ru, P(r(o)("Components.PosInfoComponent.Title")), 1),
        m(v, null, {
          default: E(() => [
            m(h, null, {
              default: E(() => [
                c("div", Lu, P(r(o)("Components.PosInfoComponent.Notice")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        m(v, null, {
          default: E(() => [
            m(h, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var N;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(l) + "-documentNumber",
                      class: "form-label"
                    }, P(r(o)("Components.PosInfoComponent.documentNumber")), 9, xu),
                    m(be, {
                      id: r(l) + "-documentNumber",
                      modelValue: i.documentNumber,
                      "onUpdate:modelValue": g[0] || (g[0] = ($) => i.documentNumber = $),
                      variant: "outlined",
                      autocomplete: "off",
                      error: r(y).documentNumber.$error,
                      "error-messages": ((N = r(y).documentNumber.$errors[0]) == null ? void 0 : N.$message) ?? "",
                      onFocus: g[1] || (g[1] = ($) => r(y).documentNumber.$reset())
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            m(h, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                c("div", null, [
                  c("label", {
                    for: r(l) + "-bindingFiles",
                    class: "form-label"
                  }, P(r(o)("Components.PosInfoComponent.bindingFiles")), 9, Fu),
                  m(Jo, {
                    id: r(l) + "-bindingFiles",
                    modelValue: i.bindingFiles,
                    "onUpdate:modelValue": g[2] || (g[2] = (N) => i.bindingFiles = N),
                    "info-text": r(o)("Components.PosInfoComponent.UploadHelp")
                  }, null, 8, ["id", "modelValue", "info-text"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        u.message ? (w(), F("div", Vu, P(u.message), 1)) : B("", !0)
      ], 512);
    };
  }
}), on = "data:image/svg+xml;base64,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";
function to() {
  return {
    TRR: "SI56",
    hasSlovenianBankAccount: void 0,
    isSlovenianCitizen: void 0,
    employmentType: void 0,
    orderToken: ""
  };
}
function zu() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function ju(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    TRR: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ye)
      // validIban: helpers.withMessage(t("GlobalErrors.InvalidIban"), (value: string) => {
      //     if (!value) {
      //         return true;
      //     }
      //     return isDomestic() ? isValidSlovenianTrr(value) : isValidForeignIban(value);
      // })
    },
    hasSlovenianBankAccount: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ye)
    }
  })) };
}
function Uu(e, t, s) {
  const n = ue("commClient"), { t: a } = oe(), { validationRules: o } = ju(), l = Me(o, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: i } = Oe();
  async function u() {
    return await d() ? await f() : !1;
  }
  async function d() {
    return t.externalResults.TRR = [], l.value.$touch(), await l.value.$validate();
  }
  async function p(h) {
    e.hasSlovenianBankAccount != h.hasSlovenianBankAccount && e.hasSlovenianBankAccount && (e.TRR = "");
  }
  const y = G(() => {
    if (e.hasSlovenianBankAccount === !0 || e.employmentType === Ne.SP)
      return 15;
  });
  async function f() {
    t.isDataLoading = !0, t.externalResults.TRR = [];
    const h = await n.executeMethodAsync(
      "CheckIban",
      {
        OrderToken: e.orderToken,
        IBAN: e.hasSlovenianBankAccount ? "SI56" + e.TRR : e.TRR
      }
    );
    return t.isDataLoading = !1, h.Status == "VALID" ? !0 : h.Status == "UNCHECKED" ? (e.hasSlovenianBankAccount || e.employmentType == Ne.SP) && !_() ? (t.externalResults.TRR = [a("Components.PaymentDetailsComponent.InvalidIban")], !1) : b() ? !0 : (t.externalResults.TRR = [a("Components.PaymentDetailsComponent.InvalidIban")], !1) : (t.externalResults.TRR = [a("Components.PaymentDetailsComponent.InvalidIban")], !1);
  }
  function _() {
    var h = (98 - parseInt(e.TRR.substring(0, 13) + "00") % 97).toString();
    return h.length == 1 && (h = "0" + h), e.TRR == e.TRR.substring(0, 13) + h;
  }
  function b() {
    return e.TRR.replaceAll(" ", "").length > 14 && /^[A-Za-z]{2}[A-Za-z0-9]*$/.test(e.TRR.replaceAll(" ", ""));
  }
  function g() {
    i(".payment-details-component");
  }
  return {
    v$: l,
    dataChanged: p,
    validateForm: u,
    scrollToFirstErrorWrapper: g,
    trrMaxLength: y
  };
}
const Gu = { class: "section-heading" }, Bu = { class: "form-label form-label--text" }, Wu = { class: "form-label" }, Yu = {
  key: 0,
  class: "loader-small ml-4 ga-4 align-center"
}, qu = { class: "font-size-75" }, Hu = {
  key: 0,
  class: "notification notification--warning",
  role: "alert"
}, ty = /* @__PURE__ */ ge({
  __name: "payment-details-component",
  props: {
    data: { default: to }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = se({ ...n.data }), i = se(to()), u = se(zu()), d = X(null), p = X(!1);
    te(
      () => n.data,
      // Watch for changes in the data
      (h) => {
        Object.assign(l, h);
      },
      { deep: !0 }
    ), te(
      l,
      async (h) => {
        await f(i), Object.assign(i, h), a("update:data", h);
      },
      { deep: !0 }
    ), Se(() => {
      p.value = !0, a("componentReady");
    });
    const {
      v$: y,
      dataChanged: f,
      validateForm: _,
      scrollToFirstErrorWrapper: b,
      trrMaxLength: g
    } = Uu(l, u);
    return t({
      componentReady: p,
      validateForm: _,
      scrollToFirstErrorWrapper: b
    }), (h, v) => {
      const N = U("v-radio"), $ = U("v-radio-group"), S = U("v-col"), I = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: d,
        class: "payment-details-component"
      }, [
        c("h2", Gu, P(r(o)("Components.PaymentDetailsComponent.Title")), 1),
        m(I, null, {
          default: E(() => [
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                c("div", null, [
                  c("label", Bu, P(r(o)("Components.PaymentDetailsComponent.SlovenianTrr")), 1),
                  m($, {
                    modelValue: l.hasSlovenianBankAccount,
                    "onUpdate:modelValue": v[0] || (v[0] = (C) => l.hasSlovenianBankAccount = C),
                    disabled: l.isSlovenianCitizen == !1 && l.hasSlovenianBankAccount == !0 || l.employmentType === r(Ne).SP,
                    error: r(y).hasSlovenianBankAccount.error,
                    "error-messages": r(y).hasSlovenianBankAccount.$errors[0] != null ? r(y).hasSlovenianBankAccount.$errors[0].$message : "",
                    onFocus: r(y).hasSlovenianBankAccount.$reset
                  }, {
                    default: E(() => [
                      m(N, {
                        label: r(o)("GeneralButtons.Yes"),
                        value: !0
                      }, null, 8, ["label"]),
                      m(N, {
                        label: r(o)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            }),
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var C;
                return [
                  c("div", null, [
                    c("label", Wu, P(r(o)("Components.PaymentDetailsComponent.TRR")), 1),
                    m(be, {
                      ref: "trrRef",
                      modelValue: l.TRR,
                      "onUpdate:modelValue": v[1] || (v[1] = (T) => l.TRR = T),
                      variant: "outlined",
                      error: r(y).TRR.$error,
                      "error-messages": ((C = r(y).TRR.$errors[0]) == null ? void 0 : C.$message) ?? "",
                      onFocus: r(y).TRR.$reset,
                      disabled: u.isDataLoading,
                      autocomplete: "off",
                      prefix: l.hasSlovenianBankAccount == !0 || l.isSlovenianCitizen == !1 || l.employmentType === r(Ne).SP ? "SI56" : void 0,
                      counter: l.hasSlovenianBankAccount == !0 || l.isSlovenianCitizen == !1 || l.employmentType === r(Ne).SP ? "15" : void 0,
                      maxLength: r(g)
                    }, null, 8, ["modelValue", "error", "error-messages", "onFocus", "disabled", "prefix", "counter", "maxLength"]),
                    u.isDataLoading ? (w(), F("span", Yu, [
                      v[2] || (v[2] = c("img", {
                        src: on,
                        alt: "Loader"
                      }, null, -1)),
                      c("span", qu, P(h.$t("Components.PaymentDetailsComponent.LoadingData")), 1)
                    ])) : B("", !0)
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        u.message ? (w(), F("div", Hu, P(u.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function rr(e) {
  return e.mustProvideThreeSalaries;
}
function Qu() {
  return {
    taxNumber: void 0,
    creditAmount: void 0,
    selectedProductType: void 0,
    selectedProduct: void 0,
    selectedSpecialProduct: void 0,
    isPreapproved: !1,
    preapprovedCreditAmount: 0,
    preapprovedInstallmentAmount: 0,
    numberOfPreapprovedSalaries: 0,
    lastMonthsIncome: void 0,
    lastMonthsIncome2: void 0,
    lastMonthsIncome3: void 0,
    mustProvideThreeSalaries: !0,
    preapprovedCreditType: "",
    flowType: void 0,
    orderToken: "",
    msisdn: null,
    employmentType: void 0,
    isDocumentationNeeded: !1,
    isSlovenianCitizen: void 0,
    minCredit: 0,
    contractDebtInstallments: 0,
    debtInstallments: 0,
    calculatedMinInstallment: void 0,
    calculatedMaxInstallment: void 0,
    installmentNr: void 0,
    hasSlovenianIncome: void 0,
    isSalaryConfirmed: !1,
    birthdate: null,
    belowNotificationHtml: "",
    notificationHtml: "",
    notificationType: void 0,
    title: "",
    needsToEnterIncome: !0,
    numberOfPrefilledSalaries: 0,
    isViewDataLoading: !1
  };
}
function Ku() {
  return {
    externalResults: {},
    calculationError: "",
    message: "",
    clientIncomeInsert: !1
  };
}
function Zu(e) {
  const { t } = oe();
  function s(o) {
    return !rr(e) || o != null && o >= 1;
  }
  function n() {
    if (e.preapprovedCreditType !== "T2")
      return !0;
    const { lastMonthsIncome: o, lastMonthsIncome2: l, lastMonthsIncome3: i } = e;
    return o == null || l == null || i == null ? !0 : (o + l + i) / 3 >= 1500;
  }
  return { validationRules: G(() => ({
    lastMonthsIncome: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ye),
      minimum: V.withMessage(t("GlobalErrors.InvalidValue"), (o) => o != null && o > 100)
    },
    lastMonthsIncome2: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ve(() => rr(e))),
      minimum: V.withMessage(t("GlobalErrors.InvalidValue"), s)
    },
    lastMonthsIncome3: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ve(() => rr(e))),
      minimum: V.withMessage(t("GlobalErrors.InvalidValue"), s),
      average: V.withMessage(t("Components.PersonalIncomeComponent.MinAverage"), n)
    }
  })) };
}
function Ju(e, t, s, n) {
  const { validationRules: a } = Zu(e), o = Me(a, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: l } = Oe();
  async function i() {
    return o.value.$touch(), await o.value.$validate();
  }
  function u() {
    l(s.value);
  }
  function d(L) {
    t.message = L;
  }
  const { t: p } = oe(), y = ue("commClient"), f = ue("navigationButtonsApi", null), _ = G(() => e.isPreapproved && (e.creditAmount == null || e.creditAmount <= e.preapprovedCreditAmount)), b = G(() => e.mustProvideThreeSalaries || e.isPreapproved && e.numberOfPreapprovedSalaries === 3 || e.lastMonthsIncome2 != null && e.lastMonthsIncome2 > 0 ? ((e.lastMonthsIncome ? e.lastMonthsIncome : 0) + (e.lastMonthsIncome2 ? e.lastMonthsIncome2 : 0) + (e.lastMonthsIncome3 ? e.lastMonthsIncome3 : 0)) / 3 : e.lastMonthsIncome ? e.lastMonthsIncome : 0), g = G(() => {
    if (e.isSalaryConfirmed)
      return "";
    const L = e.isDocumentationNeeded;
    switch (e.employmentType) {
      case Ne.SP:
        return p("Components.InstallmentPlanComponent.MonthlyIncomeHintSPDoc");
      case Ne.Upokojenec:
        return p(L ? "Components.InstallmentPlanComponent.MonthlyIncomeHintUpokojenecDoc" : "Components.InstallmentPlanComponent.MonthlyIncomeHintUpokojenecNoDoc");
      case Ne.Zaposlen:
        return p(L ? "Components.InstallmentPlanComponent.MonthlyIncomeHintZaposleniDoc" : "Components.InstallmentPlanComponent.MonthlyIncomeHintZaposleniNoDoc");
      default:
        return "";
    }
  }), h = G(() => {
    const L = (/* @__PURE__ */ new Date()).getMonth();
    return {
      month0: L > 2 ? L - 3 : L + 9,
      month1: L > 1 ? L - 2 : L + 10,
      month2: L > 0 ? L - 1 : L + 11,
      month3: L
    };
  }), v = G(() => rr(e)), N = G(() => {
    const L = e.lastMonthsIncome ?? 0;
    if (!v.value)
      return L;
    const z = e.lastMonthsIncome2 ?? 0, O = e.lastMonthsIncome3 ?? 0;
    return (L + z + O) / 3;
  });
  async function $() {
    e.lastMonthsIncome = void 0, e.lastMonthsIncome2 = void 0, e.lastMonthsIncome3 = void 0, o.value.lastMonthsIncome.$reset(), o.value.lastMonthsIncome2.$reset(), o.value.lastMonthsIncome3.$reset(), t.clientIncomeInsert = !0, await y.executeMethodAsync("CreateCustomerIncomeInsertUrl", {
      Msisdn: e.msisdn,
      IsSP: e.employmentType == Ne.SP || e.mustProvideThreeSalaries
    });
  }
  async function S() {
    e.lastMonthsIncome = void 0, e.lastMonthsIncome2 = void 0, e.lastMonthsIncome3 = void 0, o.value.lastMonthsIncome.$reset(), o.value.lastMonthsIncome2.$reset(), o.value.lastMonthsIncome3.$reset(), t.clientIncomeInsert = !1;
  }
  function I(L) {
    console.log("Customer set income message:", L), L && L[0] && L[0].CallbackType == "INCOME_INSERTION" && (e.lastMonthsIncome = L[0].IncomeData.IncomeOne || void 0, e.lastMonthsIncome2 = L[0].IncomeData.IncomeTwo || void 0, e.lastMonthsIncome3 = L[0].IncomeData.IncomeThree || void 0, C());
  }
  async function C() {
    if (o.value.lastMonthsIncome.$touch(), o.value.lastMonthsIncome2.$touch(), o.value.lastMonthsIncome3.$touch(), (await Promise.all([
      o.value.lastMonthsIncome.$validate(),
      o.value.lastMonthsIncome2.$validate(),
      o.value.lastMonthsIncome3.$validate()
    ])).every((O) => O === !0)) {
      const O = await A();
      O !== null ? n("navigationEvent", O) : (e.installmentNr = e.calculatedMinInstallment + Math.round((e.calculatedMaxInstallment - e.calculatedMinInstallment) / 2), e.isSalaryConfirmed = !0, f !== null && (f == null || f.setButtonDisabled("Next", !1)));
    }
  }
  function T(L) {
    L && (L.success && Pe(e, L), Pe(t, L));
  }
  async function A() {
    var L, z;
    t.calculationError = "", e.isViewDataLoading = !0, await ae();
    try {
      let O;
      switch (e.flowType) {
        case Z.WEB:
        case Z.SKLENI_SAM:
          return O = await y.executeMethodAsync("SalaryRequirementsNewWeb", {
            OrderToken: e.orderToken,
            OrderType: e.flowType,
            TaxNumber: e.taxNumber,
            SlovenianCitizen: e.isSlovenianCitizen,
            EmploymentType: e.employmentType,
            Salary: b.value,
            minCredit: e.minCredit,
            ContractDebt: e.contractDebtInstallments,
            SisbonDebt: e.debtInstallments
          }), T(O), O.success ? null : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + O.errorId, { name: "end" });
        case Z.POS:
          return O = await y.executeMethodAsync("SalaryRequirementsNewPos", {
            SelectedProductId: (L = e.selectedProduct) == null ? void 0 : L.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(String(e.selectedSpecialProduct.productId), 10) : -1,
            TaxNumber: e.taxNumber,
            CreditAmount: e.creditAmount,
            SlovenianCitizen: e.isSlovenianCitizen,
            ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
            EmploymentType: e.employmentType,
            SisbonDebt: e.debtInstallments,
            ContractDebt: e.contractDebtInstallments,
            Salary: b.value,
            minCredit: e.minCredit
          }), T(O), O.success ? null : (e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + O.errorId, { name: "end" });
        case Z.POS_STRANKA:
          return O = await y.executeMethodAsync("SalaryRequirementsNewPosFinish", {
            PosOrderToken: e.orderToken,
            SelectedProductId: (z = e.selectedProduct) == null ? void 0 : z.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(String(e.selectedSpecialProduct.productId), 10) : -1,
            TaxNumber: e.taxNumber,
            CreditAmount: e.creditAmount,
            SlovenianCitizen: e.isSlovenianCitizen,
            ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
            EmploymentType: e.employmentType,
            SisbonDebt: e.debtInstallments,
            ContractDebt: e.contractDebtInstallments,
            Salary: b.value,
            minCredit: e.minCredit
          }), T(O), O.success ? null : (e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + O.errorId, { name: "end" });
        default:
          return null;
      }
    } finally {
      e.isViewDataLoading = !1, await ae();
    }
  }
  async function M() {
    var L, z;
    e.isViewDataLoading = !0, await ae();
    try {
      let O;
      switch (e.flowType) {
        case Z.POS_STRANKA:
          if (O = await y.executeMethodAsync("GetSalaryInformationPOSFinish", {
            PosOrderToken: e.orderToken,
            SelectedProductId: (L = e.selectedProduct) == null ? void 0 : L.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(e.selectedSpecialProduct.productId) : -1,
            TaxNumber: e.taxNumber,
            CreditAmount: e.creditAmount,
            Birthdate: we(e.birthdate),
            SlovenianCitizen: e.isSlovenianCitizen,
            ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
            EmploymentType: e.employmentType
          }), O)
            return O.success === !0 ? (Pe(e, O), Pe(t, O), null) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + O.error, { name: "end" });
          break;
        case Z.POS:
          if (O = await y.executeMethodAsync("GetSalaryInformationPOS", {
            SelectedProductId: (z = e.selectedProduct) == null ? void 0 : z.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(e.selectedSpecialProduct.productId) : -1,
            TaxNumber: e.taxNumber,
            CreditAmount: e.creditAmount,
            Birthdate: we(e.birthdate),
            SlovenianCitizen: e.isSlovenianCitizen,
            ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
            EmploymentType: e.employmentType
          }), O)
            return O.success === !0 ? (Pe(e, O), Pe(t, O), null) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + O.error, { name: "end" });
          break;
        case Z.WEB:
        case Z.SKLENI_SAM:
          if (O = await y.executeMethodAsync("GetSalaryInformationWeb", {
            OrderToken: e.orderToken,
            OrderType: e.flowType,
            TaxNumber: e.taxNumber,
            SlovenianCitizen: e.isSlovenianCitizen,
            EmploymentType: e.employmentType,
            Birthdate: we(e.birthdate)
          }), O)
            return O.success === !0 ? (Pe(e, O), Pe(t, O), null) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + O.error, { name: "end" });
          break;
      }
      return null;
    } finally {
      e.isViewDataLoading = !1, await ae();
    }
  }
  return {
    v$: o,
    validateForm: i,
    scrollToFirstErrorWrapper: u,
    fail: d,
    pastMonths: h,
    showThreeSalaryFields: v,
    averageIncome: N,
    customerSetIncome: I,
    monthlyIncomeHint: g,
    getSalaryInformation: M,
    customerIncomeInsert: $,
    partnerIncomeInsert: S,
    confirmSalary: C,
    getPreapprovedAmountValidity: _
  };
}
function jt() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (jt.cache.has(e)) return jt.cache.get(e);
  const t = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return jt.cache.set(e, t), t;
}
jt.cache = /* @__PURE__ */ new Map();
function Xu(e, t) {
  const s = qt();
  if (!s)
    throw new Error(`[Vuetify] ${e} must be called from inside a setup function`);
  return s;
}
function Du() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const t = Xu(e).type;
  return jt((t == null ? void 0 : t.aliasName) || (t == null ? void 0 : t.name));
}
const ed = Symbol.for("vuetify:display");
function sn() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    mobile: null
  }, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Du();
  const s = ue(ed);
  if (!s) throw new Error("Could not find Vuetify display injection");
  const n = G(() => e.mobile ? !0 : typeof e.mobileBreakpoint == "number" ? s.width.value < e.mobileBreakpoint : e.mobileBreakpoint ? s.width.value < s.thresholds.value[e.mobileBreakpoint] : e.mobile === null ? s.mobile.value : !1), a = G(() => t ? {
    [`${t}--mobile`]: n.value
  } : {});
  return {
    ...s,
    displayClasses: a,
    mobile: n
  };
}
const td = { key: 0 }, rd = { class: "mb-4" }, nd = { class: "form-label" }, od = { class: "control-income-wrapper" }, sd = {
  key: 0,
  class: "mb-4"
}, id = { class: "form-label" }, ld = {
  key: 1,
  class: "mb-4"
}, ad = { class: "form-label" }, ud = { class: "callout" }, dd = { key: 0 }, cd = { key: 1 }, md = { class: "mt-4" }, ry = /* @__PURE__ */ ge({
  __name: "personal-income-component",
  props: {
    data: { default: Qu }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const { smAndDown: n } = sn(), a = ue("commClient"), o = e, l = s, { t: i } = oe(), u = se({ ...o.data }), d = se(Ku()), p = X(null), y = X(!1);
    te(
      () => o.data,
      // Watch for changes in the data
      (T) => {
        Object.assign(u, T);
      },
      { deep: !0 }
    ), te(
      u,
      async (T) => {
        l("update:data", T);
      },
      { deep: !0 }
    ), Se(async () => {
      a.OnStreamDataReceived.AddCallback(S);
      const T = await v();
      if (T != null && T.name != null) {
        l("navigationEvent", T);
        return;
      }
      u.mustProvideThreeSalaries && u.numberOfPrefilledSalaries < 3 && (u.needsToEnterIncome = !0), u.needsToEnterIncome || (u.mustProvideThreeSalaries == !1 && u.lastMonthsIncome3 != null && u.lastMonthsIncome3 > 0 && (u.lastMonthsIncome2 = void 0, u.lastMonthsIncome3 = void 0), await ae(), await N()), y.value = !0, l("componentReady");
    }), Wr(() => {
      a.OnStreamDataReceived.RemoveCallback(S);
    });
    const {
      v$: f,
      monthlyIncomeHint: _,
      scrollToFirstErrorWrapper: b,
      getPreapprovedAmountValidity: g,
      pastMonths: h,
      getSalaryInformation: v,
      confirmSalary: N,
      validateForm: $,
      customerSetIncome: S,
      customerIncomeInsert: I,
      partnerIncomeInsert: C
    } = Ju(u, d, p, l);
    return t({
      componentReady: y,
      validateForm: $,
      scrollToFirstErrorWrapper: b
    }), (T, A) => {
      const M = U("v-text-field"), L = U("v-btn"), z = U("v-tooltip"), O = U("v-col"), H = U("v-row");
      return u.needsToEnterIncome ? (w(), F("div", {
        key: 0,
        ref_key: "rootRef",
        ref: p,
        class: "personal-income-component"
      }, [
        u.flowType != r(Z).INFOCALC && u.flowType != r(Z).WEB_INFOCALC && u.flowType != r(Z).PORTAL_INFOCALC ? (w(), ce(H, { key: 0 }, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                !r(g) || u.mustProvideThreeSalaries === !0 && u.numberOfPreapprovedSalaries < 3 ? (w(), F("div", td, [
                  c("h2", {
                    class: ke(["section-heading", { "mt-2": r(n) }])
                  }, P(r(i)("Components.InstallmentPlanComponent.MonthlyIncome")), 3),
                  c("div", rd, [
                    c("label", nd, P(u.employmentType == r(Ne).SP || u.mustProvideThreeSalaries ? r(i)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + r(i)("Components.InstallmentPlanComponent.Months." + r(h).month0.toString()) : r(i)("Components.InstallmentPlanComponent.LastMonthlyIncome")), 1),
                    c("div", od, [
                      De(m(Ke, {
                        modelValue: u.lastMonthsIncome,
                        "onUpdate:modelValue": A[0] || (A[0] = (q) => u.lastMonthsIncome = q),
                        "error-messages": r(f).lastMonthsIncome.$errors[0] != null ? r(f).lastMonthsIncome.$errors[0].$message : "",
                        disabled: u.isSalaryConfirmed || d.clientIncomeInsert,
                        onFocus: r(f).lastMonthsIncome.$reset,
                        variant: "outlined",
                        appendText: "EUR",
                        numberOfDecimals: 2,
                        hint: r(_),
                        "persistent-hint": "",
                        autocomplete: "off"
                      }, null, 8, ["modelValue", "error-messages", "disabled", "onFocus", "hint"]), [
                        [et, !d.clientIncomeInsert || u.lastMonthsIncome == null]
                      ]),
                      De(m(M, {
                        modelValue: "********",
                        variant: "outlined",
                        suffix: "EUR",
                        hint: r(_),
                        "persistent-hint": "",
                        disabled: ""
                      }, null, 8, ["hint"]), [
                        [et, d.clientIncomeInsert && u.lastMonthsIncome != null]
                      ]),
                      u.flowType == r(Z).POS && !d.clientIncomeInsert ? (w(), ce(z, {
                        key: 0,
                        text: u.mustProvideThreeSalaries ? T.$t("Components.InstallmentPlanComponent.CustomerIncome3BtnTooltip") : T.$t("Components.InstallmentPlanComponent.CustomerIncomeBtnTooltip"),
                        location: "bottom",
                        class: "tooltip--vnese-stranka",
                        "close-on-content-click": !0
                      }, {
                        activator: E(({ props: q }) => [
                          m(L, Yr(q, {
                            onClick: A[1] || (A[1] = (me) => r(I)()),
                            flat: "",
                            size: "x-small",
                            class: "btn btn--primary-outline btn--sm",
                            disabled: u.isSalaryConfirmed
                          }), {
                            default: E(() => [
                              Ie(P(T.$t("Components.InstallmentPlanComponent.CustomerIncomeBtn")), 1)
                            ]),
                            _: 2
                          }, 1040, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["text"])) : u.flowType == r(Z).POS && d.clientIncomeInsert ? (w(), ce(L, {
                        key: 1,
                        onClick: A[2] || (A[2] = (q) => r(C)()),
                        flat: "",
                        size: "x-small",
                        class: "btn btn--primary-outline btn--sm",
                        disabled: u.isSalaryConfirmed
                      }, {
                        default: E(() => [
                          Ie(P(T.$t("Components.InstallmentPlanComponent.PartnerIncomeBtn")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])) : B("", !0)
                    ])
                  ]),
                  u.employmentType == r(Ne).SP || u.mustProvideThreeSalaries ? (w(), F("div", sd, [
                    c("label", id, P(u.employmentType == r(Ne).SP || u.mustProvideThreeSalaries ? r(i)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + r(i)("Components.InstallmentPlanComponent.Months." + r(h).month1.toString()) : r(i)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                    De(m(Ke, {
                      modelValue: u.lastMonthsIncome2,
                      "onUpdate:modelValue": A[3] || (A[3] = (q) => u.lastMonthsIncome2 = q),
                      "error-messages": r(f).lastMonthsIncome2.$errors[0] != null ? r(f).lastMonthsIncome2.$errors[0].$message : "",
                      onFocus: r(f).lastMonthsIncome2.$reset,
                      variant: "outlined",
                      appendText: "EUR",
                      disabled: u.isSalaryConfirmed || d.clientIncomeInsert,
                      numberOfDecimals: 2,
                      hint: r(_),
                      "persistent-hint": "",
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled", "hint"]), [
                      [et, !d.clientIncomeInsert || u.lastMonthsIncome2 == null]
                    ]),
                    De(m(M, {
                      modelValue: "********",
                      variant: "outlined",
                      suffix: "EUR",
                      hint: r(_),
                      "persistent-hint": "",
                      disabled: ""
                    }, null, 8, ["hint"]), [
                      [et, d.clientIncomeInsert && u.lastMonthsIncome2 != null]
                    ])
                  ])) : B("", !0),
                  u.employmentType == r(Ne).SP || u.mustProvideThreeSalaries ? (w(), F("div", ld, [
                    c("label", ad, P(u.employmentType == r(Ne).SP || u.mustProvideThreeSalaries ? r(i)("Components.InstallmentPlanComponent.MonthlyIncome") + "- " + r(i)("Components.InstallmentPlanComponent.Months." + r(h).month2.toString()) : r(i)("Components.InstallmentPlanComponent.MonthlyIncome")), 1),
                    De(m(Ke, {
                      modelValue: u.lastMonthsIncome3,
                      "onUpdate:modelValue": A[4] || (A[4] = (q) => u.lastMonthsIncome3 = q),
                      "error-messages": r(f).lastMonthsIncome3.$errors[0] != null ? r(f).lastMonthsIncome3.$errors[0].$message : "",
                      onFocus: r(f).lastMonthsIncome3.$reset,
                      variant: "outlined",
                      appendText: "EUR",
                      disabled: u.isSalaryConfirmed || d.clientIncomeInsert,
                      numberOfDecimals: 2,
                      hint: r(_),
                      "persistent-hint": "",
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "disabled", "hint"]), [
                      [et, !d.clientIncomeInsert || u.lastMonthsIncome3 == null]
                    ]),
                    De(m(M, {
                      modelValue: "********",
                      variant: "outlined",
                      suffix: "EUR",
                      hint: r(_),
                      "persistent-hint": "",
                      disabled: ""
                    }, null, 8, ["hint"]), [
                      [et, d.clientIncomeInsert && u.lastMonthsIncome3 != null]
                    ])
                  ])) : B("", !0)
                ])) : B("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0),
        !u.isSalaryConfirmed && u.flowType != r(Z).INFOCALC && u.flowType != r(Z).WEB_INFOCALC && u.flowType != r(Z).PORTAL_INFOCALC ? (w(), ce(H, { key: 1 }, {
          default: E(() => [
            m(O, null, {
              default: E(() => [
                c("div", ud, [
                  u.flowType === r(Z).POS ? (w(), F("div", dd, " Potrdite vnesene podatke. ")) : (w(), F("div", cd, "Potrjujem, da so vpisani zneski mesečnih prihodkov točni in se ujemajo s podatki na plačilnih listah ali bančnih izpisih. ")),
                  c("div", md, [
                    m(L, {
                      class: "btn btn--primary-fill",
                      onClick: A[5] || (A[5] = (q) => r(N)()),
                      disabled: d.clientIncomeInsert
                    }, {
                      default: E(() => A[6] || (A[6] = [
                        Ie(" Potrjujem podatke ")
                      ])),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0)
      ], 512)) : B("", !0);
    };
  }
}), fd = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Icon'%3e%3cpath%20id='Vector'%20d='M12%204L4%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M4%204L12%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e", pd = { class: "dialog__heading" }, vd = { class: "dialog__body" }, gd = /* @__PURE__ */ ge({
  __name: "modal",
  props: {
    buttons: {
      type: Array,
      default: () => [],
      required: !1
    },
    display: {
      type: Boolean,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    showCloseXButton: {
      type: Boolean,
      default: !1
    },
    btnCenter: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "action",
    "modalClosed"
  ],
  setup(e) {
    const { t, te: s } = oe();
    return (n, a) => {
      const o = U("v-btn"), l = U("v-dialog");
      return w(), ce(l, {
        persistent: "",
        modelValue: e.display
      }, {
        default: E(() => [
          e.showCloseXButton ? (w(), ce(o, {
            key: 0,
            class: "btn btn--default-fill btn--round btn--sm ml-auto",
            onClick: a[0] || (a[0] = (i) => n.$emit("modalClosed"))
          }, {
            default: E(() => a[1] || (a[1] = [
              c("img", {
                src: fd,
                alt: "Close"
              }, null, -1)
            ])),
            _: 1
          })) : B("", !0),
          c("div", pd, P(r(s)(e.title) ? r(t)(e.title) : e.title), 1),
          c("div", vd, [
            mo(n.$slots, "default", {}, void 0, !0)
          ]),
          a[2] || (a[2] = c("hr", { class: "hr mb-8" }, null, -1)),
          e.buttons ? (w(), F("div", {
            key: 1,
            class: ke(["dialog__footer", [e.btnCenter ? n.$style.moveCenter : null]])
          }, [
            (w(!0), F(Ae, null, tt(e.buttons, (i) => De((w(), ce(o, {
              key: i.name,
              disabled: i.disabled === !0,
              class: ke(["btn", i.class]),
              onClick: (u) => n.$emit("action", i.action)
            }, {
              default: E(() => [
                Ie(P(r(t)(i.name)), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "class", "onClick"])), [
              [et, i.visible]
            ])), 128))
          ], 2)) : B("", !0)
        ]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
}), yd = "_moveCenter_38vq5_3", bd = {
  moveCenter: yd
}, Cd = {
  $style: bd
}, Pt = /* @__PURE__ */ Zo(gd, [["__cssModules", Cd], ["__scopeId", "data-v-68eb3c1a"]]), Id = ["src"], kt = /* @__PURE__ */ ge({
  __name: "document-signer",
  props: {
    url: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, s) => (w(), F("iframe", {
      style: { width: "100%", height: "100%" },
      src: e.url,
      allow: "local-network-access https://app-qa.betrsign.com https://app-test.betrsign.com https://app.betrsign.com"
    }, null, 8, Id));
  }
});
function Xo(e) {
  const t = String(e ?? "");
  if (!/^[1-9]\d{7}$/.test(t))
    return !1;
  const s = [...t.slice(0, 7)].reduce((n, a, o) => n + Number(a) * (8 - o), 0);
  return Number(t[7]) === (11 - s % 11) % 10;
}
function Qt(e, t = /* @__PURE__ */ new Date()) {
  const s = t.getMonth() < e.getMonth() || t.getMonth() === e.getMonth() && t.getDate() < e.getDate();
  return t.getFullYear() - e.getFullYear() - (s ? 1 : 0);
}
function ln(e) {
  return e === null ? !1 : e !== null && Qt(e) >= 70;
}
function _d(e, t, s) {
  const { t: n } = oe(), a = V.withMessage(n("GlobalErrors.FieldRequired"), ye), o = /* @__PURE__ */ new Date();
  o.setHours(0, 0, 0, 0);
  function l(f) {
    return f instanceof Date && Number.isFinite(f.getTime());
  }
  function i(f) {
    const _ = f.toUpperCase();
    return e.isSlovenianCitizen === !1 ? f.length >= 8 && !_.startsWith("SI") : e.personalDocumentType === qe.Passport ? /^[A-Z]{2}\d{7}$/.test(_) : /^(\d{9}|IE\d{7})$/.test(_);
  }
  function u(f) {
    const _ = new Date(o.getTime() + 86399999);
    return l(f) && f <= _;
  }
  function d(f) {
    return e.permanentValidity === !0 ? !0 : !l(f) || f < o ? !1 : !l(e.issueDate) || f >= e.issueDate;
  }
  function p(f) {
    var h, v, N, $;
    if (!l(f))
      return !0;
    const _ = Qt(f);
    let b, g;
    if (e.flowType === Z.WEB || e.flowType === Z.SKLENI_SAM || e.flowType === Z.LIMIT)
      b = 18, g = 80;
    else {
      const S = [
        ...e.productList,
        ...e.specialProductList
      ];
      b = ((h = e.productList[0]) == null ? void 0 : h.ageMin) ?? ((v = e.specialProductList[0]) == null ? void 0 : v.ageMin) ?? 50, g = ((N = e.productList[0]) == null ? void 0 : N.ageMax) ?? (($ = e.specialProductList[0]) == null ? void 0 : $.ageMax) ?? 0;
      for (const I of S)
        I.ageMin < b && (b = I.ageMin), I.ageMax > g && (g = I.ageMax);
      g--;
    }
    return _ < b || _ > g ? (t.ageError = n("GlobalErrors.AgeLimit", {
      minimum: b,
      maximum: g
    }), !1) : (t.ageError = "", !0);
  }
  return { validationRules: G(() => ({
    firstname: {
      required: a
    },
    surname: {
      required: a
    },
    birthdate: {
      required: a,
      customAge: V.withMessage(
        () => t.ageError,
        p
      )
    },
    birthCity: {
      required: a,
      minTwoLetters: V.withMessage(
        n("GlobalErrors.MinTwoLetters"),
        (f) => typeof f == "string" && /.*[a-zA-ZčžšČŽŠ].*[a-zA-ZčžšČŽŠ]/.test(f)
      )
    },
    // birthCity: {
    //     required: requiredField
    // },
    citizen: {
      required: V.withMessage(n("GlobalErrors.ChoiceRequired"), ye)
    },
    countrySourceFunds: {
      required: V.withMessage(n("GlobalErrors.FIELD_REQUIRED"), ve(() => s.value))
    },
    countryFundsStatus: {
      required: V.withMessage(n("GlobalErrors.FIELD_REQUIRED"), ve(() => s.value))
    },
    address: {
      required: a
    },
    postalCode: {
      required: V.withMessage(n("GlobalErrors.ChoiceRequired"), ye)
    },
    personalDocumentType: {
      required: a
    },
    idNumber: {
      required: a,
      format: V.withMessage(n("GlobalErrors.InvalidDocument"), i)
    },
    idNumberCheck: {},
    documentIssuer: {
      required: a
    },
    issueDate: {
      required: a,
      date: V.withMessage(n("GlobalErrors.InvalidDate"), u)
    },
    validityDate: {
      required: V.withMessage(n("GlobalErrors.FieldRequired"), ve(() => e.permanentValidity !== !0)),
      date: V.withMessage(n("GlobalErrors.InvalidDate"), d)
    },
    permanentValidity: {
      required: V.withMessage(n("GlobalErrors.ChoiceRequired"), ve(() => ln(e.birthdate)))
    },
    identificationConfirmation: e.flowType === Z.POS ? {
      confirmed: V.withMessage(n("GlobalErrors.ConfirmData"), Ht(!0))
    } : {}
  })) };
}
function ro() {
  return {
    taxNumber: void 0,
    msisdn: null,
    creditAmount: void 0,
    employmentType: void 0,
    hasSlovenianIncome: void 0,
    birthCity: "",
    birthdate: null,
    isMale: !0,
    email: "",
    contractSignatureType: void 0,
    countrySourceFunds: "",
    countryFundsStatus: "",
    sisbonResultId: 0,
    debtInstallments: 0,
    userFullName: "",
    firstname: "",
    surname: "",
    citizen: void 0,
    hasTemporaryResidence: void 0,
    temporaryCitizen: void 0,
    address: "",
    postalCode: void 0,
    personalDocumentType: void 0,
    idNumber: "",
    idNumberCheck: "",
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: void 0,
    identificationConfirmation: !1,
    isSlovenianCitizen: void 0,
    flowType: void 0,
    notificationHtml: "",
    notificationType: void 0,
    belowNotificationHtml: "",
    title: "",
    productList: [],
    specialProductList: []
  };
}
function hd() {
  return {
    showSigner: !1,
    signingUrl: "",
    applicationId: "",
    externalResults: {},
    isDataLoading: !1,
    message: "",
    ageError: ""
  };
}
function ny() {
  return {
    apiAuthToken: "",
    flowType: void 0,
    orderId: "",
    isFlowPageMounted: !1,
    isAppDataLoading: !1,
    isViewDataLoading: !1,
    userFullName: "",
    notVehiculesFinancing: !1,
    needsToChangePassword: !1,
    isExistingUser: !1,
    hasUserPassword: !1,
    linkPasswordReset: "Precheck",
    linkParamsId: ":1",
    partnerId: -1,
    partnerLimitsEOM: !1,
    isCustomerContinuing: !1,
    errorText: void 0,
    partnerLink: "",
    isSalaryConfirmed: !1,
    needsToEnterIncome: !0,
    numberOfPrefilledSalaries: 0,
    creditApplicationSignUrl: "",
    marketingConsent: !1,
    customerWillCompleteOrder: !1,
    numberOfIncome: 0
  };
}
function oy() {
  return {
    sisbonResultId: -1,
    debtAmount: 0,
    debtInstallments: 0,
    minSalary: 0,
    minCredit: 0
  };
}
function sy() {
  return {
    prefix: { Key: "386", Value: "SI +386" },
    phoneNumber: "",
    msisdn: "",
    email: "",
    isPhoneVerified: !1,
    isEmailVerified: !1,
    taxNumber: void 0,
    firstname: "",
    surname: "",
    address: "",
    postalCode: void 0,
    isMale: !1,
    birthdate: null,
    birthCity: "",
    citizen: void 0,
    hasTemporaryResidence: void 0,
    temporaryCitizen: void 0,
    temporaryPostalCode: void 0,
    temporaryForeignPostalCode: "",
    temporaryAddress: "",
    countryFundsStatus: "",
    countrySourceFunds: ""
  };
}
function iy() {
  return {
    calculationId: 0,
    creditAmount: void 0,
    installmentNr: 0,
    installmentVal: 0,
    installmentValNoCost: 0,
    lastMonthsIncome: void 0,
    lastMonthsIncome2: void 0,
    lastMonthsIncome3: void 0,
    mustProvideThreeSalaries: !1,
    isDocumentationNeeded: !1,
    calculatedMaxInstallment: void 0,
    calculatedMinInstallment: void 0
  };
}
function ly() {
  return {
    employmentType: void 0,
    employmentSubType: void 0,
    employerName: "",
    employerAddress: "",
    employerPostCode: "",
    isPoliticallyExposedPerson: void 0,
    politicalFunction: "",
    pioSourceFunds: "",
    pioFundsStatus: ""
  };
}
function ay() {
  return {
    minSalary: 0,
    summitDebt: 0,
    contractDebt: 0,
    contractDebtInstallments: 0,
    maxHitri: void 0,
    maxTriglavAmount: void 0,
    maxCreditAmount: void 0,
    availableCreditAmount: void 0,
    isCurrentSpecialProductAvailable: void 0
  };
}
function uy() {
  return {
    isIdentified: !1,
    personalDocumentType: void 0,
    idNumber: "",
    idNumberCheck: "",
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: void 0,
    identificationConfirmation: !1,
    identificationPlace: Ko.posta,
    identificationAddress: "",
    identificationPostalCode: void 0
  };
}
function dy() {
  return {
    hasPermanentResidenceInSlovenia: void 0,
    isSlovenianCitizen: void 0,
    hasSlovenianIncome: void 0,
    hasSlovenianBankAccount: void 0,
    code: "",
    documentationSendType: void 0,
    TRR: "",
    creditAmount: void 0,
    selectedSpecialProduct: void 0,
    selectedPromoProduct: void 0,
    selectedProduct: void 0,
    selectedProductType: void 0,
    EOMInstallmentMax: void 0,
    documentNumber: "",
    bindingFiles: [],
    willAttachDocumentation: void 0,
    documentationFiles: [],
    termsAgreement: !1,
    isCompanyTaxNumber: !1,
    file: [],
    productList: [],
    specialProductList: [],
    promoProductList: [],
    dataConfirmation: !1,
    marketingConsent: !1,
    password: "",
    firstPassword: "",
    repeatPassword: "",
    status: nn.Success,
    descriptionText: "Geslo je bilo uspešno zamenjano",
    contractSignatureType: void 0,
    contractSending: void 0,
    promoCode: "",
    triglavCode: "",
    pogodbaId: 0,
    stPogodbe: "",
    hasMultipleProducts: !1
  };
}
function cy() {
  return {
    isPreapproved: !1,
    preapprovedType: "",
    numberOfPreapprovedSalaries: 0,
    preapprovedCreditAmount: 0,
    preapprovedInstallmentAmount: 0
  };
}
function my() {
  return {
    steps: void 0,
    currentStep: null
  };
}
function fy() {
  return {
    hadTRRExecution: void 0,
    hadLatePayment: void 0,
    hadBlockedTRR: void 0,
    hadBankruptcyProceedings: void 0,
    sumInstallments: void 0,
    averageSalary: void 0
  };
}
function py() {
  return {
    orderToken: "",
    referenceNumber: "",
    successPage: "",
    errorPage: "",
    orderId: "",
    minInstallment: 0,
    maxInstallment: 0,
    logoImage: "",
    storeUrl: "",
    storeName: "",
    hasPersonalPickUp: !0,
    hasHomeDelivery: !0,
    hasMultipleProducts: !1,
    proformaFile: [],
    proformaPartnerType: "",
    isVehiclesFinancing: !1,
    isFromPasswordReset: !1
  };
}
function Gr() {
  return {
    firstname: "",
    surname: "",
    citizen: void 0,
    address: "",
    postalCode: void 0,
    personalDocumentType: void 0,
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: void 0
  };
}
function Td(e, t, s, n) {
  const a = ue("generalStore");
  ue(Hr);
  const o = G(() => {
    const T = a.state.countryList ?? [];
    return e.isSlovenianCitizen === !0 ? (e.citizen = 204, T.slice(0, 1)) : e.isSlovenianCitizen === !1 ? T.slice(1) : (console.log("returning: ", T), T);
  }), l = G(() => {
    const T = a.state.postalCodeList ?? [];
    return e.isSlovenianCitizen === !1 ? T.slice(0, -1) : T;
  }), i = G(() => {
    var T;
    return (T = a.state.countryList) == null ? void 0 : T.find((A) => String(A.Key) === String(e.citizen));
  }), u = G(() => {
    var M, L;
    const T = e.citizen;
    if (T == null)
      return !1;
    const A = (M = a.state.countryList) == null ? void 0 : M.find((z) => String(z.Key) === String(T));
    return ((L = A == null ? void 0 : A.AdditionalData) == null ? void 0 : L.RiskDrzava) == !0;
  }), { validationRules: d } = _d(e, t, u), p = Me(d, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), y = Gr();
  e.isSlovenianCitizen === !0 && (y.citizen = e.citizen);
  const { scrollToFirstError: f } = Oe();
  async function _() {
    return p.value.$touch(), await p.value.$validate();
  }
  function b() {
    f(s.value);
  }
  const { t: g } = oe(), h = ue("commClient");
  async function v(T) {
    if (t.showSigner = !1, t.isDataLoading = !1, T.success !== !0 && T.Success !== !0) {
      e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = T.errorText, await ae(), n("navigationEvent", { name: "end" });
      return;
    }
    e.sisbonResultId = T.sisbonResultId, e.debtInstallments = T.debtInstallments, await ae(), n("navigationEvent", { name: "nextStep" });
  }
  async function N() {
    t.showSigner = !0, t.signingUrl = "/StaticLoaders/sisbon_process.html", t.isDataLoading = !0;
    try {
      const T = await h.executeMethodAsync("CheckExposureIdentificationData", {
        flowType: e.flowType,
        CreditAmount: e.creditAmount,
        TaxNumber: e.taxNumber,
        Firstname: e.firstname,
        Surname: e.surname,
        Birthdate: we(e.birthdate),
        EmploymentType: e.employmentType,
        Msisdn: e.msisdn,
        isSlovenianCitizen: e.isSlovenianCitizen,
        isIncomeSlo: e.hasSlovenianIncome,
        VlogaId: t.applicationId
      });
      ((T == null ? void 0 : T.success) !== !0 || T.sisbonWasChecked === !0) && await v(T ?? {});
    } catch {
      t.message = g("GlobalErrors.ServiceError");
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function $(T) {
    T[0].CallbackType === "SIGN" && T[0].Status === "complete" && T[0].Success === !0 && T[0].Type === "vloga" ? (t.applicationId = T[0].VlogaId, t.showSigner = !1, t.signingUrl = "", await N()) : T[0].CallbackType === "SISBON" && await v(T[0]);
  }
  async function S() {
    var L, z, O, H;
    if (!await _())
      return;
    const T = e.hasTemporaryResidence === !0 ? (L = a.state.countryList) == null ? void 0 : L.find((q) => String(q.Key) === String(e.temporaryCitizen)) : void 0, A = ((O = (z = i.value) == null ? void 0 : z.AdditionalData) == null ? void 0 : O.TveganaDrzava) === !0, M = ((H = T == null ? void 0 : T.AdditionalData) == null ? void 0 : H.RiskDrzava) == !0;
    if (A || M) {
      e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = g("GlobalErrors.EndFail.RiskCountry"), await ae(), n("navigationEvent", { name: "end" });
      return;
    }
    try {
      t.isDataLoading = !0, t.message = "", t.showSigner = !0, t.signingUrl = "/StaticLoaders/vloga_upload_wait.html";
      const q = await h.executeMethodAsync("UploadVloga", {
        IzracunId: -1,
        Ime: e.firstname,
        Priimek: e.surname,
        DavcnaSt: e.taxNumber,
        Telefon: e.msisdn,
        Ulica: e.address,
        Posta: e.postalCode,
        Birthdate: we(e.birthdate),
        VrstaOsDok: e.personalDocumentType,
        StOsDok: e.idNumber,
        DatumIzdajeOsDok: we(e.issueDate),
        DatumVeljavnostiOsDok: we(e.validityDate ?? new Date(1753, 1, 1)),
        Drzava: e.citizen,
        KrajRojstva: e.birthCity,
        IzdajateljOsDok: e.documentIssuer,
        Email: e.email,
        chkUseSMS: e.contractSignatureType === Nt.SMS,
        redirectUrl: ""
      });
      if ((q == null ? void 0 : q.Success) !== !0 || !q.Url || !q.VlogaId)
        throw new Error("Application upload failed");
      t.applicationId = q.VlogaId, t.signingUrl = q.Url, t.showSigner = !0;
    } catch {
      t.message = g("GlobalErrors.ServiceError");
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function I() {
    p.value.idNumber.$touch(), await p.value.idNumber.$validate(), !p.value.idNumber.$error && e.idNumberCheck !== null && e.idNumberCheck != "" && e.idNumber !== e.idNumberCheck && (e.idNumber = "", e.idNumberCheck = "", Pe(e, y), await ae(), p.value.$reset(), await ae());
  }
  async function C(T) {
    var A, M, L, z;
    (e.idNumber != T.idNumber || e.personalDocumentType != T.personalDocumentType || e.firstname != T.firstname || e.surname != T.surname || e.address != T.address || e.postalCode != T.postalCode || e.citizen != T.citizen || e.documentIssuer != T.documentIssuer || ((A = e.issueDate) == null ? void 0 : A.getTime()) != ((M = T.issueDate) == null ? void 0 : M.getTime()) || ((L = e.validityDate) == null ? void 0 : L.getTime()) != ((z = T.validityDate) == null ? void 0 : z.getTime())) && (e.identificationConfirmation = !1), e.permanentValidity != T.permanentValidity && e.permanentValidity && (e.validityDate = null), e.birthdate != T.birthdate && e.birthdate != null && (ln(e.birthdate) || (e.permanentValidity = !1), await ae());
  }
  return {
    isRiskCountry: u,
    countries: o,
    postalCodes: l,
    dataChanged: C,
    handleIdNumber: I,
    v$: p,
    signApplication: S,
    validateForm: _,
    signComplete: $,
    scrollToFirstErrorWrapper: b
  };
}
const Ed = { class: "section-heading" }, Nd = { class: "notification notification--notice mb-10" }, Sd = {
  key: 0,
  class: "notification notification--alert"
}, Pd = { class: "mb-2" }, $d = ["id"], Md = ["for"], Ad = ["for"], wd = ["for"], kd = ["for"], Od = { class: "notification notification--notice mb-4" }, Rd = { class: "font-weight-600" }, Ld = ["for"], xd = ["for"], Fd = ["for"], Vd = ["for"], zd = ["for"], jd = ["for"], Ud = ["for"], Gd = ["for"], Bd = ["id"], Wd = {
  key: 4,
  class: "notification notification--warning",
  role: "alert"
}, vy = /* @__PURE__ */ ge({
  __name: "identification-info-component",
  props: {
    data: { default: ro },
    riskCountryType: { default: "permanent" }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = ue("commClient"), i = Be(), u = se({ ...n.data }), d = se(ro()), p = se(hd()), y = X(null), f = X(!1);
    te(
      () => n.data,
      // Watch for changes in the data
      (A) => {
        Object.assign(u, A);
      },
      { deep: !0 }
    ), te(
      u,
      async (A) => {
        await g(d), Object.assign(d, A), a("update:data", A);
      },
      { deep: !0 }
    ), St(() => {
      var A;
      (A = l.OnStreamDataReceived) == null || A.RemoveCallback(v);
    }), Se(() => {
      var A;
      (A = l.OnStreamDataReceived) == null || A.AddCallback(v), f.value = !0, a("componentReady");
    });
    const {
      isRiskCountry: _,
      v$: b,
      dataChanged: g,
      handleIdNumber: h,
      signComplete: v,
      validateForm: N,
      signApplication: $,
      scrollToFirstErrorWrapper: S,
      countries: I,
      postalCodes: C
    } = Td(u, p, y, a), T = G(() => ln(u.birthdate));
    return t({
      componentReady: f,
      signApplication: $,
      validateForm: N,
      scrollToFirstErrorWrapper: S
    }), (A, M) => {
      const L = U("v-radio"), z = U("v-radio-group"), O = U("v-col"), H = U("v-row"), q = U("Datepicker"), me = U("v-input"), x = U("v-autocomplete"), ie = U("v-checkbox");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: y,
        class: "identification-info-component"
      }, [
        c("h2", Ed, P(r(o)("Components.IdentificationInfoComponent.Title")), 1),
        c("div", Nd, P(r(o)("Components.IdentificationInfoComponent.Notice")), 1),
        u.isSlovenianCitizen ? B("", !0) : (w(), F("div", Sd, P(r(o)("Components.IdentificationInfoComponent.ForeignerAlert")), 1)),
        m(H, null, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", Pd, [
                    c("label", {
                      id: r(i) + "-personalDocumentType-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.IdentificationInfoComponent.personalDocumentType")), 9, $d),
                    m(z, {
                      modelValue: u.personalDocumentType,
                      "onUpdate:modelValue": M[0] || (M[0] = (J) => u.personalDocumentType = J),
                      "aria-labelledby": r(i) + "-personalDocumentType-label",
                      error: r(b).personalDocumentType.$error,
                      "error-messages": ((ne = r(b).personalDocumentType.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[1] || (M[1] = (J) => r(b).personalDocumentType.$reset()),
                      class: "input-document-type"
                    }, {
                      default: E(() => [
                        m(L, {
                          label: r(o)("Components.IdentificationInfoComponent.PersonalId"),
                          value: r(qe).PersonalId
                        }, null, 8, ["label", "value"]),
                        m(L, {
                          label: r(o)("Components.IdentificationInfoComponent.Passport"),
                          value: r(qe).Passport
                        }, null, 8, ["label", "value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(H, null, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-firstname",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.firstname")), 9, Md),
                    m(be, {
                      id: r(i) + "-firstname",
                      modelValue: u.firstname,
                      "onUpdate:modelValue": M[2] || (M[2] = (J) => u.firstname = J),
                      variant: "outlined",
                      error: r(b).firstname.$error,
                      "error-messages": ((ne = r(b).firstname.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[3] || (M[3] = (J) => r(b).firstname.$reset()),
                      autocomplete: "off"
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-surname",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.surname")), 9, Ad),
                    m(be, {
                      id: r(i) + "-surname",
                      modelValue: u.surname,
                      "onUpdate:modelValue": M[4] || (M[4] = (J) => u.surname = J),
                      variant: "outlined",
                      error: r(b).surname.$error,
                      "error-messages": ((ne = r(b).surname.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[5] || (M[5] = (J) => r(b).surname.$reset()),
                      autocomplete: "off"
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(H, null, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-birthdate",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.birthdate")), 9, wd),
                    m(me, {
                      error: r(b).birthdate.$error,
                      "error-messages": ((ne = r(b).birthdate.$errors[0]) == null ? void 0 : ne.$message) ?? ""
                    }, {
                      default: E(() => [
                        m(q, {
                          uid: r(i) + "-birthdate",
                          modelValue: u.birthdate,
                          "onUpdate:modelValue": M[6] || (M[6] = (J) => u.birthdate = J),
                          maxDate: /* @__PURE__ */ new Date(),
                          enableTimePicker: !1,
                          autoApply: "",
                          position: "right",
                          locale: "sl",
                          textInput: "",
                          format: "d.M.yyyy",
                          class: ke(r(b).birthdate.$error ? "v-input--error" : "")
                        }, null, 8, ["uid", "modelValue", "maxDate", "class"])
                      ]),
                      _: 1
                    }, 8, ["error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-citizen",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.citizen")), 9, kd),
                    m(x, {
                      id: r(i) + "-citizen",
                      modelValue: u.citizen,
                      "onUpdate:modelValue": M[7] || (M[7] = (J) => u.citizen = J),
                      items: r(I),
                      "item-title": "Value",
                      "item-value": "Key",
                      variant: "outlined",
                      error: r(b).citizen.$error,
                      "error-messages": ((ne = r(b).citizen.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[8] || (M[8] = (J) => r(b).citizen.$reset()),
                      readonly: u.isSlovenianCitizen === !0
                    }, null, 8, ["id", "modelValue", "items", "error", "error-messages", "readonly"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        r(_) ? (w(), ce(H, { key: 1 }, {
          default: E(() => [
            m(O, null, {
              default: E(() => [
                c("div", Od, [
                  c("span", Rd, P(r(o)("Components.AdditionalContactInfoComponent.RiskCountryTitle")), 1),
                  Ie(" " + P(r(o)("Components.AdditionalContactInfoComponent.RiskCountryNotice")), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0),
        r(_) ? (w(), ce(H, { key: 2 }, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-countrySourceFunds",
                      class: "form-label"
                    }, P(r(o)("Components.AdditionalContactInfoComponent.CountrySourceFunds")), 9, Ld),
                    m(be, {
                      id: r(i) + "-countrySourceFunds",
                      modelValue: u.countrySourceFunds,
                      "onUpdate:modelValue": M[9] || (M[9] = (J) => u.countrySourceFunds = J),
                      variant: "outlined",
                      error: r(b).countrySourceFunds.$error,
                      "error-messages": ((ne = r(b).countrySourceFunds.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[10] || (M[10] = (J) => r(b).countrySourceFunds.$reset()),
                      hint: r(o)("Components.AdditionalContactInfoComponent.CountrySourceFundsInfo"),
                      "persistent-hint": "",
                      autocomplete: "off"
                    }, null, 8, ["id", "modelValue", "error", "error-messages", "hint"])
                  ])
                ];
              }),
              _: 1
            }),
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-countryFundsStatus",
                      class: "form-label"
                    }, P(r(o)("Components.AdditionalContactInfoComponent.CountryFundsStatus")), 9, xd),
                    m(be, {
                      id: r(i) + "-countryFundsStatus",
                      modelValue: u.countryFundsStatus,
                      "onUpdate:modelValue": M[11] || (M[11] = (J) => u.countryFundsStatus = J),
                      variant: "outlined",
                      error: r(b).countryFundsStatus.$error,
                      "error-messages": ((ne = r(b).countryFundsStatus.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[12] || (M[12] = (J) => r(b).countryFundsStatus.$reset()),
                      hint: r(o)("Components.AdditionalContactInfoComponent.CountryFundsStatusInfo"),
                      "persistent-hint": "",
                      autocomplete: "off"
                    }, null, 8, ["id", "modelValue", "error", "error-messages", "hint"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0),
        m(H, null, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-address",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.address")), 9, Fd),
                    m(be, {
                      id: r(i) + "-address",
                      modelValue: u.address,
                      "onUpdate:modelValue": M[13] || (M[13] = (J) => u.address = J),
                      variant: "outlined",
                      error: r(b).address.$error,
                      "error-messages": ((ne = r(b).address.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[14] || (M[14] = (J) => r(b).address.$reset()),
                      autocomplete: "off"
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-postalCode",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.postalCode")), 9, Vd),
                    m(x, {
                      id: r(i) + "-postalCode",
                      modelValue: u.postalCode,
                      "onUpdate:modelValue": M[15] || (M[15] = (J) => u.postalCode = J),
                      items: r(C),
                      "item-title": "Value",
                      "item-value": "Key",
                      variant: "outlined",
                      error: r(b).postalCode.$error,
                      "error-messages": ((ne = r(b).postalCode.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[16] || (M[16] = (J) => r(b).postalCode.$reset())
                    }, null, 8, ["id", "modelValue", "items", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(H, null, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-idNumber",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.idNumber")), 9, zd),
                    m(be, {
                      id: r(i) + "-idNumber",
                      modelValue: u.idNumber,
                      "onUpdate:modelValue": M[17] || (M[17] = (J) => u.idNumber = J),
                      variant: "outlined",
                      error: r(b).idNumber.$error,
                      onBlur: r(h),
                      "error-messages": ((ne = r(b).idNumber.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[18] || (M[18] = (J) => r(b).idNumber.$reset()),
                      maxLength: u.isSlovenianCitizen === !0 && (u.personalDocumentType === r(qe).PersonalId || u.personalDocumentType === r(qe).Passport) ? "9" : void 0,
                      autocomplete: "off"
                    }, null, 8, ["id", "modelValue", "error", "onBlur", "error-messages", "maxLength"])
                  ])
                ];
              }),
              _: 1
            }),
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-documentIssuer",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.documentIssuer")), 9, jd),
                    m(be, {
                      id: r(i) + "-documentIssuer",
                      modelValue: u.documentIssuer,
                      "onUpdate:modelValue": M[19] || (M[19] = (J) => u.documentIssuer = J),
                      variant: "outlined",
                      error: r(b).documentIssuer.$error,
                      "error-messages": ((ne = r(b).documentIssuer.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[20] || (M[20] = (J) => r(b).documentIssuer.$reset()),
                      prefix: "UE",
                      autocomplete: "off"
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(H, null, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: "dp-input-" + r(i) + "-issueDate",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.issueDate")), 9, Ud),
                    m(me, {
                      error: r(b).issueDate.$error,
                      "error-messages": ((ne = r(b).issueDate.$errors[0]) == null ? void 0 : ne.$message) ?? ""
                    }, {
                      default: E(() => [
                        m(q, {
                          uid: r(i) + "-issueDate",
                          modelValue: u.issueDate,
                          "onUpdate:modelValue": M[21] || (M[21] = (J) => u.issueDate = J),
                          maxDate: /* @__PURE__ */ new Date(),
                          enableTimePicker: !1,
                          autoApply: "",
                          position: "right",
                          locale: "sl",
                          textInput: "",
                          format: "d.M.yyyy",
                          class: ke(r(b).issueDate.$errors[0] ? "v-input--error" : "")
                        }, null, 8, ["uid", "modelValue", "maxDate", "class"])
                      ]),
                      _: 1
                    }, 8, ["error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      for: "dp-input-" + r(i) + "-validityDate",
                      class: "form-label"
                    }, P(r(o)("Components.IdentificationInfoComponent.validityDate")), 9, Gd),
                    m(me, {
                      error: r(b).validityDate.$error,
                      "error-messages": ((ne = r(b).validityDate.$errors[0]) == null ? void 0 : ne.$message) ?? ""
                    }, {
                      default: E(() => [
                        m(q, {
                          uid: r(i) + "-validityDate",
                          modelValue: u.validityDate,
                          "onUpdate:modelValue": M[22] || (M[22] = (J) => u.validityDate = J),
                          minDate: /* @__PURE__ */ new Date(),
                          enableTimePicker: !1,
                          autoApply: "",
                          position: "right",
                          locale: "sl",
                          textInput: "",
                          format: "d.M.yyyy",
                          disabled: u.permanentValidity == !0,
                          class: ke(r(b).validityDate.$errors[0] ? "v-input--error" : "")
                        }, null, 8, ["uid", "modelValue", "minDate", "disabled", "class"])
                      ]),
                      _: 1
                    }, 8, ["error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        T.value ? (w(), ce(H, { key: 3 }, {
          default: E(() => [
            m(O, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var ne;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(i) + "-permanentValidity-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.IdentificationInfoComponent.permanentValidity")), 9, Bd),
                    m(z, {
                      modelValue: u.permanentValidity,
                      "onUpdate:modelValue": M[23] || (M[23] = (J) => u.permanentValidity = J),
                      "aria-labelledby": r(i) + "-permanentValidity-label",
                      error: r(b).permanentValidity.$error,
                      "error-messages": ((ne = r(b).permanentValidity.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                      onFocus: M[24] || (M[24] = (J) => r(b).permanentValidity.$reset())
                    }, {
                      default: E(() => [
                        m(L, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m(L, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0),
        m(H, null, {
          default: E(() => [
            m(O, { class: "v-col-12" }, {
              default: E(() => {
                var ne;
                return [
                  u.flowType === r(Z).POS ? (w(), ce(ie, {
                    key: 0,
                    modelValue: u.identificationConfirmation,
                    "onUpdate:modelValue": M[25] || (M[25] = (J) => u.identificationConfirmation = J),
                    label: r(o)("Components.IdentificationInfoComponent.identificationConfirmation", { userFullName: u.userFullName }),
                    error: r(b).identificationConfirmation.$error,
                    "error-messages": ((ne = r(b).identificationConfirmation.$errors[0]) == null ? void 0 : ne.$message) ?? "",
                    onFocus: M[26] || (M[26] = (J) => r(b).identificationConfirmation.$reset())
                  }, null, 8, ["modelValue", "label", "error", "error-messages"])) : B("", !0)
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(Pt, {
          display: p.showSigner,
          onModalClosed: M[27] || (M[27] = (ne) => p.showSigner = !1),
          showAcceptButton: !1,
          showDeclineButton: !1,
          class: "dialog-preview"
        }, {
          default: E(() => [
            m(kt, {
              url: p.signingUrl,
              frameBorder: "0"
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["display"]),
        p.message ? (w(), F("div", Wd, P(p.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function no() {
  return {
    taxNumber: "",
    msisdn: null,
    creditAmount: void 0,
    employmentType: void 0,
    hasSlovenianIncome: void 0,
    birthCity: "",
    birthdate: null,
    email: "",
    countrySourceFunds: "",
    countryFundsStatus: "",
    isViewDataLoading: !1,
    contractSignatureType: void 0,
    sisbonResultId: 0,
    debtInstallments: 0,
    userFullName: "",
    firstname: "",
    surname: "",
    citizen: void 0,
    address: "",
    postalCode: void 0,
    personalDocumentType: void 0,
    idNumber: "",
    idNumberCheck: "",
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: void 0,
    identificationConfirmation: !1,
    isSlovenianCitizen: void 0,
    flowType: void 0,
    notificationHtml: "",
    notificationType: void 0,
    belowNotificationHtml: "",
    title: "",
    productList: [],
    specialProductList: []
  };
}
function Yd() {
  return {
    showSigner: !1,
    signingUrl: "",
    applicationId: "",
    externalResults: {},
    isDataLoading: !1,
    isIdNumberCommited: !1,
    showIdAlert: !1,
    message: "",
    fieldsReadonly: !0,
    isIdNumberPrefilled: !1,
    ageError: ""
  };
}
function an(e) {
  return e === null ? !1 : e !== null && Qt(e) >= 70;
}
function qd(e, t) {
  const { t: s } = oe(), n = V.withMessage(s("GlobalErrors.FieldRequired"), ye), a = /* @__PURE__ */ new Date();
  a.setHours(0, 0, 0, 0);
  function o(y) {
    return y instanceof Date && Number.isFinite(y.getTime());
  }
  function l(y) {
    const f = y.toUpperCase();
    return e.isSlovenianCitizen === !1 ? y.length >= 8 && !f.startsWith("SI") : e.personalDocumentType === qe.Passport ? /^[A-Z]{2}\d{7}$/.test(f) : /^(\d{9}|IE\d{7})$/.test(f);
  }
  function i(y) {
    const f = new Date(a.getTime() + 86399999);
    return o(y) && y <= f;
  }
  function u(y) {
    return e.permanentValidity === !0 ? !0 : !o(y) || y < a ? !1 : !o(e.issueDate) || y >= e.issueDate;
  }
  function d(y) {
    var h, v, N, $;
    if (!o(y))
      return !0;
    const f = [
      ...e.productList,
      ...e.specialProductList
    ];
    let _ = ((h = e.productList[0]) == null ? void 0 : h.ageMin) ?? ((v = e.specialProductList[0]) == null ? void 0 : v.ageMin) ?? 50, b = ((N = e.productList[0]) == null ? void 0 : N.ageMax) ?? (($ = e.specialProductList[0]) == null ? void 0 : $.ageMax) ?? 0;
    for (const S of f)
      S.ageMin < _ && (_ = S.ageMin), S.ageMax > b && (b = S.ageMax);
    const g = Qt(y);
    return g < _ || g >= b ? (t.ageError = s("GlobalErrors.AgeLimit", {
      minimum: _,
      maximum: b - 1
    }), !1) : (t.ageError = "", !0);
  }
  return { validationRules: G(() => ({
    firstname: {
      required: n
    },
    surname: {
      required: n
    },
    citizen: {
      required: n
    },
    address: {
      required: n
    },
    postalCode: {
      required: n
    },
    birthdate: {
      required: n,
      customAge: V.withMessage(
        () => t.ageError,
        d
      )
    },
    personalDocumentType: {
      required: n
    },
    idNumber: {
      required: n,
      format: V.withMessage(s("GlobalErrors.InvalidDocument"), l)
    },
    documentIssuer: {
      required: n
    },
    issueDate: {
      required: n,
      date: V.withMessage(s("GlobalErrors.InvalidDate"), i)
    },
    validityDate: {
      required: V.withMessage(s("GlobalErrors.FieldRequired"), ve(() => e.permanentValidity !== !0)),
      date: V.withMessage(s("GlobalErrors.InvalidDate"), u)
    },
    permanentValidity: {
      required: V.withMessage(s("GlobalErrors.ChoiceRequired"), ve(() => an(e.birthdate)))
    },
    identificationConfirmation: e.flowType === Z.POS ? {
      confirmed: V.withMessage(s("GlobalErrors.ConfirmData"), Ht(!0))
    } : {}
  })) };
}
function Hd(e, t, s, n) {
  const a = ue("navigationButtonsApi", null), { validationRules: o } = qd(e, t), l = Me(o, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: i } = Oe();
  ue(Hr);
  const u = Gr(), d = Gr();
  Pe(d, e), e.idNumberCheck != null && e.idNumberCheck !== "" && (t.isIdNumberPrefilled = !0);
  async function p() {
    return t.externalResults.idNumber = t.isIdNumberCommited ? [] : [f("Components.ExistingIdentificationInfoComponent.ConfirmIdNumber")], l.value.$touch(), await l.value.$validate();
  }
  function y() {
    i(s.value);
  }
  const { t: f } = oe(), _ = ue("commClient"), b = ue("generalStore"), g = G(() => {
    var A;
    return (A = b.state.countryList) == null ? void 0 : A.find((M) => String(M.Key) === String(e.citizen));
  }), h = G(() => {
    var A, M;
    return ((M = (A = g.value) == null ? void 0 : A.AdditionalData) == null ? void 0 : M.RiskDrzava) === !0;
  });
  async function v(A) {
    if (t.showSigner = !1, e.isViewDataLoading = !1, A.success !== !0 && A.Success !== !0) {
      e.title = "OrderEnd.TitleFail", e.belowNotificationHtml = A.errorText, e.notificationType = Ce.Error, await ae(), n("navigationEvent", { name: "end" });
      return;
    }
    e.sisbonResultId = A.sisbonResultId, e.debtInstallments = A.debtInstallments, await ae(), n("navigationEvent", { name: "nextStep" });
  }
  async function N() {
    t.showSigner = !0, t.signingUrl = "/StaticLoaders/sisbon_process.html", e.isViewDataLoading = !0;
    try {
      const A = await _.executeMethodAsync("CheckExposureIdentificationData", {
        flowType: e.flowType,
        CreditAmount: e.creditAmount,
        TaxNumber: e.taxNumber,
        Firstname: e.firstname,
        Surname: e.surname,
        Birthdate: we(e.birthdate),
        EmploymentType: e.employmentType,
        Msisdn: e.msisdn,
        isSlovenianCitizen: e.isSlovenianCitizen,
        isIncomeSlo: e.hasSlovenianIncome,
        VlogaId: t.applicationId
      });
      ((A == null ? void 0 : A.success) !== !0 || A.sisbonWasChecked === !0) && await v(A ?? {});
    } catch {
      t.message = f("GlobalErrors.ServiceError"), e.isViewDataLoading = !1;
    }
  }
  async function $(A) {
    A[0].CallbackType === "SIGN" && A[0].Status === "complete" && A[0].Success === !0 && A[0].Type === "vloga" ? (t.applicationId = A[0].VlogaId, t.showSigner = !1, t.signingUrl = "", await N()) : A[0].CallbackType === "SISBON" && await v(A[0]);
  }
  async function S() {
    if (await p())
      try {
        e.isViewDataLoading = !0, t.message = "", t.showSigner = !0, t.signingUrl = "/StaticLoaders/vloga_upload_wait.html";
        const A = await _.executeMethodAsync("UploadVloga", {
          IzracunId: -1,
          Ime: e.firstname,
          Priimek: e.surname,
          DavcnaSt: e.taxNumber,
          Telefon: e.msisdn,
          Ulica: e.address,
          Posta: String(e.postalCode ?? ""),
          Birthdate: we(e.birthdate),
          VrstaOsDok: e.personalDocumentType,
          StOsDok: e.idNumber,
          DatumIzdajeOsDok: we(e.issueDate),
          DatumVeljavnostiOsDok: we(e.validityDate ?? new Date(1753, 1, 1)),
          Drzava: String(e.citizen),
          KrajRojstva: e.birthCity,
          IzdajateljOsDok: e.documentIssuer,
          Email: e.email,
          chkUseSMS: e.contractSignatureType == Nt.SMS,
          redirectUrl: ""
        });
        if ((A == null ? void 0 : A.Success) !== !0 || !A.Url || !A.VlogaId)
          throw new Error("Application upload failed");
        t.applicationId = A.VlogaId, t.signingUrl = A.Url, t.showSigner = !0;
      } catch {
        t.message = f("GlobalErrors.ServiceError");
      } finally {
        e.isViewDataLoading = !1;
      }
  }
  async function I() {
    t.externalResults.idNumber = [], l.value.idNumber.$touch(), await l.value.idNumber.$validate(), !l.value.idNumber.$error && (t.isIdNumberCommited ? (a == null || a.setButtonVisible("UpdateData", !1), t.isIdNumberCommited = !1, t.fieldsReadonly = !1, t.showIdAlert = !1, await ae()) : (e.identificationConfirmation = !1, t.isIdNumberCommited = !0, e.idNumberCheck != "" && e.idNumber == e.idNumberCheck ? (a == null || a.setButtonVisible("UpdateData", !0), Pe(e, d), t.fieldsReadonly = !0) : e.idNumber !== e.idNumberCheck && (Pe(e, u), t.fieldsReadonly = !1, t.showIdAlert = !0, await ae(), l.value.$reset(), await ae())));
  }
  async function C() {
    t.fieldsReadonly = !1, t.showIdAlert = !1;
  }
  async function T(A) {
    e.permanentValidity != A.permanentValidity && e.permanentValidity && (e.validityDate = null), e.birthdate != A.birthdate && e.birthdate != null && (an(e.birthdate) || (e.permanentValidity = !1), await ae());
  }
  return {
    isRiskCountry: h,
    v$: l,
    dataChanged: T,
    signApplication: S,
    signComplete: $,
    validateForm: p,
    startUpdateData: C,
    handleIdNumber: I,
    scrollToFirstErrorWrapper: y
  };
}
const Qd = { class: "section-heading" }, Kd = { class: "notification notification--notice" }, Zd = {
  key: 0,
  class: "notification notification--alert"
}, Jd = {
  key: 1,
  class: "notification notification--alert"
}, Xd = ["for"], Dd = { class: "control-document-no-wrapper" }, ec = { class: "mb-2" }, tc = ["id"], rc = ["for"], nc = ["for"], oc = ["for"], sc = ["for"], ic = ["for"], lc = ["for"], ac = ["for"], uc = ["for"], dc = ["for"], cc = ["id"], mc = {
  key: 3,
  class: "notification notification--warning",
  role: "alert"
}, gy = /* @__PURE__ */ ge({
  __name: "existing-identification-info-component",
  props: {
    data: { default: no }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = ue("commClient"), a = e, o = s, { t: l } = oe(), i = Be(), u = X(null), d = X(!1), p = se({ ...a.data }), y = se(Yd()), f = se(no());
    te(
      () => a.data,
      // Watch for changes in the data
      (L) => {
        Object.assign(p, L);
      },
      { deep: !0 }
    ), te(
      p,
      async (L) => {
        await h(f), Object.assign(f, L), o("update:data", L);
      },
      { deep: !0 }
    ), Se(() => {
      var L;
      (L = n == null ? void 0 : n.OnStreamDataReceived) == null || L.AddCallback(v), d.value = !0, o("componentReady");
    }), St(() => {
      var L;
      (L = n == null ? void 0 : n.OnStreamDataReceived) == null || L.RemoveCallback(v);
    });
    const {
      v$: _,
      validateForm: b,
      scrollToFirstErrorWrapper: g,
      dataChanged: h,
      signComplete: v,
      signApplication: N,
      startUpdateData: $,
      handleIdNumber: S
    } = Hd(p, y, u, o), I = ue("generalStore"), C = G(() => {
      const L = I.state.countryList ?? [];
      return p.isSlovenianCitizen === !0 ? L.slice(0, 1) : p.isSlovenianCitizen === !1 ? L.slice(1) : L;
    }), T = G(() => {
      const L = I.state.postalCodeList ?? [];
      return p.isSlovenianCitizen === !1 ? L.slice(0, -1) : L;
    }), A = G(() => an(p.birthdate));
    return (/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0), t({
      componentReady: d,
      signApplication: N,
      validateForm: b,
      scrollToFirstErrorWrapper: g,
      startUpdateData: $
    }), (L, z) => {
      const O = U("v-btn"), H = U("v-col"), q = U("v-row"), me = U("v-radio"), x = U("v-radio-group"), ie = U("Datepicker"), ne = U("v-input"), J = U("v-autocomplete"), j = U("v-checkbox");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: u,
        class: "existing-identification-info-component"
      }, [
        c("h2", Qd, P(r(l)("Components.ExistingIdentificationInfoComponent.Title")), 1),
        c("div", Kd, P(r(l)("Components.ExistingIdentificationInfoComponent.Notice")), 1),
        p.isSlovenianCitizen ? B("", !0) : (w(), F("div", Zd, P(r(l)("Components.ExistingIdentificationInfoComponent.ForeignerAlert")), 1)),
        y.showIdAlert ? (w(), F("div", Jd, P(r(l)("Components.IdentificationInfoComponent.AlertNotRecognized")), 1)) : B("", !0),
        m(q, null, {
          default: E(() => [
            m(H, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Y;
                return [
                  c("label", {
                    for: r(i) + "-idNumber",
                    class: "form-label"
                  }, P(r(l)("Components.IdentificationInfoComponent.idNumberCheck")), 9, Xd),
                  c("div", Dd, [
                    m(be, {
                      id: r(i) + "-idNumber",
                      modelValue: p.idNumber,
                      "onUpdate:modelValue": z[0] || (z[0] = (re) => p.idNumber = re),
                      readonly: y.isIdNumberCommited,
                      variant: "outlined",
                      error: r(_).idNumber.$error,
                      "error-messages": ((Y = r(_).idNumber.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                      onFocus: z[1] || (z[1] = (re) => r(_).idNumber.$reset()),
                      maxLength: p.isSlovenianCitizen === !0 && (p.personalDocumentType === r(qe).PersonalId || p.personalDocumentType === r(qe).Passport) ? "9" : void 0,
                      autocomplete: "off"
                    }, {
                      "append-inner": E(() => [
                        m(O, {
                          class: "btn btn--primary-outline btn--sm",
                          variant: "flat",
                          onClick: r(S)
                        }, {
                          default: E(() => [
                            Ie(P(r(l)(y.isIdNumberCommited ? "Components.IdentificationInfoComponent.Change" : "Components.IdentificationInfoComponent.Confirm")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["id", "modelValue", "readonly", "error", "error-messages", "maxLength"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        y.isIdNumberCommited ? (w(), F(Ae, { key: 2 }, [
          y.fieldsReadonly ? B("", !0) : (w(), ce(q, { key: 0 }, {
            default: E(() => [
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", ec, [
                      c("label", {
                        id: r(i) + "-personalDocumentType-label",
                        class: "form-label form-label--text"
                      }, P(r(l)("Components.IdentificationInfoComponent.personalDocumentType")), 9, tc),
                      m(x, {
                        modelValue: p.personalDocumentType,
                        "onUpdate:modelValue": z[2] || (z[2] = (re) => p.personalDocumentType = re),
                        "aria-labelledby": r(i) + "-personalDocumentType-label",
                        error: r(_).personalDocumentType.$error,
                        "error-messages": ((Y = r(_).personalDocumentType.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        readonly: y.fieldsReadonly,
                        onFocus: z[3] || (z[3] = (re) => r(_).personalDocumentType.$reset()),
                        class: "input-document-type"
                      }, {
                        default: E(() => [
                          m(me, {
                            label: r(l)("Components.IdentificationInfoComponent.PersonalId"),
                            value: r(qe).PersonalId
                          }, null, 8, ["label", "value"]),
                          m(me, {
                            label: r(l)("Components.IdentificationInfoComponent.Passport"),
                            value: r(qe).Passport
                          }, null, 8, ["label", "value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "aria-labelledby", "error", "error-messages", "readonly"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })),
          m(q, null, {
            default: E(() => [
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(i) + "-firstname",
                        class: "form-label"
                      }, P(r(l)("Components.IdentificationInfoComponent.firstname")), 9, rc),
                      m(be, {
                        id: r(i) + "-firstname",
                        modelValue: p.firstname,
                        "onUpdate:modelValue": z[4] || (z[4] = (re) => p.firstname = re),
                        variant: "outlined",
                        error: r(_).firstname.$error,
                        "error-messages": ((Y = r(_).firstname.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        onFocus: z[5] || (z[5] = (re) => r(_).firstname.$reset()),
                        readonly: y.fieldsReadonly,
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages", "readonly"])
                    ])
                  ];
                }),
                _: 1
              }),
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(i) + "-surname",
                        class: "form-label"
                      }, P(r(l)("Components.IdentificationInfoComponent.surname")), 9, nc),
                      m(be, {
                        id: r(i) + "-surname",
                        modelValue: p.surname,
                        "onUpdate:modelValue": z[6] || (z[6] = (re) => p.surname = re),
                        variant: "outlined",
                        error: r(_).surname.$error,
                        "error-messages": ((Y = r(_).surname.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        onFocus: z[7] || (z[7] = (re) => r(_).surname.$reset()),
                        readonly: y.fieldsReadonly,
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages", "readonly"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          m(q, null, {
            default: E(() => [
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: "dp-input-" + r(i) + "-birthdate",
                        class: "form-label"
                      }, P(r(l)("Components.ExistingIdentificationInfoComponent.birthdate")), 9, oc),
                      m(ne, {
                        error: r(_).birthdate.$error,
                        "error-messages": ((Y = r(_).birthdate.$errors[0]) == null ? void 0 : Y.$message) ?? ""
                      }, {
                        default: E(() => [
                          m(ie, {
                            modelValue: p.birthdate,
                            "onUpdate:modelValue": z[8] || (z[8] = (re) => p.birthdate = re),
                            maxDate: /* @__PURE__ */ new Date(),
                            enableTimePicker: !1,
                            autoApply: "",
                            position: "right",
                            locale: "sl",
                            textInput: "",
                            format: "d.M.yyyy",
                            readonly: y.fieldsReadonly,
                            class: ke(r(_).birthdate.$errors[0] ? "v-input--error" : "")
                          }, null, 8, ["modelValue", "maxDate", "readonly", "class"])
                        ]),
                        _: 1
                      }, 8, ["error", "error-messages"])
                    ])
                  ];
                }),
                _: 1
              }),
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(i) + "-citizen",
                        class: "form-label"
                      }, P(r(l)("Components.IdentificationInfoComponent.citizen")), 9, sc),
                      m(J, {
                        id: r(i) + "-citizen",
                        modelValue: p.citizen,
                        "onUpdate:modelValue": z[9] || (z[9] = (re) => p.citizen = re),
                        items: C.value,
                        "item-title": "Value",
                        "item-value": "Key",
                        variant: "outlined",
                        error: r(_).citizen.$error,
                        "error-messages": ((Y = r(_).citizen.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        onFocus: z[10] || (z[10] = (re) => r(_).citizen.$reset()),
                        readonly: y.fieldsReadonly
                      }, null, 8, ["id", "modelValue", "items", "error", "error-messages", "readonly"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          m(q, null, {
            default: E(() => [
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(i) + "-address",
                        class: "form-label"
                      }, P(r(l)("Components.IdentificationInfoComponent.address")), 9, ic),
                      m(be, {
                        id: r(i) + "-address",
                        modelValue: p.address,
                        "onUpdate:modelValue": z[11] || (z[11] = (re) => p.address = re),
                        variant: "outlined",
                        error: r(_).address.$error,
                        "error-messages": ((Y = r(_).address.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        onFocus: z[12] || (z[12] = (re) => r(_).address.$reset()),
                        readonly: y.fieldsReadonly,
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages", "readonly"])
                    ])
                  ];
                }),
                _: 1
              }),
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(i) + "-postalCode",
                        class: "form-label"
                      }, P(r(l)("Components.IdentificationInfoComponent.postalCode")), 9, lc),
                      m(J, {
                        id: r(i) + "-postalCode",
                        modelValue: p.postalCode,
                        "onUpdate:modelValue": z[13] || (z[13] = (re) => p.postalCode = re),
                        items: T.value,
                        "item-title": "Value",
                        "item-value": "Key",
                        variant: "outlined",
                        error: r(_).postalCode.$error,
                        "error-messages": ((Y = r(_).postalCode.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        onFocus: z[14] || (z[14] = (re) => r(_).postalCode.$reset()),
                        readonly: y.fieldsReadonly
                      }, null, 8, ["id", "modelValue", "items", "error", "error-messages", "readonly"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          m(q, null, {
            default: E(() => [
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: r(i) + "-documentIssuer",
                        class: "form-label"
                      }, P(r(l)("Components.IdentificationInfoComponent.documentIssuer")), 9, ac),
                      m(be, {
                        id: r(i) + "-documentIssuer",
                        modelValue: p.documentIssuer,
                        "onUpdate:modelValue": z[15] || (z[15] = (re) => p.documentIssuer = re),
                        variant: "outlined",
                        error: r(_).documentIssuer.$error,
                        "error-messages": ((Y = r(_).documentIssuer.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        onFocus: z[16] || (z[16] = (re) => r(_).documentIssuer.$reset()),
                        prefix: "UE",
                        readonly: y.fieldsReadonly,
                        autocomplete: "off"
                      }, null, 8, ["id", "modelValue", "error", "error-messages", "readonly"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          m(q, null, {
            default: E(() => [
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: "dp-input-" + r(i) + "-issueDate",
                        class: "form-label"
                      }, P(r(l)("Components.IdentificationInfoComponent.issueDate")), 9, uc),
                      m(ne, {
                        error: r(_).issueDate.$error,
                        "error-messages": ((Y = r(_).issueDate.$errors[0]) == null ? void 0 : Y.$message) ?? ""
                      }, {
                        default: E(() => [
                          m(ie, {
                            modelValue: p.issueDate,
                            "onUpdate:modelValue": z[17] || (z[17] = (re) => p.issueDate = re),
                            maxDate: /* @__PURE__ */ new Date(),
                            enableTimePicker: !1,
                            autoApply: "",
                            position: "right",
                            locale: "sl",
                            textInput: "",
                            format: "d.M.yyyy",
                            readonly: y.fieldsReadonly,
                            class: ke(r(_).issueDate.$errors[0] ? "v-input--error" : "")
                          }, null, 8, ["modelValue", "maxDate", "readonly", "class"])
                        ]),
                        _: 1
                      }, 8, ["error", "error-messages"])
                    ])
                  ];
                }),
                _: 1
              }),
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        for: "dp-input-" + r(i) + "-validityDate",
                        class: "form-label"
                      }, P(r(l)("Components.IdentificationInfoComponent.validityDate")), 9, dc),
                      m(ne, {
                        error: r(_).validityDate.$error,
                        "error-messages": ((Y = r(_).validityDate.$errors[0]) == null ? void 0 : Y.$message) ?? ""
                      }, {
                        default: E(() => [
                          m(ie, {
                            modelValue: p.validityDate,
                            "onUpdate:modelValue": z[18] || (z[18] = (re) => p.validityDate = re),
                            minDate: /* @__PURE__ */ new Date(),
                            enableTimePicker: !1,
                            autoApply: "",
                            position: "right",
                            locale: "sl",
                            textInput: "",
                            format: "d.M.yyyy",
                            readonly: y.fieldsReadonly,
                            disabled: p.permanentValidity == !0,
                            class: ke(r(_).validityDate.$errors[0] ? "v-input--error" : "")
                          }, null, 8, ["modelValue", "minDate", "readonly", "disabled", "class"])
                        ]),
                        _: 1
                      }, 8, ["error", "error-messages"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          !y.fieldsReadonly && A.value || p.permanentValidity == !0 ? (w(), ce(q, { key: 1 }, {
            default: E(() => [
              m(H, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Y;
                  return [
                    c("div", null, [
                      c("label", {
                        id: r(i) + "-permanentValidity-label",
                        class: "form-label form-label--text"
                      }, P(r(l)("Components.IdentificationInfoComponent.permanentValidity")), 9, cc),
                      m(x, {
                        modelValue: p.permanentValidity,
                        "onUpdate:modelValue": z[19] || (z[19] = (re) => p.permanentValidity = re),
                        "aria-labelledby": r(i) + "-permanentValidity-label",
                        error: r(_).permanentValidity.$error,
                        "error-messages": ((Y = r(_).permanentValidity.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        readonly: y.fieldsReadonly,
                        disabled: y.fieldsReadonly,
                        onFocus: z[20] || (z[20] = (re) => r(_).permanentValidity.$reset())
                      }, {
                        default: E(() => [
                          m(me, {
                            label: r(l)("GeneralButtons.Yes"),
                            value: !0
                          }, null, 8, ["label"]),
                          m(me, {
                            label: r(l)("GeneralButtons.No"),
                            value: !1
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "aria-labelledby", "error", "error-messages", "readonly", "disabled"])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })) : B("", !0),
          m(q, null, {
            default: E(() => [
              m(H, { class: "v-col-12" }, {
                default: E(() => {
                  var Y;
                  return [
                    p.flowType === r(Z).POS ? (w(), ce(j, {
                      key: 0,
                      modelValue: p.identificationConfirmation,
                      "onUpdate:modelValue": z[21] || (z[21] = (re) => p.identificationConfirmation = re),
                      label: r(l)("Components.IdentificationInfoComponent.identificationConfirmation", { userFullName: p.userFullName }),
                      error: r(_).identificationConfirmation.$error,
                      "error-messages": ((Y = r(_).identificationConfirmation.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                      onFocus: z[22] || (z[22] = (re) => r(_).identificationConfirmation.$reset())
                    }, null, 8, ["modelValue", "label", "error", "error-messages"])) : B("", !0)
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64)) : B("", !0),
        m(Pt, {
          display: y.showSigner,
          onModalClosed: z[23] || (z[23] = (Y) => y.showSigner = !1),
          showAcceptButton: !1,
          showDeclineButton: !1,
          class: "dialog-preview"
        }, {
          default: E(() => [
            m(kt, {
              url: y.signingUrl,
              frameBorder: "0"
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["display"]),
        y.message ? (w(), F("div", mc, P(y.message), 1)) : B("", !0)
      ], 512);
    };
  }
}), Do = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%206L9%2017L4%2012'%20stroke='%2373A300'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", es = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='16'%20fill='%23E6F2CC'/%3e%3cpath%20d='M26%2015.0801V16.0001C25.9988%2018.1565%2025.3005%2020.2548%2024.0093%2021.9819C22.7182%2023.7091%2020.9033%2024.9726%2018.8354%2025.584C16.7674%2026.1954%2014.5573%2026.122%2012.5345%2025.3747C10.5117%2024.6274%208.78465%2023.2462%207.61096%2021.4372C6.43727%2019.6281%205.87979%2017.4882%206.02168%2015.3364C6.16356%2013.1847%206.99721%2011.1364%208.39828%209.49718C9.79935%207.85793%2011.6928%206.71549%2013.7962%206.24025C15.8996%205.76502%2018.1003%205.98245%2020.07%206.86011'%20stroke='%2373A300'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M26%208L16%2018.01L13%2015.01'%20stroke='%2373A300'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e";
function oo() {
  return {
    creditAmount: void 0,
    selectedProductType: void 0,
    selectedSpecialProduct: void 0,
    firstname: "",
    surname: "",
    address: "",
    idNumber: "",
    idNumberCheck: "",
    documentIssuer: "",
    birthCity: "",
    employerName: "",
    employerAddress: "",
    TRR: "",
    countrySourceFunds: "",
    countryFundsStatus: "",
    email: "",
    citizen: void 0,
    postalCode: void 0,
    employerPostCode: void 0,
    hasPermanentResidenceInSlovenia: void 0,
    isSlovenianCitizen: void 0,
    hasSlovenianIncome: void 0,
    hasSlovenianBankAccount: void 0,
    permanentValidity: void 0,
    isPoliticallyExposedPerson: void 0,
    msisdn: null,
    birthdate: null,
    issueDate: null,
    validityDate: null,
    personalDocumentType: void 0,
    employmentType: void 0,
    isExistingUser: !1,
    isPreapproved: !1,
    isEmailVerified: !1,
    identificationConfirmation: !1,
    taxNumber: void 0,
    orderToken: "",
    isCompanyTaxNumber: !1,
    errorText: void 0,
    summitDebt: 0,
    contractDebt: 0,
    contractDebtInstallments: 0,
    isCurrentSpecialProductAvailable: void 0,
    availableCreditAmount: 0,
    maxCreditAmount: void 0,
    minSalary: 0,
    minCredit: 0,
    preapprovedType: "",
    preapprovedCreditAmount: 0,
    preapprovedInstallmentAmount: 0,
    phoneNumber: "",
    prefix: void 0,
    code: "",
    isPhoneVerified: !1,
    flowType: void 0,
    belowNotificationHtml: "",
    notificationType: void 0,
    title: "",
    needsToEnterIncome: !0,
    numberOfPrefilledSalaries: 0,
    marketingConsent: !1,
    isViewDataLoading: !1,
    lastMonthsIncome: void 0,
    lastMonthsIncome2: void 0,
    lastMonthsIncome3: void 0,
    hasUserPassword: !1
  };
}
function fc() {
  return {
    externalResults: {},
    isDataLoading: !1,
    isSpecialActionCorrect: null,
    message: "",
    isCodeSent: !1
  };
}
function pc(e) {
  const { t } = oe();
  function s() {
    var a;
    return ((a = e.code) == null ? void 0 : a.length) === 4;
  }
  return { validationRules: G(() => ({
    taxNumber: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ye),
      format: V.withMessage(t("GlobalErrors.InvalidTax"), Xo)
    },
    prefix: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ye)
    },
    phoneNumber: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ye),
      format: V.withMessage(t("GlobalErrors.InvalidValue"), (a) => /^\d{8,12}$/.test(a))
    },
    code: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ye),
      customRequired: V.withMessage(t("GlobalErrors.FieldRequired"), s)
    }
  })) };
}
function ts() {
  return {
    icon: "",
    title: "",
    aboveNotificationHtml: "",
    belowNotificationHtml: "",
    notificationType: void 0,
    notificationHtml: "",
    successPage: "",
    errorPage: ""
  };
}
function Br(e, t) {
  return {
    ...ts(),
    title: e,
    belowNotificationHtml: t,
    notificationType: Ce.Error
  };
}
function vc(e, t, s, n) {
  const { validationRules: a } = pc(e), o = Me(a, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: l } = Oe();
  async function i() {
    return o.value.$touch(), await o.value.$validate();
  }
  function u() {
    l(".verification-component");
  }
  const { t: d } = oe(), p = ue("commClient"), y = ue("generalStore");
  function f() {
    e.prefix === void 0 && (e.prefix = y.state.countryPhoneList.find((I) => I.Key === "+386") ?? void 0), t.isCodeSent = e.isPhoneVerified;
  }
  function _() {
    var T;
    const I = String(((T = e.prefix) == null ? void 0 : T.Key) ?? "").replace("+", "").trim(), C = e.phoneNumber.replace(/^0+/, "");
    return e.phoneNumber = C, I + C;
  }
  function b() {
    e.code = "", e.msisdn = null, e.isPhoneVerified = !1, t.isCodeSent = !1, t.message = "", t.externalResults.code = [], o.value.$reset();
  }
  async function g() {
    const I = ["taxNumber", "prefix", "phoneNumber"];
    if ((await Promise.all(I.map((T) => o.value[T].$validate()))).some((T) => !T))
      return !1;
    t.message = "", e.code = "", e.isPhoneVerified = !1;
    try {
      const T = {
        Msisdn: _(),
        ...e.flowType === Z.WEB || e.flowType === Z.SKLENI_SAM || e.flowType === Z.LIMIT ? { OrderToken: e.orderToken } : {}
      };
      return console.log("sendConfirmationCodePayload", T), console.log(e.flowType), (await p.executeMethodAsync("SendConfirmationCode", T)).Success == !0 ? (t.isCodeSent = !0, !0) : (t.message = d("GlobalErrors.CodeNotExpired"), !1);
    } catch {
      return t.message = d("GlobalErrors.ServiceError"), !1;
    } finally {
    }
  }
  async function h() {
    if (!t.isCodeSent || !await i())
      return !1;
    const I = (C) => new Promise((T) => setTimeout(T, C));
    t.isDataLoading = !0, await ae(), await Promise.all([
      I(1e3)
    ]), await v(), t.isDataLoading = !1, await ae();
  }
  async function v() {
    t.message = "";
    try {
      let I = "sf.ConfirmationCodeCheck";
      (e.flowType === Z.WEB || e.flowType === Z.SKLENI_SAM || e.flowType === Z.LIMIT) && (I = "ConfirmationCodeCheck");
      const C = {
        Msisdn: _(),
        Code: e.code,
        ...e.flowType === Z.WEB || e.flowType === Z.SKLENI_SAM || e.flowType === Z.LIMIT ? {
          OrderToken: e.orderToken,
          TaxNumber: e.taxNumber,
          Msisdn: _()
        } : {}
      }, T = await p.executeMethodAsync(I, C);
      if (T.Success !== !0)
        return e.code = "", t.message = d("GlobalErrors." + T.Error), !1;
      switch (e.msisdn = _(), e.flowType) {
        case Z.POS:
          const A = await p.executeMethodAsync("sf.PrefillCustomerData", {
            TaxNumber: e.taxNumber,
            Msisdn: e.msisdn
          });
          A != null ? (A.birthdate != null && A.birthdate != "" && (A.birthdate = new Date(A.birthdate)), A.issueDate != null && A.issueDate != "" && (A.issueDate = new Date(A.issueDate)), A.permanentValidity === !0 ? A.validityDate = null : A.validityDate != null && A.validityDate != "" && (A.validityDate = new Date(A.validityDate)), Pe(e, A), Pe(t, A)) : e.isExistingUser = !1;
          break;
        case Z.LIMIT:
        case Z.SKLENI_SAM:
        case Z.WEB:
          const M = await p.executeMethodAsync("sw.PrefillCustomerData", {
            OrderToken: e.orderToken
          });
          Pe(e, M), e.isExistingUser = !1, e.isEmailVerified === !1 && n("verifyEmail");
          break;
      }
      return e.isPhoneVerified = !0, !0;
    } catch {
      return t.message = d("GlobalErrors.ServiceError"), !1;
    } finally {
    }
  }
  async function N() {
    var I;
    if (!e.isPhoneVerified)
      return !1;
    t.message = "";
    try {
      let C;
      switch (e.isViewDataLoading = !0, e.flowType) {
        case Z.POS:
          C = await p.executeMethodAsync("IzpostavljenostCheckTaxNumberNewFlow", {
            OrderToken: e.orderToken,
            DavcnaSt: e.taxNumber,
            CreditAmount: e.creditAmount,
            EmploymentType: e.employmentType,
            SelectedProductType: e.selectedProductType,
            SelectedSpecialProduct: (I = e.selectedSpecialProduct) == null ? void 0 : I.productId,
            IsSlovenianCitizen: e.isSlovenianCitizen
          });
          break;
        case Z.SKLENI_SAM:
        case Z.WEB:
          C = await p.executeMethodAsync("IzpostavljenostCheckTaxNumberNewWeb", {
            OrderToken: e.orderToken,
            CreditAmount: e.creditAmount
          });
          break;
        case Z.LIMIT:
          C = await p.executeMethodAsync("IzpostavljenostCheckTaxNumberLimit", {
            OrderToken: e.orderToken
          });
          break;
      }
      if (e.isViewDataLoading = !1, Pe(e, C), await ae(), console.log(e), e.errorText != null && e.errorText != "") {
        const T = Br("GlobalErrors.Error", "GlobalErrors." + e.errorText);
        return await ae(), Pe(e, T), await ae(), n("navigationEvent", { name: "end" }), !1;
      }
    } catch {
      return t.message = d("GlobalErrors.ServiceError"), !1;
    }
    return !0;
  }
  async function $() {
    if (o.value.taxNumber.$touch(), await o.value.taxNumber.$validate(), o.value.taxNumber.$error)
      u();
    else if ((await p.executeMethodAsync("PreverjanjeSuspectNewFlowInsert", {
      DavcnaSt: e.taxNumber
    })).Success) {
      const C = Br("GlobalErrors.Error", "GlobalErrors.SuspectPersonError");
      await ae(), Pe(e, C), await ae(), n("navigationEvent", { name: "end" });
    }
  }
  async function S(I) {
    e.code != I.code && (e.isPhoneVerified = !1, t.externalResults.code = []);
  }
  return {
    v$: o,
    dataChanged: S,
    validateForm: i,
    scrollToFirstErrorWrapper: u,
    resetVerification: b,
    generalStore: y,
    InitializeData: f,
    sendCode: g,
    verifyCode: h,
    checkExposure: N,
    suspectPerson: $
  };
}
const gc = ["for"], yc = ["for"], bc = { class: "control-phone-wrapper" }, Cc = { class: "control-phone-actions" }, Ic = {
  key: 0,
  src: Do,
  alt: "Success",
  class: "icon-sent"
}, _c = { class: "v-input__details" }, hc = ["role"], Tc = { class: "v-messages__message" }, Ec = ["id"], Nc = { class: "d-flex align-center" }, Sc = {
  key: 0,
  class: "loader-small ml-8"
}, Pc = {
  key: 1,
  class: "d-flex align-center ga-2 ml-8"
}, $c = {
  key: 0,
  src: es,
  alt: "Success"
}, Mc = {
  key: 0,
  class: "v-input--error"
}, Ac = { class: "v-input__details" }, wc = {
  class: "v-messages",
  role: "alert"
}, kc = { class: "v-messages__message" }, Oc = {
  key: 0,
  class: "notification notification--warning mt-6",
  role: "alert"
}, yy = /* @__PURE__ */ ge({
  __name: "verification-component",
  props: {
    data: { default: oo }
  },
  emits: ["update:data", "componentReady", "navigationEvent", "verifyEmail"],
  setup(e, { expose: t, emit: s }) {
    const { smAndDown: n } = sn(), a = e, o = s, { t: l } = oe(), i = Be(), u = se({ ...a.data }), d = se(oo()), p = se(fc()), y = X(null), f = X(!1);
    te(
      () => a.data,
      // Watch for changes in the data
      (x) => {
        Object.assign(u, x);
      },
      { deep: !0 }
    ), te(
      u,
      async (x) => {
        await I(d), Object.assign(d, x), o("update:data", x);
      },
      { deep: !0 }
    ), Se(() => {
      S(), f.value = !0, o("componentReady");
    });
    const {
      v$: _,
      validateForm: b,
      scrollToFirstErrorWrapper: g,
      generalStore: h,
      sendCode: v,
      resetVerification: N,
      verifyCode: $,
      InitializeData: S,
      dataChanged: I,
      suspectPerson: C,
      checkExposure: T
    } = vc(u, p, y, o), A = X(null), M = X(null);
    let L = !1;
    function z(x, ie) {
      const ne = x.target;
      if (!(ne instanceof HTMLInputElement)) return;
      const J = ne.value.replace(/[^0-9]/g, "");
      ne.value = J, u[ie] = J;
    }
    function O() {
      L = !0;
    }
    function H(x) {
      var ie, ne;
      x.preventDefault(), (ie = x.target) == null || ie.blur(), (ne = M.value) == null || ne.focus();
    }
    function q(x) {
      var ne;
      const ie = x.relatedTarget;
      if ((ie == null ? void 0 : ie.id) === i + "-prefix" && L) {
        L = !1;
        return;
      }
      L = !1, (ie == null ? void 0 : ie.id) !== i + "-phoneNumber" && ((ne = M.value) == null || ne.focus());
    }
    async function me() {
      var x, ie;
      if (p.isCodeSent || u.isPhoneVerified) {
        N(), await ae(), (x = M.value) == null || x.focus();
        return;
      }
      await v() && (await ae(), (ie = A.value) == null || ie.focus());
    }
    return t({
      componentReady: f,
      validateForm: b,
      checkExposure: T,
      suspectPerson: C,
      scrollToFirstErrorWrapper: g
    }), (x, ie) => {
      const ne = U("v-text-field"), J = U("v-col"), j = U("v-row"), Y = U("v-autocomplete"), re = U("v-btn"), fe = U("v-otp-input");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: y,
        class: "verification-component"
      }, [
        c("h2", {
          class: ke(["section-heading", { "mt-2": r(n) }])
        }, P(r(l)("Components.VerificationComponent.Title")), 3),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Le;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-taxNumber",
                      class: "form-label"
                    }, P(r(l)("Components.VerificationComponent.taxNumber")), 9, gc),
                    m(ne, {
                      id: r(i) + "-taxNumber",
                      modelValue: u.taxNumber,
                      "onUpdate:modelValue": ie[0] || (ie[0] = (Q) => u.taxNumber = Q),
                      error: r(_).taxNumber.$error,
                      "error-messages": ((Le = r(_).taxNumber.$errors[0]) == null ? void 0 : Le.$message) ?? "",
                      onFocus: ie[1] || (ie[1] = (Q) => r(_).taxNumber.$reset()),
                      onKeydown: qr(H, ["enter"]),
                      onBlur: q,
                      autocomplete: "off",
                      variant: "outlined",
                      identifier: "",
                      "max-length": 8,
                      disabled: p.isCodeSent,
                      inputmode: "numeric",
                      onInput: ie[2] || (ie[2] = (Q) => z(Q, "taxNumber"))
                    }, null, 8, ["id", "modelValue", "error", "error-messages", "disabled"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Le, Q, ee;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(i) + "-phoneNumber",
                      class: "form-label"
                    }, P(r(l)("Components.VerificationComponent.phoneNumber")), 9, yc),
                    c("div", bc, [
                      m(Y, {
                        id: r(i) + "-prefix",
                        modelValue: u.prefix,
                        "onUpdate:modelValue": ie[3] || (ie[3] = (Xe) => u.prefix = Xe),
                        items: r(h).state.countryPhoneList,
                        "item-title": "Value",
                        "item-value": "Key",
                        "return-object": "",
                        variant: "outlined",
                        class: "control-phone-country",
                        "aria-label": r(l)("Components.VerificationComponent.prefix"),
                        error: r(_).prefix.$error,
                        "error-messages": ((Le = r(_).prefix.$errors[0]) == null ? void 0 : Le.$message) ?? "",
                        onFocus: ie[4] || (ie[4] = (Xe) => r(_).prefix.$reset()),
                        onMousedownCapture: O,
                        disabled: p.isCodeSent
                      }, null, 8, ["id", "modelValue", "items", "aria-label", "error", "error-messages", "disabled"]),
                      m(ne, {
                        id: r(i) + "-phoneNumber",
                        ref_key: "phoneNumberInputRef",
                        ref: M,
                        modelValue: u.phoneNumber,
                        "onUpdate:modelValue": ie[5] || (ie[5] = (Xe) => u.phoneNumber = Xe),
                        identifier: "",
                        "max-length": 12,
                        class: "control-phone-number",
                        error: r(_).phoneNumber.$error,
                        "error-messages": ((Q = r(_).phoneNumber.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                        onFocus: ie[6] || (ie[6] = (Xe) => r(_).phoneNumber.$reset()),
                        variant: "outlined",
                        autocomplete: "off",
                        readonly: p.isCodeSent,
                        inputmode: "numeric",
                        onInput: ie[7] || (ie[7] = (Xe) => z(Xe, "phoneNumber"))
                      }, {
                        "append-inner": E(() => [
                          c("div", Cc, [
                            p.isCodeSent ? (w(), F("img", Ic)) : B("", !0),
                            m(re, {
                              class: "btn btn--primary-outline btn--sm",
                              variant: "flat",
                              onClick: me
                            }, {
                              default: E(() => [
                                Ie(P(r(l)(p.isCodeSent || u.isPhoneVerified ? "Components.VerificationComponent.Edit" : "Components.VerificationComponent.Send")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["id", "modelValue", "error", "error-messages", "readonly"])
                    ]),
                    r(_).phoneNumber.$error || p.isCodeSent && !u.isPhoneVerified ? (w(), F("div", {
                      key: 0,
                      class: ke({ "v-input--error": r(_).phoneNumber.$error })
                    }, [
                      c("div", _c, [
                        c("div", {
                          class: "v-messages",
                          role: r(_).phoneNumber.$error ? "alert" : "status"
                        }, [
                          c("div", Tc, P(r(_).phoneNumber.$error ? (ee = r(_).phoneNumber.$errors[0]) == null ? void 0 : ee.$message : r(l)("Components.VerificationComponent.CodeSent")), 1)
                        ], 8, hc)
                      ])
                    ], 2)) : B("", !0)
                  ])
                ];
              }),
              _: 1
            }),
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Le;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(i) + "-code-label",
                      class: "form-label"
                    }, P(r(l)("Components.VerificationComponent.code")), 9, Ec),
                    c("div", Nc, [
                      m(fe, {
                        ref_key: "codeInputRef",
                        ref: A,
                        modelValue: u.code,
                        "onUpdate:modelValue": ie[8] || (ie[8] = (Q) => u.code = Q),
                        length: 4,
                        type: "number",
                        "aria-labelledby": r(i) + "-code-label",
                        disabled: !p.isCodeSent || u.isPhoneVerified,
                        error: r(_).code.$error,
                        onFinish: r($)
                      }, null, 8, ["modelValue", "aria-labelledby", "disabled", "error", "onFinish"]),
                      p.isDataLoading ? (w(), F("span", Sc, ie[9] || (ie[9] = [
                        c("img", {
                          src: on,
                          alt: "Loader"
                        }, null, -1),
                        c("div", null, "Preverjam", -1)
                      ]))) : B("", !0),
                      u.isPhoneVerified ? (w(), F("div", Pc, [
                        p.isCodeSent ? (w(), F("img", $c)) : B("", !0),
                        ie[10] || (ie[10] = c("span", null, "Potrjeno", -1))
                      ])) : B("", !0)
                    ]),
                    r(_).code.$error ? (w(), F("div", Mc, [
                      c("div", Ac, [
                        c("div", wc, [
                          c("div", kc, P((Le = r(_).code.$errors[0]) == null ? void 0 : Le.$message), 1)
                        ])
                      ])
                    ])) : B("", !0)
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        p.message ? (w(), F("div", Oc, P(p.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function Rc() {
  return {
    orderToken: "",
    email: "",
    isEmailVerified: !1,
    flowType: void 0,
    isViewDataLoading: !1
  };
}
function Lc() {
  return {
    externalResults: {},
    isDataLoading: !1,
    isSpecialActionCorrect: null,
    message: "",
    code: "",
    isCodeSending: !1,
    isCodeSent: !1
  };
}
function xc(e, t) {
  const { t: s } = oe();
  function n() {
    var a;
    return ((a = t.code) == null ? void 0 : a.length) === 4;
  }
  return G(() => ({
    email: {
      required: V.withMessage(s("GlobalErrors.FieldRequired"), ye),
      customEmail: V.withMessage(s("GlobalErrors.CorrectEmail"), Gl)
    },
    code: {
      required: V.withMessage(s("GlobalErrors.FieldRequired"), ye),
      customRequired: V.withMessage(s("GlobalErrors.FieldRequired"), n)
    }
  }));
}
function Fc(e, t) {
  const s = ue("commClient"), { t: n } = oe(), a = Me(
    xc(e, t),
    G(() => ({
      email: e.email,
      code: t.code
    })),
    { $autoDirty: !0 }
  );
  async function o() {
    return a.value.$touch(), a.value.$validate();
  }
  function l() {
    t.code = "", e.email = "", e.isEmailVerified = !1, t.isCodeSent = !1, t.message = "", t.externalResults.code = [], a.value.$reset();
  }
  async function i() {
    return t.message = "", a.value.email.$touch(), await a.value.email.$validate(), a.value.email.$error ? !1 : (await s.executeMethodAsync(
      "VerificationEmailSend",
      {
        Email: e.email,
        OrderToken: e.orderToken
      }
    )).Success == !0 ? (t.isCodeSent = !0, !0) : (t.message = n("GlobalErrors.CodeEmailExpired"), !1);
  }
  async function u() {
    if (!t.isCodeSent || !await o())
      return !1;
    const p = (y) => new Promise((f) => setTimeout(f, y));
    t.isDataLoading = !0, await ae(), await Promise.all([
      p(1e3)
    ]), await d(), t.isDataLoading = !1, await ae();
  }
  async function d() {
    t.message = "";
    try {
      const p = await s.executeMethodAsync("VerificationEmailCheck", {
        Email: e.email,
        Code: t.code,
        OrderToken: e.orderToken
      });
      return p.Success !== !0 ? (t.code = "", t.message = n("GlobalErrors." + p.ErrorType), !1) : (e.isEmailVerified = !0, !0);
    } catch {
      return t.message = n("GlobalErrors.ServiceError"), !1;
    } finally {
    }
  }
  return {
    v$: a,
    sendVerificationEmail: i,
    resetVerification: l,
    validateForm: o,
    verifyCode: u
  };
}
const Vc = {
  class: "verification-email-component",
  ref: "rootRef"
}, zc = { class: "form-label" }, jc = { class: "control-email-wrapper" }, Uc = { class: "control-phone-actions" }, Gc = {
  key: 0,
  src: Do,
  alt: "Success",
  class: "icon-sent"
}, Bc = ["id"], Wc = { class: "d-flex align-center" }, Yc = {
  key: 0,
  class: "loader-small ml-8"
}, qc = {
  key: 1,
  class: "d-flex align-center ga-2 ml-8"
}, Hc = {
  key: 0,
  src: es,
  alt: "Success"
}, Qc = {
  key: 0,
  class: "v-input--error"
}, Kc = { class: "v-input__details" }, Zc = {
  class: "v-messages",
  role: "alert"
}, Jc = { class: "v-messages__message" }, Xc = {
  key: 0,
  class: "notification notification--warning mt-6",
  role: "alert"
}, by = /* @__PURE__ */ ge({
  __name: "email-verification-component",
  props: {
    data: { default: Rc }
  },
  emits: ["update:data"],
  setup(e, { expose: t, emit: s }) {
    const { t: n } = oe(), a = Be(), o = e, l = s;
    let i = X(!1);
    const u = se({ ...o.data }), d = se(Lc()), p = X(null), y = X(null), { v$: f, sendVerificationEmail: _, resetVerification: b, validateForm: g, verifyCode: h } = Fc(u, d);
    te(
      () => o.data,
      // Watch for changes in the data
      (N) => {
        Object.assign(u, N);
      },
      { deep: !0 }
    ), te(
      u,
      (N) => {
        l("update:data", N);
      },
      { deep: !0 }
    );
    async function v() {
      var N, $;
      if (d.isCodeSent || u.isEmailVerified) {
        b(), await ae(), (N = y.value) == null || N.focus();
        return;
      }
      await _() && (await ae(), ($ = p.value) == null || $.focus());
    }
    return t({
      sendVerificationEmail: _,
      validateForm: g,
      componentReady: i
    }), (N, $) => {
      const S = U("v-btn"), I = U("v-text-field"), C = U("v-col"), T = U("v-otp-input"), A = U("v-row");
      return w(), F("div", Vc, [
        m(A, { class: "responsive-container" }, {
          default: E(() => [
            m(C, { class: "v-col-12 v-col-md-6 responsive-col" }, {
              default: E(() => [
                c("label", zc, P(N.$t("Components.EmailVerificationComponent.Email")), 1),
                c("div", jc, [
                  m(I, {
                    modelValue: u.email,
                    "onUpdate:modelValue": $[0] || ($[0] = (M) => u.email = M),
                    ref_key: "emailInputRef",
                    ref: y,
                    "error-messages": r(f).email.$errors[0] != null ? r(f).email.$errors[0].$message : "",
                    onFocus: r(f).email.$reset,
                    variant: "outlined",
                    readonly: d.isCodeSent || d.isCodeSending,
                    autocomplete: "off"
                  }, {
                    "append-inner": E(() => [
                      c("div", Uc, [
                        d.isCodeSent ? (w(), F("img", Gc)) : B("", !0),
                        m(S, {
                          class: "btn btn--primary-outline btn--sm",
                          variant: "flat",
                          onClick: v
                        }, {
                          default: E(() => [
                            Ie(P(N.$t(d.isCodeSent || u.isEmailVerified ? "Components.EmailVerificationComponent.Edit" : "Components.EmailVerificationComponent.Send")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error-messages", "onFocus", "readonly"])
                ])
              ]),
              _: 1
            }),
            m(C, { class: "v-col-12 v-col-md-6 responsive-col" }, {
              default: E(() => {
                var M;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(a) + "-code-label",
                      class: "form-label"
                    }, P(N.$t("Components.VerificationComponent.code")), 9, Bc),
                    c("div", Wc, [
                      m(T, {
                        ref_key: "codeInputRef",
                        ref: p,
                        modelValue: d.code,
                        "onUpdate:modelValue": $[1] || ($[1] = (L) => d.code = L),
                        length: 4,
                        type: "number",
                        "aria-labelledby": r(a) + "-code-label",
                        disabled: !d.isCodeSent || d.isCodeSending || u.isEmailVerified,
                        error: r(f).code.$error,
                        onFinish: r(h)
                      }, null, 8, ["modelValue", "aria-labelledby", "disabled", "error", "onFinish"]),
                      d.isDataLoading || d.isCodeSending ? (w(), F("span", Yc, $[2] || ($[2] = [
                        c("img", {
                          src: on,
                          alt: "Loader"
                        }, null, -1),
                        c("div", null, " Preverjam ", -1)
                      ]))) : B("", !0),
                      u.isEmailVerified ? (w(), F("div", qc, [
                        d.isCodeSent ? (w(), F("img", Hc)) : B("", !0),
                        $[3] || ($[3] = c("span", null, "Potrjeno", -1))
                      ])) : B("", !0)
                    ]),
                    r(f).code.$error ? (w(), F("div", Qc, [
                      c("div", Kc, [
                        c("div", Zc, [
                          c("div", Jc, P((M = r(f).code.$errors[0]) == null ? void 0 : M.$message), 1)
                        ])
                      ])
                    ])) : B("", !0)
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        d.message ? (w(), F("div", Xc, P(d.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function so() {
  return {
    flowType: void 0,
    creditAmount: void 0,
    selectedProductType: void 0,
    selectedProduct: void 0,
    selectedSpecialProduct: void 0,
    productList: [],
    specialProductList: []
  };
}
function Dc() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function rs(e) {
  return e.selectedProductType === "SPECIAL" ? e.selectedSpecialProduct : e.selectedProduct;
}
function em(e) {
  const { t } = oe();
  function s() {
    return e.flowType !== Z.POS ? !0 : e.selectedProductType !== void 0 && e.selectedProductType !== null;
  }
  function n() {
    return e.selectedProductType !== "SPECIAL" ? !0 : e.selectedSpecialProduct !== null && e.selectedSpecialProduct !== void 0;
  }
  function a(l) {
    if (l === null || !Number.isFinite(l) || l <= 0)
      return !0;
    const i = rs(e);
    return i ? l >= i.amountMin && l <= i.amountMax : !0;
  }
  return { validationRules: G(() => ({
    selectedProductType: {
      available: V.withMessage(t("GlobalErrors.SelectProduct"), s)
    },
    selectedSpecialProduct: {
      available: V.withMessage(t("GlobalErrors.SelectProduct"), n)
    },
    creditAmount: {
      required: V.withMessage(t("GlobalErrors.FieldRequired"), ye),
      range: V.withMessage(() => {
        const { min: l, max: i } = ns(e);
        return t("Components.FinancingOptionsComponent.AmountRange", { min: jr(l), max: jr(i) });
      }, a)
    }
  })) };
}
function ns(e) {
  const t = rs(e);
  return {
    min: (t == null ? void 0 : t.amountMin) ?? 0,
    max: (t == null ? void 0 : t.amountMax) ?? 0
  };
}
function tm(e, t, s) {
  const { t: n } = oe(), a = ue("commClient"), { validationRules: o } = em(e), l = Me(o, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: i } = Oe();
  async function u() {
    return l.value.$touch(), await l.value.$validate();
  }
  function d() {
    i(".financing-options-component");
  }
  const p = G(() => ns(e));
  function y(b) {
    return e.productList.some((g) => ea(g.productId, b));
  }
  async function f() {
    t.isDataLoading = !0, t.message = "", e.productList = [], e.specialProductList = [], e.selectedProduct = void 0;
    try {
      const b = await a.executeMethodAsync("sf.ProductListNewFlow", {});
      return e.productList = b.productList, e.specialProductList = b.specialProducts, !0;
    } catch {
      return t.message = n("GlobalErrors.ServiceError"), !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function _(b) {
    if (e.selectedProductType != b.selectedProductType)
      for (let g = 0; g < e.productList.length; g++)
        e.productList[g].productId == e.selectedProductType && (e.selectedProduct = e.productList[g]);
  }
  return {
    v$: l,
    localData: t,
    bounds: p,
    productIsAvailable: y,
    dataChanged: _,
    loadProducts: f,
    validateForm: u,
    scrollToFirstErrorWrapper: d
  };
}
const rm = { class: "section-heading" }, nm = ["for"], om = { class: "control-product-type" }, sm = ["id"], im = {
  key: 0,
  class: "mb-4"
}, lm = ["for"], am = {
  key: 0,
  class: "notification notification--notice"
}, um = {
  key: 1,
  class: "notification notification--warning",
  role: "alert"
}, Cy = /* @__PURE__ */ ge({
  __name: "financing-options-component",
  props: {
    data: { default: so }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const { t: n } = oe(), a = Be(), o = e, l = s, i = se({ ...o.data }), u = se(so()), d = se(Dc()), p = X(null), y = X(!1);
    te(
      () => o.data,
      // Watch for changes in the data
      (N) => {
        Object.assign(i, N);
      },
      { deep: !0 }
    ), te(
      i,
      async (N) => {
        await _(u), Object.assign(u, N), l("update:data", N);
      },
      { deep: !0 }
    ), Se(async () => {
      switch (i.flowType) {
        case Z.POS:
          await g();
          break;
      }
      y.value = !0, l("componentReady");
    });
    const {
      v$: f,
      dataChanged: _,
      productIsAvailable: b,
      loadProducts: g,
      scrollToFirstErrorWrapper: h,
      validateForm: v
    } = tm(i, d);
    return t({
      componentReady: y,
      validateForm: v,
      scrollToFirstErrorWrapper: h,
      loadProducts: g
    }), (N, $) => {
      const S = U("v-col"), I = U("v-radio"), C = U("v-radio-group"), T = U("v-autocomplete"), A = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: p,
        class: "financing-options-component"
      }, [
        c("h2", rm, P(r(n)("Components.FinancingOptionsComponent.Title")), 1),
        m(A, null, {
          default: E(() => [
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var M;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(a) + "-creditAmount",
                      class: "form-label"
                    }, P(r(n)("Components.FinancingOptionsComponent.creditAmount")), 9, nm),
                    m(Ke, {
                      id: r(a) + "-creditAmount",
                      modelValue: i.creditAmount,
                      "onUpdate:modelValue": $[0] || ($[0] = (L) => i.creditAmount = L),
                      error: r(f).creditAmount.$error,
                      "error-messages": ((M = r(f).creditAmount.$errors[0]) == null ? void 0 : M.$message) ?? "",
                      onFocus: $[1] || ($[1] = (L) => r(f).creditAmount.$reset()),
                      "number-of-decimals": 2,
                      "append-text": "EUR",
                      autocomplete: "off",
                      disabled: d.isDataLoading
                    }, null, 8, ["id", "modelValue", "error", "error-messages", "disabled"])
                  ])
                ];
              }),
              _: 1
            }),
            m(S, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var M, L;
                return [
                  c("div", om, [
                    c("label", {
                      id: r(a) + "-product-label",
                      class: "form-label"
                    }, P(r(n)("Components.FinancingOptionsComponent.selectedProductType")), 9, sm),
                    m(C, {
                      modelValue: i.selectedProductType,
                      "onUpdate:modelValue": $[2] || ($[2] = (z) => i.selectedProductType = z),
                      "aria-labelledby": r(a) + "-product-label",
                      error: r(f).selectedProductType.$error,
                      "error-messages": ((M = r(f).selectedProductType.$errors[0]) == null ? void 0 : M.$message) ?? "",
                      onFocus: $[3] || ($[3] = (z) => r(f).selectedProductType.$reset()),
                      disabled: d.isDataLoading
                    }, {
                      default: E(() => [
                        r(b)("OBR") ? (w(), ce(I, {
                          key: 0,
                          class: "product-type__obrestni",
                          value: "OBR",
                          label: r(n)("Components.FinancingOptionsComponent.OBR")
                        }, null, 8, ["label"])) : B("", !0),
                        r(b)("BREZOBR") ? (w(), ce(I, {
                          key: 1,
                          class: "product-type__brez-obresti",
                          value: "BREZOBR",
                          label: r(n)("Components.FinancingOptionsComponent.BREZOBR")
                        }, null, 8, ["label"])) : B("", !0),
                        r(b)("EOM0") ? (w(), ce(I, {
                          key: 2,
                          class: "product-type__eom0",
                          value: "EOM0",
                          label: r(n)("Components.FinancingOptionsComponent.EOM0")
                        }, null, 8, ["label"])) : B("", !0),
                        r(b)("MOR") ? (w(), ce(I, {
                          key: 3,
                          class: "product-type__moratorij",
                          value: "MOR",
                          label: r(n)("Product.MOR")
                        }, null, 8, ["label"])) : B("", !0),
                        i.specialProductList.length > 0 ? (w(), ce(I, {
                          key: 4,
                          class: "product-type__posebne-akcije",
                          value: "SPECIAL",
                          label: r(n)("Components.FinancingOptionsComponent.SPECIAL")
                        }, null, 8, ["label"])) : B("", !0)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages", "disabled"])
                  ]),
                  i.selectedProductType === "SPECIAL" ? (w(), F("div", im, [
                    c("label", {
                      for: r(a) + "-selectedSpecialProduct",
                      class: "form-label"
                    }, P(r(n)("Components.FinancingOptionsComponent.selectedSpecialProduct")), 9, lm),
                    m(T, {
                      id: r(a) + "-selectedSpecialProduct",
                      modelValue: i.selectedSpecialProduct,
                      "onUpdate:modelValue": $[4] || ($[4] = (z) => i.selectedSpecialProduct = z),
                      items: i.specialProductList,
                      "item-title": "productName",
                      "item-value": "productId",
                      "return-object": "",
                      variant: "outlined",
                      error: r(f).selectedSpecialProduct.$error,
                      "error-messages": ((L = r(f).selectedSpecialProduct.$errors[0]) == null ? void 0 : L.$message) ?? "",
                      onFocus: $[5] || ($[5] = (z) => r(f).selectedSpecialProduct.$reset()),
                      disabled: d.isDataLoading
                    }, null, 8, ["id", "modelValue", "items", "error", "error-messages", "disabled"])
                  ])) : B("", !0)
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        !d.isDataLoading && !i.productList.length && !i.specialProductList.length ? (w(), F("div", am, P(r(n)("Components.FinancingOptionsComponent.NoProducts")), 1)) : B("", !0),
        d.message ? (w(), F("div", um, P(d.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function io() {
  return {
    orderToken: "",
    partnerLink: "",
    firstname: "",
    surname: "",
    calculationId: -1,
    creditAmount: 0,
    installmentNr: 0,
    installmentVal: 0,
    installmentValNoCost: 0,
    lastMonthsIncome: 0,
    lastMonthsIncome2: 0,
    lastMonthsIncome3: 0,
    flowType: void 0,
    isPreapproved: !1,
    preapprovedCreditAmount: 0,
    preapprovedInstallmentAmount: 0,
    numberOfPreapprovedSalaries: 0,
    employmentType: void 0,
    mustProvideThreeSalaries: !1,
    isSlovenianCitizen: !0,
    hasSlovenianIncome: !0,
    citizen: -1,
    selectedProduct: void 0,
    selectedSpecialProduct: void 0,
    msisdn: "",
    taxNumber: "",
    prefix: void 0,
    phoneNumber: "",
    birthdate: null,
    isDocumentationNeeded: !1,
    isViewDataLoading: !1,
    selectedProductType: void 0,
    productList: [],
    specialProductList: [],
    sisbonResultId: -1,
    debtAmount: 0,
    debtInstallments: 0,
    contractDebtInstallments: 0,
    minSalary: 0,
    minCredit: 0,
    email: "",
    isSalaryConfirmed: !1,
    calculatedMinInstallment: void 0,
    calculatedMaxInstallment: void 0,
    belowNotificationHtml: "",
    notificationHtml: "",
    notificationType: void 0,
    title: ""
  };
}
function dm() {
  return {
    externalResults: {},
    isDataLoading: !1,
    installmentVal: 0,
    installmentValNoCost: 0,
    interestNr: 0,
    EOM: 0,
    amountTotal: 0,
    insuranceVal: 0,
    approvalVal: 0,
    calculationError: "",
    showMore: !1,
    clientIncomeInsert: !1,
    printCalculation: !1,
    dateOfFirstInstallment: "",
    dateOfLastInstallment: "",
    showModal: !1,
    isUserDraggingSlider: !1,
    modalErrorMessage: null,
    overridenProductName: null,
    isOverridenProduct: !1,
    overridenMaxInstallments: null
  };
}
function cm(e) {
  const { t } = oe();
  return G(() => ({
    selectedProductType: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ve(() => e.flowType === Z.INFOCALC))
    },
    selectedSpecialProduct: {
      required: V.withMessage(t("GlobalErrors.FIELD_REQUIRED"), ve(() => e.selectedProductType === "SPECIAL"))
    },
    email: {
      emailOrPhoneRequired: V.withMessage(t("GlobalErrors.FieldRequired"), () => {
        const s = e.email != null && e.email !== "", n = e.prefix != null && e.phoneNumber != null;
        return s || n;
      }),
      emailFormat: V.withMessage(t("GlobalErrors.CorrectEmail"), () => e.email === void 0 || e.email === "" ? !0 : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.email))
    },
    prefix: {
      emailOrPhoneRequired: V.withMessage(t("GlobalErrors.FieldRequired"), () => {
        const s = e.email != null && e.email !== "", n = e.prefix != null && e.phoneNumber != null;
        return s || n;
      })
    },
    phoneNumber: {
      emailOrPhoneRequired: V.withMessage(t("GlobalErrors.FieldRequired"), () => {
        const s = e.email != null && e.email !== "", n = e.prefix != null && e.phoneNumber != null;
        return s || n;
      }),
      minLength: V.withMessage(t("GlobalErrors.CorrectPhoneNumber"), ql(8)),
      maxLength: V.withMessage(t("GlobalErrors.CorrectPhoneNumber"), Wl(12))
    }
  }));
}
function Ft(e, t) {
  return { name: e, params: t };
}
function mm(e, t, s, n) {
  const a = ue("navigationButtonsApi", null), o = ue("commClient"), l = ue("showReport"), { scrollToFirstError: i } = Oe(), u = Me(cm(e), G(() => e), { $autoDirty: !0 });
  async function d() {
    return u.value.$touch(), u.value.$validate();
  }
  let p, y = !1;
  St(() => {
    y = !0, clearTimeout(p), p = void 0;
  });
  function f() {
    e.calculatedMaxInstallment != null && e.installmentNr > e.calculatedMaxInstallment && (e.installmentNr = e.calculatedMaxInstallment);
  }
  async function _() {
    e.isViewDataLoading = !0, t.printCalculation = !0, await M(), await l(
      {
        Title: "Izpis informativnega izračuna",
        MethodName: "InformativniIzracunForPrint",
        Parameters: { IzracunId: e.calculationId },
        FileName: "InformativniIzracun_" + e.calculationId.toString()
      }
    ), e.isViewDataLoading = !1, t.printCalculation = !1;
  }
  const b = G(() => e.mustProvideThreeSalaries || e.isPreapproved && e.numberOfPreapprovedSalaries === 3 || e.lastMonthsIncome2 != null && e.lastMonthsIncome2 > 0 ? ((e.lastMonthsIncome ? e.lastMonthsIncome : 0) + (e.lastMonthsIncome2 ? e.lastMonthsIncome2 : 0) + (e.lastMonthsIncome3 ? e.lastMonthsIncome3 : 0)) / 3 : e.lastMonthsIncome ? e.lastMonthsIncome : 0);
  function g() {
    u.value.email.$reset(), u.value.prefix.$reset(), u.value.phoneNumber.$reset(), t.modalErrorMessage = null, t.showModal = !0;
  }
  function h() {
    t.showModal = !1, t.modalErrorMessage = null, e.email = "", e.prefix = void 0, e.phoneNumber = "";
  }
  async function v() {
    var j;
    u.value.email.$touch(), u.value.prefix.$touch(), u.value.phoneNumber.$touch(), !(u.value.email.$invalid || u.value.prefix.$invalid || u.value.phoneNumber.$invalid) && (t.modalErrorMessage = null, t.printCalculation = !0, await M(), e.email != null && e.email !== "" && await o.executeMethodAsync("SendCalculationEmail", {
      CalculationId: e.calculationId,
      Email: e.email
    }).then((Y) => {
      Y.Success ? h() : t.modalErrorMessage = Y.Error;
    }), e.phoneNumber != null && e.prefix != null && await o.executeMethodAsync("SendCalculationPhone", {
      CalculationId: e.calculationId,
      PhoneNumber: ((j = e.prefix) == null ? void 0 : j.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString()
    }).then((Y) => {
      Y.Success ? h() : t.modalErrorMessage = Y.Error;
    }));
  }
  async function N(j) {
    if (!y && (f(), e.installmentNr != j.installmentNr && e.installmentNr != null && (clearTimeout(p), p = setTimeout(async () => {
      if (p = void 0, !y)
        try {
          const Y = await M();
          !y && Y != null && Y.name != null && n("navigationEvent", Y);
        } catch {
          if (y) return;
          t.calculationError = "ServiceError", a == null || a.setButtonDisabled("Next", !0);
        }
    }, 500)), e.selectedProductType != j.selectedProductType || e.selectedSpecialProduct != j.selectedSpecialProduct)) {
      for (let Y = 0; Y < e.productList.length; Y++)
        e.productList[Y].productId == e.selectedProductType && (e.selectedProduct = e.productList[Y]);
      e.selectedProductType === "SPECIAL" ? e.selectedSpecialProduct != null && (e.calculatedMinInstallment = e.selectedSpecialProduct.installmentMin, e.calculatedMaxInstallment = e.selectedSpecialProduct.installmentMax) : (e.calculatedMinInstallment = e.selectedProduct.installmentMin, e.calculatedMaxInstallment = e.selectedProduct.installmentMax), e.installmentNr > e.calculatedMaxInstallment ? e.installmentNr = e.calculatedMaxInstallment : await M().then((Y) => {
        Y != null && Y.name != null && n("navigationEvent", Y);
      });
    }
  }
  const $ = G(() => e.isPreapproved && (e.creditAmount == null || e.creditAmount <= e.preapprovedCreditAmount) && (e.calculatedMinInstallment == null || e.calculatedMinInstallment <= e.preapprovedInstallmentAmount)), S = G(() => e.isPreapproved && (e.creditAmount == null || e.creditAmount <= e.preapprovedCreditAmount)), I = G(() => e.calculatedMinInstallment == null || e.calculatedMaxInstallment == null ? {} : {
    [e.calculatedMinInstallment]: `${e.calculatedMinInstallment} obrokov`,
    [e.calculatedMinInstallment + Math.round((e.calculatedMaxInstallment - e.calculatedMinInstallment) / 2)]: `${e.calculatedMinInstallment + Math.round((e.calculatedMaxInstallment - e.calculatedMinInstallment) / 2)} obrokov`,
    [e.calculatedMaxInstallment]: `${e.calculatedMaxInstallment} obrokov`
  });
  async function C() {
    var j, Y;
    switch ($.value || (e.isPreapproved = !1), f(), e.isViewDataLoading = !0, e.flowType) {
      case Z.POS_STRANKA:
      case Z.POS:
        if (e.installmentNr != null && e.installmentNr > 2) {
          const re = {
            SelectedProductId: (j = e.selectedProduct) == null ? void 0 : j.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(String(e.selectedSpecialProduct.productId), 10) : -1,
            SisbonResultId: e.sisbonResultId,
            TaxNumber: e.taxNumber,
            Firstname: e.firstname,
            Surname: e.surname,
            PhoneNumber: ((Y = e.prefix) == null ? void 0 : Y.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
            CreditAmount: e.creditAmount,
            InstallmentNr: e.installmentNr,
            Birthdate: we(e.birthdate),
            SlovenianCitizen: e.isSlovenianCitizen,
            SlovenianIncome: e.hasSlovenianIncome,
            ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
            EmploymentType: e.employmentType,
            IsFinalCalculation: !0,
            // will be saved to the database
            Salary1: e.lastMonthsIncome,
            Salary2: e.lastMonthsIncome2 !== void 0 && e.lastMonthsIncome2 !== null ? e.lastMonthsIncome2 : 0,
            Salary3: e.lastMonthsIncome3 !== void 0 && e.lastMonthsIncome3 !== null ? e.lastMonthsIncome3 : 0,
            minCredit: e.minCredit,
            SisbonDebt: e.debtInstallments,
            ContractDebt: e.contractDebtInstallments,
            ...e.flowType === Z.POS_STRANKA ? {
              PosOrderToken: e.orderToken
            } : {}
          };
          let fe = "ContractCalculationCreateCheckExposure";
          e.flowType === Z.POS_STRANKA && (fe = "ContractCalculationCreateCheckExposurePosFinish");
          const Le = await o.executeMethodAsync(fe, re);
          if (e.isViewDataLoading = !1, Le.success === !0)
            return Pe(e, Le), Pe(t, Le), { name: "nextStep" };
          switch (Le.error) {
            case "NoSuitableProduct":
            case "CreditDenied":
            case "InstallmentTooHigh":
            case "CreditErrorMaxAmount":
            case "CreditErrorMinAmount":
            case "InstallmentErrorMinAmount":
            case "InstallmentNrErrorMax":
            case "InstallmentNrErrorMin":
            case "CalculationFailed":
              return t.calculationError = Le.error, null;
            default:
              return e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + Le.error, { name: "end" };
          }
        }
        break;
    }
    return null;
  }
  async function T() {
    if ($.value || (e.isPreapproved = !1), f(), e.isViewDataLoading = !0, e.installmentNr > 2) {
      const j = await o.executeMethodAsync("ContractCalculationCreate", {
        OrderToken: e.orderToken,
        OrderType: e.flowType,
        Installments: e.installmentNr,
        Firstname: "",
        Surname: "",
        TaxNumber: e.taxNumber,
        Msisdn: e.msisdn,
        Birthdate: we(e.birthdate),
        Salary1: e.lastMonthsIncome,
        Salary2: e.lastMonthsIncome2 !== void 0 ? e.lastMonthsIncome2 : 0,
        Salary3: e.lastMonthsIncome3 !== void 0 ? e.lastMonthsIncome3 : 0,
        minCredit: e.minCredit,
        ContractDebt: e.contractDebtInstallments,
        SisbonDebt: e.debtInstallments,
        SlovenianCitizen: e.isSlovenianCitizen === void 0 ? e.citizen === 204 : e.isSlovenianCitizen,
        HasSlovenianIncome: e.hasSlovenianIncome,
        EmploymentType: e.employmentType
      });
      if (e.isViewDataLoading = !1, j)
        if (j.success === !0) {
          if (Pe(e, j), Pe(t, j), await d())
            return Ft("nextStep");
        } else
          switch (j.calculationError) {
            case "ProcessError":
            case "TaxNrMsisdnMismatch":
            case "MaxRemainingCredit":
            case "SpNeustrezen":
            case "InstallmentTooHigh":
            case "SalaryRequirementsFail1":
            case "SalaryRequirementsFail2":
              return e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + j.calculationError, Ft("end");
            case "NoSuitableProduct":
            case "CreditErrorMaxAmount":
            case "CreditErrorMinAmount":
            case "InstallmentErrorMinAmount":
            case "InstallmentNrErrorMax":
            case "InstallmentNrErrorMin":
            case "CalculationFailed":
              return t.calculationError = j.calculationError, Ft("end");
            default:
              return e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + j.calculationError, Ft("end");
          }
      else
        return Ft("end");
    }
    return null;
  }
  function A(j) {
    j && (j.success && Pe(e, j), Pe(t, j));
  }
  async function M() {
    var j, Y, re;
    if (f(), t.calculationError = "", e.installmentNr >= 3) {
      let fe;
      switch (e.flowType) {
        case Z.PORTAL_INFOCALC:
          if (fe = await o.executeMethodAsync("CalculationCreate", {
            CreditAmount: e.creditAmount,
            InstallmentNr: e.installmentNr,
            PrintCalculation: t.printCalculation
          }), A(fe), !fe.success)
            switch (fe.CalculationError) {
              case "NoSuitableProduct":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = fe.CalculationError;
            }
          break;
        case Z.WEB_INFOCALC:
          if (fe = await o.executeMethodAsync("InformativeCalculationCreate", {
            PartnerUrlParam: e.partnerLink,
            Amount: e.creditAmount,
            Installments: e.installmentNr,
            PrintCalculation: t.printCalculation
          }), A(fe), !fe.success)
            switch (fe.CalculationError) {
              case "NoSuitableProduct":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = fe.CalculationError;
            }
          break;
        case Z.INFOCALC:
          if (fe = await o.executeMethodAsync("CalculationCreateNewPos", {
            SelectedProductId: (j = e.selectedProduct) == null ? void 0 : j.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(String(e.selectedSpecialProduct.productId), 10) : -1,
            CreditAmount: e.creditAmount,
            InstallmentNr: e.installmentNr,
            PrintCalculation: t.printCalculation
          }), A(fe), !fe.success)
            switch (fe.CalculationError) {
              case "NoSuitableProduct":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = fe.CalculationError;
            }
          break;
        case Z.WEB:
        case Z.SKLENI_SAM:
          if (fe = await o.executeMethodAsync("GenericCalculationCreateNewWeb", {
            OrderToken: e.orderToken,
            OrderType: e.flowType,
            TaxNumber: e.taxNumber,
            InstallmentNr: e.installmentNr,
            SlovenianCitizen: e.isSlovenianCitizen,
            EmploymentType: e.employmentType,
            Birthdate: we(e.birthdate),
            Salary: b.value,
            minCredit: e.minCredit,
            ContractDebt: e.contractDebtInstallments
          }), A(fe), fe.success)
            a !== null && (a == null || a.setButtonDisabled("Next", !1));
          else
            switch (a !== null && (a == null || a.setButtonDisabled("Next", !0)), fe.calculationError) {
              case "MaxRemainingCredit":
              case "ProcessError":
                return e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + fe.calculationError, { name: "end" };
              case "CreditDenied":
              case "NoSuitableProduct":
              case "InstallmentTooHigh":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = fe.calculationError;
            }
          break;
        case Z.POS:
        case Z.POS_STRANKA:
          const Le = {
            PosOrderToken: e.orderToken,
            SelectedProductId: (Y = e.selectedProduct) == null ? void 0 : Y.productId,
            SpecialProductId: e.selectedProductType === "SPECIAL" && e.selectedSpecialProduct !== void 0 ? parseInt(String(e.selectedSpecialProduct.productId), 10) : -1,
            TaxNumber: e.taxNumber,
            PhoneNumber: ((re = e.prefix) == null ? void 0 : re.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
            CreditAmount: e.creditAmount,
            InstallmentNr: e.installmentNr,
            Birthdate: we(e.birthdate),
            SlovenianCitizen: e.isSlovenianCitizen,
            ZaposlitevSlo: e.hasSlovenianIncome === void 0 ? !0 : e.hasSlovenianIncome,
            EmploymentType: e.employmentType,
            SisbonDebt: e.debtInstallments,
            ContractDebt: e.contractDebtInstallments,
            Salary: b.value,
            minCredit: e.minCredit,
            IsFinalCalculation: !1,
            ...e.flowType === Z.POS_STRANKA ? {
              PosOrderToken: e.orderToken
            } : {}
          };
          let Q = "ContractCalculationCreateNewPos";
          if (e.flowType === Z.POS_STRANKA && (Q = "ContractCalculationCreateNewPosFinish"), fe = await o.executeMethodAsync(Q, Le), A(fe), fe.success)
            a !== null && (a == null || a.setButtonDisabled("Next", !1));
          else
            switch (a !== null && (a == null || a.setButtonDisabled("Next", !0)), fe.calculationError) {
              case "MaxRemainingCredit":
                return e.title = "OrderEnd.TitleFail", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + fe.calculationError, { name: "end" };
              case "CreditDenied":
              case "NoSuitableProduct":
              case "InstallmentTooHigh":
              case "CreditErrorMaxAmount":
              case "CreditErrorMinAmount":
              case "InstallmentErrorMinAmount":
              case "InstallmentNrErrorMax":
              case "InstallmentNrErrorMin":
              case "CalculationFailed":
                t.calculationError = fe.calculationError;
                break;
            }
          break;
      }
    }
    return null;
  }
  async function L() {
    e.isViewDataLoading = !0, await o.executeMethodAsync("sf.ProductList", {
      Employment: "1"
      // zaposleni
    }).then(async (j) => {
      var Y;
      if (j) {
        e.productList = j.productList, e.specialProductList = j.specialProducts, e.selectedProduct = e.productList[0];
        const re = (Y = e.selectedProduct) == null ? void 0 : Y.productId;
        e.selectedProductType = re === "OBR" || re === "BREZOBR" || re === "EOM0" || re === "SPECIAL" ? re : void 0, e.selectedSpecialProduct = void 0;
      }
      e.isViewDataLoading = !1;
    });
  }
  function z(j) {
    if (e.productList != null) {
      for (let Y = 0; Y < e.productList.length; Y++)
        if (e.productList[Y].productId == j)
          return !0;
    }
    return !1;
  }
  async function O() {
    if (e.flowType === Z.PORTAL_INFOCALC) {
      const j = await o.executeMethodAsync("PortalActionData", {}), Y = q(j);
      return Y != "" ? { name: Y } : null;
    } else if (e.flowType === Z.WEB_INFOCALC) {
      const j = await o.executeMethodAsync("WebActionData", {
        PartnerUrlParam: e.partnerLink
      }), Y = q(j);
      return Y != "" ? { name: Y } : null;
    } else {
      const j = await o.executeMethodAsync("ActionData", {
        OrderToken: e.orderToken,
        OrderType: e.flowType,
        TaxNumber: e.taxNumber,
        IsSlovenianCitizen: e.isSlovenianCitizen,
        IsSP: e.employmentType === Ne.SP
      }), Y = q(j);
      return Y != "" ? { name: Y } : null;
    }
  }
  function H() {
    e.creditAmount !== void 0 && e.creditAmount > 0 && (e.creditAmount < 1e3 ? e.installmentNr = 6 : e.creditAmount < 2e3 ? e.installmentNr = 12 : e.creditAmount < 5e3 || e.creditAmount < 1e4 ? e.installmentNr = 24 : e.installmentNr = 36);
  }
  function q(j) {
    return j.Success ? (e.selectedProduct = {
      productId: "",
      productName: "",
      installmentMin: j.MinInstallment,
      installmentMax: j.MaxInstallment,
      amountMin: j.MinAmount,
      amountMax: j.MaxAmount,
      ageMin: 0,
      ageMax: 0
    }, e.calculatedMinInstallment = j.MinInstallment, e.calculatedMaxInstallment = j.MaxInstallment, j.CreditAmount != null && (e.creditAmount = j.CreditAmount), j.Installments != null ? e.installmentNr = j.Installments : H(), "") : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors." + j.Error, "end");
  }
  const me = [
    Z.INFOCALC,
    Z.WEB_INFOCALC,
    Z.PORTAL_INFOCALC
  ];
  function x() {
    a !== null && (me.includes(e.flowType) ? a == null || a.setButtonVisible("Print", !0) : a == null || a.setButtonVisible("Print", !1)), (S.value || e.flowType === Z.INFOCALC || e.flowType === Z.WEB_INFOCALC || e.flowType === Z.PORTAL_INFOCALC) && (e.isSalaryConfirmed = !0), a !== null && !e.isPreapproved && (a == null || a.setButtonDisabled("Next", !0));
  }
  function ie() {
    i(s.value);
  }
  function ne() {
    const j = document.querySelector("#calculation-error");
    j && j.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  async function J(j) {
    let Y = !1, re = null;
    switch (j) {
      case "calculationAndExposure":
      case "webNext":
        if (Y = await d(), !Y) return null;
        j === "calculationAndExposure" ? re = await C() : re = await T(), re === null && (t.calculationError !== "" ? ne() : ie());
        break;
      case "printCalculation":
        await _();
        break;
      case "sendCalculation":
        g();
        break;
      case "toLimit":
        re = { name: "toLimit" };
        break;
    }
    return re;
  }
  return {
    getPreapprovedValidity: $,
    getPreapprovedAmountValidity: S,
    getSliderTicks: I,
    validateForm: d,
    dataChanged: N,
    navigationAction: J,
    productIsAvailable: z,
    ProductList: L,
    CreateInformativeCalculation: M,
    WebActionData: O,
    scrollToFirstErrorWrapper: ie,
    SetupInstallmentBasedOnAmount: H,
    initData: x,
    v$: u,
    SendEmailOrPhone: v,
    CloseModalDialog: h,
    CreateCalculationAndCheckExposure: C,
    CreateWebCalculation: T
  };
}
const fm = ["aria-busy"], pm = { class: "section-heading mt-0" }, vm = { class: "form-label" }, gm = { class: "form-label" }, ym = {
  key: 0,
  class: "notification notification--alert mt-8"
}, bm = { key: 1 }, Cm = { class: "control-product-type" }, Im = { class: "form-label" }, _m = {
  key: 0,
  class: "form-label"
}, hm = { class: "installment-plan-calculation installment-plan-calculation--bg ml-md-6" }, Tm = { class: "installment-plan-calculation__grid" }, Em = { class: "installment-plan-calculation__installment" }, Nm = { key: 0 }, Sm = { key: 1 }, Pm = { class: "installment-plan-calculation__disclaimer" }, $m = {
  key: 0,
  class: "alert alert--error mb-5 mt-5 alert-predodobreno"
}, Mm = {
  key: 0,
  class: "notification notification--warning mb-4"
}, Am = { class: "mb-4" }, wm = { class: "form-label" }, km = { class: "control-email-wrapper" }, Om = { class: "form-label" }, Rm = { class: "control-phone-wrapper" }, Lm = {
  key: 0,
  id: "calculation-error",
  class: "notification notification--warning mt-4"
}, Iy = /* @__PURE__ */ ge({
  __name: "installment-plan-selection-component",
  props: {
    data: { default: io }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = ue("generalStore"), i = se({ ...n.data }), u = se(dm());
    let d = { ...io() };
    const p = X(null), y = X(!1);
    te(() => n.data, (z) => {
      Object.assign(i, z);
    }, { deep: !0 }), te(
      i,
      async (z) => {
        await _(d), Object.assign(d, z), a("update:data", z);
      },
      { deep: !0 }
    );
    function f(z, O) {
      const H = z.target;
      if (!(H instanceof HTMLInputElement)) return;
      const q = H.value.replace(/[^0-9]/g, "");
      H.value = q, i[O] = q;
    }
    Se(() => {
      y.value = !0, a("componentReady");
    });
    const {
      dataChanged: _,
      v$: b,
      getPreapprovedValidity: g,
      getPreapprovedAmountValidity: h,
      getSliderTicks: v,
      navigationAction: N,
      CreateInformativeCalculation: $,
      SendEmailOrPhone: S,
      CloseModalDialog: I,
      productIsAvailable: C,
      scrollToFirstErrorWrapper: T,
      CreateCalculationAndCheckExposure: A,
      CreateWebCalculation: M,
      validateForm: L
    } = mm(i, u, p, a);
    return t({
      componentReady: y,
      navigationAction: N,
      validateForm: L,
      CreateCalculationAndCheckExposure: A,
      CreateWebCalculation: M,
      scrollToFirstErrorWrapper: T
    }), (z, O) => {
      const H = U("v-slider"), q = U("v-radio"), me = U("v-radio-group"), x = U("v-autocomplete"), ie = U("v-col"), ne = U("v-row"), J = U("v-text-field");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: p,
        class: ke(["installment-plan-selection-component", { "opacity-50": !i.isSalaryConfirmed }]),
        "aria-busy": u.isDataLoading || i.isSalaryConfirmed
      }, [
        m(ne, {
          class: ke(i.isSalaryConfirmed ? "" : "disabled")
        }, {
          default: E(() => [
            m(ie, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                c("div", null, [
                  c("h2", pm, P(i.flowType == r(Z).INFOCALC || i.flowType == r(Z).WEB_INFOCALC || i.flowType == r(Z).PORTAL_INFOCALC ? r(o)("Components.InstallmentPlanComponent.InfoCalculTitle") : r(o)("Components.InstallmentPlanComponent.Title")), 1),
                  c("div", null, [
                    c("label", vm, P(r(o)("Components.InstallmentPlanComponent.PurchaseAmount")), 1),
                    m(Ke, {
                      ref: "creditAmountRef",
                      modelValue: i.creditAmount,
                      "onUpdate:modelValue": O[0] || (O[0] = (j) => i.creditAmount = j),
                      numberOfDecimals: 2,
                      onChange: O[1] || (O[1] = (j) => r($)()),
                      disabled: i.flowType != r(Z).INFOCALC && i.flowType != r(Z).WEB_INFOCALC && i.flowType != r(Z).PORTAL_INFOCALC,
                      appendText: "EUR",
                      formatNumber: (j, Y) => j.toLocaleString("sl-SI", { minimumFractionDigits: Y, maximumFractionDigits: Y }),
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "disabled", "formatNumber"])
                  ]),
                  c("div", null, [
                    c("label", gm, P(r(o)("Components.InstallmentPlanComponent.InstallmentNumber")), 1),
                    m(Ke, {
                      ref: "installmentNrRef",
                      modelValue: i.installmentNr,
                      "onUpdate:modelValue": O[2] || (O[2] = (j) => i.installmentNr = j),
                      minValue: i.calculatedMinInstallment,
                      maxValue: i.calculatedMaxInstallment,
                      disabled: !i.isSalaryConfirmed,
                      appendText: "obrokov",
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "minValue", "maxValue", "disabled"]),
                    m(H, {
                      modelValue: i.installmentNr,
                      "onUpdate:modelValue": O[3] || (O[3] = (j) => i.installmentNr = j),
                      step: "1",
                      min: i.calculatedMinInstallment,
                      max: i.calculatedMaxInstallment,
                      disabled: !i.isSalaryConfirmed,
                      ticks: r(v),
                      "show-ticks": "always",
                      "tick-size": "4"
                    }, {
                      "thumb-label": E(({ modelValue: j }) => [
                        Ie(P(r(o)("Components.InstallmentPlanComponent.InstallmentNumberPlural", {
                          count: j
                        })), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min", "max", "disabled", "ticks"])
                  ]),
                  u.isOverridenProduct ? (w(), F("div", ym, P(u.overridenProductName) + " financiranje je na voljo do " + P(u.overridenMaxInstallments) + " obrokov. Pri daljši odplačilni dobi je na voljo obrestno financiranje. ", 1)) : B("", !0),
                  i.flowType === r(Z).INFOCALC ? (w(), F("div", bm, [
                    O[10] || (O[10] = c("h2", { class: "section-heading" }, " Izbira produkta ", -1)),
                    c("div", Cm, [
                      c("label", Im, P(r(o)("Components.IdentificationDataComponent.ChooseProductType")), 1),
                      m(me, {
                        modelValue: i.selectedProductType,
                        "onUpdate:modelValue": O[4] || (O[4] = (j) => i.selectedProductType = j),
                        error: r(b).selectedProductType.error,
                        "error-messages": r(b).selectedProductType.$errors[0] != null ? r(b).selectedProductType.$errors[0].$message : "",
                        onFocus: r(b).selectedProductType.$reset
                      }, {
                        default: E(() => [
                          r(C)("OBR") ? (w(), ce(q, {
                            key: 0,
                            class: "product-type__obrestni",
                            value: "OBR",
                            label: r(o)("Product.OBR")
                          }, null, 8, ["label"])) : B("", !0),
                          r(C)("BREZOBR") ? (w(), ce(q, {
                            key: 1,
                            class: "product-type__brez-obresti",
                            value: "BREZOBR",
                            label: r(o)("Product.BREZOBR")
                          }, null, 8, ["label"])) : B("", !0),
                          r(C)("EOM0") ? (w(), ce(q, {
                            key: 2,
                            class: "product-type__eom0",
                            value: "EOM0",
                            label: r(o)("Product.EOM0")
                          }, null, 8, ["label"])) : B("", !0),
                          r(C)("MOR") ? (w(), ce(q, {
                            key: 3,
                            class: "product-type__moratorij",
                            value: "MOR",
                            label: r(o)("Product.MOR")
                          }, null, 8, ["label"])) : B("", !0),
                          i.specialProductList != null && i.specialProductList.length > 0 ? (w(), ce(q, {
                            key: 4,
                            class: "product-type__posebne-akcije",
                            value: "SPECIAL",
                            label: r(o)("Product.SPECIAL")
                          }, null, 8, ["label"])) : B("", !0)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                    ]),
                    i.selectedProductType === "SPECIAL" ? (w(), F("label", _m, " Posebne akcije ")) : B("", !0),
                    i.selectedProductType === "SPECIAL" ? (w(), ce(x, {
                      key: 1,
                      modelValue: i.selectedSpecialProduct,
                      "onUpdate:modelValue": O[5] || (O[5] = (j) => i.selectedSpecialProduct = j),
                      items: i.specialProductList,
                      error: r(b).selectedSpecialProduct.error,
                      "error-messages": r(b).selectedSpecialProduct.$errors[0] != null ? r(b).selectedSpecialProduct.$errors[0].$message : "",
                      onFocus: r(b).selectedSpecialProduct.$reset,
                      "return-object": !0,
                      "item-title": "productName",
                      "item-value": "productId",
                      variant: "outlined"
                    }, null, 8, ["modelValue", "items", "error", "error-messages", "onFocus"])) : B("", !0)
                  ])) : B("", !0)
                ])
              ]),
              _: 1
            }),
            m(ie, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                c("div", hm, [
                  c("div", Tm, [
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.MonthlyInstallment")) + ":", 1),
                    c("div", Em, [
                      Ie(P(z.$n(u.installmentVal == null || u.installmentVal.toString() == "" ? 0 : u.installmentVal, "decimal")) + " ", 1),
                      O[11] || (O[11] = c("div", null, [
                        c("div", { class: "installment-plan-calculation__installment_currency" }, " EUR "),
                        c("div", { class: "installment-plan-calculation__installment_period" }, "/mesec")
                      ], -1))
                    ]),
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.PurchaseAmount2")) + ":", 1),
                    c("div", null, P(z.$n(i.creditAmount == null || i.creditAmount.toString() == "" ? 0 : i.creditAmount, "decimal")) + " EUR ", 1),
                    i.installmentNr != null ? (w(), F("div", Nm, P(r(o)("Components.InstallmentPlanComponent.InstallmentNumber")) + ":", 1)) : B("", !0),
                    i.installmentNr != null ? (w(), F("div", Sm, P(r(o)(
                      "Components.InstallmentPlanComponent.InstallmentNumberPlural",
                      i.installmentNr
                    )), 1)) : B("", !0),
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.DateOfFirstInstallment")) + ": ", 1),
                    c("div", null, P(u.dateOfFirstInstallment != "" ? r(Zn)(u.dateOfFirstInstallment) : "-"), 1),
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.DateOfLastInstallment")) + ": ", 1),
                    c("div", null, P(u.dateOfLastInstallment != "" ? r(Zn)(u.dateOfLastInstallment) : "-"), 1),
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.InterestRate")) + ":", 1),
                    c("div", null, P(u.interestNr != null ? z.$n(u.interestNr, "decimal") + " %" : "-"), 1),
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.EOM")) + ":", 1),
                    c("div", null, P(u.EOM != null ? z.$n(u.EOM, "decimal") + " %" : "-"), 1),
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.InsuranceCost")) + ":", 1),
                    c("div", null, P(u.insuranceVal != null ? z.$n(
                      u.insuranceVal,
                      "decimal"
                    ) + " EUR" : "-"), 1),
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.ApprovalCost")) + ":", 1),
                    c("div", null, P(u.approvalVal != null ? z.$n(u.approvalVal, "decimal") + " EUR" : "-"), 1),
                    c("div", null, P(r(o)("Components.InstallmentPlanComponent.CompleteCost")) + ":", 1),
                    c("div", null, P(u.amountTotal != null ? z.$n(u.amountTotal, "decimal") + " EUR" : "0,00 EUR"), 1)
                  ]),
                  c("div", Pm, [
                    Ie(P(r(o)("Components.InstallmentPlanComponent.AllCosts")) + " ", 1),
                    O[12] || (O[12] = c("br", null, null, -1)),
                    O[13] || (O[13] = c("br", null, null, -1)),
                    Ie(" " + P(r(o)("Components.InstallmentPlanComponent.EOMDisclaimer")), 1)
                  ]),
                  i.isPreapproved && !r(g) && r(h) ? (w(), F("div", $m, P(r(o)("Components.InstallmentPlanComponent.PreapprovedError")), 1)) : B("", !0)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        m(Pt, {
          display: u.showModal,
          showCloseXButton: !0,
          title: "Pošlji izračun",
          showAcceptButton: !0,
          acceptText: "Pošlji",
          closeText: "Prekliči",
          showDeclineButton: !0,
          onAccept: r(S),
          onModalClosed: r(I)
        }, {
          default: E(() => [
            u.modalErrorMessage ? (w(), F("div", Mm, P(u.modalErrorMessage), 1)) : B("", !0),
            O[14] || (O[14] = c("div", { class: "mb-6" }, "Vnesite e-mail naslov ali mobilno številko na katero želite poslati izračun.", -1)),
            m(ne, { class: "w-100" }, {
              default: E(() => [
                m(ie, { class: "v-col-8" }, {
                  default: E(() => [
                    c("div", Am, [
                      c("label", wm, P(r(o)("Components.IdentificationDataComponent.Email")), 1),
                      c("div", km, [
                        m(J, {
                          modelValue: i.email,
                          "onUpdate:modelValue": O[6] || (O[6] = (j) => i.email = j),
                          variant: "outlined",
                          "persistent-hint": "",
                          "error-messages": r(b).email.$errors[0] != null ? r(b).email.$errors[0].$message : "",
                          onFocus: r(b).email.$reset,
                          autocomplete: "off"
                        }, null, 8, ["modelValue", "error-messages", "onFocus"])
                      ])
                    ]),
                    c("div", null, [
                      c("label", Om, P(r(o)("Components.IdentificationDataComponent.PhoneNumber")), 1),
                      c("div", Rm, [
                        m(x, {
                          modelValue: i.prefix,
                          "onUpdate:modelValue": O[7] || (O[7] = (j) => i.prefix = j),
                          items: r(l).state.countryPhoneList,
                          variant: "outlined",
                          class: "control-phone-country",
                          "return-object": !0,
                          "item-title": "Value",
                          "item-value": "Key",
                          "persistent-hint": "",
                          "error-messages": r(b).prefix.$errors[0] != null ? r(b).prefix.$errors[0].$message : "",
                          onFocus: r(b).prefix.$reset
                        }, null, 8, ["modelValue", "items", "error-messages", "onFocus"]),
                        m(J, {
                          modelValue: i.phoneNumber,
                          "onUpdate:modelValue": O[8] || (O[8] = (j) => i.phoneNumber = j),
                          identifier: "",
                          "max-length": 12,
                          variant: "outlined",
                          class: "control-phone-number",
                          "error-messages": r(b).phoneNumber.$errors[0] != null ? r(b).phoneNumber.$errors[0].$message : "",
                          onFocus: r(b).phoneNumber.$reset,
                          inputmode: "numeric",
                          onInput: O[9] || (O[9] = (j) => f(j, "phoneNumber")),
                          autocomplete: "off"
                        }, null, 8, ["modelValue", "error-messages", "onFocus"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["display", "onAccept", "onModalClosed"]),
        u.calculationError != "" ? (w(), F("div", Lm, P(r(o)(`GlobalErrors.${u.calculationError}`)), 1)) : B("", !0)
      ], 10, fm);
    };
  }
}), xm = { class: "d-flex justify-space-between align-end my-8 my-md-14" }, Fm = { key: 0 }, Vm = { key: 1 }, zm = ["src"], _y = /* @__PURE__ */ ge({
  __name: "navigation-buttons-component",
  props: {
    buttons: {},
    icons: {},
    onAction: {},
    onNavigation: {}
  },
  setup(e) {
    const { t } = oe(), s = e, n = (a, o) => {
      a != null ? s.onAction ? s.onAction(a) : console.warn("No onAction handler provided for NavigationButtons") : o != null ? s.onNavigation ? s.onNavigation(o) : console.warn("No onNavigation handler provided for NavigationButtons") : console.warn("No action or navigation provided for NavigationButtons");
    };
    return (a, o) => {
      const l = U("v-btn");
      return w(), F("div", xm, [
        a.buttons ? (w(), F("div", Fm, [
          (w(!0), F(Ae, null, tt(s.buttons, (i) => De((w(), ce(l, {
            key: i.name,
            disabled: i.disabled === !0,
            onClick: (u) => n(i.action, i.navigateTo),
            class: ke(["btn", "btn--" + (i.class != null ? i.class : "primary-fill"), "mr-4"])
          }, {
            default: E(() => [
              Ie(P(r(t)("GeneralButtons." + i.name)), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick", "class"])), [
            [et, i.visible]
          ])), 128))
        ])) : B("", !0),
        a.icons ? (w(), F("div", Vm, [
          (w(!0), F(Ae, null, tt(s.icons, (i) => De((w(), ce(l, {
            key: i.name,
            disabled: i.disabled === !0,
            onClick: (u) => n(i.action, i.navigateTo),
            class: ke(i.class)
          }, {
            default: E(() => [
              c("img", {
                src: i.image
              }, null, 8, zm)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick", "class"])), [
            [et, i.visible]
          ])), 128))
        ])) : B("", !0)
      ]);
    };
  }
}), jm = "data:image/svg+xml;base64,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";
function Um() {
  return {
    isViewDataLoading: !1
  };
}
const Gm = {
  key: 0,
  class: "view-loader-component"
}, hy = /* @__PURE__ */ ge({
  __name: "loader-component",
  props: {
    data: { default: Um }
  },
  emits: ["update:data"],
  setup(e, { emit: t }) {
    const { t: s } = oe(), n = e, a = t, o = se({ ...n.data });
    return te(
      () => n.data,
      // Watch for changes in the data
      (l) => {
        Object.assign(o, l);
      },
      { deep: !0 }
    ), te(
      o,
      async (l) => {
        a("update:data", l);
      },
      { deep: !0 }
    ), (l, i) => o.isViewDataLoading ? (w(), F("div", Gm, i[0] || (i[0] = [
      c("div", { class: "loader-overlay" }, [
        c("div", { class: "loader-large" }, [
          c("img", {
            src: jm,
            alt: "Loader"
          }),
          c("div", null, "Nalagam")
        ])
      ], -1)
    ]))) : B("", !0);
  }
}), lo = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.875%207.875V19.125H19.125'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M5.25%2016.125V5.25H21.75V16.125H5.25Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3ccircle%20cx='13.5'%20cy='10.5'%20r='2'%20stroke='%23404245'%20stroke-width='2'/%3e%3c/svg%3e", Bm = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%2022C9.55228%2022%2010%2021.5523%2010%2021C10%2020.4477%209.55228%2020%209%2020C8.44772%2020%208%2020.4477%208%2021C8%2021.5523%208.44772%2022%209%2022Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M20%2022C20.5523%2022%2021%2021.5523%2021%2021C21%2020.4477%2020.5523%2020%2020%2020C19.4477%2020%2019%2020.4477%2019%2021C19%2021.5523%2019.4477%2022%2020%2022Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M1%201H5L7.68%2014.39C7.77144%2014.8504%208.02191%2015.264%208.38755%2015.5583C8.75318%2015.8526%209.2107%2016.009%209.68%2016H19.4C19.8693%2016.009%2020.3268%2015.8526%2020.6925%2015.5583C21.0581%2015.264%2021.3086%2014.8504%2021.4%2014.39L23%206H6'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Wm = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21%204H3C1.89543%204%201%204.89543%201%206V18C1%2019.1046%201.89543%2020%203%2020H21C22.1046%2020%2023%2019.1046%2023%2018V6C23%204.89543%2022.1046%204%2021%204Z'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M1%2010H23'%20stroke='%23404245'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e";
function Ym() {
  return {
    flowType: void 0,
    creditAmount: void 0,
    storeUrl: "",
    storeName: ""
  };
}
const qm = {
  class: "order-summary-component",
  ref: "rootRef"
}, Hm = { class: "order-summary" }, Qm = { class: "pa-6" }, Km = {
  key: 0,
  class: "order-summary__section"
}, Zm = { class: "order-summary__value" }, Jm = {
  key: 1,
  class: "order-summary__section"
}, Xm = { class: "order-summary__value" }, Dm = ["href"], ef = {
  key: 2,
  class: "hr-sm"
}, tf = {
  key: 3,
  class: "order-summary__section"
}, rf = { class: "order-summary__value" }, nf = { class: "pa-6" }, of = { class: "order-summary__footnotes" }, sf = { key: 0 }, lf = { key: 1 }, Ty = /* @__PURE__ */ ge({
  __name: "order-summary-component",
  props: {
    data: { default: Ym }
  },
  setup(e) {
    const t = e, s = se({ ...t.data });
    return te(
      () => t.data,
      // Watch for changes in the data
      (n) => {
        Object.assign(s, n);
      },
      { deep: !0 }
    ), (n, a) => (w(), F("div", qm, [
      c("div", Hm, [
        c("div", Qm, [
          a[6] || (a[6] = c("h1", { class: "order-summary__heading" }, "Povzetek naročila", -1)),
          s.flowType === r(Z).SKLENI_SAM && s.creditAmount != null && s.creditAmount > 0 ? (w(), F("div", Km, [
            a[1] || (a[1] = c("div", { class: "order-summary__label" }, " Vrednost predračuna ", -1)),
            c("div", Zm, [
              a[0] || (a[0] = c("img", {
                src: lo,
                alt: "Vrednost nakupa"
              }, null, -1)),
              c("div", null, P(s.creditAmount != null ? n.$n(s.creditAmount, "decimal") + " EUR" : ""), 1)
            ])
          ])) : B("", !0),
          s.flowType === r(Z).WEB && s.storeUrl != "" ? (w(), F("div", Jm, [
            a[3] || (a[3] = c("div", { class: "order-summary__label" }, " Trgovec ", -1)),
            c("div", Xm, [
              a[2] || (a[2] = c("img", {
                src: Bm,
                alt: "Trgovec"
              }, null, -1)),
              c("div", null, [
                c("a", {
                  href: s.storeUrl,
                  target: "_blank",
                  class: ""
                }, P(s.storeName), 9, Dm)
              ])
            ])
          ])) : B("", !0),
          s.flowType === r(Z).WEB && s.storeUrl != "" ? (w(), F("hr", ef)) : B("", !0),
          s.flowType === r(Z).WEB ? (w(), F("div", tf, [
            a[5] || (a[5] = c("div", { class: "order-summary__label" }, " Vrednost nakupa ", -1)),
            c("div", rf, [
              a[4] || (a[4] = c("img", {
                src: lo,
                alt: "Vrednost nakupa"
              }, null, -1)),
              c("div", null, P(s.creditAmount != null ? n.$n(s.creditAmount, "decimal") + " EUR" : ""), 1)
            ])
          ])) : B("", !0),
          a[7] || (a[7] = fs('<hr class="hr-sm"><div class="order-summary__section"><div class="order-summary__label"> Izbrani način plačila </div><div class="order-summary__value"><img src="' + Wm + '" alt="Način plačila"><div>NLB Buy&amp;Go</div></div></div>', 2))
        ]),
        a[10] || (a[10] = c("hr", null, null, -1)),
        c("div", nf, [
          c("div", of, [
            s.flowType === r(Z).WEB ? (w(), F("div", sf, a[8] || (a[8] = [
              Ie(" Na tej strani se nahajate, ker ste v spletni trgovini izbrali plačilo na obroke. V primeru težav smo vam na voljo na e-mail naslovu "),
              c("a", { href: "mailto:info@nlbbuygo.si" }, "info@nlbbuygo.si", -1),
              Ie(". ")
            ]))) : (w(), F("div", lf, a[9] || (a[9] = [
              Ie(" V primeru težav smo vam na voljo na e-mail naslovu "),
              c("a", { href: "mailto:info@nlbbuygo.si" }, "info@nlbbuygo.si", -1),
              Ie(". ")
            ])))
          ])
        ])
      ])
    ], 512));
  }
});
function af() {
  return {
    steps: void 0,
    currentStep: null
  };
}
const uf = { class: "flow-navigation-component" }, df = { class: "flow-navigation__steps" }, cf = ["aria-label", "aria-valuenow", "aria-valuemax"], mf = {
  class: "flow-navigation__progress-label",
  "aria-hidden": "true"
}, ff = ["aria-current"], pf = { class: "flow-navigation__step-number" }, vf = { class: "flow-navigation__step-label" }, Ey = /* @__PURE__ */ ge({
  __name: "flow-navigation-component",
  props: {
    data: { default: af },
    navigationType: { default: "horizontal" }
  },
  emits: ["update:data"],
  setup(e, { emit: t }) {
    const { t: s } = oe(), n = e, a = t, o = se({ ...n.data }), l = G(() => {
      var p;
      return ((p = o.steps) == null ? void 0 : p.length) ?? 0;
    }), i = G(
      () => {
        var p;
        return (((p = o.steps) == null ? void 0 : p.findIndex((y) => y.id === o.currentStep)) ?? -1) + 1;
      }
    ), u = G(
      () => l.value > 0 ? i.value / l.value * 100 : 0
    );
    function d(p) {
      return n.navigationType === "vertical" ? p + 1 < i.value : o.currentStep != null && p + 1 < o.currentStep;
    }
    return te(
      () => n.data,
      // Watch for changes in the data
      (p) => {
        Object.assign(o, p);
      },
      { deep: !0 }
    ), te(
      o,
      async (p) => {
        a("update:data", p);
      },
      { deep: !0 }
    ), (p, y) => (w(), F("div", uf, [
      c("div", {
        class: ke(["flow-navigation", { "flow-navigation--vertical": p.navigationType === "vertical" }])
      }, [
        c("nav", df, [
          p.navigationType === "vertical" && l.value > 0 ? (w(), F("div", {
            key: 0,
            class: ke(["flow-navigation__progress", { "flow-navigation__progress--initial": i.value <= 1 }]),
            role: "progressbar",
            "aria-label": r(s)("OrderNavigation.Progress", "Napredek"),
            "aria-valuenow": i.value,
            "aria-valuemin": 0,
            "aria-valuemax": l.value
          }, [
            c("span", {
              class: "flow-navigation__progress-fill",
              style: ps({ width: `${u.value}%` })
            }, null, 4),
            c("span", mf, [
              c("strong", null, P(i.value), 1),
              c("span", null, P(r(s)("OrderNavigation.Of", "od")), 1),
              c("span", null, P(l.value), 1)
            ])
          ], 10, cf)) : B("", !0),
          c("ol", null, [
            (w(!0), F(Ae, null, tt(o.steps, (f, _) => (w(), F("li", {
              key: f.id
            }, [
              c("button", {
                type: "button",
                class: ke({ "flow-navigation__step--completed": d(_) }),
                "aria-current": o.currentStep === f.id ? "step" : void 0
              }, [
                c("span", pf, P(_ + 1) + ".", 1),
                c("span", vf, P(r(s)("OrderNavigation." + f.label)), 1)
              ], 10, ff)
            ]))), 128))
          ])
        ])
      ], 2)
    ]));
  }
});
function gf() {
  return {
    flowType: void 0,
    isViewDataLoading: !1,
    orderToken: "",
    installmentNr: 0,
    msisdn: null,
    repeatPassword: "",
    bindingFiles: [],
    documentationFiles: [],
    calculationId: 0,
    firstname: "",
    surname: "",
    taxNumber: void 0,
    birthdate: null,
    isMale: !0,
    address: "",
    postalCode: void 0,
    hasTemporaryResidence: !1,
    temporaryCitizen: void 0,
    temporaryPostalCode: void 0,
    temporaryForeignPostalCode: "",
    temporaryAddress: "",
    contractSending: void 0,
    documentationSendType: void 0,
    contractSignatureType: void 0,
    prefix: void 0,
    phoneNumber: "",
    email: "",
    isEmailVerified: !1,
    TRR: "",
    birthCity: "",
    personalDocumentType: void 0,
    idNumber: "",
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: void 0,
    citizen: void 0,
    employmentType: void 0,
    employerName: "",
    employerAddress: "",
    employerPostCode: "",
    documentNumber: "",
    isPoliticallyExposedPerson: void 0,
    politicalFunction: "",
    pioSourceFunds: "",
    pioFundsStatus: "",
    countrySourceFunds: "",
    countryFundsStatus: "",
    hasSlovenianBankAccount: void 0,
    marketingConsent: !1,
    lastMonthsIncome: void 0,
    lastMonthsIncome2: void 0,
    lastMonthsIncome3: void 0,
    willAttachDocumentation: void 0,
    pogodbaId: 0,
    stPogodbe: "",
    isDocumentationNeeded: !1,
    isPreapproved: !1,
    hasMultipleProducts: !1,
    belowNotificationHtml: "",
    notificationType: void 0,
    notificationHtml: "",
    title: "",
    icon: ""
  };
}
function yf() {
  return {
    isDataLoading: !1,
    showPodpis: !1,
    podpisUrl: "",
    urlList: [],
    productsList: [],
    podpisId: 0
  };
}
function bf(e, t, s) {
  const { t: n } = oe(), a = ue("commClient"), o = ue("generalStore");
  ue(Hr);
  function l(h) {
    const v = h ?? "", N = v.startsWith("SI56") ? "" : v.slice(0, 4), $ = v.slice(4).replace(/[^0-9]/g, "");
    return N + $;
  }
  async function i() {
    var I;
    e.isViewDataLoading = !0, await ae();
    let h = "";
    e.documentationFiles.length > 0 && (h = e.documentationFiles.map((C) => C.FileId).join(";")), e.bindingFiles.length > 0 && (h.length > 0 && (h += ";"), h += e.bindingFiles.map((C) => C.FileId).join(";"));
    let v = 0;
    e.employmentType == Ne.Upokojenec ? v = 1 : e.employmentType == Ne.SP && (v = 2);
    const N = {
      UploadFiles: h,
      IzracunId: e.calculationId,
      txtIme: e.firstname,
      txtPriimek: e.surname,
      txtDavcnaSt: e.taxNumber,
      DatumRojstvaText: we(e.birthdate),
      jeMoski: e.isMale,
      txtUlica: e.address,
      ddPosta: e.postalCode,
      zacasenNaslov: e.temporaryAddress,
      zacasnaPosta: e.temporaryPostalCode != null ? e.temporaryPostalCode : "",
      zacasnaDrzava: e.temporaryCitizen != null ? e.temporaryCitizen : -1,
      zacasnaPostaTujina: e.temporaryForeignPostalCode,
      naslovPosiljanje: e.hasTemporaryResidence ? "Z" : "S",
      txtTelefon: ((I = e.prefix) == null ? void 0 : I.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
      txtEmail: e.email,
      isEmailVerified: e.isEmailVerified,
      txtStTR: l(e.TRR),
      txtKrajRojstva: e.birthCity,
      ddVrstaOsDok: e.personalDocumentType,
      txtIzdajateljOsDok: e.documentIssuer,
      txtStOsDok: e.idNumber,
      dtDatumIzdajeOsDok: we(e.issueDate),
      dtDatumVeljavnostiOsDok: we(e.validityDate == null ? new Date(1753, 1, 1) : e.validityDate),
      ddDrzavljan: e.citizen,
      ddZaposlitevStatus: v,
      txtDelodajalecNaziv: e.employerName,
      txtDelodajalecUlica: e.employerAddress,
      ddDelodajalecPosta: e.employerPostCode,
      txtStRacuna: e.documentNumber,
      chkPIO: e.isPoliticallyExposedPerson,
      txtPIOVsebina: e.politicalFunction,
      txtPIOIzvor: e.pioSourceFunds,
      txtPIOPremozenje: e.pioFundsStatus,
      txtTveganIzvor: e.countrySourceFunds,
      txtTveganPremozenje: e.countryFundsStatus,
      chkTujaBanka: !e.hasSlovenianBankAccount,
      ddSoglasjeSLS: e.marketingConsent == !0 ? 1 : 0,
      ddSoglasjePartner: 0,
      numPlacaPokojnina: e.lastMonthsIncome,
      numPlaca2: e.lastMonthsIncome2 ?? 0,
      numPlaca3: e.lastMonthsIncome3 ?? 0,
      intBlagovnaSkupina: 0,
      ...e.flowType === Z.POS_STRANKA ? {
        PosOrderToken: e.orderToken
      } : {}
    };
    let $ = "ContractCreate";
    e.flowType === Z.POS_STRANKA && ($ = "ContractCreatePosFinish");
    const S = await a.executeMethodAsync($, N);
    return e.isViewDataLoading = !1, await ae(), S ? S.Success ? (e.pogodbaId = S.PogodbaId, e.stPogodbe = S.StPogodbe, await y() ? !0 : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "Components.ContractCreateComponent.UploadFailed", !1)) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = S.ResponseText, !1) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "fw4.Communication.InternalErrorText", !1);
  }
  async function u() {
    var N;
    e.isViewDataLoading = !0, await ae();
    let h = "";
    e.bindingFiles.length > 0 && (h += e.bindingFiles.map(($) => $.FileId).join(";"));
    const v = await a.executeMethodAsync("ContractCreatePreapproved", {
      UploadFiles: h,
      IzracunId: e.calculationId,
      txtDavcnaSt: e.taxNumber,
      txtTelefon: ((N = e.prefix) == null ? void 0 : N.Key.toString().replace("+", "").trim()) + e.phoneNumber.toString(),
      txtStRacuna: e.documentNumber,
      Firstname: e.firstname,
      Surname: e.surname,
      DatumRojstvaText: we(e.birthdate),
      Address: e.address,
      PostalCode: e.postalCode,
      BirthCity: e.birthCity,
      PersonalDocumentType: e.personalDocumentType,
      DocumentIssuer: e.documentIssuer,
      IdNumber: e.idNumber,
      IssueDate: we(e.issueDate),
      ValidityDate: we(e.validityDate == null ? new Date(1753, 1, 1) : e.validityDate),
      Citizen: e.citizen
    });
    return e.isViewDataLoading = !1, await ae(), v ? v.Success ? (e.pogodbaId = v.PogodbaId, e.stPogodbe = v.StPogodbe, await y() ? !0 : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "Components.ContractCreateComponent.UploadFailed", !1)) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = v.ResponseText, !1) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "fw4.Communication.InternalErrorText", !1);
  }
  async function d() {
    e.isViewDataLoading = !0, await ae();
    let h = "ContractSaveWebCredit";
    e.hasMultipleProducts && (h = "ContractSaveWebCreditMultiProduct");
    const v = await a.executeMethodAsync(h, {
      OrderToken: e.orderToken,
      Installments: e.installmentNr,
      FlowId: e.flowType,
      Firstname: e.firstname,
      Surname: e.surname,
      TaxNumber: e.taxNumber,
      Email: e.email,
      Address: e.address,
      PostalCode: e.postalCode != null ? e.postalCode : "",
      BirthCity: e.birthCity,
      Birthdate: we(e.birthdate),
      Citizen: e.citizen,
      hasTemporaryResidence: e.hasTemporaryResidence,
      TemporaryAddress: e.temporaryAddress,
      TemporaryPostalCode: e.temporaryPostalCode != null ? e.temporaryPostalCode : "",
      TemporaryForeignPostalCode: e.temporaryForeignPostalCode,
      TemporaryCitizen: e.temporaryCitizen != null ? e.temporaryCitizen : -1,
      PersonalDocumentType: e.personalDocumentType,
      IdNumber: e.idNumber,
      DocumentIssuer: e.documentIssuer,
      IssueDate: we(e.issueDate),
      ValidityDate: we(e.validityDate == null ? new Date(1753, 1, 1) : e.validityDate),
      EmploymentType: e.employmentType,
      EmployerName: e.employerName,
      EmployerAddress: e.employerAddress,
      EmployerPostalCode: e.employerPostCode,
      IsPIO: e.isPoliticallyExposedPerson,
      PoliticalFunction: e.politicalFunction,
      PIOSourceFunds: e.pioSourceFunds,
      PIOFundsStatus: e.pioFundsStatus,
      CountryRiskSourceFunds: e.countrySourceFunds,
      CountryRiskFundsStatus: e.countryFundsStatus,
      HasThreeSalaries: !1,
      Salary: e.lastMonthsIncome,
      Salary2: e.lastMonthsIncome2 === void 0 ? 0 : e.lastMonthsIncome2,
      Salary3: e.lastMonthsIncome3 === void 0 ? 0 : e.lastMonthsIncome3,
      Msisdn: e.msisdn,
      TRR: l(e.TRR),
      uploadDatoteke: "",
      gdprSls: e.marketingConsent == !0 ? 1 : 0,
      HasSlovenianAccount: e.hasSlovenianBankAccount,
      UserPasswordNew: e.repeatPassword
    });
    return e.isViewDataLoading = !1, await ae(), v ? v.Success ? (e.pogodbaId = v.PogodbaId, e.stPogodbe = v.StPogodbe, await y() ? !0 : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "Components.ContractCreateComponent.UploadFailed", await ae(), !1)) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = v.ErrorCode != "" ? "GlobalErrors." + v.ErrorCode : v.ResponseText, await ae(), !1) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "fw4.Communication.InternalErrorText", await ae(), !1);
  }
  async function p() {
    e.isViewDataLoading = !0, await ae();
    let h = "ContractSavePreapprovedWebCredit";
    e.hasMultipleProducts && (h = "ContractSavePreapprovedWebCreditMultiProduct");
    const v = await a.executeMethodAsync(h, {
      OrderToken: e.orderToken,
      Installments: e.installmentNr,
      FlowId: e.flowType,
      Msisdn: e.msisdn,
      SlovenianCitizen: e.citizen == 204
    });
    return e.isViewDataLoading = !1, await ae(), v ? v.Success ? (e.pogodbaId = v.PogodbaId, e.stPogodbe = v.StPogodbe, await y() ? !0 : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "Components.ContractCreateComponent.UploadFailed", !1)) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = v.ResponseText, !1) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "fw4.Communication.InternalErrorText", !1);
  }
  async function y() {
    e.isViewDataLoading = !1, await ae(), t.showPodpis = !0, t.podpisUrl = "/StaticLoaders/upload_wait.html";
    let h;
    switch (e.flowType) {
      case Z.POS:
        if (h = await a.executeMethodAsync("UploadDocuments", {
          PogodbaId: e.pogodbaId,
          SendType: e.contractSending == ht.Elektronsko ? "EMAIL" : "POSTA",
          chkUseSMS: e.contractSignatureType === Nt.SMS,
          flowType: e.flowType
        }), h && h.Success)
          return t.showPodpis = !0, t.podpisUrl = h.Url, !0;
        break;
      case Z.POS_STRANKA:
        if (h = await a.executeMethodAsync("UploadDocumentsPosFinish", {
          PosOrderToken: e.orderToken,
          PogodbaId: e.pogodbaId,
          SendType: e.contractSending == ht.Elektronsko ? "EMAIL" : "POSTA",
          chkUseSMS: e.contractSignatureType === Nt.SMS,
          flowType: e.flowType
        }), h && h.Success)
          return t.showPodpis = !0, t.podpisUrl = h.Url, !0;
        break;
      case Z.WEB:
      case Z.SKLENI_SAM:
        if (h = await a.executeMethodAsync("UploadDocumentsForWeb", {
          //PogodbaId: 140620,
          OrderToken: e.orderToken
        }), h && h.Success)
          return t.showPodpis = !0, t.podpisId = 0, t.urlList = h.Urls, t.productsList = h.Products, t.podpisUrl = h.Urls[t.podpisId], !0;
        break;
    }
    return !1;
  }
  async function f(h) {
    if (h && h[0] && h[0].CallbackType == "SIGN" && h[0].Success)
      switch (h[0].Type) {
        case "pogodba":
          h[0].Status == "complete" && (t.urlList.length > 1 && t.podpisId < t.urlList.length - 1 ? (t.podpisId++, t.podpisUrl = t.urlList[t.podpisId]) : (t.showPodpis = !1, t.podpisId = -1, t.urlList = [], e.isViewDataLoading = !1, e.flowType === Z.POS ? !e.isDocumentationNeeded || e.isPreapproved ? (e.icon = "iconContractEndSuccess", e.title = "OrderEnd.TitleNoDoc", e.notificationType = Ce.Success, e.notificationHtml = "OrderEnd.NotificationNoDoc", e.belowNotificationHtml = "") : (e.icon = "iconContractEndSuccess", e.title = "OrderEnd.TitleDoc", e.notificationType = Ce.Alert, e.notificationHtml = "OrderEnd.NotificationDoc", e.belowNotificationHtml = "") : e.flowType === Z.POS_STRANKA ? !e.isDocumentationNeeded || e.isPreapproved ? (e.icon = "iconContractEndSuccess", e.title = "OrderEnd.TitleWebCustomerNoDoc", e.belowNotificationHtml = "OrderEnd.TextWebCustomerNoDoc") : (e.icon = "iconContractEndSuccess", e.title = "OrderEnd.TitleWebCustomerDoc", e.belowNotificationHtml = "OrderEnd.TextWebCustomerDoc") : (e.icon = "iconContractEndSuccess", e.title = "OrderEnd.TitleWeb", e.belowNotificationHtml = n("OrderEnd.TextWeb")), await ae(), s("navigationEvent", { name: "end" })));
          break;
      }
    return !1;
  }
  const _ = G(() => {
    var h;
    return (h = o.state.countryList) == null ? void 0 : h.find((v) => e.temporaryCitizen === v.Key);
  }), b = G(() => {
    var h, v;
    return ((v = (h = _.value) == null ? void 0 : h.AdditionalData) == null ? void 0 : v.RiskDrzava) == !0;
  });
  async function g(h) {
    let v = null;
    switch (h) {
      case "createContract":
        if (b.value) {
          const N = Br("GlobalErrors.Error", "GlobalErrors.EndFail.RiskCountry");
          return await ae(), Pe(e, N), await ae(), v = { name: "end" };
        } else
          await i().then((N) => {
            if (!N) {
              v = { name: "end" };
              return;
            }
          });
        break;
      case "createContractPreapproved":
        await u().then((N) => {
          if (!N) {
            v = { name: "end" };
            return;
          }
        });
        break;
      case "webCreateContract":
        await d().then((N) => {
          if (!N) {
            v = { name: "end" };
            return;
          }
        });
        break;
      case "webCreateContractPreapproved":
        await p().then((N) => {
          if (!N) {
            v = { name: "end" };
            return;
          }
        });
        break;
    }
    return v;
  }
  return {
    contractCreate: i,
    contractCreatePreapproved: u,
    contractCreateWeb: d,
    contractCreateWebPreapproved: p,
    navigationAction: g,
    signComplete: f
  };
}
const Cf = {
  key: 0,
  class: "top-info-bar"
}, Ny = /* @__PURE__ */ ge({
  __name: "contract-create-component",
  props: {
    data: { default: gf }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, o = se({ ...n.data }), l = se(yf()), i = ue("commClient"), u = X(!1);
    te(
      () => n.data,
      // Watch for changes in the data
      (g) => {
        Object.assign(o, g);
      },
      { deep: !0 }
    ), te(o, async (g) => {
      a("update:data", g);
    }, { deep: !0 }), Se(async () => {
      i.OnStreamDataReceived.AddCallback(b);
    }), Wr(() => {
      i.OnStreamDataReceived.RemoveCallback(b);
    });
    const {
      contractCreate: d,
      contractCreatePreapproved: p,
      contractCreateWeb: y,
      contractCreateWebPreapproved: f,
      navigationAction: _,
      signComplete: b
    } = bf(
      o,
      l,
      a
    );
    return t({
      componentReady: u,
      navigationAction: _,
      contractCreate: d,
      contractCreatePreapproved: p,
      contractCreateWeb: y,
      contractCreateWebPreapproved: f
    }), (g, h) => (w(), ce(Pt, {
      display: l.showPodpis,
      onModalClosed: h[0] || (h[0] = (v) => l.showPodpis = !1),
      showAcceptButton: !1,
      showDeclineButton: !1,
      class: "dialog-preview"
    }, {
      default: E(() => [
        l.urlList.length > 1 ? (w(), F("div", Cf, "Podpisujete dokumentacijo za " + P(l.productsList[l.podpisId]) + ". (" + P((l.podpisId + 1).toString()) + "/" + P(l.urlList.length.toString()) + ")", 1)) : B("", !0),
        m(kt, {
          url: l.podpisUrl,
          frameBorder: "0"
        }, null, 8, ["url"])
      ]),
      _: 1
    }, 8, ["display"]));
  }
});
function If() {
  return {
    creditAmount: void 0,
    availableCreditAmount: void 0
  };
}
function _f(e) {
  const { t } = oe(), s = G(() => e.availableCreditAmount ?? 0);
  return {
    validationRules: G(() => ({
      creditAmount: {
        required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye),
        minValue: V.withMessage(t("GlobalErrors.InvalidValue"), Vt(100)),
        maxValue: V.withMessage(t("GlobalErrors.InvalidValue"), Qo(s))
      }
    }))
  };
}
function hf(e, t) {
  const { validationRules: s } = _f(e), n = Me(s, G(() => e), { $autoDirty: !0 }), { scrollToFirstError: a } = Oe();
  function o() {
    a(t.value);
  }
  async function l() {
    return n.value.$touch(), await n.value.$validate();
  }
  async function i() {
    return await l() ? !0 : (await ae(), o(), !1);
  }
  return {
    v$: n,
    validateForm: l,
    confirmLimitExceeded: i
  };
}
const Tf = { class: "notification notification--warning" }, Ef = { class: "font-weight-semibold mb-2" }, Nf = {
  class: "form-label",
  for: "pos-order-new-amount"
}, Sy = /* @__PURE__ */ ge({
  __name: "limit-exceeded-component",
  props: {
    data: { default: If }
  },
  emits: ["update:data"],
  setup(e, { expose: t, emit: s }) {
    const { t: n } = oe(), a = e, o = s, l = X(null), i = se({ ...a.data });
    te(
      () => a.data,
      // Watch for changes in the data
      (y) => {
        Object.assign(i, y);
      },
      { deep: !0 }
    ), te(
      i,
      (y) => {
        o("update:data", y);
      },
      { deep: !0 }
    );
    const u = G(() => jr(i.availableCreditAmount ?? 0)), { v$: d, confirmLimitExceeded: p } = hf(i, l);
    return t({
      confirmLimitExceeded: p
    }), (y, f) => (w(), F(Ae, null, [
      c("div", Tf, [
        c("div", Ef, P(r(n)("Components.LimitExceeded.Notification")), 1),
        c("div", null, P(r(n)("Components.LimitExceeded.Notification2", { amount: u.value })), 1)
      ]),
      c("div", null, [
        c("label", Nf, P(r(n)("Components.LimitExceeded.NewAmount")), 1),
        m(Ke, {
          id: "pos-order-new-amount",
          modelValue: i.creditAmount,
          "onUpdate:modelValue": f[0] || (f[0] = (_) => i.creditAmount = _),
          error: r(d).creditAmount.$error,
          "error-messages": r(d).creditAmount.$errors[0] != null ? r(d).creditAmount.$errors[0].$message : "",
          onFocus: f[1] || (f[1] = (_) => r(d).creditAmount.$reset()),
          "number-of-decimals": 2,
          "append-text": "EUR",
          autocomplete: "off"
        }, null, 8, ["modelValue", "error", "error-messages"])
      ])
    ], 64));
  }
});
function Sf() {
  return {
    selectedSpecialProduct: void 0,
    specialProductList: [],
    employmentType: void 0,
    availableCreditAmount: void 0,
    contractDebt: 0
  };
}
function Pf(e) {
  const { t } = oe();
  return {
    validationRules: G(() => ({
      selectedSpecialProduct: {
        required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
      }
    }))
  };
}
function $f(e, t) {
  const { validationRules: s } = Pf(), n = ue("commClient"), a = Me(s, G(() => e), { $autoDirty: !0 }), { scrollToFirstError: o } = Oe();
  function l() {
    o(t.value);
  }
  async function i() {
    return a.value.$touch(), await a.value.$validate();
  }
  async function u() {
    const p = await n.executeMethodAsync("sf.ProductListSpecialActions", {
      Employment: e.employmentType
    });
    return e.specialProductList = p.specialProducts, !0;
  }
  async function d() {
    return await i() ? (e.availableCreditAmount = e.selectedSpecialProduct.amountMax - e.contractDebt, await ae(), !0) : (await ae(), l(), !1);
  }
  return {
    v$: a,
    validateForm: i,
    confirmSpecialProduct: d,
    loadSpecialProductList: u
  };
}
const Mf = { class: "notification notification--warning" }, Af = { class: "font-weight-semibold mb-2" }, wf = {
  class: "form-label",
  for: "pos-order-new-product"
}, Py = /* @__PURE__ */ ge({
  __name: "product-update-component",
  props: {
    data: { default: Sf }
  },
  emits: ["update:data"],
  setup(e, { expose: t, emit: s }) {
    const { t: n } = oe(), a = e, o = s, l = X(null), i = se({ ...a.data });
    te(
      () => a.data,
      // Watch for changes in the data
      (y) => {
        Object.assign(i, y);
      },
      { deep: !0 }
    ), te(
      i,
      (y) => {
        o("update:data", y);
      },
      { deep: !0 }
    ), Se(async () => {
      i.selectedSpecialProduct = void 0, await p();
    });
    const { v$: u, confirmSpecialProduct: d, loadSpecialProductList: p } = $f(i, l);
    return t({
      confirmSpecialProduct: d
    }), (y, f) => {
      var b;
      const _ = U("v-autocomplete");
      return w(), F(Ae, null, [
        c("div", Mf, [
          c("div", Af, P(r(n)("Components.ProductUpdate.Notification")), 1),
          c("div", null, P(r(n)("Components.ProductUpdate.Notification2")), 1)
        ]),
        c("div", null, [
          c("label", wf, P(r(n)("Components.ProductUpdate.NewProduct")), 1),
          m(_, {
            id: "pos-order-new-product",
            modelValue: i.selectedSpecialProduct,
            "onUpdate:modelValue": f[0] || (f[0] = (g) => i.selectedSpecialProduct = g),
            items: i.specialProductList,
            "item-title": "productName",
            "return-object": "",
            variant: "outlined",
            error: r(u).selectedSpecialProduct.$error,
            "error-messages": ((b = r(u).selectedSpecialProduct.$errors[0]) == null ? void 0 : b.$message) ?? "",
            onFocus: f[1] || (f[1] = (g) => r(u).selectedSpecialProduct.$reset())
          }, null, 8, ["modelValue", "items", "error", "error-messages"])
        ])
      ], 64);
    };
  }
});
function kf() {
  return {
    contractSending: void 0,
    documentationSendType: void 0,
    flowType: void 0,
    hasTemporaryResidence: void 0,
    isEmailVerified: !1,
    taxNumber: void 0
  };
}
function Of(e) {
  const { t } = oe();
  return {
    validationRules: G(() => ({
      contractSending: {
        required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
      },
      documentationSendType: {
        customRequired: V.withMessage(t("GlobalErrors.FieldRequired"), ve(e.contractSending == ht.Posta && e.hasTemporaryResidence == !0))
      }
    }))
  };
}
function Rf(e, t) {
  ue("commClient");
  const { validationRules: s } = Of(e), n = Me(s, G(() => e), { $autoDirty: !0 }), { t: a } = oe();
  async function o() {
    e.hasTemporaryResidence || (e.documentationSendType = ar.PermanentResidence);
  }
  async function l() {
    return n.value.$touch(), await n.value.$validate();
  }
  return {
    v$: n,
    validateForm: l,
    initData: o
  };
}
const Lf = { class: "form-label" }, xf = { class: "form-label form-label--text" }, $y = /* @__PURE__ */ ge({
  __name: "contract-documentation-component",
  props: {
    data: { default: kf }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: s }) {
    ue("commClient");
    const { t: n } = oe(), a = e, o = s;
    let l = X(!1);
    const i = se({ ...a.data }), u = X(null), { v$: d, initData: p, validateForm: y } = Rf(i);
    return te(
      () => a.data,
      // Watch for changes in the data
      (f) => {
        Object.assign(i, f);
      },
      { deep: !0 }
    ), te(
      i,
      (f) => {
        o("update:data", f);
      },
      { deep: !0 }
    ), Se(() => {
      p(), l.value = !0, o("componentReady");
    }), t({
      componentReady: l,
      validateForm: y
    }), (f, _) => {
      const b = U("v-radio"), g = U("v-radio-group"), h = U("v-col"), v = U("v-row");
      return w(), F("div", {
        class: "signature-details-component",
        ref_key: "rootRef",
        ref: u
      }, [
        c("div", null, [
          c("label", Lf, P(r(n)("Components.ContractDocumentation.ContractSending")), 1),
          m(g, {
            modelValue: i.contractSending,
            "onUpdate:modelValue": _[0] || (_[0] = (N) => i.contractSending = N),
            error: r(d).contractSending.error,
            "error-messages": r(d).contractSending.$errors[0] != null ? r(d).contractSending.$errors[0].$message : "",
            onFocus: r(d).contractSending.$reset
          }, {
            default: E(() => [
              m(b, {
                label: r(n)("Components.ContractDocumentation.ElectronicSignatureBtn"),
                value: r(ht).Elektronsko
              }, null, 8, ["label", "value"]),
              m(b, {
                label: r(n)("Components.ContractDocumentation.SendByPosteBtn"),
                value: r(ht).Posta
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue", "error", "error-messages", "onFocus"])
        ]),
        i.contractSending == r(ht).Posta && i.hasTemporaryResidence == !0 ? (w(), ce(v, { key: 0 }, {
          default: E(() => [
            m(h, { class: "v-col-12" }, {
              default: E(() => [
                c("div", null, [
                  c("label", xf, P(f.$t("Components.ContractDocumentation.SendAddress")), 1),
                  m(g, {
                    modelValue: i.documentationSendType,
                    "onUpdate:modelValue": _[1] || (_[1] = (N) => i.documentationSendType = N),
                    error: r(d).documentationSendType.error,
                    "error-messages": r(d).documentationSendType.$errors[0] != null ? r(d).documentationSendType.$errors[0].$message : "",
                    onFocus: r(d).documentationSendType.$reset
                  }, {
                    default: E(() => [
                      m(b, {
                        label: r(n)("Components.ContractDocumentation.PermanentBtn"),
                        value: r(ar).PermanentResidence
                      }, null, 8, ["label", "value"]),
                      m(b, {
                        label: r(n)("Components.ContractDocumentation.TemporaryBtn"),
                        value: r(ar).TemporaryResidence
                      }, null, 8, ["label", "value"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error", "error-messages", "onFocus"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0)
      ], 512);
    };
  }
});
function Ff() {
  return {
    contractSignatureType: void 0
  };
}
function Vf(e) {
  const { t } = oe();
  return {
    validationRules: G(() => ({
      contractSignatureType: {
        required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
      }
    }))
  };
}
function zf(e, t) {
  const { validationRules: s } = Vf(), n = Me(s, G(() => e), { $autoDirty: !0 }), { scrollToFirstError: a } = Oe();
  function o() {
    a(t.value);
  }
  const { t: l } = oe();
  async function i() {
    return n.value.$touch(), await n.value.$validate();
  }
  async function u() {
    return await i() ? !0 : (await ae(), o(), !1);
  }
  return {
    v$: n,
    validateForm: i,
    createVloga: u
  };
}
const jf = { class: "mb-2" }, Uf = { class: "form-label" }, My = /* @__PURE__ */ ge({
  __name: "contract-signature-type-component",
  props: {
    data: { default: Ff }
  },
  emits: ["update:data"],
  setup(e, { expose: t, emit: s }) {
    const { t: n } = oe(), a = e, o = s, l = X(null), i = se({ ...a.data });
    te(
      () => a.data,
      // Watch for changes in the data
      (p) => {
        Object.assign(i, p);
      },
      { deep: !0 }
    ), te(
      i,
      (p) => {
        o("update:data", p);
      },
      { deep: !0 }
    );
    const { v$: u, createVloga: d } = zf(i, l);
    return t({
      createVloga: d
    }), (p, y) => {
      const f = U("v-radio"), _ = U("v-radio-group");
      return w(), F("div", {
        class: "signature-details-component",
        ref_key: "rootRef",
        ref: l
      }, [
        c("div", jf, [
          c("label", Uf, P(r(n)("Components.ContractSignatureType.ContractSigning")), 1),
          m(_, {
            modelValue: i.contractSignatureType,
            "onUpdate:modelValue": y[0] || (y[0] = (b) => i.contractSignatureType = b),
            error: r(u).contractSignatureType.error,
            "error-messages": r(u).contractSignatureType.$errors[0] != null ? r(u).contractSignatureType.$errors[0].$message : "",
            onFocus: r(u).contractSignatureType.$reset
          }, {
            default: E(() => [
              m(f, {
                label: r(n)("Components.ContractSignatureType.UseSMS"),
                value: r(Nt).SMS
              }, null, 8, ["label", "value"]),
              m(f, {
                label: r(n)("Components.ContractSignatureType.UseTablet"),
                value: r(Nt).PodpisnaTablica
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue", "error", "error-messages", "onFocus"])
        ])
      ], 512);
    };
  }
});
function Gf(e, t) {
  const s = ue("commClient");
  async function n() {
    e.isViewDataLoading = !0, await ae();
    const a = await s.executeMethodAsync("PosOrderInsert", {
      TaxNumber: e.taxNumber,
      CreditAmount: e.creditAmount,
      IsExistingUser: e.isExistingUser,
      SelectedProductType: e.selectedProductType ?? null,
      SelectedProduct: e.selectedProduct == null ? null : JSON.stringify(e.selectedProduct),
      SelectedSpecialProduct: e.selectedSpecialProduct == null ? null : JSON.stringify(e.selectedSpecialProduct),
      IsPreapproved: e.isPreapproved,
      PreapprovedCreditAmount: e.preapprovedCreditAmount,
      PreapprovedInstallmentAmount: e.preapprovedInstallmentAmount,
      PreapprovedCreditType: e.preapprovedCreditType,
      NumberOfPreapprovedSalaries: e.numberOfPreapprovedSalaries,
      LastMonthsIncome: e.lastMonthsIncome ?? void 0,
      LastMonthsIncome2: e.lastMonthsIncome2 ?? void 0,
      LastMonthsIncome3: e.lastMonthsIncome3 ?? void 0,
      MustProvideThreeSalaries: e.mustProvideThreeSalaries,
      Msisdn: e.msisdn,
      IsDocumentationNeeded: e.isDocumentationNeeded,
      IsSlovenianCitizen: e.isSlovenianCitizen ?? null,
      MinCredit: e.minCredit,
      ContractDebtInstallments: e.contractDebtInstallments,
      DebtInstallments: e.debtInstallments,
      HasSlovenianIncome: e.hasSlovenianIncome ?? null,
      Birthdate: we(e.birthdate),
      NeedsToEnterIncome: e.needsToEnterIncome,
      NumberOfPrefilledSalaries: e.numberOfPrefilledSalaries,
      Firstname: e.firstname,
      Surname: e.surname,
      Prefix: e.prefix == null ? null : JSON.stringify(e.prefix),
      PhoneNumber: e.phoneNumber,
      Citizen: e.citizen ?? null,
      SisbonResultId: e.sisbonResultId,
      DebtAmount: e.debtAmount,
      MinSalary: e.minSalary,
      Email: e.email,
      IsEmailVerified: e.isEmailVerified ?? null,
      TRR: e.TRR,
      HasSlovenianBankAccount: e.hasSlovenianBankAccount ?? null,
      BindingFiles: JSON.stringify(e.bindingFiles),
      Address: e.address,
      PostalCode: e.postalCode ?? null,
      HasTemporaryResidence: e.hasTemporaryResidence,
      TemporaryCitizen: e.temporaryCitizen ?? null,
      TemporaryPostalCode: e.temporaryPostalCode ?? null,
      TemporaryForeignPostalCode: e.temporaryForeignPostalCode,
      TemporaryAddress: e.temporaryAddress,
      DocumentationSendType: e.documentationSendType ?? null,
      ContractSignatureType: e.contractSignatureType ?? null,
      BirthCity: e.birthCity,
      PersonalDocumentType: e.personalDocumentType ?? null,
      IdNumber: e.idNumber,
      DocumentIssuer: e.documentIssuer,
      IssueDate: we(e.issueDate),
      ValidityDate: we(e.validityDate ?? new Date(1753, 1, 1)),
      PermanentValidity: e.permanentValidity ?? null,
      EmploymentType: e.employmentType ?? null,
      EmployerName: e.employerName,
      EmployerAddress: e.employerAddress,
      EmployerPostCode: e.employerPostCode,
      DocumentNumber: e.documentNumber,
      IsPoliticallyExposedPerson: e.isPoliticallyExposedPerson ?? null,
      PoliticalFunction: e.politicalFunction,
      PioSourceFunds: e.pioSourceFunds,
      PioFundsStatus: e.pioFundsStatus,
      CountrySourceFunds: e.countrySourceFunds,
      CountryFundsStatus: e.countryFundsStatus,
      MarketingConsent: e.marketingConsent
    });
    return e.isViewDataLoading = !1, await ae(), a.success ? (e.icon = "iconContractEndCustomerContinue", e.title = "OrderEnd.TitleCustomerContinue", e.notificationType = Ce.Alert, e.notificationHtml = "OrderEnd.NotificationCustomerContinue", e.belowNotificationHtml = "", await ae(), t("navigationEvent", { name: "end" }), !0) : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "GlobalErrors.Error", e.notificationHtml = "", await ae(), t("navigationEvent", { name: "end" }), !1);
  }
  return { sendLinkToCustomer: n };
}
function Bf() {
  return {
    isExistingUser: !1,
    isViewDataLoading: !1,
    taxNumber: void 0,
    flowType: void 0,
    orderToken: "",
    creditAmount: void 0,
    selectedProductType: void 0,
    selectedProduct: void 0,
    selectedSpecialProduct: void 0,
    isPreapproved: !1,
    preapprovedCreditAmount: 0,
    preapprovedInstallmentAmount: 0,
    preapprovedCreditType: "",
    numberOfPreapprovedSalaries: 0,
    lastMonthsIncome: void 0,
    lastMonthsIncome2: void 0,
    lastMonthsIncome3: void 0,
    mustProvideThreeSalaries: !1,
    msisdn: null,
    isDocumentationNeeded: !1,
    isSlovenianCitizen: void 0,
    minCredit: 0,
    contractDebtInstallments: 0,
    debtInstallments: 0,
    hasSlovenianIncome: void 0,
    birthdate: null,
    needsToEnterIncome: !0,
    numberOfPrefilledSalaries: 0,
    firstname: "",
    surname: "",
    prefix: void 0,
    phoneNumber: "",
    citizen: void 0,
    sisbonResultId: 0,
    debtAmount: 0,
    minSalary: 0,
    email: "",
    isEmailVerified: !1,
    TRR: "",
    hasSlovenianBankAccount: void 0,
    bindingFiles: [],
    address: "",
    postalCode: void 0,
    hasTemporaryResidence: !1,
    temporaryCitizen: void 0,
    temporaryPostalCode: void 0,
    temporaryForeignPostalCode: "",
    temporaryAddress: "",
    documentationSendType: void 0,
    contractSignatureType: void 0,
    birthCity: "",
    personalDocumentType: void 0,
    idNumber: "",
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: void 0,
    employmentType: void 0,
    employerName: "",
    employerAddress: "",
    employerPostCode: "",
    documentNumber: "",
    isPoliticallyExposedPerson: void 0,
    politicalFunction: "",
    pioSourceFunds: "",
    pioFundsStatus: "",
    countrySourceFunds: "",
    countryFundsStatus: "",
    marketingConsent: !1,
    belowNotificationHtml: "",
    notificationHtml: "",
    notificationType: void 0,
    title: "",
    icon: ""
  };
}
const Wf = { class: "notification notification--info mb-0" }, Yf = { class: "font-weight-semibold mb-2" }, qf = { class: "mb-4" }, Ay = /* @__PURE__ */ ge({
  __name: "customer-entry-notice-component",
  props: {
    data: { default: Bf }
  },
  emits: ["update:data", "navigationEvent"],
  setup(e, { emit: t }) {
    const s = e, n = t, a = se({ ...s.data }), { t: o } = oe();
    te(
      a,
      async (i) => {
        n("update:data", i);
      },
      { deep: !0 }
    );
    const { sendLinkToCustomer: l } = Gf(a, n);
    return (i, u) => {
      const d = U("v-btn");
      return w(), F("div", Wf, [
        c("div", Yf, P(r(o)(a.needsToEnterIncome ? "PosOrder.CustomerEntryNew" : "PosOrder.CustomerEntryExisting")), 1),
        c("div", qf, P(r(o)("PosOrder.CustomerEntryClick")), 1),
        m(d, {
          class: "btn btn--default-fill btn--sm",
          onClick: r(l)
        }, {
          default: E(() => [
            Ie(P(r(o)("PosOrder.CustomerEntry")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]);
    };
  }
}), Hf = { class: "contract-final-terms" }, Qf = { key: 0 }, wy = /* @__PURE__ */ ge({
  __name: "contract-final-terms-component",
  props: {
    data: { default: null },
    display: { type: Boolean },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["close", "accept"],
  setup(e, { emit: t }) {
    const s = e, { t: n } = oe(), a = G(() => s.data);
    function o(l) {
      return typeof l == "number" ? new Intl.NumberFormat("sl-SI", { style: "currency", currency: "EUR" }).format(l) : "";
    }
    return (l, i) => {
      var u, d, p, y, f, _;
      return w(), F(Ae, null, [
        c("dl", Hf, [
          c("dt", null, P(r(n)("PosOrder.Product")), 1),
          c("dd", null, P((u = a.value) == null ? void 0 : u.akcijaNaziv), 1),
          c("dt", null, P(r(n)("PosOrder.Installments")), 1),
          c("dd", null, P((d = a.value) == null ? void 0 : d.installmentNr), 1),
          c("dt", null, P(r(n)("PosOrder.MonthlyPayment")), 1),
          c("dd", null, P(o((p = a.value) == null ? void 0 : p.installmentVal)), 1),
          i[0] || (i[0] = c("dt", null, "EOM", -1)),
          c("dd", null, P((y = a.value) == null ? void 0 : y.EOM) + " %", 1),
          c("dt", null, P(r(n)("PosOrder.Total")), 1),
          c("dd", null, P(o((f = a.value) == null ? void 0 : f.amountTotal)), 1)
        ]),
        (_ = a.value) != null && _.isOverridenProduct ? (w(), F("p", Qf, P(r(n)("PosOrder.ProductChanged")), 1)) : B("", !0)
      ], 64);
    };
  }
}), Kf = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Icon'%3e%3cpath%20id='Vector'%20d='M12%204L4%2012'%20stroke='%23230078'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M4%204L12%2012'%20stroke='%23404245'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e", Zf = { class: "flow-header-component" }, Jf = { class: "flow-header" }, Xf = { class: "flow-header__title" }, ky = /* @__PURE__ */ ge({
  __name: "flow-header-component",
  props: {
    title: {},
    closeLabel: {},
    closeHref: { default: "" }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const s = t;
    function n(a) {
      a.ctrlKey || a.metaKey || a.shiftKey || a.altKey || a.button !== 0 || (a.preventDefault(), s("close"));
    }
    return (a, o) => {
      const l = U("v-btn");
      return w(), F("header", Zf, [
        c("div", Jf, [
          c("h1", Xf, P(a.title), 1),
          a.closeLabel ? (w(), ce(l, {
            key: 0,
            class: "flow-header__close",
            "aria-label": a.closeLabel,
            href: a.closeHref || void 0,
            onClick: n
          }, {
            default: E(() => o[0] || (o[0] = [
              c("img", {
                src: Kf,
                alt: ""
              }, null, -1)
            ])),
            _: 1
          }, 8, ["aria-label", "href"])) : B("", !0)
        ])
      ]);
    };
  }
});
function Df(e) {
  const t = ue("navigationButtonsApi", null);
  async function s() {
    await ae(), e.notificationType == Ce.Error ? e.errorPage != null && e.errorPage != "" && (console.log("Navigating to", e.errorPage), window.location.replace(e.errorPage)) : e.successPage != null && e.successPage != "" && (console.log("Navigating to", e.successPage), window.location.replace(e.successPage));
  }
  async function n() {
    t == null || t.setButtonVisible("BackToStore", !1), e.notificationType == Ce.Error ? e.errorPage != null && e.errorPage != "" && (t == null || t.setButtonVisible("BackToStore", !0)) : e.successPage != null && e.successPage != "" && (t == null || t.setButtonVisible("BackToStore", !0)), await ae();
  }
  return {
    backToStore: s,
    initButtons: n
  };
}
const ep = { class: "order-end-component" }, tp = { class: "section-heading mt-0" }, rp = ["innerHTML"], np = ["innerHTML"], op = ["innerHTML"], Oy = /* @__PURE__ */ ge({
  __name: "order-end-component",
  props: {
    data: { default: ts }
  },
  emits: ["update:data"],
  setup(e, { expose: t, emit: s }) {
    const { t: n, te: a } = oe(), o = e, l = s, i = se({ ...o.data });
    te(
      () => o.data,
      // Watch for changes in the data
      (p) => {
        Object.assign(i, p);
      },
      { deep: !0 }
    ), te(
      i,
      async (p) => {
        l("update:data", p);
      },
      { deep: !0 }
    );
    const {
      initButtons: u,
      backToStore: d
    } = Df(i);
    return Se(async () => {
      await u();
    }), t({
      backToStore: d
    }), (p, y) => {
      const f = U("v-icon");
      return w(), F("div", ep, [
        m(f, {
          icon: i.icon != "" ? "custom:" + i.icon : "custom:iconContractEndFail",
          class: "mt-4 mb-2"
        }, null, 8, ["icon"]),
        c("h2", tp, P(r(a)(i.title) ? r(n)(i.title) : i.title), 1),
        i.aboveNotificationHtml ? (w(), F("div", {
          key: 0,
          innerHTML: r(a)(i.aboveNotificationHtml) ? r(n)(i.aboveNotificationHtml) : i.aboveNotificationHtml,
          class: "indigo-100"
        }, null, 8, rp)) : B("", !0),
        i.notificationHtml ? (w(), F("div", {
          key: 1,
          class: ke(`notification notification--${i.notificationType ?? "notice"}`)
        }, [
          i.notificationHtml ? (w(), F("div", {
            key: 0,
            innerHTML: r(a)(i.notificationHtml) ? r(n)(i.notificationHtml) : i.notificationHtml,
            class: "font-weight-semibold"
          }, null, 8, np)) : B("", !0)
        ], 2)) : B("", !0),
        i.belowNotificationHtml ? (w(), F("div", {
          key: 2,
          innerHTML: r(a)(i.belowNotificationHtml) ? r(n)(i.belowNotificationHtml) : i.belowNotificationHtml,
          class: "indigo-100"
        }, null, 8, op)) : B("", !0)
      ]);
    };
  }
});
function sp() {
  return {
    flowType: void 0,
    termsAgreement: !1
  };
}
function ip(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    termsAgreement: {
      accepted: V.withMessage(t("GlobalErrors.ChoiceRequired"), Ht(!0))
    }
  })) };
}
function lp(e, t) {
  const { validationRules: s } = ip(), n = Me(s, G(() => e), { $autoDirty: !0 }), { scrollToFirstError: a } = Oe();
  async function o() {
    return n.value.$touch(), !!await n.value.$validate();
  }
  function l() {
    a(t.value);
  }
  return { v$: n, validateForm: o, scrollToFirstErrorWrapper: l };
}
const ap = { class: "" }, up = { class: "" }, dp = {
  target: "_blank",
  href: "https://nlbleasego.si/pravna-vsebina/pogoji-uporabe"
}, cp = { class: "" }, mp = {
  target: "_blank",
  href: "https://nlbleasego.si/pravna-vsebina/varstvo-osebnih-podatkov"
}, Ry = /* @__PURE__ */ ge({
  __name: "terms-and-conditions-component",
  props: {
    data: { default: sp },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = se(zt(n.data)), i = X(null), u = X(!1);
    Be();
    const { v$: d, validateForm: p, scrollToFirstErrorWrapper: y } = lp(l, i);
    return te(() => n.data, (f) => {
      Ur(f, l) || Object.assign(l, zt(f));
    }, { deep: !0 }), te(l, (f) => {
      Ur(f, n.data) || a("update:data", zt(f));
    }, { deep: !0 }), Se(() => {
      u.value = !0, a("componentReady");
    }), t({
      componentReady: u,
      validateForm: p,
      scrollToFirstErrorWrapper: y
    }), (f, _) => {
      const b = U("v-checkbox"), g = U("v-col"), h = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: i,
        class: "terms-and-conditions-component"
      }, [
        m(h, null, {
          default: E(() => [
            m(g, null, {
              default: E(() => {
                var v;
                return [
                  m(b, {
                    modelValue: l.termsAgreement,
                    "onUpdate:modelValue": _[0] || (_[0] = (N) => l.termsAgreement = N),
                    "error-messages": r((v = r(d).termsAgreement.$errors[0]) == null ? void 0 : v.$message) ?? "",
                    onFocus: r(d).termsAgreement.$reset
                  }, {
                    label: E(() => [
                      c("div", ap, [
                        c("span", up, P(r(o)("Components.TermsConditionsComponent.TermsAgreement1")), 1),
                        c("a", dp, P(r(o)("Components.TermsConditionsComponent.TermsAgreement2")), 1),
                        c("span", cp, P(r(o)("Components.TermsConditionsComponent.TermsAgreement3")), 1),
                        c("a", mp, P(r(o)("Components.TermsConditionsComponent.TermsAgreement4")), 1),
                        _[1] || (_[1] = Ie(". "))
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error-messages", "onFocus"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512);
    };
  }
});
function fp(e) {
  const t = ue("commClient");
  async function s() {
    if ((e.flowType === Z.WEB || e.flowType === Z.LIMIT || e.flowType === Z.SKLENI_SAM) && (await t.executeMethodAsync("sw.UpdateMarketingData", {
      OrderToken: e.orderToken,
      MarketingConsent: e.marketingConsent
    })).Success !== !0)
      throw new Error("Marketing data update rejected");
    return !0;
  }
  return {
    saveDataToWebOrder: s
  };
}
function pp() {
  return {
    marketingConsent: !1,
    orderToken: "",
    flowType: void 0
  };
}
const vp = {
  key: 0,
  class: "marketing-consent-component",
  ref: "rootRef"
}, gp = { class: "v-row" }, yp = { class: "v-col" }, bp = { class: "v-input__details" }, Cp = { class: "v-messages__message" }, Ip = {
  href: "https://www.nlbleasego.si/pravna-vsebina/varstvo-osebnih-podatkov/splosne-informacije-o-varstvu-osebnih-podatkov",
  target: "_blank"
}, Ly = /* @__PURE__ */ ge({
  __name: "marketing-consent-component",
  props: {
    data: { default: pp }
  },
  emits: ["update:data"],
  setup(e, { expose: t, emit: s }) {
    const { t: n } = oe(), a = e, o = X(!1), l = s, i = se({ ...a.data });
    te(
      () => a.data,
      // Watch for changes in the data
      (d) => {
        Object.assign(i, d);
      },
      { deep: !0 }
    ), te(
      i,
      (d) => {
        l("update:data", d);
      },
      { deep: !0 }
    );
    const { saveDataToWebOrder: u } = fp(i);
    return fo(() => {
      console.log("Marketing consent before mount:", i.marketingConsent), o.value = i.marketingConsent;
    }), t({
      saveDataToWebOrder: u
    }), (d, p) => {
      const y = U("v-checkbox");
      return o.value != !0 ? (w(), F("div", vp, [
        c("div", gp, [
          c("div", yp, [
            m(y, {
              modelValue: i.marketingConsent,
              "onUpdate:modelValue": p[0] || (p[0] = (f) => i.marketingConsent = f),
              label: r(n)("Components.MarketingConsentComponent.MarketingConsent")
            }, null, 8, ["modelValue", "label"]),
            c("div", bp, [
              c("div", Cp, [
                Ie(P(r(n)("Components.MarketingConsentComponent.GeneralInformation")) + " ", 1),
                c("a", Ip, P(r(n)("Components.MarketingConsentComponent.GeneralInformationLink")), 1),
                p[1] || (p[1] = Ie(". "))
              ])
            ])
          ])
        ])
      ], 512)) : B("", !0);
    };
  }
});
function _p() {
  return {
    taxNumber: void 0,
    orderToken: "",
    creditAmount: void 0,
    isCompanyTaxNumber: !1,
    password: "",
    hasUserPassword: !1,
    firstPassword: "",
    repeatPassword: "",
    status: nn.Success,
    flowType: void 0,
    errorText: void 0,
    contractDebt: 0,
    minSalary: 0,
    minCredit: 0,
    preapprovedType: "",
    preapprovedCreditAmount: 0,
    preapprovedInstallmentAmount: 0,
    msisdn: null,
    firstname: "",
    surname: "",
    address: "",
    idNumber: "",
    idNumberCheck: "",
    documentIssuer: "",
    birthCity: "",
    employerName: "",
    employerAddress: "",
    TRR: "",
    countrySourceFunds: "",
    countryFundsStatus: "",
    email: "",
    citizen: void 0,
    postalCode: void 0,
    employerPostCode: void 0,
    hasPermanentResidenceInSlovenia: void 0,
    isSlovenianCitizen: void 0,
    hasSlovenianIncome: void 0,
    hasSlovenianBankAccount: void 0,
    permanentValidity: void 0,
    isPoliticallyExposedPerson: void 0,
    birthdate: null,
    issueDate: null,
    validityDate: null,
    personalDocumentType: void 0,
    employmentType: void 0,
    isExistingUser: !1,
    isPreapproved: !1,
    isEmailVerified: !1,
    identificationConfirmation: !1,
    belowNotificationHtml: "",
    notificationType: void 0,
    title: "",
    needsToEnterIncome: !0,
    numberOfPrefilledSalaries: 0,
    marketingConsent: !1,
    isViewDataLoading: !1,
    lastMonthsIncome: void 0,
    lastMonthsIncome2: void 0,
    lastMonthsIncome3: void 0,
    hasMultipleProducts: !1
  };
}
function hp() {
  return {
    serverError: "",
    externalResults: {}
  };
}
function Tp(e, t) {
  const { t: s } = oe();
  return G(() => ({
    password: {
      requiredIf: V.withMessage(s("GlobalErrors.FieldRequired"), ve(() => e.hasUserPassword))
    },
    firstPassword: {
      requiredIf: V.withMessage(s("GlobalErrors.FieldRequired"), ve(() => !e.hasUserPassword)),
      complexPassword: V.withMessage(s("GlobalErrors.PasswordComplex"), () => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(e.firstPassword) || e.hasUserPassword)
    },
    repeatPassword: {
      requiredIf: V.withMessage(s("GlobalErrors.FieldRequired"), ve(() => !e.hasUserPassword)),
      matches: V.withMessage(s("GlobalErrors.PasswordNotMatch"), () => e.firstPassword == e.repeatPassword || e.hasUserPassword)
    }
  }));
}
function Ep(e, t, s) {
  const { t: n } = oe(), a = ue("commClient"), o = Me(Tp(e), G(() => e), { $autoDirty: !0, $externalResults: t.externalResults }), { scrollToFirstError: l } = Oe();
  async function i() {
    return o.value.$touch(), await o.value.$validate();
  }
  async function u() {
    let f = !1;
    if (e.hasUserPassword) {
      e.isViewDataLoading = !0;
      const _ = await a.executeMethodAsync("LoginNewFlow", {
        Password: e.password,
        OrderToken: e.orderToken
      });
      if (e.isViewDataLoading = !1, _.Success)
        f = !0;
      else
        switch (_.Error) {
          case "InvalidLogin":
            return t.externalResults.password = n(`GlobalErrors.${_.Error}`), "";
          case "MsisdnMoreThanOneTaxNumber":
          case "MsisdnNotExists":
          case "ProcessError":
            return e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = _.Error, "end";
        }
    }
    if (!e.hasUserPassword || f) {
      const _ = await a.executeMethodAsync("sw.UserDataLoadNewFlow", {
        OrderToken: e.orderToken
      });
      return _.birthdate != null && _.birthdate != "" && (_.birthdate = new Date(_.birthdate)), _.issueDate != null && _.issueDate != "" && (_.issueDate = new Date(_.issueDate)), _.permanentValidity === !0 ? _.validityDate = null : _.validityDate != null && _.validityDate != "" && (_.validityDate = new Date(_.validityDate)), Pe(e, _), e.isPreapproved || e.isExistingUser ? e.hasMultipleProducts ? (console.log("multi product flow"), "installmentPlanMulti") : (console.log("single product flow"), "installmentPlan") : "precheck";
    }
    return "";
  }
  async function d() {
    await y().then((f) => {
      f != null && s("navigationEvent", f);
    }).catch((f) => console.log(f));
  }
  function p() {
    l(".password-component");
  }
  async function y() {
    let f = null;
    return await i() && await u().then((b) => {
      f = b;
    }), f;
  }
  return {
    v$: o,
    DoLoginWithEnter: d,
    doLogin: y,
    scrollToFirstErrorWrapper: p
  };
}
const Np = {
  class: "password-component",
  ref: "rootRef"
}, Sp = { class: "notification notification--notice" }, Pp = { class: "font-weight-600" }, $p = { key: 0 }, Mp = { key: 1 }, Ap = { class: "form-label" }, wp = {
  key: 0,
  class: "v-input__details"
}, kp = { class: "v-messages" }, Op = { class: "v-messages__message error" }, Rp = {
  key: 1,
  class: "panel__footer mt-10"
}, Lp = { class: "panel__footer-text d-sm-flex" }, xp = { key: 1 }, Fp = { class: "mb-4" }, Vp = { class: "form-label" }, zp = { class: "form-label" }, xy = /* @__PURE__ */ ge({
  __name: "login-password-component",
  props: {
    data: { default: () => ({
      ..._p()
    }) }
  },
  emits: ["update:data", "navigationEvent", "componentReady"],
  setup(e, { expose: t, emit: s }) {
    const { smAndDown: n } = sn(), a = e, o = s;
    let l = X(!1);
    const i = se({ ...a.data }), { t: u } = oe(), d = se(hp()), { v$: p, doLogin: y, DoLoginWithEnter: f, scrollToFirstErrorWrapper: _ } = Ep(i, d, o);
    te(
      () => a.data,
      // Watch for changes in the data
      (g) => {
        Object.assign(i, g);
      },
      { deep: !0 }
    ), te(
      i,
      (g) => {
        o("update:data", g);
      },
      { deep: !0 }
    ), Se(async () => {
      l.value = !0, o("componentReady");
    }), t({
      doLogin: y,
      componentReady: l,
      scrollToFirstErrorWrapper: _
    });
    const b = X(!1);
    return (g, h) => {
      const v = U("v-text-field"), N = U("router-link"), $ = U("v-col"), S = U("v-row");
      return w(), F("div", Np, [
        c("h2", {
          class: ke(["section-heading", { "mt-2": r(n) }])
        }, P(r(u)("Components.LoginPasswordComponent.Title")), 3),
        c("div", Sp, [
          c("span", Pp, P(i.hasUserPassword ? r(u)("Components.LoginPasswordComponent.NoticeWithPassword") : r(u)("Components.LoginPasswordComponent.NoticeWithoutPassword")), 1),
          i.hasUserPassword ? B("", !0) : (w(), F("br", $p)),
          i.hasUserPassword ? B("", !0) : (w(), F("br", Mp)),
          Ie(" " + P(i.hasUserPassword ? "" : r(u)("Components.LoginPasswordComponent.NoticeWithoutPasswordText")), 1)
        ]),
        i.hasUserPassword ? (w(), ce(S, { key: 0 }, {
          default: E(() => [
            m($, {
              onKeydown: h[2] || (h[2] = qr((I) => r(f)(), ["enter"])),
              class: "v-col-12 v-col-md-6"
            }, {
              default: E(() => [
                c("div", null, [
                  c("label", Ap, P(r(u)("Components.LoginPasswordComponent.Password")), 1),
                  m(v, {
                    modelValue: i.password,
                    "onUpdate:modelValue": h[0] || (h[0] = (I) => i.password = I),
                    "error-messages": r(p).password.$errors[0] != null ? r(p).password.$errors[0].$message : "",
                    onFocus: r(p).password.$reset,
                    autofocus: "",
                    variant: "outlined",
                    "append-inner-icon": b.value ? "custom:iconPasswordVisible" : "custom:iconPasswordNotVisible",
                    type: b.value ? "text" : "password",
                    "onClick:appendInner": h[1] || (h[1] = (I) => b.value = !b.value),
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "append-inner-icon", "type"])
                ]),
                d.serverError !== "" ? (w(), F("div", wp, [
                  c("div", kp, [
                    c("div", Op, P(d.serverError), 1)
                  ])
                ])) : B("", !0),
                i.flowType == r(Z).WEB || i.flowType == r(Z).SKLENI_SAM || i.flowType == r(Z).LIMIT ? (w(), F("div", Rp, [
                  c("div", Lp, [
                    i.flowType == r(Z).LIMIT ? (w(), ce(N, {
                      key: 0,
                      to: { name: "LimitPassworResetTaxNum" }
                    }, {
                      default: E(() => h[7] || (h[7] = [
                        c("div", { class: "btn-link mr-6" }, " Ste pozabili svoje geslo? ", -1)
                      ])),
                      _: 1
                    })) : (w(), ce(N, {
                      key: 1,
                      to: { name: "PassworResetTaxNum" }
                    }, {
                      default: E(() => h[8] || (h[8] = [
                        c("div", { class: "btn-link mr-6" }, " Ste pozabili svoje geslo? ", -1)
                      ])),
                      _: 1
                    }))
                  ])
                ])) : B("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : (w(), F("div", xp, [
          m(S, null, {
            default: E(() => [
              m($, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => [
                  c("div", Fp, [
                    c("label", Vp, P(r(u)("Components.LoginPasswordComponent.NewPassword")), 1),
                    m(v, {
                      modelValue: i.firstPassword,
                      "onUpdate:modelValue": h[3] || (h[3] = (I) => i.firstPassword = I),
                      variant: "outlined",
                      hint: r(u)("Components.LoginPasswordComponent.PasswordHint"),
                      "persistent-hint": "",
                      "error-messages": r(p).firstPassword.$errors[0] != null ? r(p).firstPassword.$errors[0].$message : "",
                      onFocus: r(p).firstPassword.$reset,
                      "append-inner-icon": b.value ? "custom:iconPasswordVisible" : "custom:iconPasswordNotVisible",
                      type: b.value ? "text" : "password",
                      "onClick:appendInner": h[4] || (h[4] = (I) => b.value = !b.value),
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "hint", "error-messages", "onFocus", "append-inner-icon", "type"])
                  ]),
                  c("div", null, [
                    c("label", zp, P(r(u)("Components.LoginPasswordComponent.RepeatPassword")), 1),
                    m(v, {
                      modelValue: i.repeatPassword,
                      "onUpdate:modelValue": h[5] || (h[5] = (I) => i.repeatPassword = I),
                      "error-messages": r(p).repeatPassword.$errors[0] != null ? r(p).repeatPassword.$errors[0].$message : "",
                      onFocus: r(p).repeatPassword.$reset,
                      variant: "outlined",
                      "append-inner-icon": b.value ? "custom:iconPasswordVisible" : "custom:iconPasswordNotVisible",
                      type: b.value ? "text" : "password",
                      "onClick:appendInner": h[6] || (h[6] = (I) => b.value = !b.value),
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "error-messages", "onFocus", "append-inner-icon", "type"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      ], 512);
    };
  }
});
function jp() {
  return {
    creditAmount: void 0,
    proformaFile: [],
    isVehiclesFinancing: !1,
    flowType: void 0,
    proformaPartnerType: "",
    belowNotificationHtml: "",
    notificationHtml: "",
    notificationType: void 0,
    title: "",
    icon: "",
    isViewDataLoading: !1
  };
}
function Up() {
  return {
    PartnerName: "",
    AvtoBroker: !1
  };
}
function Gp(e, t) {
  const { t: s } = oe();
  return G(() => ({
    creditAmount: {
      required: V.withMessage(s("GlobalErrors.FieldRequired"), ye),
      minValue: V.withMessage(s("GlobalErrors.MinValue", { value: "100,00" }), Vt(100)),
      maxValue: V.withMessage(s("GlobalErrors.MaxValue", { value: "15.000,00" }), Qo(15e3))
    },
    proformaFile: {
      required: V.withMessage(s("GlobalErrors.FileAdd"), () => e.proformaFile.length > 0)
    },
    isVehiclesFinancing: {
      custom: V.withMessage(s("GlobalErrors.ChoiceRequired"), (n) => !t.AvtoBroker || n === !0)
    }
  }));
}
function Bp(e, t) {
  const s = ue("commClient"), n = Me(Gp(e, t), G(() => e), { $autoDirty: !0 }), { scrollToFirstError: a } = Oe();
  async function o() {
    return n.value.$touch(), n.value.$validate();
  }
  function l() {
    a(".proforma-payment-component");
  }
  async function i() {
    e.isViewDataLoading = !0;
    let d = "";
    e.proformaFile.length > 0 && (d.length > 0 && (d += ";"), d += e.proformaFile.map((y) => y.FileId).join(";"));
    const p = await s.executeMethodAsync("CreateWebOrderSupplier", {
      ProformaInvoice: d,
      Amount: e.creditAmount,
      DobType: e.proformaPartnerType
    });
    return e.isViewDataLoading = !1, p.Success ? { name: "nextStep", params: { id: p.OrderToken } } : (e.title = "GlobalErrors.Error", e.notificationType = Ce.Error, e.belowNotificationHtml = "Components.ProformaComponent.ProcessFailed", { name: "endFail" });
  }
  async function u() {
    if (console.log("Loading proforma data for partner type:", e.proformaPartnerType), e.proformaPartnerType != null && e.proformaPartnerType !== "") {
      e.isViewDataLoading = !0;
      const d = await s.executeMethodAsync("sw.ProformaDataLoad", {
        DobType: e.proformaPartnerType
      });
      d && (t.PartnerName = d.PartnerName, t.AvtoBroker = d.AvtoBroker), e.isViewDataLoading = !1;
    } else
      t.PartnerName = "", t.AvtoBroker = !0;
    return !0;
  }
  return {
    v$: n,
    validateForm: o,
    startProformaPayment: i,
    loadProformaData: u,
    scrollToFirstErrorWrapper: l
  };
}
const Wp = {
  class: "proforma-invoice-component",
  ref: "rootRef"
}, Yp = { class: "form-label" }, qp = { class: "form-label" }, Hp = { class: "" }, Fy = /* @__PURE__ */ ge({
  __name: "proforma-payment-component",
  props: {
    data: { default: jp }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: s }) {
    const { t: n } = oe(), a = e, o = s;
    let l = X(!1);
    const i = se(Up()), u = se({ ...a.data }), { v$: d, validateForm: p, startProformaPayment: y, loadProformaData: f, scrollToFirstErrorWrapper: _ } = Bp(u, i);
    return te(
      () => a.data,
      // Watch for changes in the data
      (b) => {
        Object.assign(u, b);
      },
      { deep: !0 }
    ), te(
      u,
      (b) => {
        o("update:data", b);
      },
      { deep: !0 }
    ), Se(async () => {
      await f(), l.value = !0, o("componentReady");
    }), t({
      validateForm: p,
      startProformaPayment: y,
      scrollToFirstErrorWrapper: _,
      componentReady: l
    }), (b, g) => {
      const h = U("v-col"), v = U("v-row"), N = U("v-checkbox");
      return w(), F("div", Wp, [
        m(v, null, {
          default: E(() => [
            m(h, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                c("label", Yp, P(r(n)("Components.ProformaPaymentComponent.CreditAmount")), 1),
                m(Ke, {
                  ref: "creditAmountRef",
                  modelValue: u.creditAmount,
                  "onUpdate:modelValue": g[0] || (g[0] = ($) => u.creditAmount = $),
                  numberOfDecimals: 2,
                  appendText: "EUR",
                  "error-messages": r(d).creditAmount.$errors[0] != null ? r(d).creditAmount.$errors[0].$message : "",
                  formatNumber: ($, S) => $.toLocaleString("sl-SI", { minimumFractionDigits: S, maximumFractionDigits: S })
                }, null, 8, ["modelValue", "error-messages", "formatNumber"])
              ]),
              _: 1
            }),
            m(h, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                c("label", qp, P(r(n)("Components.ProformaPaymentComponent.FileUpload")), 1),
                m(Jo, {
                  modelValue: u.proformaFile,
                  "onUpdate:modelValue": g[1] || (g[1] = ($) => u.proformaFile = $),
                  error: r(d).proformaFile.$error,
                  errorText: r(d).proformaFile.$errors[0] != null ? r(d).proformaFile.$errors : [],
                  infoText: b.$t("Components.ProformaPaymentComponent.Files")
                }, null, 8, ["modelValue", "error", "errorText", "infoText"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        i.AvtoBroker ? (w(), ce(v, { key: 0 }, {
          default: E(() => [
            m(h, null, {
              default: E(() => [
                c("div", Hp, [
                  m(N, {
                    modelValue: u.isVehiclesFinancing,
                    "onUpdate:modelValue": g[2] || (g[2] = ($) => u.isVehiclesFinancing = $),
                    "error-messages": r(d).isVehiclesFinancing.$errors[0] != null ? r(d).isVehiclesFinancing.$errors[0].$message : "",
                    onFocus: r(d).isVehiclesFinancing.$reset,
                    label: r(n)("Components.ProformaPaymentComponent.VechilesFinancing")
                  }, null, 8, ["modelValue", "error-messages", "onFocus", "label"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0)
      ], 512);
    };
  }
});
function Qp() {
  return {
    amountEOM0: void 0,
    amountWithoutInterest: void 0,
    amountWithInterest: void 0,
    documentNumber: "",
    apiAuthToken: "",
    orderToken: ""
  };
}
function Kp() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function Zp(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    amountEOM0: {
      minValue: V.withMessage(
        t("Components.StartOrderComponent.AmountNonNegative"),
        Vt(0)
      ),
      atLeastOneAmount: V.withMessage(
        t("Components.StartOrderComponent.AtLeastOneAmount"),
        () => [
          e.amountEOM0,
          e.amountWithoutInterest,
          e.amountWithInterest
        ].some((n) => typeof n == "number" && Number.isFinite(n) && n > 0)
      )
    },
    amountWithoutInterest: {
      minValue: V.withMessage(
        t("Components.StartOrderComponent.AmountNonNegative"),
        Vt(0)
      )
    },
    amountWithInterest: {
      minValue: V.withMessage(
        t("Components.StartOrderComponent.AmountNonNegative"),
        Vt(0)
      )
    },
    documentNumber: {
      required: V.withMessage(
        t("GlobalErrors.FieldRequired"),
        ye
      )
    }
  })) };
}
function Jp(e, t, s, n) {
  const a = ue("commClient"), { validationRules: o } = Zp(e), l = Me(
    o,
    G(() => e),
    {
      $autoDirty: !0,
      $externalResults: t.externalResults
    }
  ), { scrollToFirstError: i } = Oe();
  async function u() {
    if (e.apiAuthToken)
      return !0;
    try {
      const f = await a.executeMethodAsync(
        "ApiOrderAuthenticate",
        {}
      );
      return (f == null ? void 0 : f.Result) !== "OK" || !f.AuthToken ? (console.error(
        "API Order authentication failed:",
        (f == null ? void 0 : f.Message) ?? "No response"
      ), !1) : (e.apiAuthToken = f.AuthToken, console.log("API Order Auth Token:", f.AuthToken), n("update:data", { ...e }), console.log("API Order Authentication:", {
        Result: f.Result,
        HasAuthToken: !!f.AuthToken
      }), !0);
    } catch (f) {
      return console.error("API Order authentication error:", f), !1;
    }
  }
  async function d() {
    if (t.isDataLoading)
      return !1;
    t.isDataLoading = !0, t.message = "";
    try {
      if (!e.apiAuthToken && !await u())
        return t.message = "API avtentikacija ni uspela.", !1;
      const f = await a.executeMethodAsync(
        "ApiOrderStartOrder",
        {
          AmountWithInterest: e.amountWithInterest ?? 0,
          AmountWithoutInterest: e.amountWithoutInterest ?? 0,
          AmountEOM0: e.amountEOM0 ?? 0,
          InvoiceNr: e.documentNumber,
          ApiAuthToken: e.apiAuthToken
        }
      );
      return (f == null ? void 0 : f.Result) !== "OK" || !f.OrderToken ? (t.message = (f == null ? void 0 : f.Message) || "Napaka pri začetku naročila.", !1) : (e.orderToken = f.OrderToken, n("update:data", { ...e }), console.log("API Order StartOrder:", {
        Result: f.Result,
        HasOrderToken: !!f.OrderToken
      }), !0);
    } catch (f) {
      return console.error("API Order StartOrder error:", f), t.message = "Napaka pri povezavi s strežnikom.", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function p() {
    return l.value.$touch(), await l.value.$validate() ? await d() : !1;
  }
  function y() {
    i(s.value);
  }
  return Se(() => {
    u();
  }), {
    v$: l,
    authenticate: u,
    validateForm: p,
    scrollToFirstErrorWrapper: y,
    startOrder: d
  };
}
const Xp = { class: "section-heading" }, Dp = ["for"], ev = ["for"], tv = ["for"], rv = ["for"], nv = {
  key: 0,
  class: "notification notification--warning",
  role: "alert"
}, Vy = /* @__PURE__ */ ge({
  __name: "start-order-component",
  props: {
    data: { default: Qp }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = Be(), i = se({ ...n.data }), u = se(Kp()), d = X(null), p = X(!1);
    te(
      () => n.data,
      (b) => {
        Object.assign(i, b);
      },
      { deep: !0 }
    ), te(
      i,
      (b) => {
        a("update:data", b);
      },
      { deep: !0 }
    ), Se(() => {
      p.value = !0, a("componentReady");
    });
    const {
      v$: y,
      validateForm: f,
      scrollToFirstErrorWrapper: _
    } = Jp(i, u, d, a);
    return t({
      componentReady: p,
      validateForm: f,
      scrollToFirstErrorWrapper: _
    }), (b, g) => {
      const h = U("v-text-field"), v = U("v-col"), N = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: d,
        class: "start-order-component"
      }, [
        c("h2", Xp, P(r(o)("Components.StartOrderComponent.Title")), 1),
        m(N, null, {
          default: E(() => [
            m(v, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var $;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(l) + "-amountEOM0",
                      class: "form-label"
                    }, P(r(o)("Components.StartOrderComponent.amountEOM0")), 9, Dp),
                    m(h, {
                      id: r(l) + "-amountEOM0",
                      modelValue: i.amountEOM0,
                      "onUpdate:modelValue": g[0] || (g[0] = (S) => i.amountEOM0 = S),
                      modelModifiers: { number: !0 },
                      type: "number",
                      min: "0",
                      step: "0.01",
                      variant: "outlined",
                      autocomplete: "off",
                      error: r(y).amountEOM0.$error,
                      "error-messages": (($ = r(y).amountEOM0.$errors[0]) == null ? void 0 : $.$message) ?? "",
                      onFocus: g[1] || (g[1] = (S) => r(y).amountEOM0.$reset())
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(N, null, {
          default: E(() => [
            m(v, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var $;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(l) + "-amountWithoutInterest",
                      class: "form-label"
                    }, P(r(o)("Components.StartOrderComponent.amountWithoutInterest")), 9, ev),
                    m(h, {
                      id: r(l) + "-amountWithoutInterest",
                      modelValue: i.amountWithoutInterest,
                      "onUpdate:modelValue": g[2] || (g[2] = (S) => i.amountWithoutInterest = S),
                      modelModifiers: { number: !0 },
                      type: "number",
                      min: "0",
                      step: "0.01",
                      variant: "outlined",
                      autocomplete: "off",
                      error: r(y).amountWithoutInterest.$error,
                      "error-messages": (($ = r(y).amountWithoutInterest.$errors[0]) == null ? void 0 : $.$message) ?? "",
                      onFocus: g[3] || (g[3] = (S) => r(y).amountWithoutInterest.$reset())
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(N, null, {
          default: E(() => [
            m(v, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var $;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(l) + "-amountWithInterest",
                      class: "form-label"
                    }, P(r(o)("Components.StartOrderComponent.amountWithInterest")), 9, tv),
                    m(h, {
                      id: r(l) + "-amountWithInterest",
                      modelValue: i.amountWithInterest,
                      "onUpdate:modelValue": g[4] || (g[4] = (S) => i.amountWithInterest = S),
                      modelModifiers: { number: !0 },
                      type: "number",
                      min: "0",
                      step: "0.01",
                      variant: "outlined",
                      autocomplete: "off",
                      error: r(y).amountWithInterest.$error,
                      "error-messages": (($ = r(y).amountWithInterest.$errors[0]) == null ? void 0 : $.$message) ?? "",
                      onFocus: g[5] || (g[5] = (S) => r(y).amountWithInterest.$reset())
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(N, null, {
          default: E(() => [
            m(v, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var $;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(l) + "-documentNumber",
                      class: "form-label"
                    }, P(r(o)("Components.StartOrderComponent.documentNumber")), 9, rv),
                    m(be, {
                      id: r(l) + "-documentNumber",
                      modelValue: i.documentNumber,
                      "onUpdate:modelValue": g[6] || (g[6] = (S) => i.documentNumber = S),
                      variant: "outlined",
                      autocomplete: "off",
                      error: r(y).documentNumber.$error,
                      "error-messages": (($ = r(y).documentNumber.$errors[0]) == null ? void 0 : $.$message) ?? "",
                      onFocus: g[7] || (g[7] = (S) => r(y).documentNumber.$reset())
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        u.message ? (w(), F("div", nv, P(u.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function ov() {
  return {
    taxNumber: void 0,
    prefix: void 0,
    phoneNumber: "",
    code: "",
    orderToken: "",
    isPhoneVerified: !1,
    isExistingUser: !1,
    apiAuthToken: ""
  };
}
function sv() {
  return {
    externalResults: {},
    isDataLoading: !1,
    isCodeSent: !1,
    message: ""
  };
}
function iv(e) {
  const { t } = oe();
  function s() {
    var a;
    return ((a = e.code) == null ? void 0 : a.length) === 4;
  }
  return { validationRules: G(() => ({
    taxNumber: {
      required: V.withMessage(
        t("GlobalErrors.FieldRequired"),
        ye
      ),
      format: V.withMessage(
        t("GlobalErrors.InvalidTax"),
        Xo
      )
    },
    prefix: {
      required: V.withMessage(
        t("GlobalErrors.FieldRequired"),
        ye
      )
    },
    phoneNumber: {
      required: V.withMessage(
        t("GlobalErrors.FieldRequired"),
        ye
      ),
      format: V.withMessage(
        t("GlobalErrors.InvalidValue"),
        (a) => /^\d{8,12}$/.test(a)
      )
    },
    code: {
      required: V.withMessage(
        t("GlobalErrors.FieldRequired"),
        ye
      ),
      customRequired: V.withMessage(
        t("GlobalErrors.FieldRequired"),
        s
      )
    }
  })) };
}
function lv(e, t, s) {
  const { validationRules: n } = iv(e), a = ue("commClient"), o = Me(
    n,
    G(() => e),
    {
      $autoDirty: !0,
      $externalResults: t.externalResults
    }
  ), { scrollToFirstError: l } = Oe(), i = ue("generalStore"), u = G(
    () => (i == null ? void 0 : i.state.countryPhoneList) ?? []
  );
  function d() {
    e.prefix === void 0 && (e.prefix = u.value.find(
      (C) => String(C.Key).replace(/\D/g, "") === "386"
    )), t.isCodeSent = e.isPhoneVerified;
  }
  function p() {
    var A;
    const C = String(((A = e.prefix) == null ? void 0 : A.Key) ?? "").replace(/\D/g, ""), T = e.phoneNumber.replace(/^0+/, "");
    return "+" + C + T;
  }
  async function y() {
    const C = ["taxNumber", "prefix", "phoneNumber"];
    return (await Promise.all(
      C.map((A) => o.value[A].$validate())
    )).every((A) => A === !0);
  }
  async function f() {
    return await o.value.code.$validate();
  }
  async function _() {
    o.value.$touch();
    const C = await o.value.$validate();
    return e.isPhoneVerified ? C : (t.message = "Najprej potrdite mobilno številko z OTP kodo.", !1);
  }
  function b() {
    l(s.value);
  }
  function g() {
    e.code = "", e.isPhoneVerified = !1, e.isExistingUser = !1, t.isCodeSent = !1, t.isDataLoading = !1, t.message = "", t.externalResults.code = [], o.value.$reset();
  }
  function h() {
    e.code = "", e.isPhoneVerified = !1, e.isExistingUser = !1, t.isCodeSent = !0, t.isDataLoading = !1, t.message = "";
  }
  function v(C) {
    e.isPhoneVerified = !0, e.isExistingUser = C, t.isDataLoading = !1, t.message = "", t.externalResults.code = [];
  }
  function N(C) {
    t.isDataLoading = C;
  }
  function $(C) {
    t.message = C, t.isDataLoading = !1;
  }
  async function S() {
    if (t.isDataLoading)
      return !1;
    if (t.message = "", !e.apiAuthToken)
      return t.message = "Manjka API AuthToken.", !1;
    if (!e.orderToken)
      return t.message = "Manjka OrderToken.", !1;
    t.isDataLoading = !0;
    try {
      const C = await a.executeMethodAsync(
        "ApiOrderCheckVATandMSISDN",
        {
          OrderToken: e.orderToken,
          TaxNumber: e.taxNumber,
          Msisdn: p(),
          ApiAuthToken: e.apiAuthToken
        }
      );
      return (C == null ? void 0 : C.Result) !== "OK" ? (t.message = (C == null ? void 0 : C.Message) || (C == null ? void 0 : C.Result) || "Napaka pri pošiljanju OTP kode.", !1) : (h(), console.log("API Order CheckVATandMSISDN:", {
        Result: C.Result,
        CodeSent: !0
      }), !0);
    } catch (C) {
      return console.error("API Order CheckVATandMSISDN error:", C), t.message = "Napaka pri povezavi s strežnikom.", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function I() {
    if (!t.isCodeSent || t.isDataLoading || e.isPhoneVerified || !await f())
      return !1;
    if (t.message = "", !e.apiAuthToken)
      return t.message = "Manjka API AuthToken.", !1;
    if (!e.orderToken)
      return t.message = "Manjka OrderToken.", !1;
    t.isDataLoading = !0;
    try {
      const C = await a.executeMethodAsync(
        "ApiOrderCheckOTP",
        {
          OrderToken: e.orderToken,
          OTP: e.code,
          ApiAuthToken: e.apiAuthToken
        }
      );
      return (C == null ? void 0 : C.Result) !== "OK" ? (t.message = (C == null ? void 0 : C.Message) || (C == null ? void 0 : C.Result) || "OTP koda ni pravilna.", !1) : typeof C.IsExistingCustomer != "boolean" ? (t.message = "API ni vrnil podatka IsExistingCustomer.", !1) : (v(C.IsExistingCustomer), console.log("API Order CheckOTP:", {
        Result: C.Result,
        IsExistingCustomer: C.IsExistingCustomer,
        IsPhoneVerified: e.isPhoneVerified
      }), !0);
    } catch (C) {
      return console.error("API Order CheckOTP error:", C), t.message = "Napaka pri preverjanju OTP kode.", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  return {
    v$: o,
    countryPhoneList: u,
    InitializeData: d,
    getMsisdn: p,
    validateContact: y,
    validateCode: f,
    validateForm: _,
    scrollToFirstErrorWrapper: b,
    resetVerification: g,
    markCodeSent: h,
    markCodeVerified: v,
    setLoading: N,
    setMessage: $,
    sendCodeApiOrder: S,
    verifyCodeApiOrder: I
  };
}
const av = ["for"], uv = ["for"], dv = { class: "control-phone-wrapper" }, cv = { class: "control-phone-actions" }, mv = {
  key: 0,
  class: "mt-2"
}, fv = ["id"], pv = { class: "d-flex align-center" }, vv = {
  key: 0,
  class: "ml-8"
}, gv = {
  key: 1,
  class: "ml-8"
}, yv = {
  key: 0,
  class: "v-input--error"
}, bv = { class: "v-input__details" }, Cv = {
  class: "v-messages",
  role: "alert"
}, Iv = { class: "v-messages__message" }, _v = {
  key: 1,
  class: "notification notification--warning mt-6",
  role: "alert"
}, zy = /* @__PURE__ */ ge({
  __name: "verification-component",
  props: {
    data: { default: ov }
  },
  emits: ["update:data", "componentReady", "navigationEvent", "sendCodeRequest", "verifyCodeRequest"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, o = Be(), l = se({ ...n.data }), i = se(sv()), u = X(null), d = X(!1), p = X(null), y = X(null);
    te(
      () => n.data,
      (H) => {
        Object.assign(l, H);
      },
      { deep: !0 }
    ), te(
      l,
      (H) => {
        a("update:data", H);
      },
      { deep: !0 }
    );
    const {
      v$: f,
      countryPhoneList: _,
      InitializeData: b,
      validateContact: g,
      validateForm: h,
      scrollToFirstErrorWrapper: v,
      resetVerification: N,
      markCodeSent: $,
      markCodeVerified: S,
      setLoading: I,
      setMessage: C,
      sendCodeApiOrder: T,
      verifyCodeApiOrder: A
    } = lv(l, i, u);
    te(
      () => {
        var H;
        return [
          l.taxNumber,
          (H = l.prefix) == null ? void 0 : H.Key,
          l.phoneNumber
        ];
      },
      () => {
        (i.isCodeSent || l.isPhoneVerified) && N();
      }
    ), Se(() => {
      b(), d.value = !0, a("componentReady");
    });
    function M(H, q) {
      const me = H.target;
      if (!(me instanceof HTMLInputElement))
        return;
      const x = me.value.replace(/[^0-9]/g, "");
      me.value = x, l[q] = x;
    }
    function L(H) {
      var q;
      H.preventDefault(), (q = p.value) == null || q.focus();
    }
    async function z() {
      var H;
      if (!i.isDataLoading) {
        if (i.isCodeSent || l.isPhoneVerified) {
          N(), await ae(), (H = p.value) == null || H.focus();
          return;
        }
        if (!await g()) {
          await ae(), v();
          return;
        }
        await T();
      }
    }
    async function O() {
      await A();
    }
    return t({
      componentReady: d,
      validateForm: h,
      scrollToFirstErrorWrapper: v,
      markCodeSent: $,
      markCodeVerified: S,
      resetVerification: N,
      setLoading: I,
      setMessage: C
    }), (H, q) => {
      const me = U("v-text-field"), x = U("v-col"), ie = U("v-row"), ne = U("v-autocomplete"), J = U("v-btn"), j = U("v-otp-input");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: u,
        class: "verification-component"
      }, [
        q[9] || (q[9] = c("h2", { class: "section-heading" }, " Preverjanje stranke ", -1)),
        m(ie, null, {
          default: E(() => [
            m(x, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Y;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(o) + "-taxNumber",
                      class: "form-label"
                    }, " Davčna številka ", 8, av),
                    m(me, {
                      id: r(o) + "-taxNumber",
                      modelValue: l.taxNumber,
                      "onUpdate:modelValue": q[0] || (q[0] = (re) => l.taxNumber = re),
                      variant: "outlined",
                      autocomplete: "off",
                      inputmode: "numeric",
                      maxlength: 8,
                      disabled: i.isCodeSent,
                      error: r(f).taxNumber.$error,
                      "error-messages": ((Y = r(f).taxNumber.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                      onFocus: q[1] || (q[1] = (re) => r(f).taxNumber.$reset()),
                      onKeydown: qr(L, ["enter"]),
                      onInput: q[2] || (q[2] = (re) => M(re, "taxNumber"))
                    }, null, 8, ["id", "modelValue", "disabled", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(ie, null, {
          default: E(() => [
            m(x, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Y, re;
                return [
                  c("div", null, [
                    c("label", {
                      for: r(o) + "-phoneNumber",
                      class: "form-label"
                    }, " Mobilna številka ", 8, uv),
                    c("div", dv, [
                      m(ne, {
                        id: r(o) + "-prefix",
                        modelValue: l.prefix,
                        "onUpdate:modelValue": q[3] || (q[3] = (fe) => l.prefix = fe),
                        items: r(_),
                        "item-title": "Value",
                        "item-value": "Key",
                        "return-object": "",
                        variant: "outlined",
                        class: "control-phone-country",
                        error: r(f).prefix.$error,
                        "error-messages": ((Y = r(f).prefix.$errors[0]) == null ? void 0 : Y.$message) ?? "",
                        disabled: i.isCodeSent,
                        onFocus: q[4] || (q[4] = (fe) => r(f).prefix.$reset())
                      }, null, 8, ["id", "modelValue", "items", "error", "error-messages", "disabled"]),
                      m(me, {
                        id: r(o) + "-phoneNumber",
                        ref_key: "phoneNumberInputRef",
                        ref: p,
                        modelValue: l.phoneNumber,
                        "onUpdate:modelValue": q[5] || (q[5] = (fe) => l.phoneNumber = fe),
                        class: "control-phone-number",
                        variant: "outlined",
                        autocomplete: "off",
                        inputmode: "numeric",
                        maxlength: 12,
                        readonly: i.isCodeSent,
                        error: r(f).phoneNumber.$error,
                        "error-messages": ((re = r(f).phoneNumber.$errors[0]) == null ? void 0 : re.$message) ?? "",
                        onFocus: q[6] || (q[6] = (fe) => r(f).phoneNumber.$reset()),
                        onInput: q[7] || (q[7] = (fe) => M(fe, "phoneNumber"))
                      }, {
                        "append-inner": E(() => [
                          c("div", cv, [
                            m(J, {
                              class: "btn btn--primary-outline btn--sm",
                              variant: "flat",
                              loading: i.isDataLoading,
                              onClick: z
                            }, {
                              default: E(() => [
                                Ie(P(i.isCodeSent || l.isPhoneVerified ? "Uredi" : "Pošlji"), 1)
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["id", "modelValue", "readonly", "error", "error-messages"])
                    ]),
                    i.isCodeSent && !l.isPhoneVerified ? (w(), F("div", mv, " Koda za potrditev je bila poslana. ")) : B("", !0)
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        i.isCodeSent || l.isPhoneVerified ? (w(), ce(ie, { key: 0 }, {
          default: E(() => [
            m(x, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Y;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(o) + "-code-label",
                      class: "form-label"
                    }, " OTP ", 8, fv),
                    c("div", pv, [
                      m(j, {
                        ref_key: "codeInputRef",
                        ref: y,
                        modelValue: l.code,
                        "onUpdate:modelValue": q[8] || (q[8] = (re) => l.code = re),
                        length: 4,
                        type: "number",
                        "aria-labelledby": r(o) + "-code-label",
                        disabled: !i.isCodeSent || l.isPhoneVerified || i.isDataLoading,
                        error: r(f).code.$error,
                        onFinish: O
                      }, null, 8, ["modelValue", "aria-labelledby", "disabled", "error"]),
                      i.isDataLoading ? (w(), F("span", vv, " Preverjam ... ")) : B("", !0),
                      l.isPhoneVerified ? (w(), F("span", gv, " Potrjeno ")) : B("", !0)
                    ]),
                    r(f).code.$error ? (w(), F("div", yv, [
                      c("div", bv, [
                        c("div", Cv, [
                          c("div", Iv, P((Y = r(f).code.$errors[0]) == null ? void 0 : Y.$message), 1)
                        ])
                      ])
                    ])) : B("", !0)
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0),
        i.message ? (w(), F("div", _v, P(i.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function ao() {
  return {
    hasPermanentResidenceInSlovenia: void 0,
    isSlovenianCitizen: void 0,
    hasSlovenianIncome: void 0,
    hasSlovenianBankAccount: void 0,
    employmentSubType: void 0,
    orderToken: "",
    apiAuthToken: ""
  };
}
function hv() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function Tv(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    hasPermanentResidenceInSlovenia: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    isSlovenianCitizen: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    hasSlovenianIncome: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ye)
    },
    hasSlovenianBankAccount: {
      required: V.withMessage(t("GlobalErrors.ChoiceRequired"), ve(() => e.isSlovenianCitizen === !1))
    }
  })) };
}
function Ev(e, t, s) {
  const { validationRules: n } = Tv(e), a = ue("commClient"), o = Me(
    n,
    G(() => e),
    {
      $autoDirty: !0,
      $externalResults: t.externalResults
    }
  ), { scrollToFirstError: l } = Oe(), { t: i } = oe();
  async function u() {
    return o.value.$touch(), await o.value.$validate();
  }
  function d() {
    l(s.value);
  }
  const p = G(() => {
    const _ = e.hasPermanentResidenceInSlovenia === !1, b = e.hasSlovenianIncome === !1 || e.hasSlovenianBankAccount === !1, g = e.isSlovenianCitizen === !1 && b;
    return _ || g ? i("GlobalErrors.NotEligible") : "";
  });
  async function y(_) {
    e.isSlovenianCitizen !== _.isSlovenianCitizen && (e.isSlovenianCitizen === !1 && (e.employmentSubType = st.AfternoonSP), e.hasSlovenianBankAccount = void 0);
  }
  async function f(_) {
    if (t.isDataLoading)
      return !1;
    if (t.message = "", !e.apiAuthToken || !e.orderToken)
      return t.message = "Manjka API AuthToken ali OrderToken.", !1;
    if (_.employmentType === void 0)
      return t.message = "Manjka tip zaposlitve.", !1;
    const {
      hasPermanentResidenceInSlovenia: b,
      isSlovenianCitizen: g,
      hasSlovenianIncome: h
    } = e;
    if (typeof b != "boolean" || typeof g != "boolean" || typeof h != "boolean")
      return t.message = "Izpolnite vse obvezne podatke.", !1;
    const v = g === !1 ? e.hasSlovenianBankAccount : _.hasSlovenianBankAccount ?? e.hasSlovenianBankAccount ?? !1;
    if (typeof v != "boolean")
      return t.message = "Izberite podatek o slovenskem bančnem računu.", !1;
    t.isDataLoading = !0;
    try {
      const N = await a.executeMethodAsync(
        "ApiOrderPrecheck",
        {
          OrderToken: e.orderToken,
          HasPermanentSloResidence: b,
          IsSlovenianCitizen: g,
          HasSlovenianIncome: h,
          HasSlovenianBankAccount: v,
          EmploymentType: String(_.employmentType),
          ApiAuthToken: e.apiAuthToken
        }
      );
      return (N == null ? void 0 : N.Result) !== "OK" ? (t.message = (N == null ? void 0 : N.Message) || (N == null ? void 0 : N.Result) || "Precheck ni bil uspešen.", !1) : (console.log("API Order Precheck:", {
        Result: N.Result
      }), !0);
    } catch (N) {
      return console.error("API Order Precheck error:", N), t.message = "Napaka pri preverjanju pogojev.", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  return {
    v$: o,
    dataChanged: y,
    validateForm: u,
    scrollToFirstErrorWrapper: d,
    eligibilityError: p,
    executeApiOrderPrecheck: f
  };
}
const Nv = { class: "section-heading" }, Sv = ["id"], Pv = ["id"], $v = ["id"], Mv = ["id"], Av = {
  key: 0,
  class: "notification notification--warning",
  role: "alert"
}, wv = {
  key: 1,
  class: "notification notification--warning",
  role: "alert"
}, jy = /* @__PURE__ */ ge({
  __name: "precheck-component",
  props: {
    data: { default: ao }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = se({ ...n.data }), i = se(hv()), u = se(ao()), d = Be(), p = X(null), y = X(!1), {
      v$: f,
      dataChanged: _,
      scrollToFirstErrorWrapper: b,
      eligibilityError: g,
      validateForm: h,
      executeApiOrderPrecheck: v
    } = Ev(l, i, p);
    return te(
      () => n.data,
      (N) => {
        N && Object.assign(l, N);
      },
      { deep: !0 }
    ), te(
      l,
      async (N) => {
        await _(u), Object.assign(u, N), a("update:data", { ...N });
      },
      { deep: !0 }
    ), Se(() => {
      y.value = !0, a("componentReady");
    }), t({
      componentReady: y,
      validateForm: h,
      scrollToFirstErrorWrapper: b,
      executeApiOrderPrecheck: v
    }), (N, $) => {
      const S = U("v-radio"), I = U("v-radio-group"), C = U("v-col"), T = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: p,
        class: "precheck-component"
      }, [
        c("h2", Nv, P(r(o)("Components.PrecheckComponent.Title")), 1),
        m(T, null, {
          default: E(() => [
            m(C, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var A;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-hasPermanentResidenceInSlovenia-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.PrecheckComponent.hasPermanentResidenceInSlovenia")), 9, Sv),
                    m(I, {
                      modelValue: l.hasPermanentResidenceInSlovenia,
                      "onUpdate:modelValue": $[0] || ($[0] = (M) => l.hasPermanentResidenceInSlovenia = M),
                      "aria-labelledby": r(d) + "-hasPermanentResidenceInSlovenia-label",
                      error: r(f).hasPermanentResidenceInSlovenia.$error,
                      "error-messages": ((A = r(f).hasPermanentResidenceInSlovenia.$errors[0]) == null ? void 0 : A.$message) ?? "",
                      onFocus: $[1] || ($[1] = (M) => r(f).hasPermanentResidenceInSlovenia.$reset())
                    }, {
                      default: E(() => [
                        m(S, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m(S, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            m(C, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var A;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-isSlovenianCitizen-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.PrecheckComponent.isSlovenianCitizen")), 9, Pv),
                    m(I, {
                      modelValue: l.isSlovenianCitizen,
                      "onUpdate:modelValue": $[2] || ($[2] = (M) => l.isSlovenianCitizen = M),
                      "aria-labelledby": r(d) + "-isSlovenianCitizen-label",
                      error: r(f).isSlovenianCitizen.$error,
                      "error-messages": ((A = r(f).isSlovenianCitizen.$errors[0]) == null ? void 0 : A.$message) ?? "",
                      onFocus: $[3] || ($[3] = (M) => r(f).isSlovenianCitizen.$reset())
                    }, {
                      default: E(() => [
                        m(S, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m(S, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(T, null, {
          default: E(() => [
            m(C, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var A;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-hasSlovenianIncome-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.PrecheckComponent.hasSlovenianIncome")), 9, $v),
                    m(I, {
                      modelValue: l.hasSlovenianIncome,
                      "onUpdate:modelValue": $[4] || ($[4] = (M) => l.hasSlovenianIncome = M),
                      "aria-labelledby": r(d) + "-hasSlovenianIncome-label",
                      error: r(f).hasSlovenianIncome.$error,
                      "error-messages": ((A = r(f).hasSlovenianIncome.$errors[0]) == null ? void 0 : A.$message) ?? "",
                      onFocus: $[5] || ($[5] = (M) => r(f).hasSlovenianIncome.$reset())
                    }, {
                      default: E(() => [
                        m(S, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m(S, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            }),
            l.isSlovenianCitizen === !1 ? (w(), ce(C, {
              key: 0,
              class: "v-col-12 v-col-md-6"
            }, {
              default: E(() => {
                var A;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(d) + "-hasSlovenianBankAccount-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.PrecheckComponent.hasSlovenianBankAccount")), 9, Mv),
                    m(I, {
                      modelValue: l.hasSlovenianBankAccount,
                      "onUpdate:modelValue": $[6] || ($[6] = (M) => l.hasSlovenianBankAccount = M),
                      "aria-labelledby": r(d) + "-hasSlovenianBankAccount-label",
                      error: r(f).hasSlovenianBankAccount.$error,
                      "error-messages": ((A = r(f).hasSlovenianBankAccount.$errors[0]) == null ? void 0 : A.$message) ?? "",
                      onFocus: $[7] || ($[7] = (M) => r(f).hasSlovenianBankAccount.$reset())
                    }, {
                      default: E(() => [
                        m(S, {
                          label: r(o)("GeneralButtons.Yes"),
                          value: !0
                        }, null, 8, ["label"]),
                        m(S, {
                          label: r(o)("GeneralButtons.No"),
                          value: !1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })) : B("", !0)
          ]),
          _: 1
        }),
        r(g) ? (w(), F("div", Av, P(r(g)), 1)) : B("", !0),
        i.message ? (w(), F("div", wv, P(i.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function kv() {
  return {
    employmentType: void 0,
    isSlovenianCitizen: void 0,
    hasSlovenianBankAccount: void 0
  };
}
function Ov() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function Rv(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    employmentType: {
      required: V.withMessage(
        t("GlobalErrors.ChoiceRequired"),
        ye
      )
    }
  })) };
}
function Lv(e, t, s) {
  const { validationRules: n } = Rv(), a = Me(
    n,
    G(() => e),
    {
      $autoDirty: !0,
      $externalResults: t.externalResults
    }
  ), { scrollToFirstError: o } = Oe();
  async function l() {
    return a.value.$touch(), await a.value.$validate();
  }
  function i() {
    o(s.value);
  }
  function u() {
    e.employmentType === Ne.SP && (e.hasSlovenianBankAccount = !0, e.isSlovenianCitizen = !0);
  }
  return {
    v$: a,
    dataChanged: u,
    validateForm: l,
    scrollToFirstErrorWrapper: i
  };
}
const xv = ["id"], Fv = {
  key: 0,
  class: "notification notification--warning",
  role: "alert"
}, Uy = /* @__PURE__ */ ge({
  __name: "employment-type-component",
  props: {
    data: { default: kv }
  },
  emits: ["update:data", "componentReady"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = Be(), i = se({ ...n.data }), u = se(Ov()), d = X(null), p = X(!1);
    te(
      () => n.data,
      (g) => {
        Object.assign(i, g);
      },
      { deep: !0 }
    ), te(
      i,
      (g) => {
        f(), a("update:data", { ...g });
      },
      { deep: !0 }
    );
    const {
      v$: y,
      dataChanged: f,
      validateForm: _,
      scrollToFirstErrorWrapper: b
    } = Lv(i, u, d);
    return Se(() => {
      f(), p.value = !0, a("componentReady");
    }), t({
      componentReady: p,
      validateForm: _,
      scrollToFirstErrorWrapper: b
    }), (g, h) => {
      const v = U("v-radio"), N = U("v-radio-group"), $ = U("v-col"), S = U("v-row");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: d,
        class: "employment-type-component"
      }, [
        m(S, null, {
          default: E(() => [
            m($, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var I;
                return [
                  c("div", null, [
                    c("label", {
                      id: r(l) + "-employmentType-label",
                      class: "form-label form-label--text"
                    }, P(r(o)("Components.EmploymentTypeComponent.employmentType")), 9, xv),
                    m(N, {
                      modelValue: i.employmentType,
                      "onUpdate:modelValue": h[0] || (h[0] = (C) => i.employmentType = C),
                      "aria-labelledby": r(l) + "-employmentType-label",
                      error: r(y).employmentType.$error,
                      "error-messages": ((I = r(y).employmentType.$errors[0]) == null ? void 0 : I.$message) ?? "",
                      onFocus: h[1] || (h[1] = (C) => r(y).employmentType.$reset())
                    }, {
                      default: E(() => [
                        m(v, {
                          label: r(o)("Components.EmploymentTypeComponent.Employed"),
                          value: r(Ne).Zaposlen
                        }, null, 8, ["label", "value"]),
                        m(v, {
                          label: r(o)("Components.EmploymentTypeComponent.Pensioner"),
                          value: r(Ne).Upokojenec
                        }, null, 8, ["label", "value"]),
                        m(v, {
                          label: r(o)("Components.EmploymentTypeComponent.SP"),
                          value: r(Ne).SP
                        }, null, 8, ["label", "value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        u.message ? (w(), F("div", Fv, P(u.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function Vv() {
  return {
    firstname: "",
    surname: "",
    birthdate: null,
    citizen: void 0,
    address: "",
    postalCode: void 0,
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: void 0,
    idDocumentLast3: "",
    userCheckedData: !1,
    orderToken: "",
    apiAuthToken: "",
    creditApplicationSignUrl: ""
  };
}
function zv() {
  return {
    externalResults: {},
    isDataLoading: !1,
    isDataLoaded: !1,
    countryCode: "",
    message: ""
  };
}
function jv(e) {
  const { t } = oe();
  return { validationRules: G(() => ({
    idDocumentLast3: {
      required: V.withMessage(
        t("GlobalErrors.FieldRequired"),
        ye
      ),
      format: V.withMessage(
        "Vnesite zadnje 3 številke osebnega dokumenta.",
        (n) => /^\d{3}$/.test(n)
      )
    },
    userCheckedData: {
      confirmed: V.withMessage(
        t("GlobalErrors.ConfirmData"),
        Ht(!0)
      )
    }
  })) };
}
function Tr(e) {
  if (!e) return null;
  if (e instanceof Date)
    return Number.isNaN(e.getTime()) ? null : e;
  const t = /^(\d{4})-(\d{2})-(\d{2})/.exec(e);
  if (t)
    return new Date(
      Number(t[1]),
      Number(t[2]) - 1,
      Number(t[3])
    );
  const s = new Date(e);
  return Number.isNaN(s.getTime()) ? null : s;
}
function Er(e) {
  if (!e) return !1;
  try {
    const t = new URL(e);
    return t.protocol === "https:" || t.protocol === "http:";
  } catch {
    return !1;
  }
}
function Uv(e, t, s, n) {
  const { validationRules: a } = jv(), o = ue("commClient"), l = X(!1), i = X(""), u = X(!1), d = X(!1), p = Me(
    a,
    G(() => e),
    {
      $autoDirty: !0,
      $externalResults: t.externalResults
    }
  ), { scrollToFirstError: y } = Oe();
  let f = "", _ = "";
  async function b() {
    var C;
    if (!e.orderToken || !e.apiAuthToken)
      return !1;
    const I = `${e.orderToken}|${e.apiAuthToken}`;
    if (f === I)
      return !0;
    if (_ === I || t.isDataLoading)
      return !1;
    _ = I, t.isDataLoading = !0, t.isDataLoaded = !1, t.message = "";
    try {
      const T = await o.executeMethodAsync(
        "ApiOrderGetExistingCustomerData",
        {
          OrderToken: e.orderToken,
          ApiAuthToken: e.apiAuthToken
        }
      );
      return console.log(
        "[API ORDER] GetExistingCustomerData:",
        T
      ), (T == null ? void 0 : T.Result) !== "OK" ? (t.message = (T == null ? void 0 : T.Message) || (T == null ? void 0 : T.Result) || "Podatkov obstoječe stranke ni bilo mogoče pridobiti.", !1) : (t.countryCode = ((C = T.CountryId) == null ? void 0 : C.trim().toUpperCase()) ?? "", e.firstname = T.FirstName ?? "", e.surname = T.LastName ?? "", e.birthdate = Tr(T.BirthDate), e.address = T.Address ?? "", e.postalCode = T.PostalCode ?? void 0, e.documentIssuer = T.IdIssuer ?? "", e.issueDate = Tr(T.IdIssueDate), e.validityDate = Tr(T.IdValidDate), e.permanentValidity = T.IdIsValidPermanently === !0, f = I, t.isDataLoaded = !0, !0);
    } catch (T) {
      return console.error(
        "[API ORDER] GetExistingCustomerData error:",
        T
      ), t.message = "Napaka pri pridobivanju podatkov stranke.", !1;
    } finally {
      t.isDataLoading = !1, _ = "";
    }
  }
  te(
    () => [
      e.orderToken,
      e.apiAuthToken
    ],
    () => {
      b();
    },
    { immediate: !0 }
  );
  async function g() {
    return !t.isDataLoaded || t.isDataLoading ? (t.message = "Najprej je treba pridobiti podatke stranke.", !1) : (p.value.$touch(), await p.value.$validate());
  }
  function h() {
    y(s.value);
  }
  async function v() {
    if (console.log("[API ORDER] signApplication START"), t.isDataLoading || d.value || !await g())
      return !1;
    if (t.message = "", Er(
      e.creditApplicationSignUrl
    ))
      return i.value = e.creditApplicationSignUrl, u.value = !0, l.value = !0, console.log(
        "[API ORDER] Reopening existing signing URL"
      ), !0;
    if (!e.orderToken || !e.apiAuthToken)
      return t.message = "Manjka OrderToken ali API AuthToken.", !1;
    t.isDataLoading = !0, l.value = !0, i.value = "/StaticLoaders/vloga_upload_wait.html";
    try {
      const I = await o.executeMethodAsync(
        "ApiOrderIdentificationForExistingCustomer",
        {
          OrderToken: e.orderToken,
          IdDocumentNumber: e.idDocumentLast3,
          UserCheckedData: e.userCheckedData,
          ApiAuthToken: e.apiAuthToken
        }
      );
      return console.log(
        "[API ORDER] IdentificationForExistingCustomer:",
        {
          Result: I == null ? void 0 : I.Result,
          Message: I == null ? void 0 : I.Message,
          HasSignUrl: Er(
            I == null ? void 0 : I.CreditApplicationSignUrl
          )
        }
      ), (I == null ? void 0 : I.Result) !== "OK" || !Er(
        I.CreditApplicationSignUrl
      ) ? (t.message = (I == null ? void 0 : I.Message) || "Napaka pri pripravi vloge za podpis.", l.value = !1, i.value = "", !1) : (e.creditApplicationSignUrl = I.CreditApplicationSignUrl, i.value = I.CreditApplicationSignUrl, u.value = !0, l.value = !0, console.log(
        "[API ORDER] Waiting for SIGN callback"
      ), !0);
    } catch (I) {
      return console.error(
        "[API ORDER] signApplication error:",
        I
      ), t.message = "Napaka pri pripravi vloge za podpis.", l.value = !1, i.value = "", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function N(I) {
    if (console.log(
      "[API ORDER] finishExposure:",
      I
    ), l.value = !1, i.value = "", (I == null ? void 0 : I.Result) !== "OK") {
      t.message = (I == null ? void 0 : I.Message) || "Napaka pri preverjanju SISBON-a.";
      return;
    }
    if (I.NumberOfIncome !== 1 && I.NumberOfIncome !== 3) {
      t.message = "API je vrnil neveljavno število plač.";
      return;
    }
    console.log(
      "[API ORDER] Identification completed. NumberOfIncome:",
      I.NumberOfIncome
    ), await ae(), n("navigationEvent", {
      name: "nextStep",
      numberOfIncome: I.NumberOfIncome
    });
  }
  async function $() {
    if (console.log("[API ORDER] checkExposure START"), !e.orderToken || !e.apiAuthToken) {
      t.message = "Manjka OrderToken ali API AuthToken.";
      return;
    }
    l.value = !0, i.value = "/StaticLoaders/sisbon_process.html", t.isDataLoading = !0;
    try {
      console.log(
        "[API ORDER] Calling ApiOrderIdentificationComplete"
      );
      const I = await o.executeMethodAsync(
        "ApiOrderIdentificationComplete",
        {
          OrderToken: e.orderToken,
          FlowType: "POS",
          ApiAuthToken: e.apiAuthToken
        }
      );
      console.log(
        "[API ORDER] ApiOrderIdentificationComplete RESPONSE:",
        I
      ), await N(I);
    } catch (I) {
      console.error(
        "[API ORDER] checkExposure error:",
        I
      ), t.message = "Napaka pri preverjanju SISBON-a.", l.value = !1, i.value = "";
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function S(I) {
    console.log(
      "[API ORDER] STREAM CALLBACK RECEIVED:",
      I
    );
    const C = Array.isArray(I) ? I[0] : I;
    if ((C == null ? void 0 : C.CallbackType) === "SIGN" && C.Status === "complete" && C.Success === !0 && C.Type === "vloga") {
      if (console.log(
        "[API ORDER] SIGN SUCCESS:",
        C
      ), !u.value || d.value) {
        console.log(
          "[API ORDER] SIGN ignored - not waiting or already processing"
        );
        return;
      }
      u.value = !1, l.value = !1, i.value = "", d.value = !0;
      try {
        await $();
      } finally {
        d.value = !1;
      }
    } else (C == null ? void 0 : C.CallbackType) === "SIGN" && C.Status === "complete" && C.Success === !1 && C.Type === "vloga" && u.value && (console.log(
      "[API ORDER] SIGN FAILED:",
      C
    ), u.value = !1, l.value = !1, i.value = "", t.message = C.errorText || C.Message || "Podpis vloge ni bil uspešen.");
  }
  return {
    v$: p,
    validateForm: g,
    scrollToFirstErrorWrapper: h,
    loadExistingCustomerData: b,
    signApplication: v,
    signComplete: S,
    checkExposure: $,
    finishExposure: N,
    showSigner: l,
    signingUrl: i
  };
}
const Gv = ["for"], Bv = {
  key: 0,
  class: "mt-4"
}, Wv = {
  key: 1,
  class: "notification notification--warning",
  role: "alert"
}, Gy = /* @__PURE__ */ ge({
  __name: "existing-identification-info-component",
  props: {
    data: { default: Vv }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, o = Be(), l = se({ ...n.data }), i = se(
      zv()
    ), u = X(null), d = X(!1), p = ue("commClient");
    function y(S) {
      if (!S)
        return "";
      const I = S instanceof Date ? S : new Date(S);
      return Number.isNaN(I.getTime()) ? "" : `${I.getDate()}.${I.getMonth() + 1}.${I.getFullYear()}`;
    }
    function f(S) {
      const I = S.target;
      if (!(I instanceof HTMLInputElement))
        return;
      const C = I.value.replace(/\D/g, "").slice(0, 3);
      I.value = C, l.idDocumentLast3 = C;
    }
    const {
      v$: _,
      validateForm: b,
      scrollToFirstErrorWrapper: g,
      signApplication: h,
      signComplete: v,
      showSigner: N,
      signingUrl: $
    } = Uv(
      l,
      i,
      u,
      a
    );
    return te(
      () => n.data,
      (S) => {
        S && Object.assign(l, S);
      },
      { deep: !0 }
    ), te(
      () => [
        l.idDocumentLast3,
        l.userCheckedData
      ],
      () => {
        l.creditApplicationSignUrl = "";
      }
    ), te(
      l,
      (S) => {
        a("update:data", { ...S });
      },
      { deep: !0 }
    ), Se(() => {
      var S;
      console.log(
        "[API ORDER] SIGN listener registration:",
        !!(p != null && p.OnStreamDataReceived)
      ), (S = p == null ? void 0 : p.OnStreamDataReceived) == null || S.AddCallback(v), d.value = !0, a("componentReady");
    }), St(() => {
      var S;
      (S = p == null ? void 0 : p.OnStreamDataReceived) == null || S.RemoveCallback(v);
    }), t({
      componentReady: d,
      signApplication: h,
      // Obstoječi consuming Step 4 uporablja to ime.
      submitIdentification: h,
      validateForm: b,
      scrollToFirstErrorWrapper: g
    }), (S, I) => {
      const C = U("v-text-field"), T = U("v-col"), A = U("v-row"), M = U("v-checkbox");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: u,
        class: "api-order-existing-identification-component"
      }, [
        I[16] || (I[16] = c("h2", { class: "section-heading" }, "Podatki za identifikacijo", -1)),
        I[17] || (I[17] = c("div", { class: "notification notification--notice mb-10" }, " Preverite podatke obstoječe stranke. ", -1)),
        m(A, null, {
          default: E(() => [
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var L;
                return [
                  c("label", {
                    for: r(o) + "-idDocumentLast3",
                    class: "form-label"
                  }, " Zadnje 3 številke osebnega dokumenta ", 8, Gv),
                  m(C, {
                    id: r(o) + "-idDocumentLast3",
                    modelValue: l.idDocumentLast3,
                    "onUpdate:modelValue": I[0] || (I[0] = (z) => l.idDocumentLast3 = z),
                    variant: "outlined",
                    autocomplete: "off",
                    inputmode: "numeric",
                    maxlength: 3,
                    error: r(_).idDocumentLast3.$error,
                    "error-messages": ((L = r(_).idDocumentLast3.$errors[0]) == null ? void 0 : L.$message) ?? "",
                    disabled: i.isDataLoading,
                    onFocus: I[1] || (I[1] = (z) => r(_).idDocumentLast3.$reset()),
                    onInput: f
                  }, null, 8, ["id", "modelValue", "error", "error-messages", "disabled"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(A, null, {
          default: E(() => [
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[7] || (I[7] = c("label", { class: "form-label" }, "Ime", -1)),
                m(C, {
                  "model-value": l.firstname,
                  variant: "outlined",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[8] || (I[8] = c("label", { class: "form-label" }, "Priimek", -1)),
                m(C, {
                  "model-value": l.surname,
                  variant: "outlined",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        m(A, null, {
          default: E(() => [
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[9] || (I[9] = c("label", { class: "form-label" }, "Datum rojstva", -1)),
                m(C, {
                  "model-value": y(l.birthdate),
                  variant: "outlined",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[10] || (I[10] = c("label", { class: "form-label" }, "Koda države (CountryId)", -1)),
                m(C, {
                  modelValue: i.countryCode,
                  "onUpdate:modelValue": I[2] || (I[2] = (L) => i.countryCode = L),
                  variant: "outlined",
                  autocomplete: "off",
                  maxlength: "2",
                  placeholder: "SI, HR, AT ...",
                  disabled: i.isDataLoading,
                  onBlur: I[3] || (I[3] = (L) => i.countryCode = i.countryCode.toUpperCase())
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        m(A, null, {
          default: E(() => [
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[11] || (I[11] = c("label", { class: "form-label" }, "Naslov prebivališča", -1)),
                m(C, {
                  "model-value": l.address,
                  variant: "outlined",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[12] || (I[12] = c("label", { class: "form-label" }, "Poštna številka", -1)),
                m(C, {
                  "model-value": l.postalCode ?? "",
                  variant: "outlined",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        m(A, null, {
          default: E(() => [
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[13] || (I[13] = c("label", { class: "form-label" }, " Izdajatelj osebnega dokumenta ", -1)),
                m(C, {
                  "model-value": l.documentIssuer,
                  variant: "outlined",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        m(A, null, {
          default: E(() => [
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[14] || (I[14] = c("label", { class: "form-label" }, " Datum izdaje dokumenta ", -1)),
                m(C, {
                  "model-value": y(l.issueDate),
                  variant: "outlined",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            m(T, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => [
                I[15] || (I[15] = c("label", { class: "form-label" }, " Datum veljavnosti dokumenta ", -1)),
                m(C, {
                  "model-value": l.permanentValidity ? "Trajna veljavnost" : y(l.validityDate),
                  variant: "outlined",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        m(A, null, {
          default: E(() => [
            m(T, { class: "v-col-12" }, {
              default: E(() => {
                var L;
                return [
                  m(M, {
                    modelValue: l.userCheckedData,
                    "onUpdate:modelValue": I[4] || (I[4] = (z) => l.userCheckedData = z),
                    label: "Potrjujem, da sem preveril podatke stranke.",
                    error: r(_).userCheckedData.$error,
                    "error-messages": ((L = r(_).userCheckedData.$errors[0]) == null ? void 0 : L.$message) ?? "",
                    disabled: i.isDataLoading,
                    onFocus: I[5] || (I[5] = (z) => r(_).userCheckedData.$reset())
                  }, null, 8, ["modelValue", "error", "error-messages", "disabled"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        i.isDataLoading ? (w(), F("div", Bv, " Preverjam ... ")) : B("", !0),
        m(Pt, {
          display: r(N),
          onModalClosed: I[6] || (I[6] = (L) => N.value = !1),
          showAcceptButton: !1,
          showDeclineButton: !1,
          class: "dialog-preview"
        }, {
          default: E(() => [
            m(kt, {
              url: r($),
              frameBorder: "0"
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["display"]),
        i.message ? (w(), F("div", Wv, P(i.message), 1)) : B("", !0)
      ], 512);
    };
  }
});
function Yv() {
  return {
    personalDocumentType: void 0,
    firstname: "",
    surname: "",
    birthdate: null,
    birthCity: "",
    citizen: void 0,
    address: "",
    postalCode: void 0,
    idNumber: "",
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: void 0,
    identificationConfirmation: !1,
    isSlovenianCitizen: void 0,
    hasTemporaryResidence: void 0,
    temporaryAddress: "",
    temporaryCitizen: void 0,
    temporaryPostalCode: void 0,
    temporaryForeignPostalCode: "",
    employmentType: void 0,
    employerName: "",
    employerAddress: "",
    employerPostCode: void 0,
    isPoliticallyExposedPerson: void 0,
    politicalFunction: "",
    pioSourceFunds: "",
    pioFundsStatus: "",
    countrySourceFunds: "",
    countryFundsStatus: "",
    orderToken: "",
    apiAuthToken: "",
    creditApplicationSignUrl: "",
    marketingConsent: !1,
    customerWillCompleteOrder: !1
  };
}
function qv() {
  return {
    externalResults: {},
    isDataLoading: !1,
    message: ""
  };
}
function un(e) {
  return e instanceof Date && Number.isFinite(e.getTime()) && Qt(e) >= 70;
}
function Hv(e, t, s) {
  const { t: n } = oe(), a = V.withMessage(
    n("GlobalErrors.FieldRequired"),
    ye
  ), o = V.withMessage(
    n("GlobalErrors.ChoiceRequired"),
    ye
  );
  function l(b) {
    return b instanceof Date && Number.isFinite(b.getTime());
  }
  function i(b) {
    if (!l(b))
      return !1;
    const g = /* @__PURE__ */ new Date();
    return g.setHours(23, 59, 59, 999), b <= g;
  }
  function u(b) {
    const g = b.toUpperCase();
    return e.isSlovenianCitizen === !1 ? b.length >= 8 && !g.startsWith("SI") : e.personalDocumentType === qe.Passport ? /^[A-Z]{2}\d{7}$/.test(g) : /^(\d{9}|IE\d{7})$/.test(g);
  }
  function d(b) {
    if (!l(b))
      return !1;
    const g = /* @__PURE__ */ new Date();
    return g.setHours(23, 59, 59, 999), b <= g;
  }
  function p(b) {
    if (e.permanentValidity === !0)
      return !0;
    if (!l(b))
      return !1;
    const g = /* @__PURE__ */ new Date();
    return g.setHours(0, 0, 0, 0), b >= g && (!l(e.issueDate) || b >= e.issueDate);
  }
  const y = () => e.hasTemporaryResidence === !0 && e.isSlovenianCitizen !== !1, f = () => e.employmentType === Ne.Zaposlen;
  return { validationRules: G(() => ({
    personalDocumentType: {
      required: o
    },
    firstname: {
      required: a
    },
    surname: {
      required: a
    },
    birthdate: {
      required: a,
      date: V.withMessage(
        n("GlobalErrors.InvalidDate"),
        i
      )
    },
    birthCity: {
      required: a,
      minTwoLetters: V.withMessage(
        n("GlobalErrors.MinTwoLetters"),
        (b) => typeof b == "string" && /.*[a-zA-ZčžšČŽŠ].*[a-zA-ZčžšČŽŠ]/.test(b)
      )
    },
    citizen: {
      required: o
    },
    address: {
      required: a
    },
    postalCode: {
      required: o
    },
    idNumber: {
      required: a,
      format: V.withMessage(
        n("GlobalErrors.InvalidDocument"),
        u
      )
    },
    documentIssuer: {
      required: a
    },
    issueDate: {
      required: a,
      date: V.withMessage(
        n("GlobalErrors.InvalidDate"),
        d
      )
    },
    validityDate: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(() => e.permanentValidity !== !0)
      ),
      date: V.withMessage(
        n("GlobalErrors.InvalidDate"),
        p
      )
    },
    permanentValidity: {
      required: V.withMessage(
        n("GlobalErrors.ChoiceRequired"),
        ve(() => un(e.birthdate))
      )
    },
    identificationConfirmation: {
      confirmed: V.withMessage(
        n("GlobalErrors.ConfirmData"),
        Ht(!0)
      )
    },
    // Temporary residence
    hasTemporaryResidence: {
      required: V.withMessage(
        n("GlobalErrors.ChoiceRequired"),
        ve(() => e.isSlovenianCitizen !== !1)
      )
    },
    temporaryAddress: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(y)
      )
    },
    temporaryCitizen: {
      required: V.withMessage(
        n("GlobalErrors.ChoiceRequired"),
        ve(y)
      )
    },
    temporaryPostalCode: {
      required: V.withMessage(
        n("GlobalErrors.ChoiceRequired"),
        ve(
          () => y() && !s.value
        )
      )
    },
    temporaryForeignPostalCode: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(
          () => y() && s.value
        )
      )
    },
    // Employment
    employerName: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(f)
      )
    },
    employerAddress: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(f)
      )
    },
    employerPostCode: {
      required: V.withMessage(
        n("GlobalErrors.ChoiceRequired"),
        ve(f)
      )
    },
    // Politically exposed person
    isPoliticallyExposedPerson: {
      required: o
    },
    politicalFunction: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(() => e.isPoliticallyExposedPerson === !0)
      )
    },
    pioSourceFunds: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(() => e.isPoliticallyExposedPerson === !0)
      )
    },
    pioFundsStatus: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(() => e.isPoliticallyExposedPerson === !0)
      )
    },
    // Risk country
    countrySourceFunds: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(() => t.value)
      )
    },
    countryFundsStatus: {
      required: V.withMessage(
        n("GlobalErrors.FieldRequired"),
        ve(() => t.value)
      )
    }
  })) };
}
function Nr(e) {
  if (!e || Number.isNaN(e.getTime())) return null;
  const t = e.getFullYear(), s = String(e.getMonth() + 1).padStart(2, "0"), n = String(e.getDate()).padStart(2, "0");
  return `${t}-${s}-${n}`;
}
function uo(e) {
  if (!e) return !1;
  try {
    const t = new URL(e);
    return t.protocol === "https:" || t.protocol === "http:";
  } catch {
    return !1;
  }
}
function Qv(e, t, s) {
  const n = ue("generalStore"), a = ue("commClient"), o = X(!1), l = X(""), i = X(!1), u = X(!1), d = G(() => {
    const M = (n == null ? void 0 : n.state.countryList) ?? [];
    return e.isSlovenianCitizen === !0 ? M.slice(0, 1) : e.isSlovenianCitizen === !1 ? M.slice(1) : M;
  }), p = G(() => (n == null ? void 0 : n.state.postalCodeList) ?? []), y = G(() => {
    var L, z;
    const M = (z = (L = n == null ? void 0 : n.state.countryList) == null ? void 0 : L[0]) == null ? void 0 : z.Key;
    return e.temporaryCitizen !== void 0 && M !== void 0 && String(e.temporaryCitizen) !== String(M);
  }), f = G(() => {
    var q, me;
    const M = (n == null ? void 0 : n.state.countryList) ?? [], L = M.find(
      (x) => String(x.Key) === String(e.citizen)
    ), z = M.find(
      (x) => String(x.Key) === String(e.temporaryCitizen)
    ), O = ((q = L == null ? void 0 : L.AdditionalData) == null ? void 0 : q.RiskDrzava) === !0, H = e.hasTemporaryResidence === !0 && e.isSlovenianCitizen !== !1 && ((me = z == null ? void 0 : z.AdditionalData) == null ? void 0 : me.RiskDrzava) === !0;
    return O || H;
  }), { validationRules: _ } = Hv(
    e,
    f,
    y
  ), b = Me(_, G(() => e), {
    $autoDirty: !0,
    $externalResults: t.externalResults
  }), { scrollToFirstError: g } = Oe();
  async function h() {
    return b.value.$touch(), await b.value.$validate();
  }
  function v() {
    g(s.value);
  }
  function N() {
    y.value ? e.temporaryPostalCode = void 0 : e.temporaryForeignPostalCode = "", b.value.temporaryPostalCode.$reset(), b.value.temporaryForeignPostalCode.$reset();
  }
  function $(M) {
    e.permanentValidity !== M.permanentValidity && e.permanentValidity === !0 && (e.validityDate = null), e.birthdate !== M.birthdate && (un(e.birthdate) || (e.permanentValidity = !1)), e.hasTemporaryResidence !== M.hasTemporaryResidence && e.hasTemporaryResidence === !1 && (e.temporaryAddress = "", e.temporaryCitizen = void 0, e.temporaryPostalCode = void 0, e.temporaryForeignPostalCode = ""), e.isSlovenianCitizen !== M.isSlovenianCitizen && e.isSlovenianCitizen === !1 && (e.hasTemporaryResidence = void 0, e.temporaryAddress = "", e.temporaryCitizen = void 0, e.temporaryPostalCode = void 0, e.temporaryForeignPostalCode = ""), (e.personalDocumentType !== M.personalDocumentType || e.firstname !== M.firstname || e.surname !== M.surname || e.birthdate !== M.birthdate || e.birthCity !== M.birthCity || e.citizen !== M.citizen || e.address !== M.address || e.postalCode !== M.postalCode || e.idNumber !== M.idNumber || e.documentIssuer !== M.documentIssuer || e.issueDate !== M.issueDate || e.validityDate !== M.validityDate || e.permanentValidity !== M.permanentValidity || e.hasTemporaryResidence !== M.hasTemporaryResidence || e.temporaryAddress !== M.temporaryAddress || e.temporaryCitizen !== M.temporaryCitizen || e.temporaryPostalCode !== M.temporaryPostalCode || e.temporaryForeignPostalCode !== M.temporaryForeignPostalCode || e.employmentType !== M.employmentType || e.employerName !== M.employerName || e.employerAddress !== M.employerAddress || e.employerPostCode !== M.employerPostCode || e.isPoliticallyExposedPerson !== M.isPoliticallyExposedPerson || e.politicalFunction !== M.politicalFunction || e.pioSourceFunds !== M.pioSourceFunds || e.pioFundsStatus !== M.pioFundsStatus || e.countrySourceFunds !== M.countrySourceFunds || e.countryFundsStatus !== M.countryFundsStatus || e.marketingConsent !== M.marketingConsent || e.customerWillCompleteOrder !== M.customerWillCompleteOrder) && (e.identificationConfirmation = !1, e.creditApplicationSignUrl = "");
  }
  te(
    () => e.isPoliticallyExposedPerson,
    () => {
      e.politicalFunction = "", e.pioSourceFunds = "", e.pioFundsStatus = "", b.value.politicalFunction.$reset(), b.value.pioSourceFunds.$reset(), b.value.pioFundsStatus.$reset();
    },
    { flush: "sync" }
  );
  async function S() {
    if (t.isDataLoading || u.value || !await h()) return !1;
    if (t.message = "", uo(e.creditApplicationSignUrl))
      return l.value = e.creditApplicationSignUrl, i.value = !0, o.value = !0, !0;
    if (!e.orderToken || !e.apiAuthToken)
      return t.message = "Manjka OrderToken ali API AuthToken.", !1;
    const M = Nr(e.birthdate), L = Nr(e.issueDate), z = e.permanentValidity === !0 ? null : Nr(e.validityDate);
    if (e.personalDocumentType === void 0 || e.citizen === void 0 || !M || !L || e.permanentValidity !== !0 && !z)
      return t.message = "Manjkajo obvezni identifikacijski podatki.", !1;
    t.isDataLoading = !0;
    try {
      const O = e.hasTemporaryResidence === !0, H = e.isPoliticallyExposedPerson === !0, q = await a.executeMethodAsync(
        "ApiOrderIdentificationForNewCustomer",
        {
          OrderToken: e.orderToken,
          IdDocumentType: String(e.personalDocumentType),
          FirstName: e.firstname,
          LastName: e.surname,
          BirthDate: M,
          CountryId: String(e.citizen),
          Address: e.address,
          PostalCode: String(e.postalCode ?? ""),
          IdDocumentNumber: e.idNumber,
          IdIssuer: e.documentIssuer,
          IdIssueDate: L,
          IdValidDate: z,
          IdIsValidPermanently: e.permanentValidity === !0,
          UserCheckedData: e.identificationConfirmation,
          BirthPlace: e.birthCity,
          TemporaryAddress: O ? e.temporaryAddress : "",
          TemporaryPostNumber: O ? y.value ? e.temporaryForeignPostalCode : String(e.temporaryPostalCode ?? "") : "",
          TemporaryCountryId: O ? String(e.temporaryCitizen ?? "") : "",
          EmployerName: e.employerName,
          EmployerAddress: e.employerAddress,
          EmployerPostNumber: String(e.employerPostCode ?? ""),
          PEPType: H ? e.politicalFunction : "",
          PEPSource: H ? e.pioSourceFunds : "",
          PEPStatus: H ? e.pioFundsStatus : "",
          RiskCountrySource: f.value ? e.countrySourceFunds : "",
          RiskCountryStatus: f.value ? e.countryFundsStatus : "",
          MarketingConsent: e.marketingConsent === !0,
          CustomerWillCompleteOrder: e.customerWillCompleteOrder === !0,
          ApiAuthToken: e.apiAuthToken
        }
      );
      return (q == null ? void 0 : q.Result) !== "OK" ? (t.message = (q == null ? void 0 : q.Message) || (q == null ? void 0 : q.Result) || "Napaka pri pripravi vloge.", !1) : uo(q.CreditApplicationSignUrl) ? (e.creditApplicationSignUrl = q.CreditApplicationSignUrl, l.value = q.CreditApplicationSignUrl, i.value = !0, o.value = !0, console.log("API Order IdentificationForNewCustomer:", {
        Result: q.Result,
        HasSignUrl: !0
      }), console.log("API Order: Waiting for SIGN callback."), !0) : (t.message = "API ni vrnil veljavne povezave za podpis vloge.", !1);
    } catch (O) {
      return console.error(
        "API Order IdentificationForNewCustomer error:",
        O
      ), t.message = "Napaka pri pripravi vloge.", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function I(M) {
    return console.log("[API ORDER NEW] finishExposure:", M), o.value = !1, l.value = "", (M == null ? void 0 : M.Result) !== "OK" ? (t.message = (M == null ? void 0 : M.Message) || "Napaka pri preverjanju SISBON-a.", null) : M.NumberOfIncome !== 1 && M.NumberOfIncome !== 3 ? (t.message = "API je vrnil neveljavno število plač.", null) : (console.log(
      "[API ORDER NEW] Identification completed. NumberOfIncome:",
      M.NumberOfIncome
    ), M.NumberOfIncome);
  }
  async function C() {
    if (console.log("[API ORDER NEW] checkExposure START"), t.isDataLoading)
      return null;
    if (!e.orderToken || !e.apiAuthToken)
      return t.message = "Manjka OrderToken ali API AuthToken.", null;
    t.message = "", t.isDataLoading = !0, o.value = !0, l.value = "/StaticLoaders/sisbon_process.html";
    try {
      console.log(
        "[API ORDER NEW] Calling ApiOrderIdentificationComplete"
      );
      const M = await a.executeMethodAsync(
        "ApiOrderIdentificationComplete",
        {
          OrderToken: e.orderToken,
          FlowType: "POS",
          ApiAuthToken: e.apiAuthToken
        }
      );
      return console.log(
        "[API ORDER NEW] ApiOrderIdentificationComplete RESPONSE:",
        M
      ), await I(M);
    } catch (M) {
      return console.error(
        "[API ORDER NEW] checkExposure error:",
        M
      ), t.message = "Napaka pri preverjanju SISBON-a.", o.value = !1, l.value = "", null;
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function T() {
    return await C();
  }
  async function A(M) {
    console.log(
      "[API ORDER NEW] STREAM CALLBACK RECEIVED:",
      M
    );
    const L = Array.isArray(M) ? M[0] : M;
    if ((L == null ? void 0 : L.CallbackType) === "SIGN" && L.Status === "complete" && L.Success === !0 && L.Type === "vloga") {
      if (console.log(
        "[API ORDER NEW] SIGN SUCCESS:",
        L
      ), !i.value || u.value)
        return console.log(
          "[API ORDER NEW] SIGN ignored - not waiting or already processing"
        ), null;
      i.value = !1, o.value = !1, l.value = "", u.value = !0;
      try {
        return await C();
      } finally {
        u.value = !1;
      }
    }
    return (L == null ? void 0 : L.CallbackType) === "SIGN" && L.Status === "complete" && L.Success === !1 && L.Type === "vloga" && i.value && (console.log(
      "[API ORDER NEW] SIGN FAILED:",
      L
    ), i.value = !1, o.value = !1, l.value = "", t.message = L.errorText || L.Message || "Podpis vloge ni bil uspešen."), null;
  }
  return {
    v$: b,
    countries: d,
    postalCodes: p,
    isForeignTemporaryCountry: y,
    isRiskCountry: f,
    checkIfSloOrAbroad: N,
    dataChanged: $,
    validateForm: h,
    scrollToFirstErrorWrapper: v,
    submitIdentification: S,
    completeIdentification: T,
    signComplete: A,
    showSigner: o,
    signingUrl: l,
    isWaitingForSignature: i
  };
}
const Kv = { class: "section-heading" }, Zv = { class: "notification notification--notice mb-10" }, Jv = {
  key: 0,
  class: "notification notification--alert"
}, Xv = ["id"], Dv = ["for"], eg = ["for"], tg = ["for"], rg = ["for"], ng = ["for"], og = ["for"], sg = ["for"], ig = ["for"], lg = ["for"], ag = ["for"], ug = ["id"], dg = { class: "section-heading mt-10" }, cg = ["for"], mg = ["id"], fg = ["for"], pg = ["for"], vg = ["for"], gg = ["for"], yg = { class: "notification notification--notice mb-4" }, bg = { class: "font-weight-600" }, Cg = ["for"], Ig = ["for"], _g = ["for"], hg = ["for"], Tg = ["for"], Eg = ["id"], Ng = ["for"], Sg = ["for"], Pg = ["for"], $g = {
  key: 5,
  class: "mt-4"
}, Mg = {
  key: 6,
  class: "notification notification--warning",
  role: "alert"
}, By = /* @__PURE__ */ ge({
  __name: "identification-info-component",
  props: {
    data: { default: Yv }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = s, { t: o } = oe(), l = Be(), i = X(null), u = X(!1), d = se({ ...n.data }), p = se(
      qv()
    ), y = se({ ...d }), f = ue("generalStore"), _ = ue("commClient"), b = G(
      () => (f == null ? void 0 : f.state.countryList) ?? []
    ), {
      v$: g,
      countries: h,
      postalCodes: v,
      isForeignTemporaryCountry: N,
      isRiskCountry: $,
      checkIfSloOrAbroad: S,
      dataChanged: I,
      validateForm: C,
      scrollToFirstErrorWrapper: T,
      submitIdentification: A,
      completeIdentification: M,
      signComplete: L,
      showSigner: z,
      signingUrl: O
    } = Qv(
      d,
      p,
      i
    ), H = G(
      () => un(d.birthdate)
    );
    te(
      () => n.data,
      (me) => {
        me && Object.assign(d, me);
      },
      { deep: !0 }
    ), te(
      () => d.isSlovenianCitizen,
      (me, x) => {
        me === !0 ? d.citizen = 204 : me === !1 && x === !0 && (d.citizen = void 0);
      },
      { immediate: !0 }
    ), te(
      d,
      (me) => {
        I(y), Object.assign(y, me), a("update:data", { ...me });
      },
      { deep: !0 }
    );
    async function q(me) {
      const x = await L(me);
      x !== 1 && x !== 3 || a("navigationEvent", {
        name: "nextStep",
        numberOfIncome: x
      });
    }
    return Se(() => {
      var me;
      (me = _ == null ? void 0 : _.OnStreamDataReceived) == null || me.AddCallback(q), u.value = !0, a("componentReady");
    }), St(() => {
      var me;
      (me = _ == null ? void 0 : _.OnStreamDataReceived) == null || me.RemoveCallback(q);
    }), t({
      componentReady: u,
      validateForm: C,
      scrollToFirstErrorWrapper: T,
      submitIdentification: A,
      completeIdentification: M
    }), (me, x) => {
      const ie = U("v-radio"), ne = U("v-radio-group"), J = U("v-col"), j = U("v-row"), Y = U("Datepicker"), re = U("v-input"), fe = U("v-autocomplete"), Le = U("v-checkbox");
      return w(), F("div", {
        ref_key: "rootRef",
        ref: i,
        class: "identification-info-component api-order-identification-info-component"
      }, [
        c("h2", Kv, P(r(o)("Components.IdentificationInfoComponent.Title")), 1),
        c("div", Zv, P(r(o)("Components.IdentificationInfoComponent.Notice")), 1),
        d.isSlovenianCitizen === !1 ? (w(), F("div", Jv, P(r(o)("Components.IdentificationInfoComponent.ForeignerAlert")), 1)) : B("", !0),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    id: r(l) + "-personalDocumentType-label",
                    class: "form-label form-label--text"
                  }, P(r(o)("Components.IdentificationInfoComponent.personalDocumentType")), 9, Xv),
                  m(ne, {
                    modelValue: d.personalDocumentType,
                    "onUpdate:modelValue": x[0] || (x[0] = (ee) => d.personalDocumentType = ee),
                    "aria-labelledby": r(l) + "-personalDocumentType-label",
                    error: r(g).personalDocumentType.$error,
                    "error-messages": ((Q = r(g).personalDocumentType.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[1] || (x[1] = (ee) => r(g).personalDocumentType.$reset()),
                    class: "input-document-type"
                  }, {
                    default: E(() => [
                      m(ie, {
                        label: r(o)("Components.IdentificationInfoComponent.PersonalId"),
                        value: r(qe).PersonalId
                      }, null, 8, ["label", "value"]),
                      m(ie, {
                        label: r(o)("Components.IdentificationInfoComponent.Passport"),
                        value: r(qe).Passport
                      }, null, 8, ["label", "value"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-firstname",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.firstname")), 9, Dv),
                  m(be, {
                    id: r(l) + "-firstname",
                    modelValue: d.firstname,
                    "onUpdate:modelValue": x[2] || (x[2] = (ee) => d.firstname = ee),
                    variant: "outlined",
                    autocomplete: "off",
                    error: r(g).firstname.$error,
                    "error-messages": ((Q = r(g).firstname.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[3] || (x[3] = (ee) => r(g).firstname.$reset())
                  }, null, 8, ["id", "modelValue", "error", "error-messages"])
                ];
              }),
              _: 1
            }),
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-surname",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.surname")), 9, eg),
                  m(be, {
                    id: r(l) + "-surname",
                    modelValue: d.surname,
                    "onUpdate:modelValue": x[4] || (x[4] = (ee) => d.surname = ee),
                    variant: "outlined",
                    autocomplete: "off",
                    error: r(g).surname.$error,
                    "error-messages": ((Q = r(g).surname.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[5] || (x[5] = (ee) => r(g).surname.$reset())
                  }, null, 8, ["id", "modelValue", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: "dp-input-" + r(l) + "-birthdate",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.birthdate")), 9, tg),
                  m(re, {
                    error: r(g).birthdate.$error,
                    "error-messages": ((Q = r(g).birthdate.$errors[0]) == null ? void 0 : Q.$message) ?? ""
                  }, {
                    default: E(() => [
                      m(Y, {
                        uid: r(l) + "-birthdate",
                        modelValue: d.birthdate,
                        "onUpdate:modelValue": x[6] || (x[6] = (ee) => d.birthdate = ee),
                        maxDate: /* @__PURE__ */ new Date(),
                        enableTimePicker: !1,
                        autoApply: "",
                        position: "right",
                        locale: "sl",
                        textInput: "",
                        format: "d.M.yyyy",
                        class: ke(r(g).birthdate.$error ? "v-input--error" : "")
                      }, null, 8, ["uid", "modelValue", "maxDate", "class"])
                    ]),
                    _: 1
                  }, 8, ["error", "error-messages"])
                ];
              }),
              _: 1
            }),
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-citizen",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.citizen")), 9, rg),
                  m(fe, {
                    id: r(l) + "-citizen",
                    modelValue: d.citizen,
                    "onUpdate:modelValue": x[7] || (x[7] = (ee) => d.citizen = ee),
                    items: r(h),
                    "item-title": "Value",
                    "item-value": "Key",
                    variant: "outlined",
                    readonly: d.isSlovenianCitizen === !0,
                    error: r(g).citizen.$error,
                    "error-messages": ((Q = r(g).citizen.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[8] || (x[8] = (ee) => r(g).citizen.$reset())
                  }, null, 8, ["id", "modelValue", "items", "readonly", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-address",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.address")), 9, ng),
                  m(be, {
                    id: r(l) + "-address",
                    modelValue: d.address,
                    "onUpdate:modelValue": x[9] || (x[9] = (ee) => d.address = ee),
                    variant: "outlined",
                    autocomplete: "off",
                    error: r(g).address.$error,
                    "error-messages": ((Q = r(g).address.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[10] || (x[10] = (ee) => r(g).address.$reset())
                  }, null, 8, ["id", "modelValue", "error", "error-messages"])
                ];
              }),
              _: 1
            }),
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-postalCode",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.postalCode")), 9, og),
                  m(fe, {
                    id: r(l) + "-postalCode",
                    modelValue: d.postalCode,
                    "onUpdate:modelValue": x[11] || (x[11] = (ee) => d.postalCode = ee),
                    items: r(v),
                    "item-title": "Value",
                    "item-value": "Key",
                    variant: "outlined",
                    error: r(g).postalCode.$error,
                    "error-messages": ((Q = r(g).postalCode.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[12] || (x[12] = (ee) => r(g).postalCode.$reset())
                  }, null, 8, ["id", "modelValue", "items", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-idNumber",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.idNumber")), 9, sg),
                  m(be, {
                    id: r(l) + "-idNumber",
                    modelValue: d.idNumber,
                    "onUpdate:modelValue": x[13] || (x[13] = (ee) => d.idNumber = ee),
                    variant: "outlined",
                    autocomplete: "off",
                    maxLength: d.isSlovenianCitizen === !0 && (d.personalDocumentType === r(qe).PersonalId || d.personalDocumentType === r(qe).Passport) ? "9" : void 0,
                    error: r(g).idNumber.$error,
                    "error-messages": ((Q = r(g).idNumber.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[14] || (x[14] = (ee) => r(g).idNumber.$reset()),
                    onBlur: x[15] || (x[15] = (ee) => r(g).idNumber.$touch())
                  }, null, 8, ["id", "modelValue", "maxLength", "error", "error-messages"])
                ];
              }),
              _: 1
            }),
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-documentIssuer",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.documentIssuer")), 9, ig),
                  m(be, {
                    id: r(l) + "-documentIssuer",
                    modelValue: d.documentIssuer,
                    "onUpdate:modelValue": x[16] || (x[16] = (ee) => d.documentIssuer = ee),
                    variant: "outlined",
                    autocomplete: "off",
                    prefix: "UE",
                    error: r(g).documentIssuer.$error,
                    "error-messages": ((Q = r(g).documentIssuer.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[17] || (x[17] = (ee) => r(g).documentIssuer.$reset())
                  }, null, 8, ["id", "modelValue", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: "dp-input-" + r(l) + "-issueDate",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.issueDate")), 9, lg),
                  m(re, {
                    error: r(g).issueDate.$error,
                    "error-messages": ((Q = r(g).issueDate.$errors[0]) == null ? void 0 : Q.$message) ?? ""
                  }, {
                    default: E(() => [
                      m(Y, {
                        uid: r(l) + "-issueDate",
                        modelValue: d.issueDate,
                        "onUpdate:modelValue": x[18] || (x[18] = (ee) => d.issueDate = ee),
                        maxDate: /* @__PURE__ */ new Date(),
                        enableTimePicker: !1,
                        autoApply: "",
                        position: "right",
                        locale: "sl",
                        textInput: "",
                        format: "d.M.yyyy",
                        class: ke(r(g).issueDate.$error ? "v-input--error" : "")
                      }, null, 8, ["uid", "modelValue", "maxDate", "class"])
                    ]),
                    _: 1
                  }, 8, ["error", "error-messages"])
                ];
              }),
              _: 1
            }),
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: "dp-input-" + r(l) + "-validityDate",
                    class: "form-label"
                  }, P(r(o)("Components.IdentificationInfoComponent.validityDate")), 9, ag),
                  m(re, {
                    error: r(g).validityDate.$error,
                    "error-messages": ((Q = r(g).validityDate.$errors[0]) == null ? void 0 : Q.$message) ?? ""
                  }, {
                    default: E(() => [
                      m(Y, {
                        uid: r(l) + "-validityDate",
                        modelValue: d.validityDate,
                        "onUpdate:modelValue": x[19] || (x[19] = (ee) => d.validityDate = ee),
                        minDate: /* @__PURE__ */ new Date(),
                        enableTimePicker: !1,
                        autoApply: "",
                        position: "right",
                        locale: "sl",
                        textInput: "",
                        format: "d.M.yyyy",
                        disabled: d.permanentValidity === !0,
                        class: ke(r(g).validityDate.$error ? "v-input--error" : "")
                      }, null, 8, ["uid", "modelValue", "minDate", "disabled", "class"])
                    ]),
                    _: 1
                  }, 8, ["error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        H.value ? (w(), ce(j, { key: 1 }, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    id: r(l) + "-permanentValidity-label",
                    class: "form-label form-label--text"
                  }, P(r(o)("Components.IdentificationInfoComponent.permanentValidity")), 9, ug),
                  m(ne, {
                    modelValue: d.permanentValidity,
                    "onUpdate:modelValue": x[20] || (x[20] = (ee) => d.permanentValidity = ee),
                    "aria-labelledby": r(l) + "-permanentValidity-label",
                    error: r(g).permanentValidity.$error,
                    "error-messages": ((Q = r(g).permanentValidity.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[21] || (x[21] = (ee) => r(g).permanentValidity.$reset())
                  }, {
                    default: E(() => [
                      m(ie, {
                        label: r(o)("GeneralButtons.Yes"),
                        value: !0
                      }, null, 8, ["label"]),
                      m(ie, {
                        label: r(o)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        })) : B("", !0),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12" }, {
              default: E(() => {
                var Q;
                return [
                  m(Le, {
                    modelValue: d.identificationConfirmation,
                    "onUpdate:modelValue": x[22] || (x[22] = (ee) => d.identificationConfirmation = ee),
                    label: "Potrjujem, da sem preveril podatke stranke.",
                    error: r(g).identificationConfirmation.$error,
                    "error-messages": ((Q = r(g).identificationConfirmation.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[23] || (x[23] = (ee) => r(g).identificationConfirmation.$reset())
                  }, null, 8, ["modelValue", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        c("h2", dg, P(r(o)("Components.OtherPersonalInfoComponent.Title")), 1),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-birthCity",
                    class: "form-label"
                  }, P(r(o)("Components.OtherPersonalInfoComponent.birthCity")), 9, cg),
                  m(be, {
                    id: r(l) + "-birthCity",
                    modelValue: d.birthCity,
                    "onUpdate:modelValue": x[24] || (x[24] = (ee) => d.birthCity = ee),
                    variant: "outlined",
                    autocomplete: "off",
                    error: r(g).birthCity.$error,
                    "error-messages": ((Q = r(g).birthCity.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[25] || (x[25] = (ee) => r(g).birthCity.$reset())
                  }, null, 8, ["id", "modelValue", "error", "error-messages"])
                ];
              }),
              _: 1
            }),
            d.isSlovenianCitizen !== !1 ? (w(), ce(J, {
              key: 0,
              class: "v-col-12 v-col-md-6"
            }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    id: r(l) + "-hasTemporaryResidence-label",
                    class: "form-label form-label--text"
                  }, P(r(o)("Components.OtherPersonalInfoComponent.hasTemporaryResidence")), 9, mg),
                  m(ne, {
                    modelValue: d.hasTemporaryResidence,
                    "onUpdate:modelValue": x[26] || (x[26] = (ee) => d.hasTemporaryResidence = ee),
                    "aria-labelledby": r(l) + "-hasTemporaryResidence-label",
                    error: r(g).hasTemporaryResidence.$error,
                    "error-messages": ((Q = r(g).hasTemporaryResidence.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[27] || (x[27] = (ee) => r(g).hasTemporaryResidence.$reset())
                  }, {
                    default: E(() => [
                      m(ie, {
                        label: r(o)("GeneralButtons.Yes"),
                        value: !0
                      }, null, 8, ["label"]),
                      m(ie, {
                        label: r(o)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                ];
              }),
              _: 1
            })) : B("", !0)
          ]),
          _: 1
        }),
        d.hasTemporaryResidence === !0 && d.isSlovenianCitizen !== !1 ? (w(), F(Ae, { key: 2 }, [
          m(j, null, {
            default: E(() => [
              m(J, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-temporaryCitizen",
                      class: "form-label"
                    }, P(r(o)("Components.AdditionalContactInfoComponent.CountryTemporaryCitizen")), 9, fg),
                    m(fe, {
                      id: r(l) + "-temporaryCitizen",
                      modelValue: d.temporaryCitizen,
                      "onUpdate:modelValue": [
                        x[28] || (x[28] = (ee) => d.temporaryCitizen = ee),
                        r(S)
                      ],
                      items: b.value,
                      "item-title": "Value",
                      "item-value": "Key",
                      variant: "outlined",
                      error: r(g).temporaryCitizen.$error,
                      "error-messages": ((Q = r(g).temporaryCitizen.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[29] || (x[29] = (ee) => r(g).temporaryCitizen.$reset())
                    }, null, 8, ["id", "modelValue", "items", "error", "error-messages", "onUpdate:modelValue"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          m(j, null, {
            default: E(() => [
              m(J, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-temporaryAddress",
                      class: "form-label"
                    }, P(r(o)("Components.OtherPersonalInfoComponent.temporaryAddress")), 9, pg),
                    m(be, {
                      id: r(l) + "-temporaryAddress",
                      modelValue: d.temporaryAddress,
                      "onUpdate:modelValue": x[30] || (x[30] = (ee) => d.temporaryAddress = ee),
                      variant: "outlined",
                      autocomplete: "off",
                      error: r(g).temporaryAddress.$error,
                      "error-messages": ((Q = r(g).temporaryAddress.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[31] || (x[31] = (ee) => r(g).temporaryAddress.$reset())
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ];
                }),
                _: 1
              }),
              r(N) ? (w(), ce(J, {
                key: 1,
                class: "v-col-12 v-col-md-6"
              }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-temporaryForeignPostalCode",
                      class: "form-label"
                    }, P(r(o)("Components.AdditionalContactInfoComponent.PostalCodeTemporaryResidence")), 9, gg),
                    m(be, {
                      id: r(l) + "-temporaryForeignPostalCode",
                      modelValue: d.temporaryForeignPostalCode,
                      "onUpdate:modelValue": x[34] || (x[34] = (ee) => d.temporaryForeignPostalCode = ee),
                      variant: "outlined",
                      autocomplete: "off",
                      error: r(g).temporaryForeignPostalCode.$error,
                      "error-messages": ((Q = r(g).temporaryForeignPostalCode.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[35] || (x[35] = (ee) => r(g).temporaryForeignPostalCode.$reset())
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ];
                }),
                _: 1
              })) : (w(), ce(J, {
                key: 0,
                class: "v-col-12 v-col-md-6"
              }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-temporaryPostalCode",
                      class: "form-label"
                    }, P(r(o)("Components.OtherPersonalInfoComponent.temporaryPostalCode")), 9, vg),
                    m(fe, {
                      id: r(l) + "-temporaryPostalCode",
                      modelValue: d.temporaryPostalCode,
                      "onUpdate:modelValue": x[32] || (x[32] = (ee) => d.temporaryPostalCode = ee),
                      items: r(v),
                      "item-title": "Value",
                      "item-value": "Key",
                      variant: "outlined",
                      error: r(g).temporaryPostalCode.$error,
                      "error-messages": ((Q = r(g).temporaryPostalCode.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[33] || (x[33] = (ee) => r(g).temporaryPostalCode.$reset())
                    }, null, 8, ["id", "modelValue", "items", "error", "error-messages"])
                  ];
                }),
                _: 1
              }))
            ]),
            _: 1
          })
        ], 64)) : B("", !0),
        r($) ? (w(), F(Ae, { key: 3 }, [
          m(j, null, {
            default: E(() => [
              m(J, null, {
                default: E(() => [
                  c("div", yg, [
                    c("span", bg, P(r(o)("Components.AdditionalContactInfoComponent.RiskCountryTitle")), 1),
                    Ie(" " + P(r(o)("Components.AdditionalContactInfoComponent.RiskCountryNotice")), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          m(j, null, {
            default: E(() => [
              m(J, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-countrySourceFunds",
                      class: "form-label"
                    }, P(r(o)("Components.AdditionalContactInfoComponent.CountrySourceFunds")), 9, Cg),
                    m(be, {
                      id: r(l) + "-countrySourceFunds",
                      modelValue: d.countrySourceFunds,
                      "onUpdate:modelValue": x[36] || (x[36] = (ee) => d.countrySourceFunds = ee),
                      variant: "outlined",
                      autocomplete: "off",
                      hint: r(o)("Components.AdditionalContactInfoComponent.CountrySourceFundsInfo"),
                      "persistent-hint": "",
                      error: r(g).countrySourceFunds.$error,
                      "error-messages": ((Q = r(g).countrySourceFunds.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[37] || (x[37] = (ee) => r(g).countrySourceFunds.$reset())
                    }, null, 8, ["id", "modelValue", "hint", "error", "error-messages"])
                  ];
                }),
                _: 1
              }),
              m(J, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-countryFundsStatus",
                      class: "form-label"
                    }, P(r(o)("Components.AdditionalContactInfoComponent.CountryFundsStatus")), 9, Ig),
                    m(be, {
                      id: r(l) + "-countryFundsStatus",
                      modelValue: d.countryFundsStatus,
                      "onUpdate:modelValue": x[38] || (x[38] = (ee) => d.countryFundsStatus = ee),
                      variant: "outlined",
                      autocomplete: "off",
                      hint: r(o)("Components.AdditionalContactInfoComponent.CountryFundsStatusInfo"),
                      "persistent-hint": "",
                      error: r(g).countryFundsStatus.$error,
                      "error-messages": ((Q = r(g).countryFundsStatus.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[39] || (x[39] = (ee) => r(g).countryFundsStatus.$reset())
                    }, null, 8, ["id", "modelValue", "hint", "error", "error-messages"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64)) : B("", !0),
        x[55] || (x[55] = c("h2", { class: "section-heading mt-10" }, " Podatki o zaposlitvi ", -1)),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-employerName",
                    class: "form-label"
                  }, " Naziv delodajalca ", 8, _g),
                  m(be, {
                    id: r(l) + "-employerName",
                    modelValue: d.employerName,
                    "onUpdate:modelValue": x[40] || (x[40] = (ee) => d.employerName = ee),
                    variant: "outlined",
                    autocomplete: "off",
                    error: r(g).employerName.$error,
                    "error-messages": ((Q = r(g).employerName.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[41] || (x[41] = (ee) => r(g).employerName.$reset())
                  }, null, 8, ["id", "modelValue", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-employerAddress",
                    class: "form-label"
                  }, " Naslov delodajalca ", 8, hg),
                  m(be, {
                    id: r(l) + "-employerAddress",
                    modelValue: d.employerAddress,
                    "onUpdate:modelValue": x[42] || (x[42] = (ee) => d.employerAddress = ee),
                    variant: "outlined",
                    autocomplete: "off",
                    error: r(g).employerAddress.$error,
                    "error-messages": ((Q = r(g).employerAddress.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[43] || (x[43] = (ee) => r(g).employerAddress.$reset())
                  }, null, 8, ["id", "modelValue", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    for: r(l) + "-employerPostCode",
                    class: "form-label"
                  }, " Pošta delodajalca ", 8, Tg),
                  m(fe, {
                    id: r(l) + "-employerPostCode",
                    modelValue: d.employerPostCode,
                    "onUpdate:modelValue": x[44] || (x[44] = (ee) => d.employerPostCode = ee),
                    items: r(v),
                    "item-title": "Value",
                    "item-value": "Key",
                    variant: "outlined",
                    error: r(g).employerPostCode.$error,
                    "error-messages": ((Q = r(g).employerPostCode.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[45] || (x[45] = (ee) => r(g).employerPostCode.$reset())
                  }, null, 8, ["id", "modelValue", "items", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        m(j, null, {
          default: E(() => [
            m(J, { class: "v-col-12 v-col-md-6" }, {
              default: E(() => {
                var Q;
                return [
                  c("label", {
                    id: r(l) + "-isPoliticallyExposedPerson-label",
                    class: "form-label form-label--text"
                  }, P(r(o)("Components.PoliticallyExposedPersonComponent.isPoliticallyExposedPerson")), 9, Eg),
                  m(ne, {
                    modelValue: d.isPoliticallyExposedPerson,
                    "onUpdate:modelValue": x[46] || (x[46] = (ee) => d.isPoliticallyExposedPerson = ee),
                    "aria-labelledby": r(l) + "-isPoliticallyExposedPerson-label",
                    error: r(g).isPoliticallyExposedPerson.$error,
                    "error-messages": ((Q = r(g).isPoliticallyExposedPerson.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                    onFocus: x[47] || (x[47] = (ee) => r(g).isPoliticallyExposedPerson.$reset())
                  }, {
                    default: E(() => [
                      m(ie, {
                        label: r(o)("GeneralButtons.Yes"),
                        value: !0
                      }, null, 8, ["label"]),
                      m(ie, {
                        label: r(o)("GeneralButtons.No"),
                        value: !1
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-labelledby", "error", "error-messages"])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        d.isPoliticallyExposedPerson === !0 ? (w(), F(Ae, { key: 4 }, [
          m(j, null, {
            default: E(() => [
              m(J, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-politicalFunction",
                      class: "form-label"
                    }, P(r(o)("Components.PoliticallyExposedPersonComponent.politicalFunction")), 9, Ng),
                    m(be, {
                      id: r(l) + "-politicalFunction",
                      modelValue: d.politicalFunction,
                      "onUpdate:modelValue": x[48] || (x[48] = (ee) => d.politicalFunction = ee),
                      variant: "outlined",
                      autocomplete: "off",
                      error: r(g).politicalFunction.$error,
                      "error-messages": ((Q = r(g).politicalFunction.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[49] || (x[49] = (ee) => r(g).politicalFunction.$reset())
                    }, null, 8, ["id", "modelValue", "error", "error-messages"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          m(j, null, {
            default: E(() => [
              m(J, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-pioSourceFunds",
                      class: "form-label"
                    }, P(r(o)("Components.PoliticallyExposedPersonComponent.pioSourceFunds")), 9, Sg),
                    m(be, {
                      id: r(l) + "-pioSourceFunds",
                      modelValue: d.pioSourceFunds,
                      "onUpdate:modelValue": x[50] || (x[50] = (ee) => d.pioSourceFunds = ee),
                      variant: "outlined",
                      autocomplete: "off",
                      hint: r(o)("Components.PoliticallyExposedPersonComponent.SourceHelp"),
                      "persistent-hint": "",
                      error: r(g).pioSourceFunds.$error,
                      "error-messages": ((Q = r(g).pioSourceFunds.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[51] || (x[51] = (ee) => r(g).pioSourceFunds.$reset())
                    }, null, 8, ["id", "modelValue", "hint", "error", "error-messages"])
                  ];
                }),
                _: 1
              }),
              m(J, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => {
                  var Q;
                  return [
                    c("label", {
                      for: r(l) + "-pioFundsStatus",
                      class: "form-label"
                    }, P(r(o)("Components.PoliticallyExposedPersonComponent.pioFundsStatus")), 9, Pg),
                    m(be, {
                      id: r(l) + "-pioFundsStatus",
                      modelValue: d.pioFundsStatus,
                      "onUpdate:modelValue": x[52] || (x[52] = (ee) => d.pioFundsStatus = ee),
                      variant: "outlined",
                      autocomplete: "off",
                      hint: r(o)("Components.PoliticallyExposedPersonComponent.StatusHelp"),
                      "persistent-hint": "",
                      error: r(g).pioFundsStatus.$error,
                      "error-messages": ((Q = r(g).pioFundsStatus.$errors[0]) == null ? void 0 : Q.$message) ?? "",
                      onFocus: x[53] || (x[53] = (ee) => r(g).pioFundsStatus.$reset())
                    }, null, 8, ["id", "modelValue", "hint", "error", "error-messages"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64)) : B("", !0),
        p.isDataLoading ? (w(), F("div", $g, "Pripravljam vlogo ...")) : B("", !0),
        p.message ? (w(), F("div", Mg, P(p.message), 1)) : B("", !0),
        m(Pt, {
          display: r(z),
          onModalClosed: x[54] || (x[54] = (Q) => z.value = !1),
          showAcceptButton: !1,
          showDeclineButton: !1,
          class: "dialog-preview"
        }, {
          default: E(() => [
            m(kt, {
              url: r(O),
              frameBorder: "0"
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["display"])
      ], 512);
    };
  }
});
function Ag() {
  return {
    orderToken: "",
    apiAuthToken: "",
    numberOfIncome: 0,
    trr: "",
    income1: void 0,
    income2: void 0,
    income3: void 0,
    installmentNr: void 0,
    minInstallment: null,
    maxInstallment: null,
    financialResponse: null,
    calculationResponse: null,
    contractResponse: null
  };
}
function wg() {
  return {
    isDataLoading: !1,
    message: ""
  };
}
function kg(e, t, s) {
  const n = ue("commClient"), a = X(!1), o = X(""), l = X([]), i = X(0), u = X(!1), d = X(!1);
  function p(h) {
    l.value = h.Contracts.map(
      (v) => v.SignUrl
    ), i.value = 0, o.value = l.value[0], u.value = !0, a.value = !0, console.log("[API ORDER STEP 5] Starting contract signing:", {
      ContractsCount: l.value.length
    });
  }
  async function y(h) {
    const v = Array.isArray(h) ? h[0] : h;
    if (!((v == null ? void 0 : v.CallbackType) !== "SIGN" || v.Type !== "pogodba" || v.Status !== "complete") && (console.log("[API ORDER STEP 5] SIGN callback:", v), !(!u.value || d.value))) {
      d.value = !0;
      try {
        if (v.Success === !1) {
          console.log("[API ORDER STEP 5] Contract signing failed"), u.value = !1, a.value = !1, o.value = "", t.message = v.errorText || v.Message || "Podpis pogodbe ni bil uspešen.", await ae(), s("navigationEvent", {
            name: "endFail"
          });
          return;
        }
        if (v.Success !== !0)
          return;
        if (console.log("[API ORDER STEP 5] Contract signed:", {
          Current: i.value + 1,
          Total: l.value.length
        }), i.value < l.value.length - 1) {
          i.value++, o.value = l.value[i.value], console.log(
            "[API ORDER STEP 5] Opening next contract:",
            i.value + 1
          );
          return;
        }
        u.value = !1, a.value = !1, o.value = "", l.value = [], console.log(
          "[API ORDER STEP 5] All contracts signed successfully"
        ), await ae(), s("navigationEvent", {
          name: "endSuccess"
        });
      } finally {
        d.value = !1;
      }
    }
  }
  te(
    () => e.installmentNr,
    (h, v) => {
      h !== v && (e.calculationResponse = null, e.contractResponse = null);
    }
  );
  async function f() {
    var S;
    if (t.isDataLoading) return !1;
    if (t.message = "", ((S = e.financialResponse) == null ? void 0 : S.Result) === "OK") return !0;
    if (!e.orderToken || !e.apiAuthToken)
      return t.message = "Manjka OrderToken ali API AuthToken.", !1;
    if (e.numberOfIncome !== 1 && e.numberOfIncome !== 3)
      return t.message = "NumberOfIncome mora biti 1 ali 3 (podatek iz IdentificationComplete).", !1;
    const h = e.trr.replace(/\s+/g, "").toUpperCase(), v = Number(e.income1), N = e.numberOfIncome === 3 ? Number(e.income2) : 0, $ = e.numberOfIncome === 3 ? Number(e.income3) : 0;
    if (!h)
      return t.message = "Vnesi TRR.", !1;
    if (!Number.isFinite(v) || v <= 0 || e.numberOfIncome === 3 && (!Number.isFinite(N) || N <= 0 || !Number.isFinite($) || $ <= 0))
      return t.message = "Vnesi vse zahtevane mesecne prihodke (vecje od 0).", !1;
    t.isDataLoading = !0;
    try {
      const I = await n.executeMethodAsync(
        "ApiOrderCustomerFinancialData",
        {
          OrderToken: e.orderToken,
          TRR: h,
          Income1: v,
          Income2: N,
          Income3: $,
          ApiAuthToken: e.apiAuthToken
        }
      );
      if (console.log("API Order CustomerFinancialData:", I), (I == null ? void 0 : I.Result) !== "OK")
        return t.message = (I == null ? void 0 : I.Message) || (I == null ? void 0 : I.Result) || "Napaka pri oddaji financnih podatkov.", !1;
      const C = I.MinInstallment, T = I.MaxInstallment;
      return C == null || T == null || !Number.isInteger(C) || !Number.isInteger(T) || C < 1 || T < C ? (t.message = "API je vrnil neveljaven razpon stevila obrokov.", !1) : (e.trr = h, e.minInstallment = C, e.maxInstallment = T, e.installmentNr = C, e.calculationResponse = null, e.contractResponse = null, e.financialResponse = I, !0);
    } catch (I) {
      return console.error("API Order CustomerFinancialData error:", I), t.message = "Napaka pri oddaji financnih podatkov.", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function _() {
    if (t.isDataLoading) return !1;
    if (t.message = "", !e.orderToken || !e.apiAuthToken)
      return t.message = "Manjka OrderToken ali API AuthToken.", !1;
    if (!e.financialResponse || e.minInstallment == null || e.maxInstallment == null)
      return t.message = "Najprej potrdi financne podatke.", !1;
    const h = Number(e.installmentNr);
    if (!Number.isInteger(h) || h < e.minInstallment || h > e.maxInstallment)
      return t.message = `Stevilo obrokov mora biti med ${e.minInstallment} in ${e.maxInstallment}.`, !1;
    t.isDataLoading = !0;
    try {
      const v = await n.executeMethodAsync(
        "ApiOrderInstallmentPlanSelection",
        {
          OrderToken: e.orderToken,
          InstallmentNr: h,
          ApiAuthToken: e.apiAuthToken
        }
      );
      return console.log("API Order InstallmentPlanSelection:", v), (v == null ? void 0 : v.Result) !== "OK" ? (t.message = (v == null ? void 0 : v.Message) || (v == null ? void 0 : v.Result) || "Napaka pri izracunu obrokov.", !1) : Number(e.installmentNr) !== h ? !1 : (e.calculationResponse = v, e.contractResponse = null, !0);
    } catch (v) {
      return console.error("API Order InstallmentPlanSelection error:", v), t.message = "Napaka pri izracunu obrokov.", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  async function b() {
    var N, $, S;
    if (t.isDataLoading) return !1;
    t.message = "";
    function h(I) {
      return !Array.isArray(I.Contracts) || I.Contracts.length === 0 ? !1 : I.Contracts.every((C) => {
        if (!(C != null && C.SignUrl))
          return !1;
        try {
          const T = new URL(C.SignUrl);
          return T.protocol === "https:" && T.hostname.length > 0;
        } catch {
          return !1;
        }
      });
    }
    if (((N = e.contractResponse) == null ? void 0 : N.Result) === "OK") {
      const I = h(e.contractResponse);
      return I || (t.message = "Pogodba je ustvarjena, vendar povezava za podpis ni veljavna."), I;
    }
    if (!e.orderToken || !e.apiAuthToken)
      return t.message = "Manjka OrderToken ali API AuthToken.", !1;
    if ((($ = e.calculationResponse) == null ? void 0 : $.Result) !== "OK")
      return t.message = "Najprej naredi izracun za izbrano stevilo obrokov.", !1;
    const v = Number(e.installmentNr);
    if (!Number.isInteger(v) || e.minInstallment == null || e.maxInstallment == null || v < e.minInstallment || v > e.maxInstallment)
      return t.message = "Izbrano stevilo obrokov ni veljavno.", !1;
    t.isDataLoading = !0;
    try {
      const I = await n.executeMethodAsync(
        "ApiOrderContractCreate",
        {
          OrderToken: e.orderToken,
          InstallmentNr: v,
          ApiAuthToken: e.apiAuthToken
        }
      );
      if (console.log("API Order ContractCreate:", I), (I == null ? void 0 : I.Result) !== "OK")
        return t.message = (I == null ? void 0 : I.Message) || (I == null ? void 0 : I.Result) || "Napaka pri ustvarjanju pogodbe.", !1;
      e.contractResponse = I;
      const C = h(I);
      return console.log("API Order ContractCreate SignUrl Check:", {
        Result: I.Result,
        ContractsCount: ((S = I.Contracts) == null ? void 0 : S.length) ?? 0,
        AllSignUrlsValid: C
      }), C ? (p(I), !0) : (t.message = "Pogodba je ustvarjena, vendar API ni vrnil veljavne povezave za podpis.", !1);
    } catch (I) {
      return console.error("API Order ContractCreate error:", I), t.message = "Napaka pri ustvarjanju pogodbe.", !1;
    } finally {
      t.isDataLoading = !1;
    }
  }
  function g() {
    var h;
    t.isDataLoading || ((h = e.contractResponse) == null ? void 0 : h.Result) === "OK" || (t.message = "", e.financialResponse = null, e.calculationResponse = null, e.contractResponse = null, e.minInstallment = null, e.maxInstallment = null, e.installmentNr = void 0);
  }
  return {
    submitFinancialData: f,
    calculateInstallment: _,
    createContract: b,
    editFinancialData: g,
    signComplete: y,
    showSigner: a,
    signingUrl: o
  };
}
const Og = { class: "api-order-step5-component" }, Rg = {
  key: 0,
  class: "notification notification--warning mb-4"
}, Lg = { class: "mt-4 mb-3" }, xg = {
  key: 1,
  class: "mt-8",
  style: { "max-width": "850px" }
}, Fg = {
  scope: "row",
  style: { width: "45%" }
}, Vg = { class: "section-heading mt-6" }, zg = {
  scope: "row",
  style: { width: "45%" }
}, jg = {
  key: 2,
  class: "mt-8",
  style: { "max-width": "850px" }
}, Ug = {
  scope: "row",
  style: { width: "45%" }
}, Gg = { class: "section-heading mt-6" }, Bg = {
  scope: "row",
  style: { width: "45%" }
}, Wg = { style: { "overflow-wrap": "anywhere" } }, Yg = {
  key: 2,
  class: "notification notification--warning mt-5",
  role: "alert"
}, Wy = /* @__PURE__ */ ge({
  __name: "step-5-component",
  props: {
    data: { default: Ag }
  },
  emits: ["update:data", "componentReady", "navigationEvent"],
  setup(e, { expose: t, emit: s }) {
    const n = e, a = ue("commClient"), o = s, l = se({ ...n.data }), i = se(wg()), u = X(!1), {
      submitFinancialData: d,
      calculateInstallment: p,
      createContract: y,
      editFinancialData: f,
      signComplete: _,
      showSigner: b,
      signingUrl: g
    } = kg(l, i, o), h = {
      Result: "Status",
      Message: "Sporočilo",
      CreditAmount: "Znesek financiranja",
      TotalAmount: "Skupni znesek",
      RiskAmount: "Strošek ocene tveganja",
      ApprovalAmount: "Strošek odobritve",
      InstallmentAmount: "Mesečni obrok",
      InstallmentAmountNoCost: "Mesečni obrok brez stroškov",
      FirstInstallmentDate: "Datum prvega obroka",
      LastInstallmentDate: "Datum zadnjega obroka",
      IsDocumentationNeeded: "Potrebna dokumentacija",
      ProductType: "Vrsta financiranja",
      MonthlyInstallmentAmount: "Mesečni obrok",
      Amount: "Znesek",
      InstallmentNr: "Število obrokov",
      InterestRate: "Obrestna mera",
      EOM: "EOM",
      ContractNr: "Številka pogodbe",
      SignUrl: "Povezava za podpis"
    }, v = /* @__PURE__ */ new Set([
      "CreditAmount",
      "TotalAmount",
      "RiskAmount",
      "ApprovalAmount",
      "InstallmentAmount",
      "InstallmentAmountNoCost",
      "MonthlyInstallmentAmount",
      "Amount"
    ]), N = new Intl.NumberFormat("sl-SI", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    function $(I, C) {
      if (C == null || C === "")
        return "—";
      if (typeof C == "boolean")
        return C ? "Da" : "Ne";
      if ((I === "FirstInstallmentDate" || I === "LastInstallmentDate") && typeof C == "string") {
        const T = C.substring(0, 10);
        if (T === "0001-01-01")
          return "—";
        const A = T.split("-");
        return A.length === 3 ? `${A[2]}.${A[1]}.${A[0]}` : C;
      }
      return typeof C == "number" ? v.has(I) ? `${N.format(C)} EUR` : I === "InterestRate" || I === "EOM" ? `${N.format(C)} %` : String(C) : String(C);
    }
    function S(I, C = []) {
      return I ? Object.entries(I).filter(([T]) => !C.includes(T)).map(([T, A]) => ({
        key: T,
        label: h[T] ?? T,
        value: $(T, A)
      })) : [];
    }
    return te(
      () => n.data,
      (I) => {
        I && Object.assign(l, I);
      },
      { deep: !0 }
    ), te(
      l,
      (I) => {
        o("update:data", { ...I });
      },
      { deep: !0 }
    ), Se(() => {
      var I;
      console.log(
        "[API ORDER STEP 5] SIGN listener registration:",
        !!(a != null && a.OnStreamDataReceived)
      ), (I = a == null ? void 0 : a.OnStreamDataReceived) == null || I.AddCallback(_), u.value = !0, o("componentReady");
    }), St(() => {
      var I;
      (I = a == null ? void 0 : a.OnStreamDataReceived) == null || I.RemoveCallback(_);
    }), t({
      componentReady: u,
      submitFinancialData: d,
      calculateInstallment: p,
      createContract: y
    }), (I, C) => {
      const T = U("v-col"), A = U("v-row"), M = U("v-btn"), L = U("v-slider"), z = U("v-table");
      return w(), F("div", Og, [
        C[21] || (C[21] = c("h2", { class: "section-heading" }, "Finančni podatki", -1)),
        l.financialResponse === null ? (w(), F(Ae, { key: 0 }, [
          l.numberOfIncome !== 1 && l.numberOfIncome !== 3 ? (w(), F("div", Rg, " Manjka NumberOfIncome iz IdentificationComplete (1 ali 3). ")) : B("", !0),
          m(A, null, {
            default: E(() => [
              m(T, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => [
                  C[7] || (C[7] = c("label", { class: "form-label" }, "Zadnji mesečni prihodek", -1)),
                  m(Ke, {
                    modelValue: l.income1,
                    "onUpdate:modelValue": C[0] || (C[0] = (O) => l.income1 = O),
                    variant: "outlined",
                    appendText: "EUR",
                    numberOfDecimals: 2,
                    disabled: i.isDataLoading,
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          l.numberOfIncome === 3 ? (w(), F(Ae, { key: 1 }, [
            m(A, null, {
              default: E(() => [
                m(T, { class: "v-col-12 v-col-md-6" }, {
                  default: E(() => [
                    C[8] || (C[8] = c("label", { class: "form-label" }, "Predzadnji mesečni prihodek", -1)),
                    m(Ke, {
                      modelValue: l.income2,
                      "onUpdate:modelValue": C[1] || (C[1] = (O) => l.income2 = O),
                      variant: "outlined",
                      appendText: "EUR",
                      numberOfDecimals: 2,
                      disabled: i.isDataLoading,
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            m(A, null, {
              default: E(() => [
                m(T, { class: "v-col-12 v-col-md-6" }, {
                  default: E(() => [
                    C[9] || (C[9] = c("label", { class: "form-label" }, "Predpredzadnji mesečni prihodek", -1)),
                    m(Ke, {
                      modelValue: l.income3,
                      "onUpdate:modelValue": C[2] || (C[2] = (O) => l.income3 = O),
                      variant: "outlined",
                      appendText: "EUR",
                      numberOfDecimals: 2,
                      disabled: i.isDataLoading,
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64)) : B("", !0),
          m(A, null, {
            default: E(() => [
              m(T, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => [
                  C[10] || (C[10] = c("label", { class: "form-label" }, "TRR", -1)),
                  m(be, {
                    modelValue: l.trr,
                    "onUpdate:modelValue": C[3] || (C[3] = (O) => l.trr = O),
                    variant: "outlined",
                    disabled: i.isDataLoading,
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          m(M, {
            class: "btn btn--primary-fill mt-3",
            loading: i.isDataLoading,
            disabled: l.numberOfIncome !== 1 && l.numberOfIncome !== 3,
            onClick: r(d)
          }, {
            default: E(() => C[11] || (C[11] = [
              Ie(" Potrdi finančne podatke ")
            ])),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])
        ], 64)) : (w(), F(Ae, { key: 1 }, [
          c("div", Lg, [
            C[12] || (C[12] = Ie(" Finančni podatki potrjeni. Ročnost: od ")),
            c("strong", null, P(l.minInstallment), 1),
            C[13] || (C[13] = Ie(" do ")),
            c("strong", null, P(l.maxInstallment), 1),
            C[14] || (C[14] = Ie(" obrokov. "))
          ]),
          l.contractResponse === null ? (w(), ce(M, {
            key: 0,
            class: "btn btn--primary-outline btn--sm mb-6",
            disabled: i.isDataLoading,
            onClick: r(f)
          }, {
            default: E(() => C[15] || (C[15] = [
              Ie(" Uredi finančne podatke ")
            ])),
            _: 1
          }, 8, ["disabled", "onClick"])) : B("", !0),
          C[20] || (C[20] = c("h2", { class: "section-heading mt-5" }, "Izbira števila obrokov", -1)),
          m(A, null, {
            default: E(() => [
              m(T, { class: "v-col-12 v-col-md-6" }, {
                default: E(() => [
                  C[17] || (C[17] = c("label", { class: "form-label" }, "Število obrokov", -1)),
                  m(Ke, {
                    modelValue: l.installmentNr,
                    "onUpdate:modelValue": C[4] || (C[4] = (O) => l.installmentNr = O),
                    variant: "outlined",
                    numberOfDecimals: 0,
                    minValue: l.minInstallment ?? void 0,
                    maxValue: l.maxInstallment ?? void 0,
                    disabled: i.isDataLoading || l.contractResponse !== null,
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "minValue", "maxValue", "disabled"]),
                  l.minInstallment !== null && l.maxInstallment !== null ? (w(), ce(L, {
                    key: 0,
                    modelValue: l.installmentNr,
                    "onUpdate:modelValue": C[5] || (C[5] = (O) => l.installmentNr = O),
                    min: l.minInstallment,
                    max: l.maxInstallment,
                    step: 1,
                    "thumb-label": "",
                    disabled: i.isDataLoading || l.contractResponse !== null
                  }, null, 8, ["modelValue", "min", "max", "disabled"])) : B("", !0),
                  m(M, {
                    class: "btn btn--primary-fill mt-3",
                    loading: i.isDataLoading,
                    disabled: l.contractResponse !== null,
                    onClick: r(p)
                  }, {
                    default: E(() => C[16] || (C[16] = [
                      Ie(" Izračunaj ")
                    ])),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          l.calculationResponse !== null ? (w(), F("div", xg, [
            C[18] || (C[18] = c("h3", { class: "section-heading" }, "Rezultat izračuna", -1)),
            m(z, {
              density: "compact",
              class: "mb-6"
            }, {
              default: E(() => [
                c("tbody", null, [
                  (w(!0), F(Ae, null, tt(S(
                    l.calculationResponse,
                    ["AvailableFinancing"]
                  ), (O) => (w(), F("tr", {
                    key: O.key
                  }, [
                    c("th", Fg, P(O.label), 1),
                    c("td", null, P(O.value), 1)
                  ]))), 128))
                ])
              ]),
              _: 1
            }),
            (w(!0), F(Ae, null, tt(l.calculationResponse.AvailableFinancing ?? [], (O, H) => (w(), F(Ae, { key: H }, [
              c("h3", Vg, " Financiranje " + P(H + 1) + " – " + P(O.ProductType), 1),
              m(z, {
                density: "compact",
                class: "mb-6"
              }, {
                default: E(() => [
                  c("tbody", null, [
                    (w(!0), F(Ae, null, tt(S(O), (q) => (w(), F("tr", {
                      key: q.key
                    }, [
                      c("th", zg, P(q.label), 1),
                      c("td", null, P(q.value), 1)
                    ]))), 128))
                  ])
                ]),
                _: 2
              }, 1024)
            ], 64))), 128))
          ])) : B("", !0),
          l.contractResponse !== null ? (w(), F("div", jg, [
            C[19] || (C[19] = c("h3", { class: "section-heading" }, "Odgovor ustvarjanja pogodbe", -1)),
            m(z, {
              density: "compact",
              class: "mb-6"
            }, {
              default: E(() => [
                c("tbody", null, [
                  (w(!0), F(Ae, null, tt(S(
                    l.contractResponse,
                    ["Contracts"]
                  ), (O) => (w(), F("tr", {
                    key: O.key
                  }, [
                    c("th", Ug, P(O.label), 1),
                    c("td", null, P(O.value), 1)
                  ]))), 128))
                ])
              ]),
              _: 1
            }),
            (w(!0), F(Ae, null, tt(l.contractResponse.Contracts ?? [], (O, H) => (w(), F(Ae, { key: H }, [
              c("h3", Gg, " Pogodba " + P(H + 1), 1),
              m(z, {
                density: "compact",
                class: "mb-6"
              }, {
                default: E(() => [
                  c("tbody", null, [
                    (w(!0), F(Ae, null, tt(S(O), (q) => (w(), F("tr", {
                      key: q.key
                    }, [
                      c("th", Bg, P(q.label), 1),
                      c("td", Wg, P(q.value), 1)
                    ]))), 128))
                  ])
                ]),
                _: 2
              }, 1024)
            ], 64))), 128))
          ])) : B("", !0)
        ], 64)),
        i.message ? (w(), F("div", Yg, P(i.message), 1)) : B("", !0),
        m(Pt, {
          display: r(b),
          onModalClosed: C[6] || (C[6] = (O) => b.value = !1),
          showAcceptButton: !1,
          showDeclineButton: !1,
          class: "dialog-preview"
        }, {
          default: E(() => [
            m(kt, {
              url: r(g),
              frameBorder: "0"
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["display"])
      ]);
    };
  }
});
export {
  Uy as ApiOrderEmploymentTypeComponent,
  Gy as ApiOrderExistingIdentificationComponent,
  By as ApiOrderIdentificationComponent,
  jy as ApiOrderPrecheckComponent,
  Wy as ApiOrderStep5Component,
  zy as ApiOrderVerificationComponent,
  Ny as ContractCreateComponent,
  $y as ContractDocumentationComponent,
  wy as ContractFinalTermsDialog,
  My as ContractSignatureTypeComponent,
  Ay as CustomerEntryNoticeComponent,
  by as EmailVerificationComponent,
  Qg as EmploymentInfoComponent,
  Zg as EmploymentTypeComponent,
  ht as EnumContractSending,
  Nt as EnumContractSignatureType,
  ar as EnumDocumentationSendType,
  Ne as EnumEmploymentType,
  Z as EnumFlowType,
  Ko as EnumIdentificationType,
  Ce as EnumNotificationType,
  nn as EnumPasswordStatus,
  qe as EnumPersonalDocumentType,
  st as EnumSubEmploymentType,
  gy as ExistingIdentificationInfoComponent,
  Jg as FinancialConditionsComponent,
  Cy as FinancingOptionsComponent,
  ky as FlowHeaderComponent,
  Ey as FlowNavigationComponent,
  vy as IdentificationInfoComponent,
  Iy as InstallmentPlanSelectionComponent,
  Sy as LimitExceededComponent,
  hy as LoaderComponent,
  xy as LoginPasswordComponent,
  Ly as MarketingConsentComponent,
  Pt as Modal,
  _y as NavigationButtonsComponent,
  Oy as OrderEndComponent,
  Ty as OrderSummaryComponent,
  Dg as OtherPersonalInfoComponent,
  ty as PaymentDetailsComponent,
  ry as PersonalIncomeComponent,
  Xg as PoliticallyExposedPersonComponent,
  ey as PosInfoComponent,
  Kg as PrecheckComponent,
  Py as ProductUpdateComponent,
  Fy as ProformaPaymentComponent,
  Vy as StartOrderComponent,
  Ry as TermsAndConditionsComponent,
  yy as VerificationComponent,
  Hr as appSystemKey,
  Pe as copySharedProperties,
  kv as createApiOrderEmploymentTypeComponentData,
  Vv as createApiOrderExistingIdentificationComponentData,
  Yv as createApiOrderIdentificationComponentData,
  Ag as createApiOrderStep5ComponentData,
  ov as createApiOrderVerificationComponentData,
  ao as createApiPrecheckComponentData,
  iy as createCalculationData,
  gf as createContractCreateComponentData,
  dy as createContractData,
  kf as createContractDocumentationComponentObject,
  Ff as createContractSignatureTypeComponentObject,
  sy as createCustomerData,
  Bf as createCustomerEntryNoticeComponentObject,
  Rc as createEmailVerificationComponentData,
  ly as createEmploymentData,
  hl as createEmploymentInfoComponentData,
  Xn as createEmploymentTypeComponentData,
  no as createExistingIdentificationInfoComponentData,
  ay as createExposureData,
  Dn as createFinancialConditionsComponentData,
  fy as createFinancialConditionsData,
  so as createFinancingOptionsComponentData,
  uy as createIdentificationData,
  ro as createIdentificationInfoComponentData,
  io as createInstallmentPlanSelectionComponentData,
  If as createLimitExceededComponentObject,
  _p as createLoginPasswordComponentObject,
  pp as createMarketingConsentComponentData,
  my as createNavigationSteps,
  ts as createOrderEndComponentData,
  eo as createOtherPersonalInfoComponentData,
  to as createPaymentDetailsComponentData,
  Qu as createPersonalIncomeComponentData,
  Ua as createPoliticallyExposedPersonComponentData,
  mu as createPosInfoComponentData,
  cy as createPreapprovedData,
  Jn as createPrecheckComponentData,
  ny as createProcessData,
  Sf as createProductUpdateComponentObject,
  jp as createProformaPaymentComponentData,
  oy as createSisbonData,
  Qp as createStartOrderComponentData,
  sp as createTermsAndConditionsComponentData,
  oo as createVerificationComponentData,
  py as createWebOrderData,
  Hg as parseAppSystem
};
//# sourceMappingURL=nlb-buy-go-library-v2.es.js.map
